var Ds = Object.defineProperty;
var In = Object.getOwnPropertySymbols;
var Os = Object.prototype.hasOwnProperty, Ms = Object.prototype.propertyIsEnumerable;
var kn = (e, i, o) => i in e ? Ds(e, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[i] = o, Cn = (e, i) => {
  for (var o in i || (i = {}))
    Os.call(i, o) && kn(e, o, i[o]);
  if (In)
    for (var o of In(i))
      Ms.call(i, o) && kn(e, o, i[o]);
  return e;
};
Number.isFinite || (Number.isFinite = (e) => typeof e == "number" && isFinite(e));
Array.prototype.find || (Array.prototype.find = function(e, i) {
  if (this === null || this === void 0)
    throw new TypeError("Array.prototype.find called on null or undefined");
  if (typeof e != "function")
    throw new TypeError("callback must be a function");
  const o = Object(this), c = o.length >>> 0;
  for (let d = 0; d < c; d++)
    if (e.call(i, o[d], d, o))
      return o[d];
});
Array.prototype.findIndex || (Array.prototype.findIndex = function(e, i) {
  if (this === null || this === void 0)
    throw new TypeError("Array.prototype.findIndex called on null or undefined");
  if (typeof e != "function")
    throw new TypeError("callback must be a function");
  const o = Object(this), c = o.length >>> 0;
  for (let d = 0; d < c; d++)
    if (d in o && e.call(i, o[d], d, o))
      return d;
  return -1;
});
Array.prototype.fill || (Array.prototype.fill = function(e, i = 0, o = this.length) {
  if (this === null || this === void 0)
    throw new TypeError("Array.prototype.fill called on null or undefined");
  const c = Object(this), d = c.length >>> 0, _ = i >> 0, v = o >> 0, f = _ < 0 ? Math.max(d + _, 0) : Math.min(_, d), y = v < 0 ? Math.max(d + v, 0) : Math.min(v, d);
  for (let D = f; D < y; D++)
    c[D] = e;
  return c;
});
var Ns = Object.defineProperty, Ps = (e, i, o) => i in e ? Ns(e, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[i] = o, Vt = (e, i, o) => (Ps(e, typeof i != "symbol" ? i + "" : i, o), o), mr = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}, Oi = {}, Us = {
  get exports() {
    return Oi;
  },
  set exports(e) {
    Oi = e;
  }
}, Qt = typeof Reflect == "object" ? Reflect : null, Dn = Qt && typeof Qt.apply == "function" ? Qt.apply : function(e, i, o) {
  return Function.prototype.apply.call(e, i, o);
}, Si;
Qt && typeof Qt.ownKeys == "function" ? Si = Qt.ownKeys : Object.getOwnPropertySymbols ? Si = function(e) {
  return Object.getOwnPropertyNames(e).concat(Object.getOwnPropertySymbols(e));
} : Si = function(e) {
  return Object.getOwnPropertyNames(e);
};
function Fs(e) {
  console && console.warn && console.warn(e);
}
var sa = Number.isNaN || function(e) {
  return e !== e;
};
function ve() {
  ve.init.call(this);
}
Us.exports = ve;
Oi.once = Gs;
ve.EventEmitter = ve;
ve.prototype._events = void 0;
ve.prototype._eventsCount = 0;
ve.prototype._maxListeners = void 0;
var On = 10;
function Hi(e) {
  if (typeof e != "function")
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof e);
}
Object.defineProperty(ve, "defaultMaxListeners", {
  enumerable: !0,
  get: function() {
    return On;
  },
  set: function(e) {
    if (typeof e != "number" || e < 0 || sa(e))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + e + ".");
    On = e;
  }
});
ve.init = function() {
  (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
};
ve.prototype.setMaxListeners = function(e) {
  if (typeof e != "number" || e < 0 || sa(e))
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + e + ".");
  return this._maxListeners = e, this;
};
function la(e) {
  return e._maxListeners === void 0 ? ve.defaultMaxListeners : e._maxListeners;
}
ve.prototype.getMaxListeners = function() {
  return la(this);
};
ve.prototype.emit = function(e) {
  for (var i = [], o = 1; o < arguments.length; o++)
    i.push(arguments[o]);
  var c = e === "error", d = this._events;
  if (d !== void 0)
    c = c && d.error === void 0;
  else if (!c)
    return !1;
  if (c) {
    var _;
    if (i.length > 0 && (_ = i[0]), _ instanceof Error)
      throw _;
    var v = new Error("Unhandled error." + (_ ? " (" + _.message + ")" : ""));
    throw v.context = _, v;
  }
  var f = d[e];
  if (f === void 0)
    return !1;
  if (typeof f == "function")
    Dn(f, this, i);
  else
    for (var y = f.length, D = _a(f, y), o = 0; o < y; ++o)
      Dn(D[o], this, i);
  return !0;
};
function ca(e, i, o, c) {
  var d, _, v;
  if (Hi(o), _ = e._events, _ === void 0 ? (_ = e._events = /* @__PURE__ */ Object.create(null), e._eventsCount = 0) : (_.newListener !== void 0 && (e.emit(
    "newListener",
    i,
    o.listener ? o.listener : o
  ), _ = e._events), v = _[i]), v === void 0)
    v = _[i] = o, ++e._eventsCount;
  else if (typeof v == "function" ? v = _[i] = c ? [o, v] : [v, o] : c ? v.unshift(o) : v.push(o), d = la(e), d > 0 && v.length > d && !v.warned) {
    v.warned = !0;
    var f = new Error("Possible EventEmitter memory leak detected. " + v.length + " " + String(i) + " listeners added. Use emitter.setMaxListeners() to increase limit");
    f.name = "MaxListenersExceededWarning", f.emitter = e, f.type = i, f.count = v.length, Fs(f);
  }
  return e;
}
ve.prototype.addListener = function(e, i) {
  return ca(this, e, i, !1);
};
ve.prototype.on = ve.prototype.addListener;
ve.prototype.prependListener = function(e, i) {
  return ca(this, e, i, !0);
};
function Bs() {
  if (!this.fired)
    return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
}
function ua(e, i, o) {
  var c = { fired: !1, wrapFn: void 0, target: e, type: i, listener: o }, d = Bs.bind(c);
  return d.listener = o, c.wrapFn = d, d;
}
ve.prototype.once = function(e, i) {
  return Hi(i), this.on(e, ua(this, e, i)), this;
};
ve.prototype.prependOnceListener = function(e, i) {
  return Hi(i), this.prependListener(e, ua(this, e, i)), this;
};
ve.prototype.removeListener = function(e, i) {
  var o, c, d, _, v;
  if (Hi(i), c = this._events, c === void 0)
    return this;
  if (o = c[e], o === void 0)
    return this;
  if (o === i || o.listener === i)
    --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete c[e], c.removeListener && this.emit("removeListener", e, o.listener || i));
  else if (typeof o != "function") {
    for (d = -1, _ = o.length - 1; _ >= 0; _--)
      if (o[_] === i || o[_].listener === i) {
        v = o[_].listener, d = _;
        break;
      }
    if (d < 0)
      return this;
    d === 0 ? o.shift() : Vs(o, d), o.length === 1 && (c[e] = o[0]), c.removeListener !== void 0 && this.emit("removeListener", e, v || i);
  }
  return this;
};
ve.prototype.off = ve.prototype.removeListener;
ve.prototype.removeAllListeners = function(e) {
  var i, o, c;
  if (o = this._events, o === void 0)
    return this;
  if (o.removeListener === void 0)
    return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : o[e] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete o[e]), this;
  if (arguments.length === 0) {
    var d = Object.keys(o), _;
    for (c = 0; c < d.length; ++c)
      _ = d[c], _ !== "removeListener" && this.removeAllListeners(_);
    return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
  }
  if (i = o[e], typeof i == "function")
    this.removeListener(e, i);
  else if (i !== void 0)
    for (c = i.length - 1; c >= 0; c--)
      this.removeListener(e, i[c]);
  return this;
};
function da(e, i, o) {
  var c = e._events;
  if (c === void 0)
    return [];
  var d = c[i];
  return d === void 0 ? [] : typeof d == "function" ? o ? [d.listener || d] : [d] : o ? Hs(d) : _a(d, d.length);
}
ve.prototype.listeners = function(e) {
  return da(this, e, !0);
};
ve.prototype.rawListeners = function(e) {
  return da(this, e, !1);
};
ve.listenerCount = function(e, i) {
  return typeof e.listenerCount == "function" ? e.listenerCount(i) : ha.call(e, i);
};
ve.prototype.listenerCount = ha;
function ha(e) {
  var i = this._events;
  if (i !== void 0) {
    var o = i[e];
    if (typeof o == "function")
      return 1;
    if (o !== void 0)
      return o.length;
  }
  return 0;
}
ve.prototype.eventNames = function() {
  return this._eventsCount > 0 ? Si(this._events) : [];
};
function _a(e, i) {
  for (var o = new Array(i), c = 0; c < i; ++c)
    o[c] = e[c];
  return o;
}
function Vs(e, i) {
  for (; i + 1 < e.length; i++)
    e[i] = e[i + 1];
  e.pop();
}
function Hs(e) {
  for (var i = new Array(e.length), o = 0; o < i.length; ++o)
    i[o] = e[o].listener || e[o];
  return i;
}
function Gs(e, i) {
  return new Promise(function(o, c) {
    function d(v) {
      e.removeListener(i, _), c(v);
    }
    function _() {
      typeof e.removeListener == "function" && e.removeListener("error", d), o([].slice.call(arguments));
    }
    Aa(e, i, _, { once: !0 }), i !== "error" && Ws(e, d, { once: !0 });
  });
}
function Ws(e, i, o) {
  typeof e.on == "function" && Aa(e, "error", i, o);
}
function Aa(e, i, o, c) {
  if (typeof e.on == "function")
    c.once ? e.once(i, o) : e.on(i, o);
  else if (typeof e.addEventListener == "function")
    e.addEventListener(i, function d(_) {
      c.once && e.removeEventListener(i, d), o(_);
    });
  else
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof e);
}
var pa = function() {
  if (typeof Map < "u")
    return Map;
  function e(i, o) {
    var c = -1;
    return i.some(function(d, _) {
      return d[0] === o ? (c = _, !0) : !1;
    }), c;
  }
  return (
    /** @class */
    function() {
      function i() {
        this.__entries__ = [];
      }
      return Object.defineProperty(i.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: !0,
        configurable: !0
      }), i.prototype.get = function(o) {
        var c = e(this.__entries__, o), d = this.__entries__[c];
        return d && d[1];
      }, i.prototype.set = function(o, c) {
        var d = e(this.__entries__, o);
        ~d ? this.__entries__[d][1] = c : this.__entries__.push([o, c]);
      }, i.prototype.delete = function(o) {
        var c = this.__entries__, d = e(c, o);
        ~d && c.splice(d, 1);
      }, i.prototype.has = function(o) {
        return !!~e(this.__entries__, o);
      }, i.prototype.clear = function() {
        this.__entries__.splice(0);
      }, i.prototype.forEach = function(o, c) {
        c === void 0 && (c = null);
        for (var d = 0, _ = this.__entries__; d < _.length; d++) {
          var v = _[d];
          o.call(c, v[1], v[0]);
        }
      }, i;
    }()
  );
}(), gr = typeof window < "u" && typeof document < "u" && window.document === document, Mi = function() {
  return typeof global < "u" && global.Math === Math ? global : typeof self < "u" && self.Math === Math ? self : typeof window < "u" && window.Math === Math ? window : Function("return this")();
}(), Ks = function() {
  return typeof requestAnimationFrame == "function" ? requestAnimationFrame.bind(Mi) : function(e) {
    return setTimeout(function() {
      return e(Date.now());
    }, 1e3 / 60);
  };
}(), zs = 2;
function $s(e, i) {
  var o = !1, c = !1, d = 0;
  function _() {
    o && (o = !1, e()), c && f();
  }
  function v() {
    Ks(_);
  }
  function f() {
    var y = Date.now();
    if (o) {
      if (y - d < zs)
        return;
      c = !0;
    } else
      o = !0, c = !1, setTimeout(v, i);
    d = y;
  }
  return f;
}
var js = 20, Ys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"], qs = typeof MutationObserver < "u", Qs = (
  /** @class */
  function() {
    function e() {
      this.connected_ = !1, this.mutationEventsAdded_ = !1, this.mutationsObserver_ = null, this.observers_ = [], this.onTransitionEnd_ = this.onTransitionEnd_.bind(this), this.refresh = $s(this.refresh.bind(this), js);
    }
    return e.prototype.addObserver = function(i) {
      ~this.observers_.indexOf(i) || this.observers_.push(i), this.connected_ || this.connect_();
    }, e.prototype.removeObserver = function(i) {
      var o = this.observers_, c = o.indexOf(i);
      ~c && o.splice(c, 1), !o.length && this.connected_ && this.disconnect_();
    }, e.prototype.refresh = function() {
      var i = this.updateObservers_();
      i && this.refresh();
    }, e.prototype.updateObservers_ = function() {
      var i = this.observers_.filter(function(o) {
        return o.gatherActive(), o.hasActive();
      });
      return i.forEach(function(o) {
        return o.broadcastActive();
      }), i.length > 0;
    }, e.prototype.connect_ = function() {
      !gr || this.connected_ || (document.addEventListener("transitionend", this.onTransitionEnd_), window.addEventListener("resize", this.refresh), qs ? (this.mutationsObserver_ = new MutationObserver(this.refresh), this.mutationsObserver_.observe(document, {
        attributes: !0,
        childList: !0,
        characterData: !0,
        subtree: !0
      })) : (document.addEventListener("DOMSubtreeModified", this.refresh), this.mutationEventsAdded_ = !0), this.connected_ = !0);
    }, e.prototype.disconnect_ = function() {
      !gr || !this.connected_ || (document.removeEventListener("transitionend", this.onTransitionEnd_), window.removeEventListener("resize", this.refresh), this.mutationsObserver_ && this.mutationsObserver_.disconnect(), this.mutationEventsAdded_ && document.removeEventListener("DOMSubtreeModified", this.refresh), this.mutationsObserver_ = null, this.mutationEventsAdded_ = !1, this.connected_ = !1);
    }, e.prototype.onTransitionEnd_ = function(i) {
      var o = i.propertyName, c = o === void 0 ? "" : o, d = Ys.some(function(_) {
        return !!~c.indexOf(_);
      });
      d && this.refresh();
    }, e.getInstance = function() {
      return this.instance_ || (this.instance_ = new e()), this.instance_;
    }, e.instance_ = null, e;
  }()
), fa = function(e, i) {
  for (var o = 0, c = Object.keys(i); o < c.length; o++) {
    var d = c[o];
    Object.defineProperty(e, d, {
      value: i[d],
      enumerable: !1,
      writable: !1,
      configurable: !0
    });
  }
  return e;
}, Zt = function(e) {
  var i = e && e.ownerDocument && e.ownerDocument.defaultView;
  return i || Mi;
}, va = Gi(0, 0, 0, 0);
function Ni(e) {
  return parseFloat(e) || 0;
}
function Mn(e) {
  for (var i = [], o = 1; o < arguments.length; o++)
    i[o - 1] = arguments[o];
  return i.reduce(function(c, d) {
    var _ = e["border-" + d + "-width"];
    return c + Ni(_);
  }, 0);
}
function Xs(e) {
  for (var i = ["top", "right", "bottom", "left"], o = {}, c = 0, d = i; c < d.length; c++) {
    var _ = d[c], v = e["padding-" + _];
    o[_] = Ni(v);
  }
  return o;
}
function Zs(e) {
  var i = e.getBBox();
  return Gi(0, 0, i.width, i.height);
}
function Js(e) {
  var i = e.clientWidth, o = e.clientHeight;
  if (!i && !o)
    return va;
  var c = Zt(e).getComputedStyle(e), d = Xs(c), _ = d.left + d.right, v = d.top + d.bottom, f = Ni(c.width), y = Ni(c.height);
  if (c.boxSizing === "border-box" && (Math.round(f + _) !== i && (f -= Mn(c, "left", "right") + _), Math.round(y + v) !== o && (y -= Mn(c, "top", "bottom") + v)), !tl(e)) {
    var D = Math.round(f + _) - i, A = Math.round(y + v) - o;
    Math.abs(D) !== 1 && (f -= D), Math.abs(A) !== 1 && (y -= A);
  }
  return Gi(d.left, d.top, f, y);
}
var el = function() {
  return typeof SVGGraphicsElement < "u" ? function(e) {
    return e instanceof Zt(e).SVGGraphicsElement;
  } : function(e) {
    return e instanceof Zt(e).SVGElement && typeof e.getBBox == "function";
  };
}();
function tl(e) {
  return e === Zt(e).document.documentElement;
}
function il(e) {
  return gr ? el(e) ? Zs(e) : Js(e) : va;
}
function rl(e) {
  var i = e.x, o = e.y, c = e.width, d = e.height, _ = typeof DOMRectReadOnly < "u" ? DOMRectReadOnly : Object, v = Object.create(_.prototype);
  return fa(v, {
    x: i,
    y: o,
    width: c,
    height: d,
    top: o,
    right: i + c,
    bottom: d + o,
    left: i
  }), v;
}
function Gi(e, i, o, c) {
  return { x: e, y: i, width: o, height: c };
}
var nl = (
  /** @class */
  function() {
    function e(i) {
      this.broadcastWidth = 0, this.broadcastHeight = 0, this.contentRect_ = Gi(0, 0, 0, 0), this.target = i;
    }
    return e.prototype.isActive = function() {
      var i = il(this.target);
      return this.contentRect_ = i, i.width !== this.broadcastWidth || i.height !== this.broadcastHeight;
    }, e.prototype.broadcastRect = function() {
      var i = this.contentRect_;
      return this.broadcastWidth = i.width, this.broadcastHeight = i.height, i;
    }, e;
  }()
), al = (
  /** @class */
  function() {
    function e(i, o) {
      var c = rl(o);
      fa(this, { target: i, contentRect: c });
    }
    return e;
  }()
), ol = (
  /** @class */
  function() {
    function e(i, o, c) {
      if (this.activeObservations_ = [], this.observations_ = new pa(), typeof i != "function")
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      this.callback_ = i, this.controller_ = o, this.callbackCtx_ = c;
    }
    return e.prototype.observe = function(i) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(i instanceof Zt(i).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var o = this.observations_;
        o.has(i) || (o.set(i, new nl(i)), this.controller_.addObserver(this), this.controller_.refresh());
      }
    }, e.prototype.unobserve = function(i) {
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      if (!(typeof Element > "u" || !(Element instanceof Object))) {
        if (!(i instanceof Zt(i).Element))
          throw new TypeError('parameter 1 is not of type "Element".');
        var o = this.observations_;
        o.has(i) && (o.delete(i), o.size || this.controller_.removeObserver(this));
      }
    }, e.prototype.disconnect = function() {
      this.clearActive(), this.observations_.clear(), this.controller_.removeObserver(this);
    }, e.prototype.gatherActive = function() {
      var i = this;
      this.clearActive(), this.observations_.forEach(function(o) {
        o.isActive() && i.activeObservations_.push(o);
      });
    }, e.prototype.broadcastActive = function() {
      if (this.hasActive()) {
        var i = this.callbackCtx_, o = this.activeObservations_.map(function(c) {
          return new al(c.target, c.broadcastRect());
        });
        this.callback_.call(i, o, i), this.clearActive();
      }
    }, e.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    }, e.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    }, e;
  }()
), ma = typeof WeakMap < "u" ? /* @__PURE__ */ new WeakMap() : new pa(), ga = (
  /** @class */
  function() {
    function e(i) {
      if (!(this instanceof e))
        throw new TypeError("Cannot call a class as a function.");
      if (!arguments.length)
        throw new TypeError("1 argument required, but only 0 present.");
      var o = Qs.getInstance(), c = new ol(i, o, this);
      ma.set(this, c);
    }
    return e;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(e) {
  ga.prototype[e] = function() {
    var i;
    return (i = ma.get(this))[e].apply(i, arguments);
  };
});
(function() {
  return typeof Mi.ResizeObserver < "u" ? Mi.ResizeObserver : ga;
})();
var sl = function(e, i) {
  if (i = i.split(":")[0], e = +e, !e)
    return !1;
  switch (i) {
    case "http":
    case "ws":
      return e !== 80;
    case "https":
    case "wss":
      return e !== 443;
    case "ftp":
      return e !== 21;
    case "gopher":
      return e !== 70;
    case "file":
      return !1;
  }
  return e !== 0;
}, wr = {}, ll = Object.prototype.hasOwnProperty, cl;
function Nn(e) {
  try {
    return decodeURIComponent(e.replace(/\+/g, " "));
  } catch (i) {
    return null;
  }
}
function Pn(e) {
  try {
    return encodeURIComponent(e);
  } catch (i) {
    return null;
  }
}
function ul(e) {
  for (var i = /([^=?#&]+)=?([^&]*)/g, o = {}, c; c = i.exec(e); ) {
    var d = Nn(c[1]), _ = Nn(c[2]);
    d === null || _ === null || d in o || (o[d] = _);
  }
  return o;
}
function dl(e, i) {
  i = i || "";
  var o = [], c, d;
  typeof i != "string" && (i = "?");
  for (d in e)
    if (ll.call(e, d)) {
      if (c = e[d], !c && (c === null || c === cl || isNaN(c)) && (c = ""), d = Pn(d), c = Pn(c), d === null || c === null)
        continue;
      o.push(d + "=" + c);
    }
  return o.length ? i + o.join("&") : "";
}
wr.stringify = dl;
wr.parse = ul;
var ya = sl, Wi = wr, hl = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, Ea = /[\n\r\t]/g, _l = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, Ta = /:\d+$/, Al = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, pl = /^[a-zA-Z]:/;
function Lr(e) {
  return (e || "").toString().replace(hl, "");
}
var yr = [
  ["#", "hash"],
  // Extract from the back.
  ["?", "query"],
  // Extract from the back.
  function(e, i) {
    return Et(i.protocol) ? e.replace(/\\/g, "/") : e;
  },
  ["/", "pathname"],
  // Extract from the back.
  ["@", "auth", 1],
  // Extract from the front.
  [NaN, "host", void 0, 1, 1],
  // Set left over value.
  [/:(\d*)$/, "port", void 0, 1],
  // RegExp the back.
  [NaN, "hostname", void 0, 1, 1]
  // Set left over.
], Un = { hash: 1, query: 1 };
function ba(e) {
  var i;
  typeof window < "u" ? i = window : typeof mr < "u" ? i = mr : typeof self < "u" ? i = self : i = {};
  var o = i.location || {};
  e = e || o;
  var c = {}, d = typeof e, _;
  if (e.protocol === "blob:")
    c = new Tt(unescape(e.pathname), {});
  else if (d === "string") {
    c = new Tt(e, {});
    for (_ in Un)
      delete c[_];
  } else if (d === "object") {
    for (_ in e)
      _ in Un || (c[_] = e[_]);
    c.slashes === void 0 && (c.slashes = _l.test(e.href));
  }
  return c;
}
function Et(e) {
  return e === "file:" || e === "ftp:" || e === "http:" || e === "https:" || e === "ws:" || e === "wss:";
}
function Ra(e, i) {
  e = Lr(e), e = e.replace(Ea, ""), i = i || {};
  var o = Al.exec(e), c = o[1] ? o[1].toLowerCase() : "", d = !!o[2], _ = !!o[3], v = 0, f;
  return d ? _ ? (f = o[2] + o[3] + o[4], v = o[2].length + o[3].length) : (f = o[2] + o[4], v = o[2].length) : _ ? (f = o[3] + o[4], v = o[3].length) : f = o[4], c === "file:" ? v >= 2 && (f = f.slice(2)) : Et(c) ? f = o[4] : c ? d && (f = f.slice(2)) : v >= 2 && Et(i.protocol) && (f = o[4]), {
    protocol: c,
    slashes: d || Et(c),
    slashesCount: v,
    rest: f
  };
}
function fl(e, i) {
  if (e === "")
    return i;
  for (var o = (i || "/").split("/").slice(0, -1).concat(e.split("/")), c = o.length, d = o[c - 1], _ = !1, v = 0; c--; )
    o[c] === "." ? o.splice(c, 1) : o[c] === ".." ? (o.splice(c, 1), v++) : v && (c === 0 && (_ = !0), o.splice(c, 1), v--);
  return _ && o.unshift(""), (d === "." || d === "..") && o.push(""), o.join("/");
}
function Tt(e, i, o) {
  if (e = Lr(e), e = e.replace(Ea, ""), !(this instanceof Tt))
    return new Tt(e, i, o);
  var c, d, _, v, f, y, D = yr.slice(), A = typeof i, S = this, E = 0;
  for (A !== "object" && A !== "string" && (o = i, i = null), o && typeof o != "function" && (o = Wi.parse), i = ba(i), d = Ra(e || "", i), c = !d.protocol && !d.slashes, S.slashes = d.slashes || c && i.slashes, S.protocol = d.protocol || i.protocol || "", e = d.rest, (d.protocol === "file:" && (d.slashesCount !== 2 || pl.test(e)) || !d.slashes && (d.protocol || d.slashesCount < 2 || !Et(S.protocol))) && (D[3] = [/(.*)/, "pathname"]); E < D.length; E++) {
    if (v = D[E], typeof v == "function") {
      e = v(e, S);
      continue;
    }
    _ = v[0], y = v[1], _ !== _ ? S[y] = e : typeof _ == "string" ? (f = _ === "@" ? e.lastIndexOf(_) : e.indexOf(_), ~f && (typeof v[2] == "number" ? (S[y] = e.slice(0, f), e = e.slice(f + v[2])) : (S[y] = e.slice(f), e = e.slice(0, f)))) : (f = _.exec(e)) && (S[y] = f[1], e = e.slice(0, f.index)), S[y] = S[y] || c && v[3] && i[y] || "", v[4] && (S[y] = S[y].toLowerCase());
  }
  o && (S.query = o(S.query)), c && i.slashes && S.pathname.charAt(0) !== "/" && (S.pathname !== "" || i.pathname !== "") && (S.pathname = fl(S.pathname, i.pathname)), S.pathname.charAt(0) !== "/" && Et(S.protocol) && (S.pathname = "/" + S.pathname), ya(S.port, S.protocol) || (S.host = S.hostname, S.port = ""), S.username = S.password = "", S.auth && (f = S.auth.indexOf(":"), ~f ? (S.username = S.auth.slice(0, f), S.username = encodeURIComponent(decodeURIComponent(S.username)), S.password = S.auth.slice(f + 1), S.password = encodeURIComponent(decodeURIComponent(S.password))) : S.username = encodeURIComponent(decodeURIComponent(S.auth)), S.auth = S.password ? S.username + ":" + S.password : S.username), S.origin = S.protocol !== "file:" && Et(S.protocol) && S.host ? S.protocol + "//" + S.host : "null", S.href = S.toString();
}
function vl(e, i, o) {
  var c = this;
  switch (e) {
    case "query":
      typeof i == "string" && i.length && (i = (o || Wi.parse)(i)), c[e] = i;
      break;
    case "port":
      c[e] = i, ya(i, c.protocol) ? i && (c.host = c.hostname + ":" + i) : (c.host = c.hostname, c[e] = "");
      break;
    case "hostname":
      c[e] = i, c.port && (i += ":" + c.port), c.host = i;
      break;
    case "host":
      c[e] = i, Ta.test(i) ? (i = i.split(":"), c.port = i.pop(), c.hostname = i.join(":")) : (c.hostname = i, c.port = "");
      break;
    case "protocol":
      c.protocol = i.toLowerCase(), c.slashes = !o;
      break;
    case "pathname":
    case "hash":
      if (i) {
        var d = e === "pathname" ? "/" : "#";
        c[e] = i.charAt(0) !== d ? d + i : i;
      } else
        c[e] = i;
      break;
    case "username":
    case "password":
      c[e] = encodeURIComponent(i);
      break;
    case "auth":
      var _ = i.indexOf(":");
      ~_ ? (c.username = i.slice(0, _), c.username = encodeURIComponent(decodeURIComponent(c.username)), c.password = i.slice(_ + 1), c.password = encodeURIComponent(decodeURIComponent(c.password))) : c.username = encodeURIComponent(decodeURIComponent(i));
  }
  for (var v = 0; v < yr.length; v++) {
    var f = yr[v];
    f[4] && (c[f[1]] = c[f[1]].toLowerCase());
  }
  return c.auth = c.password ? c.username + ":" + c.password : c.username, c.origin = c.protocol !== "file:" && Et(c.protocol) && c.host ? c.protocol + "//" + c.host : "null", c.href = c.toString(), c;
}
function ml(e) {
  (!e || typeof e != "function") && (e = Wi.stringify);
  var i, o = this, c = o.host, d = o.protocol;
  d && d.charAt(d.length - 1) !== ":" && (d += ":");
  var _ = d + (o.protocol && o.slashes || Et(o.protocol) ? "//" : "");
  return o.username ? (_ += o.username, o.password && (_ += ":" + o.password), _ += "@") : o.password ? (_ += ":" + o.password, _ += "@") : o.protocol !== "file:" && Et(o.protocol) && !c && o.pathname !== "/" && (_ += "@"), (c[c.length - 1] === ":" || Ta.test(o.hostname) && !o.port) && (c += ":"), _ += c + o.pathname, i = typeof o.query == "object" ? e(o.query) : o.query, i && (_ += i.charAt(0) !== "?" ? "?" + i : i), o.hash && (_ += o.hash), _;
}
Tt.prototype = { set: vl, toString: ml };
Tt.extractProtocol = Ra;
Tt.location = ba;
Tt.trimLeft = Lr;
Tt.qs = Wi;
var Fn = Tt;
const Ut = class {
  constructor() {
    Vt(this, "timeout", 7 * 24 * 3600 * 1e3);
  }
  write(i, o) {
    if (Ut.available)
      try {
        localStorage.setItem(
          i,
          JSON.stringify({ value: o, time: Date.now() })
        );
      } catch (c) {
      }
  }
  read(i, o = !0) {
    if (Ut.available)
      try {
        const c = localStorage.getItem(i);
        if (c) {
          const { value: d, time: _ = 0 } = JSON.parse(c);
          if (!o || Date.now() - _ < this.timeout)
            return d;
        }
      } catch (c) {
      }
  }
  static get available() {
    if (typeof Ut._available > "u")
      try {
        localStorage.setItem("alg", "test"), Ut._available = !0;
      } catch (i) {
        Ut._available = !1;
      }
    return Ut._available;
  }
};
let xr = Ut;
Vt(xr, "_available");
const gl = "kwai-p";
function ni(e, i) {
  return (!i || i.length === 0) && (i = [e], e = ""), e = gl + (e ? "::" + e : ""), i.unshift("[" + e + "] > "), i;
}
const ge = class {
  /**
   * 设置日志输出等级
   * @param l 日志等级
   */
  static level(i) {
    switch (ge.ENABLE_ERROR = ge.ENABLE_WARN = ge.ENABLE_INFO = ge.ENABLE_DEBUG = ge.ENABLE_VERBOSE = !1, i) {
      case "e":
        ge.ENABLE_ERROR = !0;
        break;
      case "w":
        ge.ENABLE_ERROR = ge.ENABLE_WARN = !0;
        break;
      case "i":
        ge.ENABLE_ERROR = ge.ENABLE_WARN = ge.ENABLE_INFO = !0;
        break;
      case "d":
        ge.ENABLE_ERROR = ge.ENABLE_WARN = ge.ENABLE_INFO = ge.ENABLE_DEBUG = !0;
        break;
      case "v":
        ge.ENABLE_ERROR = ge.ENABLE_WARN = ge.ENABLE_INFO = ge.ENABLE_DEBUG = ge.ENABLE_VERBOSE = !0;
        break;
    }
  }
  /**
   * error日志
   * @param tag tag
   * @param msg 日志信息
   */
  static e(i, ...o) {
    if (!ge.ENABLE_ERROR)
      return;
    const c = ni(i, o);
    (console.error || console.warn || console.log).apply(console, c);
  }
  /**
   * warn日志
   * @param tag tag
   * @param msg 日志信息
   */
  static w(i, ...o) {
    if (!ge.ENABLE_WARN)
      return;
    const c = ni(i, o);
    (console.warn || console.log).apply(console, c);
  }
  /**
   * info日志
   * @param tag tag
   * @param msg 日志信息
   */
  static i(i, ...o) {
    if (!ge.ENABLE_INFO)
      return;
    const c = ni(i, o);
    (console.info || console.log).apply(console, c);
  }
  /**
   * debug日志
   * @param tag tag
   * @param msg 日志信息
   */
  static d(i, ...o) {
    if (!ge.ENABLE_DEBUG)
      return;
    const c = ni(i, o);
    (console.debug || console.log).apply(console, c);
  }
  /**
   * verbose日志
   * @param tag tag
   * @param msg 日志信息
   */
  static v(i, ...o) {
    if (!ge.ENABLE_VERBOSE)
      return;
    const c = ni(i, o);
    console.log.apply(console, c);
  }
};
let I = ge;
Vt(I, "ENABLE_ERROR", !0), Vt(I, "ENABLE_WARN", !1), Vt(I, "ENABLE_INFO", !1), Vt(I, "ENABLE_DEBUG", !1), Vt(I, "ENABLE_VERBOSE", !1);
var Pi = {}, yl = {
  get exports() {
    return Pi;
  },
  set exports(e) {
    Pi = e;
  }
};
(function(e, i) {
  (function(o, c) {
    var d = "1.0.2", _ = "", v = "?", f = "function", y = "undefined", D = "object", A = "string", S = "major", E = "model", b = "name", L = "type", k = "vendor", g = "version", H = "architecture", T = "console", R = "mobile", x = "tablet", w = "smarttv", B = "wearable", N = "embedded", K = 255, G = "Amazon", q = "Apple", be = "ASUS", bt = "BlackBerry", W = "Browser", Ne = "Chrome", qe = "Edge", We = "Firefox", Ce = "Google", Ke = "Huawei", ft = "LG", ot = "Microsoft", ye = "Motorola", Pe = "Opera", Ot = "Samsung", ze = "Sony", vt = "Xiaomi", $ = "Zebra", It = "Facebook", X = function(ae, he) {
      var te = {};
      for (var Se in ae)
        he[Se] && he[Se].length % 2 === 0 ? te[Se] = he[Se].concat(ae[Se]) : te[Se] = ae[Se];
      return te;
    }, De = function(ae) {
      for (var he = {}, te = 0; te < ae.length; te++)
        he[ae[te].toUpperCase()] = ae[te];
      return he;
    }, Y = function(ae, he) {
      return typeof ae === A ? Le(he).indexOf(Le(ae)) !== -1 : !1;
    }, Le = function(ae) {
      return ae.toLowerCase();
    }, Rt = function(ae) {
      return typeof ae === A ? ae.replace(/[^\d\.]/g, _).split(".")[0] : c;
    }, St = function(ae, he) {
      if (typeof ae === A)
        return ae = ae.replace(/^\s\s*/, _).replace(/\s\s*$/, _), typeof he === y ? ae : ae.substring(0, K);
    }, Ze = function(ae, he) {
      for (var te = 0, Se, ie, Kt, me, Mt, st; te < he.length && !Mt; ) {
        var wt = he[te], hi = he[te + 1];
        for (Se = ie = 0; Se < wt.length && !Mt; )
          if (Mt = wt[Se++].exec(ae), Mt)
            for (Kt = 0; Kt < hi.length; Kt++)
              st = Mt[++ie], me = hi[Kt], typeof me === D && me.length > 0 ? me.length === 2 ? typeof me[1] == f ? this[me[0]] = me[1].call(this, st) : this[me[0]] = me[1] : me.length === 3 ? typeof me[1] === f && !(me[1].exec && me[1].test) ? this[me[0]] = st ? me[1].call(this, st, me[2]) : c : this[me[0]] = st ? st.replace(me[1], me[2]) : c : me.length === 4 && (this[me[0]] = st ? me[3].call(this, st.replace(me[1], me[2])) : c) : this[me] = st || c;
        te += 2;
      }
    }, kt = function(ae, he) {
      for (var te in he)
        if (typeof he[te] === D && he[te].length > 0) {
          for (var Se = 0; Se < he[te].length; Se++)
            if (Y(he[te][Se], ae))
              return te === v ? c : te;
        } else if (Y(he[te], ae))
          return te === v ? c : te;
      return ae;
    }, Re = {
      "1.0": "/8",
      "1.2": "/1",
      "1.3": "/3",
      "2.0": "/412",
      "2.0.2": "/416",
      "2.0.3": "/417",
      "2.0.4": "/419",
      "?": "/"
    }, J = {
      ME: "4.90",
      "NT 3.11": "NT3.51",
      "NT 4.0": "NT4.0",
      2e3: "NT 5.0",
      XP: ["NT 5.1", "NT 5.2"],
      Vista: "NT 6.0",
      7: "NT 6.1",
      8: "NT 6.2",
      "8.1": "NT 6.3",
      10: ["NT 6.4", "NT 10.0"],
      RT: "ARM"
    }, ei = {
      browser: [
        [
          /\b(?:crmo|crios)\/([\w\.]+)/i
          // Chrome for Android/iOS
        ],
        [g, [b, "Chrome"]],
        [
          /edg(?:e|ios|a)?\/([\w\.]+)/i
          // Microsoft Edge
        ],
        [g, [b, "Edge"]],
        [
          // Presto based
          /(opera mini)\/([-\w\.]+)/i,
          // Opera Mini
          /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,
          // Opera Mobi/Tablet
          /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i
          // Opera
        ],
        [b, g],
        [
          /opios[\/ ]+([\w\.]+)/i
          // Opera mini on iphone >= 8.0
        ],
        [g, [b, Pe + " Mini"]],
        [
          /\bopr\/([\w\.]+)/i
          // Opera Webkit
        ],
        [g, [b, Pe]],
        [
          // Mixed
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,
          // Lunascape/Maxthon/Netfront/Jasmine/Blazer
          // Trident based
          /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,
          // Avant/IEMobile/SlimBrowser
          /(ba?idubrowser)[\/ ]?([\w\.]+)/i,
          // Baidu Browser
          /(?:ms|\()(ie) ([\w\.]+)/i,
          // Internet Explorer
          // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
          /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
          // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
          /(weibo)__([\d\.]+)/i
          // Weibo
        ],
        [b, g],
        [
          /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i
          // UCBrowser
        ],
        [g, [b, "UC" + W]],
        [
          /\bqbcore\/([\w\.]+)/i
          // WeChat Desktop for Windows Built-in Browser
        ],
        [g, [b, "WeChat(Win) Desktop"]],
        [
          /micromessenger\/([\w\.]+)/i
          // WeChat
        ],
        [g, [b, "WeChat"]],
        [
          /konqueror\/([\w\.]+)/i
          // Konqueror
        ],
        [g, [b, "Konqueror"]],
        [
          /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i
          // IE11
        ],
        [g, [b, "IE"]],
        [
          /yabrowser\/([\w\.]+)/i
          // Yandex
        ],
        [g, [b, "Yandex"]],
        [
          /(avast|avg)\/([\w\.]+)/i
          // Avast/AVG Secure Browser
        ],
        [[b, /(.+)/, "$1 Secure " + W], g],
        [
          /\bfocus\/([\w\.]+)/i
          // Firefox Focus
        ],
        [g, [b, We + " Focus"]],
        [
          /\bopt\/([\w\.]+)/i
          // Opera Touch
        ],
        [g, [b, Pe + " Touch"]],
        [
          /coc_coc\w+\/([\w\.]+)/i
          // Coc Coc Browser
        ],
        [g, [b, "Coc Coc"]],
        [
          /dolfin\/([\w\.]+)/i
          // Dolphin
        ],
        [g, [b, "Dolphin"]],
        [
          /coast\/([\w\.]+)/i
          // Opera Coast
        ],
        [g, [b, Pe + " Coast"]],
        [
          /miuibrowser\/([\w\.]+)/i
          // MIUI Browser
        ],
        [g, [b, "MIUI " + W]],
        [
          /fxios\/([-\w\.]+)/i
          // Firefox for iOS
        ],
        [g, [b, We]],
        [
          /\bqihu|(qi?ho?o?|360)browser/i
          // 360
        ],
        [[b, "360 " + W]],
        [
          /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
        ],
        [[b, /(.+)/, "$1 " + W], g],
        [
          // Oculus/Samsung/Sailfish Browser
          /(comodo_dragon)\/([\w\.]+)/i
          // Comodo Dragon
        ],
        [[b, /_/g, " "], g],
        [
          /(electron)\/([\w\.]+) safari/i,
          // Electron-based App
          /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,
          // Tesla
          /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i
          // QQBrowser/Baidu App/2345 Browser
        ],
        [b, g],
        [
          /(metasr)[\/ ]?([\w\.]+)/i,
          // SouGouBrowser
          /(lbbrowser)/i
          // LieBao Browser
        ],
        [b],
        [
          // WebView
          /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i
          // Facebook App for iOS & Android
        ],
        [[b, It], g],
        [
          /safari (line)\/([\w\.]+)/i,
          // Line App for iOS
          /\b(line)\/([\w\.]+)\/iab/i,
          // Line App for Android
          /(chromium|instagram)[\/ ]([-\w\.]+)/i
          // Chromium/Instagram
        ],
        [b, g],
        [
          /\bgsa\/([\w\.]+) .*safari\//i
          // Google Search Appliance on iOS
        ],
        [g, [b, "GSA"]],
        [
          /headlesschrome(?:\/([\w\.]+)| )/i
          // Chrome Headless
        ],
        [g, [b, Ne + " Headless"]],
        [
          / wv\).+(chrome)\/([\w\.]+)/i
          // Chrome WebView
        ],
        [[b, Ne + " WebView"], g],
        [
          /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i
          // Android Browser
        ],
        [g, [b, "Android " + W]],
        [
          /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i
          // Chrome/OmniWeb/Arora/Tizen/Nokia
        ],
        [b, g],
        [
          /version\/([\w\.]+) .*mobile\/\w+ (safari)/i
          // Mobile Safari
        ],
        [g, [b, "Mobile Safari"]],
        [
          /version\/([\w\.]+) .*(mobile ?safari|safari)/i
          // Safari & Safari Mobile
        ],
        [g, b],
        [
          /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i
          // Safari < 3.0
        ],
        [b, [g, kt, Re]],
        [
          /(webkit|khtml)\/([\w\.]+)/i
        ],
        [b, g],
        [
          // Gecko based
          /(navigator|netscape\d?)\/([-\w\.]+)/i
          // Netscape
        ],
        [[b, "Netscape"], g],
        [
          /mobile vr; rv:([\w\.]+)\).+firefox/i
          // Firefox Reality
        ],
        [g, [b, We + " Reality"]],
        [
          /ekiohf.+(flow)\/([\w\.]+)/i,
          // Flow
          /(swiftfox)/i,
          // Swiftfox
          /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
          // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
          /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
          // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
          /(firefox)\/([\w\.]+)/i,
          // Other Firefox-based
          /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,
          // Mozilla
          // Other
          /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
          // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
          /(links) \(([\w\.]+)/i
          // Links
        ],
        [b, g]
      ],
      cpu: [
        [
          /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i
          // AMD64 (x64)
        ],
        [[H, "amd64"]],
        [
          /(ia32(?=;))/i
          // IA32 (quicktime)
        ],
        [[H, Le]],
        [
          /((?:i[346]|x)86)[;\)]/i
          // IA32 (x86)
        ],
        [[H, "ia32"]],
        [
          /\b(aarch64|arm(v?8e?l?|_?64))\b/i
          // ARM64
        ],
        [[H, "arm64"]],
        [
          /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i
          // ARMHF
        ],
        [[H, "armhf"]],
        [
          // PocketPC mistakenly identified as PowerPC
          /windows (ce|mobile); ppc;/i
        ],
        [[H, "arm"]],
        [
          /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i
          // PowerPC
        ],
        [[H, /ower/, _, Le]],
        [
          /(sun4\w)[;\)]/i
          // SPARC
        ],
        [[H, "sparc"]],
        [
          /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
          // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
        ],
        [[H, Le]]
      ],
      device: [
        [
          //////////////////////////
          // MOBILES & TABLETS
          // Ordered by popularity
          /////////////////////////
          // Samsung
          /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
        ],
        [E, [k, Ot], [L, x]],
        [
          /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
          /samsung[- ]([-\w]+)/i,
          /sec-(sgh\w+)/i
        ],
        [E, [k, Ot], [L, R]],
        [
          // Apple
          /\((ip(?:hone|od)[\w ]*);/i
          // iPod/iPhone
        ],
        [E, [k, q], [L, R]],
        [
          /\((ipad);[-\w\),; ]+apple/i,
          // iPad
          /applecoremedia\/[\w\.]+ \((ipad)/i,
          /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
        ],
        [E, [k, q], [L, x]],
        [
          // Huawei
          /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
        ],
        [E, [k, Ke], [L, x]],
        [
          /(?:huawei|honor)([-\w ]+)[;\)]/i,
          /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
        ],
        [E, [k, Ke], [L, R]],
        [
          // Xiaomi
          /\b(poco[\w ]+)(?: bui|\))/i,
          // Xiaomi POCO
          /\b; (\w+) build\/hm\1/i,
          // Xiaomi Hongmi 'numeric' models
          /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,
          // Xiaomi Hongmi
          /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,
          // Xiaomi Redmi
          /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i
          // Xiaomi Mi
        ],
        [[E, /_/g, " "], [k, vt], [L, R]],
        [
          /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i
          // Mi Pad tablets
        ],
        [[E, /_/g, " "], [k, vt], [L, x]],
        [
          // OPPO
          /; (\w+) bui.+ oppo/i,
          /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
        ],
        [E, [k, "OPPO"], [L, R]],
        [
          // Vivo
          /vivo (\w+)(?: bui|\))/i,
          /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
        ],
        [E, [k, "Vivo"], [L, R]],
        [
          // Realme
          /\b(rmx[12]\d{3})(?: bui|;|\))/i
        ],
        [E, [k, "Realme"], [L, R]],
        [
          // Motorola
          /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
          /\bmot(?:orola)?[- ](\w*)/i,
          /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
        ],
        [E, [k, ye], [L, R]],
        [
          /\b(mz60\d|xoom[2 ]{0,2}) build\//i
        ],
        [E, [k, ye], [L, x]],
        [
          // LG
          /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
        ],
        [E, [k, ft], [L, x]],
        [
          /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
          /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
          /\blg-?([\d\w]+) bui/i
        ],
        [E, [k, ft], [L, R]],
        [
          // Lenovo
          /(ideatab[-\w ]+)/i,
          /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
        ],
        [E, [k, "Lenovo"], [L, x]],
        [
          // Nokia
          /(?:maemo|nokia).*(n900|lumia \d+)/i,
          /nokia[-_ ]?([-\w\.]*)/i
        ],
        [[E, /_/g, " "], [k, "Nokia"], [L, R]],
        [
          // Google
          /(pixel c)\b/i
          // Google Pixel C
        ],
        [E, [k, Ce], [L, x]],
        [
          /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i
          // Google Pixel
        ],
        [E, [k, Ce], [L, R]],
        [
          // Sony
          /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
        ],
        [E, [k, ze], [L, R]],
        [
          /sony tablet [ps]/i,
          /\b(?:sony)?sgp\w+(?: bui|\))/i
        ],
        [[E, "Xperia Tablet"], [k, ze], [L, x]],
        [
          // OnePlus
          / (kb2005|in20[12]5|be20[12][59])\b/i,
          /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
        ],
        [E, [k, "OnePlus"], [L, R]],
        [
          // Amazon
          /(alexa)webm/i,
          /(kf[a-z]{2}wi)( bui|\))/i,
          // Kindle Fire without Silk
          /(kf[a-z]+)( bui|\)).+silk\//i
          // Kindle Fire HD
        ],
        [E, [k, G], [L, x]],
        [
          /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i
          // Fire Phone
        ],
        [[E, /(.+)/g, "Fire Phone $1"], [k, G], [L, R]],
        [
          // BlackBerry
          /(playbook);[-\w\),; ]+(rim)/i
          // BlackBerry PlayBook
        ],
        [E, k, [L, x]],
        [
          /\b((?:bb[a-f]|st[hv])100-\d)/i,
          /\(bb10; (\w+)/i
          // BlackBerry 10
        ],
        [E, [k, bt], [L, R]],
        [
          // Asus
          /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
        ],
        [E, [k, be], [L, x]],
        [
          / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
        ],
        [E, [k, be], [L, R]],
        [
          // HTC
          /(nexus 9)/i
          // HTC Nexus 9
        ],
        [E, [k, "HTC"], [L, x]],
        [
          /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,
          // HTC
          // ZTE
          /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
          /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i
          // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
        ],
        [k, [E, /_/g, " "], [L, R]],
        [
          // Acer
          /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
        ],
        [E, [k, "Acer"], [L, x]],
        [
          // Meizu
          /droid.+; (m[1-5] note) bui/i,
          /\bmz-([-\w]{2,})/i
        ],
        [E, [k, "Meizu"], [L, R]],
        [
          // Sharp
          /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
        ],
        [E, [k, "Sharp"], [L, R]],
        [
          // MIXED
          /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
          // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
          /(hp) ([\w ]+\w)/i,
          // HP iPAQ
          /(asus)-?(\w+)/i,
          // Asus
          /(microsoft); (lumia[\w ]+)/i,
          // Microsoft Lumia
          /(lenovo)[-_ ]?([-\w]+)/i,
          // Lenovo
          /(jolla)/i,
          // Jolla
          /(oppo) ?([\w ]+) bui/i
          // OPPO
        ],
        [k, E, [L, R]],
        [
          /(archos) (gamepad2?)/i,
          // Archos
          /(hp).+(touchpad(?!.+tablet)|tablet)/i,
          // HP TouchPad
          /(kindle)\/([\w\.]+)/i,
          // Kindle
          /(nook)[\w ]+build\/(\w+)/i,
          // Nook
          /(dell) (strea[kpr\d ]*[\dko])/i,
          // Dell Streak
          /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,
          // Le Pan Tablets
          /(trinity)[- ]*(t\d{3}) bui/i,
          // Trinity Tablets
          /(gigaset)[- ]+(q\w{1,9}) bui/i,
          // Gigaset Tablets
          /(vodafone) ([\w ]+)(?:\)| bui)/i
          // Vodafone
        ],
        [k, E, [L, x]],
        [
          /(surface duo)/i
          // Surface Duo
        ],
        [E, [k, ot], [L, x]],
        [
          /droid [\d\.]+; (fp\du?)(?: b|\))/i
          // Fairphone
        ],
        [E, [k, "Fairphone"], [L, R]],
        [
          /(u304aa)/i
          // AT&T
        ],
        [E, [k, "AT&T"], [L, R]],
        [
          /\bsie-(\w*)/i
          // Siemens
        ],
        [E, [k, "Siemens"], [L, R]],
        [
          /\b(rct\w+) b/i
          // RCA Tablets
        ],
        [E, [k, "RCA"], [L, x]],
        [
          /\b(venue[\d ]{2,7}) b/i
          // Dell Venue Tablets
        ],
        [E, [k, "Dell"], [L, x]],
        [
          /\b(q(?:mv|ta)\w+) b/i
          // Verizon Tablet
        ],
        [E, [k, "Verizon"], [L, x]],
        [
          /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i
          // Barnes & Noble Tablet
        ],
        [E, [k, "Barnes & Noble"], [L, x]],
        [
          /\b(tm\d{3}\w+) b/i
        ],
        [E, [k, "NuVision"], [L, x]],
        [
          /\b(k88) b/i
          // ZTE K Series Tablet
        ],
        [E, [k, "ZTE"], [L, x]],
        [
          /\b(nx\d{3}j) b/i
          // ZTE Nubia
        ],
        [E, [k, "ZTE"], [L, R]],
        [
          /\b(gen\d{3}) b.+49h/i
          // Swiss GEN Mobile
        ],
        [E, [k, "Swiss"], [L, R]],
        [
          /\b(zur\d{3}) b/i
          // Swiss ZUR Tablet
        ],
        [E, [k, "Swiss"], [L, x]],
        [
          /\b((zeki)?tb.*\b) b/i
          // Zeki Tablets
        ],
        [E, [k, "Zeki"], [L, x]],
        [
          /\b([yr]\d{2}) b/i,
          /\b(dragon[- ]+touch |dt)(\w{5}) b/i
          // Dragon Touch Tablet
        ],
        [[k, "Dragon Touch"], E, [L, x]],
        [
          /\b(ns-?\w{0,9}) b/i
          // Insignia Tablets
        ],
        [E, [k, "Insignia"], [L, x]],
        [
          /\b((nxa|next)-?\w{0,9}) b/i
          // NextBook Tablets
        ],
        [E, [k, "NextBook"], [L, x]],
        [
          /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i
          // Voice Xtreme Phones
        ],
        [[k, "Voice"], E, [L, R]],
        [
          /\b(lvtel\-)?(v1[12]) b/i
          // LvTel Phones
        ],
        [[k, "LvTel"], E, [L, R]],
        [
          /\b(ph-1) /i
          // Essential PH-1
        ],
        [E, [k, "Essential"], [L, R]],
        [
          /\b(v(100md|700na|7011|917g).*\b) b/i
          // Envizen Tablets
        ],
        [E, [k, "Envizen"], [L, x]],
        [
          /\b(trio[-\w\. ]+) b/i
          // MachSpeed Tablets
        ],
        [E, [k, "MachSpeed"], [L, x]],
        [
          /\btu_(1491) b/i
          // Rotor Tablets
        ],
        [E, [k, "Rotor"], [L, x]],
        [
          /(shield[\w ]+) b/i
          // Nvidia Shield Tablets
        ],
        [E, [k, "Nvidia"], [L, x]],
        [
          /(sprint) (\w+)/i
          // Sprint Phones
        ],
        [k, E, [L, R]],
        [
          /(kin\.[onetw]{3})/i
          // Microsoft Kin
        ],
        [[E, /\./g, " "], [k, ot], [L, R]],
        [
          /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i
          // Zebra
        ],
        [E, [k, $], [L, x]],
        [
          /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
        ],
        [E, [k, $], [L, R]],
        [
          ///////////////////
          // CONSOLES
          ///////////////////
          /(ouya)/i,
          // Ouya
          /(nintendo) ([wids3utch]+)/i
          // Nintendo
        ],
        [k, E, [L, T]],
        [
          /droid.+; (shield) bui/i
          // Nvidia
        ],
        [E, [k, "Nvidia"], [L, T]],
        [
          /(playstation [345portablevi]+)/i
          // Playstation
        ],
        [E, [k, ze], [L, T]],
        [
          /\b(xbox(?: one)?(?!; xbox))[\); ]/i
          // Microsoft Xbox
        ],
        [E, [k, ot], [L, T]],
        [
          ///////////////////
          // SMARTTVS
          ///////////////////
          /smart-tv.+(samsung)/i
          // Samsung
        ],
        [k, [L, w]],
        [
          /hbbtv.+maple;(\d+)/i
        ],
        [[E, /^/, "SmartTV"], [k, Ot], [L, w]],
        [
          /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i
          // LG SmartTV
        ],
        [[k, ft], [L, w]],
        [
          /(apple) ?tv/i
          // Apple TV
        ],
        [k, [E, q + " TV"], [L, w]],
        [
          /crkey/i
          // Google Chromecast
        ],
        [[E, Ne + "cast"], [k, Ce], [L, w]],
        [
          /droid.+aft(\w)( bui|\))/i
          // Fire TV
        ],
        [E, [k, G], [L, w]],
        [
          /\(dtv[\);].+(aquos)/i
          // Sharp
        ],
        [E, [k, "Sharp"], [L, w]],
        [
          /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,
          // Roku
          /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i
          // HbbTV devices
        ],
        [[k, St], [E, St], [L, w]],
        [
          /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i
          // SmartTV from Unidentified Vendors
        ],
        [[L, w]],
        [
          ///////////////////
          // WEARABLES
          ///////////////////
          /((pebble))app/i
          // Pebble
        ],
        [k, E, [L, B]],
        [
          /droid.+; (glass) \d/i
          // Google Glass
        ],
        [E, [k, Ce], [L, B]],
        [
          /droid.+; (wt63?0{2,3})\)/i
        ],
        [E, [k, $], [L, B]],
        [
          /(quest( 2)?)/i
          // Oculus Quest
        ],
        [E, [k, It], [L, B]],
        [
          ///////////////////
          // EMBEDDED
          ///////////////////
          /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i
          // Tesla
        ],
        [k, [L, N]],
        [
          ////////////////////
          // MIXED (GENERIC)
          ///////////////////
          /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i
          // Android Phones from Unidentified Vendors
        ],
        [E, [L, R]],
        [
          /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i
          // Android Tablets from Unidentified Vendors
        ],
        [E, [L, x]],
        [
          /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i
          // Unidentifiable Tablet
        ],
        [[L, x]],
        [
          /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i
          // Unidentifiable Mobile
        ],
        [[L, R]],
        [
          /(android[-\w\. ]{0,9});.+buil/i
          // Generic Android Device
        ],
        [E, [k, "Generic"]]
      ],
      engine: [
        [
          /windows.+ edge\/([\w\.]+)/i
          // EdgeHTML
        ],
        [g, [b, qe + "HTML"]],
        [
          /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i
          // Blink
        ],
        [g, [b, "Blink"]],
        [
          /(presto)\/([\w\.]+)/i,
          // Presto
          /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i,
          // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
          /ekioh(flow)\/([\w\.]+)/i,
          // Flow
          /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,
          // KHTML/Tasman/Links
          /(icab)[\/ ]([23]\.[\d\.]+)/i
          // iCab
        ],
        [b, g],
        [
          /rv\:([\w\.]{1,9})\b.+(gecko)/i
          // Gecko
        ],
        [g, b]
      ],
      os: [
        [
          // Windows
          /microsoft (windows) (vista|xp)/i
          // Windows (iTunes)
        ],
        [b, g],
        [
          /(windows) nt 6\.2; (arm)/i,
          // Windows RT
          /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,
          // Windows Phone
          /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
        ],
        [b, [g, kt, J]],
        [
          /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
        ],
        [[b, "Windows"], [g, kt, J]],
        [
          // iOS/macOS
          /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,
          // iOS
          /cfnetwork\/.+darwin/i
        ],
        [[g, /_/g, "."], [b, "iOS"]],
        [
          /(mac os x) ?([\w\. ]*)/i,
          /(macintosh|mac_powerpc\b)(?!.+haiku)/i
          // Mac OS
        ],
        [[b, "Mac OS"], [g, /_/g, "."]],
        [
          // Mobile OSes
          /droid ([\w\.]+)\b.+(android[- ]x86)/i
          // Android-x86
        ],
        [g, b],
        [
          // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
          /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
          /(blackberry)\w*\/([\w\.]*)/i,
          // Blackberry
          /(tizen|kaios)[\/ ]([\w\.]+)/i,
          // Tizen/KaiOS
          /\((series40);/i
          // Series 40
        ],
        [b, g],
        [
          /\(bb(10);/i
          // BlackBerry 10
        ],
        [g, [b, bt]],
        [
          /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i
          // Symbian
        ],
        [g, [b, "Symbian"]],
        [
          /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i
          // Firefox OS
        ],
        [g, [b, We + " OS"]],
        [
          /web0s;.+rt(tv)/i,
          /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i
          // WebOS
        ],
        [g, [b, "webOS"]],
        [
          // Google Chromecast
          /crkey\/([\d\.]+)/i
          // Google Chromecast
        ],
        [g, [b, Ne + "cast"]],
        [
          /(cros) [\w]+ ([\w\.]+\w)/i
          // Chromium OS
        ],
        [[b, "Chromium OS"], g],
        [
          // Console
          /(nintendo|playstation) ([wids345portablevuch]+)/i,
          // Nintendo/Playstation
          /(xbox); +xbox ([^\);]+)/i,
          // Microsoft Xbox (360, One, X, S, Series X, Series S)
          // Other
          /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,
          // Joli/Palm
          /(mint)[\/\(\) ]?(\w*)/i,
          // Mint
          /(mageia|vectorlinux)[; ]/i,
          // Mageia/VectorLinux
          /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
          // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
          /(hurd|linux) ?([\w\.]*)/i,
          // Hurd/Linux
          /(gnu) ?([\w\.]*)/i,
          // GNU
          /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i,
          // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
          /(haiku) (\w+)/i
          // Haiku
        ],
        [b, g],
        [
          /(sunos) ?([\w\.\d]*)/i
          // Solaris
        ],
        [[b, "Solaris"], g],
        [
          /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,
          // Solaris
          /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,
          // AIX
          /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,
          // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
          /(unix) ?([\w\.]*)/i
          // UNIX
        ],
        [b, g]
      ]
    }, pe = function(ae, he) {
      if (typeof ae === D && (he = ae, ae = c), !(this instanceof pe))
        return new pe(ae, he).getResult();
      var te = ae || (typeof o !== y && o.navigator && o.navigator.userAgent ? o.navigator.userAgent : _), Se = he ? X(ei, he) : ei;
      return this.getBrowser = function() {
        var ie = {};
        return ie[b] = c, ie[g] = c, Ze.call(ie, te, Se.browser), ie.major = Rt(ie.version), ie;
      }, this.getCPU = function() {
        var ie = {};
        return ie[H] = c, Ze.call(ie, te, Se.cpu), ie;
      }, this.getDevice = function() {
        var ie = {};
        return ie[k] = c, ie[E] = c, ie[L] = c, Ze.call(ie, te, Se.device), ie;
      }, this.getEngine = function() {
        var ie = {};
        return ie[b] = c, ie[g] = c, Ze.call(ie, te, Se.engine), ie;
      }, this.getOS = function() {
        var ie = {};
        return ie[b] = c, ie[g] = c, Ze.call(ie, te, Se.os), ie;
      }, this.getResult = function() {
        return {
          ua: this.getUA(),
          browser: this.getBrowser(),
          engine: this.getEngine(),
          os: this.getOS(),
          device: this.getDevice(),
          cpu: this.getCPU()
        };
      }, this.getUA = function() {
        return te;
      }, this.setUA = function(ie) {
        return te = typeof ie === A && ie.length > K ? St(ie, K) : ie, this;
      }, this.setUA(te), this;
    };
    pe.VERSION = d, pe.BROWSER = De([b, g, S]), pe.CPU = De([H]), pe.DEVICE = De([E, k, L, T, R, w, x, B, N]), pe.ENGINE = pe.OS = De([b, g]), e.exports && (i = e.exports = pe), i.UAParser = pe;
    var Je = typeof o !== y && (o.jQuery || o.Zepto);
    if (Je && !Je.ua) {
      var Ct = new pe();
      Je.ua = Ct.getResult(), Je.ua.get = function() {
        return Ct.getUA();
      }, Je.ua.set = function(ae) {
        Ct.setUA(ae);
        var he = Ct.getResult();
        for (var te in he)
          Je.ua[te] = he[te];
      };
    }
  })(typeof window == "object" ? window : mr);
})(yl, Pi);
const El = Pi;
function Tl() {
  const e = new xr();
  I.level(e.read("kwai-player-log"));
}
Tl();
let Ei = 0;
function bl() {
  return Ei = Ei ? Ei + 1 : Date.now(), `c-${Ei}`;
}
const Ge = El(), Ui = Ge.os.name, Rl = Ui && Ui.toLowerCase().indexOf("android") >= 0, Sl = Ui && Ui.toLowerCase().indexOf("ios") >= 0, Wt = Ge.device.type === "mobile" || Rl || Sl, Ki = Oi.EventEmitter;
(function() {
  try {
    if (typeof document != "undefined") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._kwai-player_uxc1a_2{position:relative;margin:0;padding:0}._kwai-player_uxc1a_2 *{margin:0;padding:0}._kwai-player-video-interactive_uxc1a_11{display:block;width:100%;height:100%;position:absolute;top:0;left:0}._kwai-player-poster_uxc1a_19{width:100%;height:100%;position:absolute;left:0;top:0;background-color:#333;background-size:contain;background-position:center;background-repeat:no-repeat}._kwai-player-video_uxc1a_11{display:block;width:100%;height:100%;position:absolute;top:0;left:0}._kwai-player-video_uxc1a_11 video{display:block;width:100%;height:100%}._kwai-player-video_uxc1a_11 canvas{display:block;margin:0 auto;max-width:100%;max-height:100%;position:relative}._kwai-player-disable-scroll_uxc1a_50{overflow:hidden;height:100%}")), document.head.appendChild(e);
    }
  } catch (i) {
    console.error("vite-plugin-css-injected-by-js", i);
  }
})();
var wl = Object.defineProperty, Ll = (e, i, o) => i in e ? wl(e, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[i] = o, V = (e, i, o) => (Ll(e, typeof i != "symbol" ? i + "" : i, o), o), yt = /* @__PURE__ */ ((e) => (e.SYSTEM = "system", e.WINDOW = "window", e))(yt || {}), wi = /* @__PURE__ */ ((e) => (e.VIDEO = "video", e.VIDEO_INTERACTIVE = "videoInteractive", e.DEFAULT = "default", e))(wi || {}), Sa = /* @__PURE__ */ ((e) => (e.NONE = "none", e.KWAI = "kwai", e.GENERAL = "general", e))(Sa || {}), P = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.MANIFEST_PARSED = "manifestparsed", e.LEVEL_SWITCHING = "levelswitching", e.LEVEL_SWITCHED = "levelswitched", e.LEVEL_SWITCH_PLAYING = "levelswitchplaying", e.LEVEL_SWITCH_FAILED = "levelswitchfailed", e.LEVEL_UPDATED = "levelupdated", e.AUDIO_TRACKS_SWITCHING = "audiotrackswitching", e.AUDIO_TRACKS_SWITCHED = "audiotrackswitched", e.LOADSTART = "loadstart", e.PROGRESS = "progress", e.SUSPEND = "suspend", e.ABORT = "abort", e.EMPTIED = "emptied", e.STALLED = "stalled", e.LOADEDMETADATA = "loadedmetadata", e.LOADEDDATA = "loadeddata", e.CANPLAY = "canplay", e.CANPLAYTHROUGH = "canplaythrough", e.PLAYING = "playing", e.WAITING = "waiting", e.SEEKING = "seeking", e.SEEKED = "seeked", e.ENDED = "ended", e.DURATIONCHANGE = "durationchange", e.TIMEUPDATE = "timeupdate", e.PLAY = "play", e.PAUSE = "pause", e.RATECHANGE = "ratechange", e.RESIZE = "resize", e.VOLUMECHANGE = "volumechange", e.ENTER_PICTURE_IN_PICTURE = "enterpictureinpicture", e.LEAVE_PICTURE_IN_PICTURE = "leavepictureinpicture", e.REPORT = "report", e.VIDEO_RENDERER_CHANGE = "videorendererchange", e.FULLSCREEN_CHANGE = "fullscreenchange", e.LIVE_SHIFT_CHANGE = "liveshiftchange", e.LIVE_SHIFT_TYPE_CHANGE = "liveshifttypechange", e.ATTRIBUTE_CHANGE_CONFIG = "attribute:change:config", e.ATTRIBUTE_CHANGE_SRC = "attribute:change:src", e.ATTRIBUTE_CHANGE_VIDEO_ID = "attribute:change:videoid", e.ATTRIBUTE_CHANGE_PREVIEW_URL = "attribute:change:previewurl", e.ATTRIBUTE_CHANGE_MASK_URL = "attribute:change:maskurl", e.ATTRIBUTE_CHANGE_CROSS_ORIGIN = "attribute:change:crossorigin", e.ATTRIBUTE_CHANGE_PRELOAD = "attribute:change:preload", e.ATTRIBUTE_CHANGE_CURRENT_TIME = "attribute:change:currenttime", e.ATTRIBUTE_CHANGE_DEFAULT_PLAYBACK_RATE = "attribute:change:defaultplaybackrate", e.ATTRIBUTE_CHANGE_PLAYBACK_RATE = "attribute:change:playbackrate", e.ATTRIBUTE_CHANGE_AUTOPLAY = "attribute:change:autoplay", e.ATTRIBUTE_CHANGE_LOOP = "attribute:change:loop", e.ATTRIBUTE_CHANGE_CONTROLS = "attribute:change:controls", e.ATTRIBUTE_CHANGE_VOLUME = "attribute:change:volume", e.ATTRIBUTE_CHANGE_MUTED = "attribute:change:muted", e.ATTRIBUTE_CHANGE_DEFAULT_MUTED = "attribute:change:defaultmuted", e.ATTRIBUTE_CHANGE_POSTER = "attribute:change:poster", e.ATTRIBUTE_CHANGE_DISABLE_PICTURE_IN_PICTURE = "attribute:change:disablepictureinpicture", e.ATTRIBUTE_CHANGE_PLAYSINLINE = "attribute:change:playsinline", e.ATTRIBUTE_CHANGE_DISABLE_ADAPTIVE = "attribute:change:disableadaptive", e.ATTRIBUTE_CHANGE_DISABLE_DOWNLOAD = "attribute:change:disabledownload", e.ATTRIBUTE_CHANGE_DISABLE_MASK = "attribute:change:disablemask", e.ATTRIBUTE_CHANGE_DISABLE_HOTKEY = "attribute:change:disablehotkey", e.ATTRIBUTE_CHANGE_DISABLE_DANMAKU = "attribute:change:disabledanmaku", e.ATTRIBUTE_CHANGE_DANMAKU_RENDERING = "attribute:change:danmakurendering", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS = "attribute:change:danmakucontrolspos", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS_FULLSCREEN = "attribute:change:danmakucontrolsposfullscreen", e.ATTRIBUTE_CHANGE_CURRENT_LEVEL = "attribute:change:currentlevel", e.ATTRIBUTE_CHANGE_NEXT_LEVEL = "attribute:change:nextlevel", e.ATTRIBUTE_CHANGE_CURRENT_FRAME = "attribute:change:currentframe", e.ATTRIBUTE_CHANGE_AUDIO_TRACK = "attribute:change:audiotrack", e.ATTRIBUTE_CHANGE_PREFETCH = "attribute:change:prefetch", e.ATTRIBUTE_CHANGE_SHOW_PROGRESS = "attribute:change:showprogress", e.ATTRIBUTE_CHANGE_SHOW_TIME = "attribute:change:showtime", e.ATTRIBUTE_CHANGE_SHOW_NEXT = "attribute:change:shownext", e.ATTRIBUTE_CHANGE_SHOW_PREV = "attribute:change:showprev", e.ATTRIBUTE_CHANGE_BIZ_DATA = "attribute:change:bizdata", e.ATTRIBUTE_CHANGE_LIVE_TIME = "attribute:change:livetime", e.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL = "attribute:change:showinfopanel", e.CLICK_NEXT = "clicknext", e.CLICK_PREV = "clickprev", e.CLICK_LOGIN = "clicklogin", e.CLICK_REGISTER = "clickregister", e.CLICK_SEND_DANMAKU = "clicksenddanmaku", e.CLICK_VIP = "clickvip", e))(P || {}), Oe = function(e) {
  var i = {};
  function o(c) {
    if (i[c])
      return i[c].exports;
    var d = i[c] = { i: c, l: !1, exports: {} };
    return e[c].call(d.exports, d, d.exports, o), d.l = !0, d.exports;
  }
  return o.m = e, o.c = i, o.d = function(c, d, _) {
    o.o(c, d) || Object.defineProperty(c, d, { enumerable: !0, get: _ });
  }, o.r = function(c) {
    typeof Symbol < "u" && Symbol.toStringTag && Object.defineProperty(c, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(c, "__esModule", { value: !0 });
  }, o.t = function(c, d) {
    if (1 & d && (c = o(c)), 8 & d || 4 & d && typeof c == "object" && c && c.__esModule)
      return c;
    var _ = /* @__PURE__ */ Object.create(null);
    if (o.r(_), Object.defineProperty(_, "default", { enumerable: !0, value: c }), 2 & d && typeof c != "string")
      for (var v in c)
        o.d(_, v, function(f) {
          return c[f];
        }.bind(null, v));
    return _;
  }, o.n = function(c) {
    var d = c && c.__esModule ? function() {
      return c.default;
    } : function() {
      return c;
    };
    return o.d(d, "a", d), d;
  }, o.o = function(c, d) {
    return Object.prototype.hasOwnProperty.call(c, d);
  }, o.p = "", o(o.s = 17);
}([function(e, i, o) {
  var c = o(9);
  function d(_, v) {
    for (var f = 0; f < v.length; f++) {
      var y = v[f];
      y.enumerable = y.enumerable || !1, y.configurable = !0, "value" in y && (y.writable = !0), Object.defineProperty(_, c(y.key), y);
    }
  }
  e.exports = function(_, v, f) {
    return v && d(_.prototype, v), f && d(_, f), Object.defineProperty(_, "prototype", { writable: !1 }), _;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i) {
  function o() {
    return e.exports = o = Object.assign ? Object.assign.bind() : function(c) {
      for (var d = 1; d < arguments.length; d++) {
        var _ = arguments[d];
        for (var v in _)
          Object.prototype.hasOwnProperty.call(_, v) && (c[v] = _[v]);
      }
      return c;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, o.apply(this, arguments);
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i, o) {
  var c = o(13);
  e.exports = function(d, _) {
    d.prototype = Object.create(_.prototype), d.prototype.constructor = d, c(d, _);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i) {
  e.exports = function(o) {
    if (o === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return o;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i, o) {
  var c = o(15), d = o(16), _ = /^[\x00-\x20\u00a0\u1680\u2000-\u200a\u2028\u2029\u202f\u205f\u3000\ufeff]+/, v = /[\n\r\t]/g, f = /^[A-Za-z][A-Za-z0-9+-.]*:\/\//, y = /:\d+$/, D = /^([a-z][a-z0-9.+-]*:)?(\/\/)?([\\/]+)?([\S\s]*)/i, A = /^[a-zA-Z]:/;
  function S(T) {
    return (T || "").toString().replace(_, "");
  }
  var E = [["#", "hash"], ["?", "query"], function(T, R) {
    return k(R.protocol) ? T.replace(/\\/g, "/") : T;
  }, ["/", "pathname"], ["@", "auth", 1], [NaN, "host", void 0, 1, 1], [/:(\d*)$/, "port", void 0, 1], [NaN, "hostname", void 0, 1, 1]], b = { hash: 1, query: 1 };
  function L(T) {
    var R, x = (typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {}).location || {}, w = {}, B = typeof (T = T || x);
    if (T.protocol === "blob:")
      w = new H(unescape(T.pathname), {});
    else if (B === "string")
      for (R in w = new H(T, {}), b)
        delete w[R];
    else if (B === "object") {
      for (R in T)
        R in b || (w[R] = T[R]);
      w.slashes === void 0 && (w.slashes = f.test(T.href));
    }
    return w;
  }
  function k(T) {
    return T === "file:" || T === "ftp:" || T === "http:" || T === "https:" || T === "ws:" || T === "wss:";
  }
  function g(T, R) {
    T = (T = S(T)).replace(v, ""), R = R || {};
    var x, w = D.exec(T), B = w[1] ? w[1].toLowerCase() : "", N = !!w[2], K = !!w[3], G = 0;
    return N ? K ? (x = w[2] + w[3] + w[4], G = w[2].length + w[3].length) : (x = w[2] + w[4], G = w[2].length) : K ? (x = w[3] + w[4], G = w[3].length) : x = w[4], B === "file:" ? G >= 2 && (x = x.slice(2)) : k(B) ? x = w[4] : B ? N && (x = x.slice(2)) : G >= 2 && k(R.protocol) && (x = w[4]), { protocol: B, slashes: N || k(B), slashesCount: G, rest: x };
  }
  function H(T, R, x) {
    if (T = (T = S(T)).replace(v, ""), !(this instanceof H))
      return new H(T, R, x);
    var w, B, N, K, G, q, be = E.slice(), bt = typeof R, W = this, Ne = 0;
    for (bt !== "object" && bt !== "string" && (x = R, R = null), x && typeof x != "function" && (x = d.parse), w = !(B = g(T || "", R = L(R))).protocol && !B.slashes, W.slashes = B.slashes || w && R.slashes, W.protocol = B.protocol || R.protocol || "", T = B.rest, (B.protocol === "file:" && (B.slashesCount !== 2 || A.test(T)) || !B.slashes && (B.protocol || B.slashesCount < 2 || !k(W.protocol))) && (be[3] = [/(.*)/, "pathname"]); Ne < be.length; Ne++)
      typeof (K = be[Ne]) != "function" ? (N = K[0], q = K[1], N != N ? W[q] = T : typeof N == "string" ? ~(G = N === "@" ? T.lastIndexOf(N) : T.indexOf(N)) && (typeof K[2] == "number" ? (W[q] = T.slice(0, G), T = T.slice(G + K[2])) : (W[q] = T.slice(G), T = T.slice(0, G))) : (G = N.exec(T)) && (W[q] = G[1], T = T.slice(0, G.index)), W[q] = W[q] || w && K[3] && R[q] || "", K[4] && (W[q] = W[q].toLowerCase())) : T = K(T, W);
    x && (W.query = x(W.query)), w && R.slashes && W.pathname.charAt(0) !== "/" && (W.pathname !== "" || R.pathname !== "") && (W.pathname = function(qe, We) {
      if (qe === "")
        return We;
      for (var Ce = (We || "/").split("/").slice(0, -1).concat(qe.split("/")), Ke = Ce.length, ft = Ce[Ke - 1], ot = !1, ye = 0; Ke--; )
        Ce[Ke] === "." ? Ce.splice(Ke, 1) : Ce[Ke] === ".." ? (Ce.splice(Ke, 1), ye++) : ye && (Ke === 0 && (ot = !0), Ce.splice(Ke, 1), ye--);
      return ot && Ce.unshift(""), ft !== "." && ft !== ".." || Ce.push(""), Ce.join("/");
    }(W.pathname, R.pathname)), W.pathname.charAt(0) !== "/" && k(W.protocol) && (W.pathname = "/" + W.pathname), c(W.port, W.protocol) || (W.host = W.hostname, W.port = ""), W.username = W.password = "", W.auth && (~(G = W.auth.indexOf(":")) ? (W.username = W.auth.slice(0, G), W.username = encodeURIComponent(decodeURIComponent(W.username)), W.password = W.auth.slice(G + 1), W.password = encodeURIComponent(decodeURIComponent(W.password))) : W.username = encodeURIComponent(decodeURIComponent(W.auth)), W.auth = W.password ? W.username + ":" + W.password : W.username), W.origin = W.protocol !== "file:" && k(W.protocol) && W.host ? W.protocol + "//" + W.host : "null", W.href = W.toString();
  }
  H.prototype = { set: function(T, R, x) {
    var w = this;
    switch (T) {
      case "query":
        typeof R == "string" && R.length && (R = (x || d.parse)(R)), w[T] = R;
        break;
      case "port":
        w[T] = R, c(R, w.protocol) ? R && (w.host = w.hostname + ":" + R) : (w.host = w.hostname, w[T] = "");
        break;
      case "hostname":
        w[T] = R, w.port && (R += ":" + w.port), w.host = R;
        break;
      case "host":
        w[T] = R, y.test(R) ? (R = R.split(":"), w.port = R.pop(), w.hostname = R.join(":")) : (w.hostname = R, w.port = "");
        break;
      case "protocol":
        w.protocol = R.toLowerCase(), w.slashes = !x;
        break;
      case "pathname":
      case "hash":
        if (R) {
          var B = T === "pathname" ? "/" : "#";
          w[T] = R.charAt(0) !== B ? B + R : R;
        } else
          w[T] = R;
        break;
      case "username":
      case "password":
        w[T] = encodeURIComponent(R);
        break;
      case "auth":
        var N = R.indexOf(":");
        ~N ? (w.username = R.slice(0, N), w.username = encodeURIComponent(decodeURIComponent(w.username)), w.password = R.slice(N + 1), w.password = encodeURIComponent(decodeURIComponent(w.password))) : w.username = encodeURIComponent(decodeURIComponent(R));
    }
    for (var K = 0; K < E.length; K++) {
      var G = E[K];
      G[4] && (w[G[1]] = w[G[1]].toLowerCase());
    }
    return w.auth = w.password ? w.username + ":" + w.password : w.username, w.origin = w.protocol !== "file:" && k(w.protocol) && w.host ? w.protocol + "//" + w.host : "null", w.href = w.toString(), w;
  }, toString: function(T) {
    T && typeof T == "function" || (T = d.stringify);
    var R, x = this, w = x.host, B = x.protocol;
    B && B.charAt(B.length - 1) !== ":" && (B += ":");
    var N = B + (x.protocol && x.slashes || k(x.protocol) ? "//" : "");
    return x.username ? (N += x.username, x.password && (N += ":" + x.password), N += "@") : x.password ? (N += ":" + x.password, N += "@") : x.protocol !== "file:" && k(x.protocol) && !w && x.pathname !== "/" && (N += "@"), (w[w.length - 1] === ":" || y.test(x.hostname) && !x.port) && (w += ":"), N += w + x.pathname, (R = typeof x.query == "object" ? T(x.query) : x.query) && (N += R.charAt(0) !== "?" ? "?" + R : R), x.hash && (N += x.hash), N;
  } }, H.extractProtocol = g, H.location = L, H.trimLeft = S, H.qs = d, e.exports = H;
}, function(e, i) {
  e.exports = void 0;
}, function(e, i, o) {
  var c, d, _, v, f;
  c = /^(?=((?:[a-zA-Z0-9+\-.]+:)?))\1(?=((?:\/\/[^\/?#]*)?))\2(?=((?:(?:[^?#\/]*\/)*[^;?#\/]*)?))\3((?:;[^?#]*)?)(\?[^#]*)?(#[^]*)?$/, d = /^(?=([^\/?#]*))\1([^]*)$/, _ = /(?:\/|^)\.(?=\/)/g, v = /(?:\/|^)\.\.\/(?!\.\.\/)[^\/]*(?=\/)/g, f = { buildAbsoluteURL: function(y, D, A) {
    if (A = A || {}, y = y.trim(), !(D = D.trim())) {
      if (!A.alwaysNormalize)
        return y;
      var S = f.parseURL(y);
      if (!S)
        throw new Error("Error trying to parse base URL.");
      return S.path = f.normalizePath(S.path), f.buildURLFromParts(S);
    }
    var E = f.parseURL(D);
    if (!E)
      throw new Error("Error trying to parse relative URL.");
    if (E.scheme)
      return A.alwaysNormalize ? (E.path = f.normalizePath(E.path), f.buildURLFromParts(E)) : D;
    var b = f.parseURL(y);
    if (!b)
      throw new Error("Error trying to parse base URL.");
    if (!b.netLoc && b.path && b.path[0] !== "/") {
      var L = d.exec(b.path);
      b.netLoc = L[1], b.path = L[2];
    }
    b.netLoc && !b.path && (b.path = "/");
    var k = { scheme: b.scheme, netLoc: E.netLoc, path: null, params: E.params, query: E.query, fragment: E.fragment };
    if (!E.netLoc && (k.netLoc = b.netLoc, E.path[0] !== "/"))
      if (E.path) {
        var g = b.path, H = g.substring(0, g.lastIndexOf("/") + 1) + E.path;
        k.path = f.normalizePath(H);
      } else
        k.path = b.path, E.params || (k.params = b.params, E.query || (k.query = b.query));
    return k.path === null && (k.path = A.alwaysNormalize ? f.normalizePath(E.path) : E.path), f.buildURLFromParts(k);
  }, parseURL: function(y) {
    var D = c.exec(y);
    return D ? { scheme: D[1] || "", netLoc: D[2] || "", path: D[3] || "", params: D[4] || "", query: D[5] || "", fragment: D[6] || "" } : null;
  }, normalizePath: function(y) {
    for (y = y.split("").reverse().join("").replace(_, ""); y.length !== (y = y.replace(v, "")).length; )
      ;
    return y.split("").reverse().join("");
  }, buildURLFromParts: function(y) {
    return y.scheme + y.netLoc + y.path + y.params + y.query + y.fragment;
  } }, e.exports = f;
}, function(e, i, o) {
  var c, d = typeof Reflect == "object" ? Reflect : null, _ = d && typeof d.apply == "function" ? d.apply : function(T, R, x) {
    return Function.prototype.apply.call(T, R, x);
  };
  c = d && typeof d.ownKeys == "function" ? d.ownKeys : Object.getOwnPropertySymbols ? function(T) {
    return Object.getOwnPropertyNames(T).concat(Object.getOwnPropertySymbols(T));
  } : function(T) {
    return Object.getOwnPropertyNames(T);
  };
  var v = Number.isNaN || function(T) {
    return T != T;
  };
  function f() {
    f.init.call(this);
  }
  e.exports = f, e.exports.once = function(T, R) {
    return new Promise(function(x, w) {
      function B(K) {
        T.removeListener(R, N), w(K);
      }
      function N() {
        typeof T.removeListener == "function" && T.removeListener("error", B), x([].slice.call(arguments));
      }
      H(T, R, N, { once: !0 }), R !== "error" && function(K, G, q) {
        typeof K.on == "function" && H(K, "error", G, q);
      }(T, B, { once: !0 });
    });
  }, f.EventEmitter = f, f.prototype._events = void 0, f.prototype._eventsCount = 0, f.prototype._maxListeners = void 0;
  var y = 10;
  function D(T) {
    if (typeof T != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof T);
  }
  function A(T) {
    return T._maxListeners === void 0 ? f.defaultMaxListeners : T._maxListeners;
  }
  function S(T, R, x, w) {
    var B, N, K, G;
    if (D(x), (N = T._events) === void 0 ? (N = T._events = /* @__PURE__ */ Object.create(null), T._eventsCount = 0) : (N.newListener !== void 0 && (T.emit("newListener", R, x.listener ? x.listener : x), N = T._events), K = N[R]), K === void 0)
      K = N[R] = x, ++T._eventsCount;
    else if (typeof K == "function" ? K = N[R] = w ? [x, K] : [K, x] : w ? K.unshift(x) : K.push(x), (B = A(T)) > 0 && K.length > B && !K.warned) {
      K.warned = !0;
      var q = new Error("Possible EventEmitter memory leak detected. " + K.length + " " + String(R) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      q.name = "MaxListenersExceededWarning", q.emitter = T, q.type = R, q.count = K.length, G = q, console && console.warn && console.warn(G);
    }
    return T;
  }
  function E() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function b(T, R, x) {
    var w = { fired: !1, wrapFn: void 0, target: T, type: R, listener: x }, B = E.bind(w);
    return B.listener = x, w.wrapFn = B, B;
  }
  function L(T, R, x) {
    var w = T._events;
    if (w === void 0)
      return [];
    var B = w[R];
    return B === void 0 ? [] : typeof B == "function" ? x ? [B.listener || B] : [B] : x ? function(N) {
      for (var K = new Array(N.length), G = 0; G < K.length; ++G)
        K[G] = N[G].listener || N[G];
      return K;
    }(B) : g(B, B.length);
  }
  function k(T) {
    var R = this._events;
    if (R !== void 0) {
      var x = R[T];
      if (typeof x == "function")
        return 1;
      if (x !== void 0)
        return x.length;
    }
    return 0;
  }
  function g(T, R) {
    for (var x = new Array(R), w = 0; w < R; ++w)
      x[w] = T[w];
    return x;
  }
  function H(T, R, x, w) {
    if (typeof T.on == "function")
      w.once ? T.once(R, x) : T.on(R, x);
    else {
      if (typeof T.addEventListener != "function")
        throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof T);
      T.addEventListener(R, function B(N) {
        w.once && T.removeEventListener(R, B), x(N);
      });
    }
  }
  Object.defineProperty(f, "defaultMaxListeners", { enumerable: !0, get: function() {
    return y;
  }, set: function(T) {
    if (typeof T != "number" || T < 0 || v(T))
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + T + ".");
    y = T;
  } }), f.init = function() {
    this._events !== void 0 && this._events !== Object.getPrototypeOf(this)._events || (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, f.prototype.setMaxListeners = function(T) {
    if (typeof T != "number" || T < 0 || v(T))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + T + ".");
    return this._maxListeners = T, this;
  }, f.prototype.getMaxListeners = function() {
    return A(this);
  }, f.prototype.emit = function(T) {
    for (var R = [], x = 1; x < arguments.length; x++)
      R.push(arguments[x]);
    var w = T === "error", B = this._events;
    if (B !== void 0)
      w = w && B.error === void 0;
    else if (!w)
      return !1;
    if (w) {
      var N;
      if (R.length > 0 && (N = R[0]), N instanceof Error)
        throw N;
      var K = new Error("Unhandled error." + (N ? " (" + N.message + ")" : ""));
      throw K.context = N, K;
    }
    var G = B[T];
    if (G === void 0)
      return !1;
    if (typeof G == "function")
      _(G, this, R);
    else {
      var q = G.length, be = g(G, q);
      for (x = 0; x < q; ++x)
        _(be[x], this, R);
    }
    return !0;
  }, f.prototype.addListener = function(T, R) {
    return S(this, T, R, !1);
  }, f.prototype.on = f.prototype.addListener, f.prototype.prependListener = function(T, R) {
    return S(this, T, R, !0);
  }, f.prototype.once = function(T, R) {
    return D(R), this.on(T, b(this, T, R)), this;
  }, f.prototype.prependOnceListener = function(T, R) {
    return D(R), this.prependListener(T, b(this, T, R)), this;
  }, f.prototype.removeListener = function(T, R) {
    var x, w, B, N, K;
    if (D(R), (w = this._events) === void 0)
      return this;
    if ((x = w[T]) === void 0)
      return this;
    if (x === R || x.listener === R)
      --this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete w[T], w.removeListener && this.emit("removeListener", T, x.listener || R));
    else if (typeof x != "function") {
      for (B = -1, N = x.length - 1; N >= 0; N--)
        if (x[N] === R || x[N].listener === R) {
          K = x[N].listener, B = N;
          break;
        }
      if (B < 0)
        return this;
      B === 0 ? x.shift() : function(G, q) {
        for (; q + 1 < G.length; q++)
          G[q] = G[q + 1];
        G.pop();
      }(x, B), x.length === 1 && (w[T] = x[0]), w.removeListener !== void 0 && this.emit("removeListener", T, K || R);
    }
    return this;
  }, f.prototype.off = f.prototype.removeListener, f.prototype.removeAllListeners = function(T) {
    var R, x, w;
    if ((x = this._events) === void 0)
      return this;
    if (x.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : x[T] !== void 0 && (--this._eventsCount == 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete x[T]), this;
    if (arguments.length === 0) {
      var B, N = Object.keys(x);
      for (w = 0; w < N.length; ++w)
        (B = N[w]) !== "removeListener" && this.removeAllListeners(B);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (typeof (R = x[T]) == "function")
      this.removeListener(T, R);
    else if (R !== void 0)
      for (w = R.length - 1; w >= 0; w--)
        this.removeListener(T, R[w]);
    return this;
  }, f.prototype.listeners = function(T) {
    return L(this, T, !0);
  }, f.prototype.rawListeners = function(T) {
    return L(this, T, !1);
  }, f.listenerCount = function(T, R) {
    return typeof T.listenerCount == "function" ? T.listenerCount(R) : k.call(T, R);
  }, f.prototype.listenerCount = k, f.prototype.eventNames = function() {
    return this._eventsCount > 0 ? c(this._events) : [];
  };
}, function(e, i, o) {
  var c = o(9);
  e.exports = function(d, _, v) {
    return (_ = c(_)) in d ? Object.defineProperty(d, _, { value: v, enumerable: !0, configurable: !0, writable: !0 }) : d[_] = v, d;
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i, o) {
  var c = o(10).default, d = o(12);
  e.exports = function(_) {
    var v = d(_, "string");
    return c(v) === "symbol" ? v : String(v);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i) {
  function o(c) {
    return e.exports = o = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(d) {
      return typeof d;
    } : function(d) {
      return d && typeof Symbol == "function" && d.constructor === Symbol && d !== Symbol.prototype ? "symbol" : typeof d;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, o(c);
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i, o) {
  function c(f) {
    var y = {};
    function D(S) {
      if (y[S])
        return y[S].exports;
      var E = y[S] = { i: S, l: !1, exports: {} };
      return f[S].call(E.exports, E, E.exports, D), E.l = !0, E.exports;
    }
    D.m = f, D.c = y, D.i = function(S) {
      return S;
    }, D.d = function(S, E, b) {
      D.o(S, E) || Object.defineProperty(S, E, { configurable: !1, enumerable: !0, get: b });
    }, D.r = function(S) {
      Object.defineProperty(S, "__esModule", { value: !0 });
    }, D.n = function(S) {
      var E = S && S.__esModule ? function() {
        return S.default;
      } : function() {
        return S;
      };
      return D.d(E, "a", E), E;
    }, D.o = function(S, E) {
      return Object.prototype.hasOwnProperty.call(S, E);
    }, D.p = "/", D.oe = function(S) {
      throw console.error(S), S;
    };
    var A = D(D.s = ENTRY_MODULE);
    return A.default || A;
  }
  function d(f) {
    return (f + "").replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
  }
  function _(f, y, D) {
    var A = {};
    A[D] = [];
    var S = y.toString(), E = S.match(/^function\s?\w*\(\w+,\s*\w+,\s*(\w+)\)/);
    if (!E)
      return A;
    for (var b, L = E[1], k = new RegExp("(\\\\n|\\W)" + d(L) + "\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)", "g"); b = k.exec(S); )
      b[3] !== "dll-reference" && A[D].push(b[3]);
    for (k = new RegExp("\\(" + d(L) + '\\("(dll-reference\\s([\\.|\\-|\\+|\\w|/|@]+))"\\)\\)\\(\\s*(/\\*.*?\\*/)?\\s*.*?([\\.|\\-|\\+|\\w|/|@]+).*?\\)', "g"); b = k.exec(S); )
      f[b[2]] || (A[D].push(b[1]), f[b[2]] = o(b[1]).m), A[b[2]] = A[b[2]] || [], A[b[2]].push(b[4]);
    for (var g, H = Object.keys(A), T = 0; T < H.length; T++)
      for (var R = 0; R < A[H[T]].length; R++)
        g = A[H[T]][R], isNaN(1 * g) || (A[H[T]][R] = 1 * A[H[T]][R]);
    return A;
  }
  function v(f) {
    return Object.keys(f).reduce(function(y, D) {
      return y || f[D].length > 0;
    }, !1);
  }
  e.exports = function(f, y) {
    y = y || {};
    var D = { main: o.m }, A = y.all ? { main: Object.keys(D.main) } : function(k, g) {
      for (var H = { main: [g] }, T = { main: [] }, R = { main: {} }; v(H); )
        for (var x = Object.keys(H), w = 0; w < x.length; w++) {
          var B = x[w], N = H[B].pop();
          if (R[B] = R[B] || {}, !R[B][N] && k[B][N]) {
            R[B][N] = !0, T[B] = T[B] || [], T[B].push(N);
            for (var K = _(k, k[B][N], B), G = Object.keys(K), q = 0; q < G.length; q++)
              H[G[q]] = H[G[q]] || [], H[G[q]] = H[G[q]].concat(K[G[q]]);
          }
        }
      return T;
    }(D, f), S = "";
    Object.keys(A).filter(function(k) {
      return k !== "main";
    }).forEach(function(k) {
      for (var g = 0; A[k][g]; )
        g++;
      A[k].push(g), D[k][g] = "(function(module, exports, __webpack_require__) { module.exports = __webpack_require__; })", S = S + "var " + k + " = (" + c.toString().replace("ENTRY_MODULE", JSON.stringify(g)) + ")({" + A[k].map(function(H) {
        return JSON.stringify(H) + ": " + D[k][H].toString();
      }).join(",") + `});
`;
    }), S = S + "new ((" + c.toString().replace("ENTRY_MODULE", JSON.stringify(f)) + ")({" + A.main.map(function(k) {
      return JSON.stringify(k) + ": " + D.main[k].toString();
    }).join(",") + "}))(self);";
    var E = new window.Blob([S], { type: "text/javascript" });
    if (y.bare)
      return E;
    var b = (window.URL || window.webkitURL || window.mozURL || window.msURL).createObjectURL(E), L = new window.Worker(b);
    return L.objectURL = b, L;
  };
}, function(e, i, o) {
  var c = o(10).default;
  e.exports = function(d, _) {
    if (c(d) !== "object" || d === null)
      return d;
    var v = d[Symbol.toPrimitive];
    if (v !== void 0) {
      var f = v.call(d, _ || "default");
      if (c(f) !== "object")
        return f;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (_ === "string" ? String : Number)(d);
  }, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i) {
  function o(c, d) {
    return e.exports = o = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(_, v) {
      return _.__proto__ = v, _;
    }, e.exports.__esModule = !0, e.exports.default = e.exports, o(c, d);
  }
  e.exports = o, e.exports.__esModule = !0, e.exports.default = e.exports;
}, function(e, i) {
  Number.isFinite || (Number.isFinite = function(o) {
    return typeof o == "number" && isFinite(o);
  }), Number.MAX_SAFE_INTEGER || (Number.MAX_SAFE_INTEGER = Math.pow(2, 53) - 1), Object.values || (Object.values = function(o) {
    if (o == null)
      throw new TypeError("Cannot convert undefined or null to object");
    var c = [];
    for (var d in o)
      Object.prototype.hasOwnProperty.call(o, d) && c.push(o[d]);
    return c;
  });
}, function(e, i, o) {
  e.exports = function(c, d) {
    if (d = d.split(":")[0], !(c = +c))
      return !1;
    switch (d) {
      case "http":
      case "ws":
        return c !== 80;
      case "https":
      case "wss":
        return c !== 443;
      case "ftp":
        return c !== 21;
      case "gopher":
        return c !== 70;
      case "file":
        return !1;
    }
    return c !== 0;
  };
}, function(e, i, o) {
  var c = Object.prototype.hasOwnProperty;
  function d(v) {
    try {
      return decodeURIComponent(v.replace(/\+/g, " "));
    } catch (f) {
      return null;
    }
  }
  function _(v) {
    try {
      return encodeURIComponent(v);
    } catch (f) {
      return null;
    }
  }
  i.stringify = function(v, f) {
    f = f || "";
    var y, D, A = [];
    for (D in typeof f != "string" && (f = "?"), v)
      if (c.call(v, D)) {
        if ((y = v[D]) || y != null && !isNaN(y) || (y = ""), D = _(D), y = _(y), D === null || y === null)
          continue;
        A.push(D + "=" + y);
      }
    return A.length ? f + A.join("&") : "";
  }, i.parse = function(v) {
    for (var f, y = /([^=?#&]+)=?([^&]*)/g, D = {}; f = y.exec(v); ) {
      var A = d(f[1]), S = d(f[2]);
      A === null || S === null || A in D || (D[A] = S);
    }
    return D;
  };
}, function(e, i, o) {
  o.r(i), o.d(i, "default", function() {
    return xn;
  }), o.d(i, "createKernel", function() {
    return Is;
  }), o.d(i, "CodecType", function() {
    return A;
  }), o.d(i, "Decoder", function() {
    return L;
  }), o.d(i, "DemuxerType", function() {
    return Ze;
  }), o.d(i, "DownloadStatus", function() {
    return Co;
  }), o.d(i, "HttpRangeType", function() {
    return x;
  }), o.d(i, "KEvents", function() {
    return F;
  }), o.d(i, "LogLevel", function() {
    return ke;
  }), o.d(i, "LiveShiftType", function() {
    return q;
  }), o.d(i, "MediaBox", function() {
    return g;
  }), o.d(i, "ReportTypes", function() {
    return et;
  }), o.d(i, "StereoType", function() {
    return K;
  }), o.d(i, "VideoDecBlockPolicy", function() {
    return R;
  }), o.d(i, "VideoDropFramePolicy", function() {
    return T;
  }), o.d(i, "VideoRendererType", function() {
    return b;
  }), o.d(i, "WasmDecoder", function() {
    return E;
  }), o.d(i, "EventReportTypes", function() {
    return Ee;
  });
  var c = o(1), d = o.n(c), _ = o(0), v = o.n(_), f = o(2), y = o.n(f), D = (o(14), o(7)), A = function(r) {
    return r.unknown = "unknown", r.h264 = "h264", r.hevc = "hevc", r.av1 = "av1", r.kvc3 = "kvc3", r.kvc4 = "kvc4", r.kvc5 = "kvc5", r.kvc6 = "kvc6", r.aac = "aac", r.mp3 = "mp3", r.opus = "opus", r.yuv = "yuv", r.rawvideo = "rawvideo", r.vvc = "vvc", r.bvc2 = "bvc2", r.kvc30 = "kvc30", r;
  }({}), S = function(r) {
    return r.UNKNOWN = "unknown", r.FHD = "fhd", r.UHD_4K = "4k", r;
  }({}), E = function(r) {
    return r.kvc3 = "kvc3", r.kvc4 = "kvc4", r.kvc5 = "kvc5", r.kvc6 = "kvc6", r.h265 = "h265", r.kw265 = "kw265", r.kvc30 = "kvc30", r;
  }({}), b = function(r) {
    return r.video = "video", r.canvas = "canvas", r;
  }({}), L = function(r) {
    return r.buildin = "buildin", r.wasm = "wasm", r.none = "none", r.unsupported = "unsupported", r;
  }({}), k = function(r) {
    return r.KWAI_FLV_ABR = "kwaiFlvAbr", r.KWAI_FLV_MP = "kwaiFlvMultipart", r.KWAI = "kwai", r.FILE = "file", r.OTHERS = "others", r;
  }({}), g = function(r) {
    return r.flv = "flv", r.hls = "hls", r.hls_ts = "hls_ts", r.hls_fmp4 = "hls_fmp4", r.webrtc = "webrtc", r.mp4 = "mp4", r.raw = "raw", r.mp3 = "mp3", r.wav = "wav", r.aac = "aac", r.matroska = "matroska", r.ts = "ts", r.ivf = "ivf", r.yuv = "yuv", r.unknown = "unknown", r;
  }({}), H = function(r) {
    return r.RTC = "rtc_retry", r.BACKUP = "backup", r.FALLBACK = "fallback", r.LOADER = "loader", r;
  }({}), T = function(r) {
    return r.AUTO = "auto", r.ALL_NON_REF = "allNonRef", r.MIN = "min", r;
  }({}), R = function(r) {
    return r.NONE = "none", r.WAITING = "waiting", r;
  }({}), x = function(r) {
    return r.STANDARD = "standard", r.QUERY_START_END = "queryStartEnd", r;
  }({}), w = function(r) {
    return r.MAIN = "main", r.AUDIO = "audio", r.SUBTITLE = "subtitle", r;
  }({}), B = function(r) {
    return r.VIDEO = "video", r.AUDIO = "audio", r;
  }({}), N = function(r) {
    return r.unknown = "unknown", r.native = "native", r.mse = "mse", r.rtc = "rtc", r;
  }({}), K = function(r) {
    return r[r.Normal = 0] = "Normal", r[r.V360 = 1] = "V360", r[r.V180 = 2] = "V180", r;
  }({}), G = function(r) {
    return r[r.normal = 0] = "normal", r[r.internal = 1] = "internal", r[r.retry = 2] = "retry", r;
  }({}), q = function(r) {
    return r.NONE = "none", r.KWAI = "kwai", r.GENERAL = "general", r;
  }({}), be = function(r) {
    return r.UNKNOWN = "", r.PROBABLY = "probably", r;
  }({}), bt = function() {
    function r() {
      var a;
      this._list = [], (a = this._list).push.apply(a, arguments);
    }
    var l = r.prototype;
    return l.push = function() {
      var a;
      (a = this._list).push.apply(a, arguments);
    }, l.destroyItem = function(a) {
      for (var t = 0; t < this._list.length; t++)
        if (this._list[t] === a)
          return this._list.splice(t, 1), void a.destroy();
    }, l.destroy = function() {
      for (; this._list.length; ) {
        var a = this._list.shift();
        a && a.destroy();
      }
    }, v()(r, [{ key: "destroyed", get: function() {
      return !!this._list.length;
    } }]), r;
  }(), W = function() {
    function r() {
      this._destroyableList = new bt();
    }
    return r.prototype.destroy = function() {
      this._destroyableList.destroy();
    }, r;
  }(), Ne = function(r) {
    return r.LOADER_CONNECT_TIMEOUT = "connectTimeout", r.LOADER_TRANS_TIMEOUT = "transTimeout", r;
  }({}), qe = function(r) {
    return r.XHR_ERROR_NAME = "XHRError", r.FETCH_ERROR_NAME = "FetchError", r.FETCH_READ_ERROR_NAME = "ReadError", r.SLICE_UNPACK_ERROR_NAME = "SliceUnpackError", r;
  }({}), We = function(r) {
    return r.UNKNOWN = "unknown", r.FETCH = "fetch", r.XHR = "xhr", r;
  }({});
  function Ce(r, l, a) {
    if (r[l] === void 0)
      r[l] = a;
    else {
      var t = r[l];
      Array.isArray(t) ? t.push(a) : typeof t == "string" && (r[l] = [t, a]);
    }
  }
  function Ke(r) {
    var l = {};
    return typeof r == "string" ? r.trim().split(/[\r\n]+/).forEach(function(a) {
      var t = a.split(": "), n = t.shift(), s = t.join(":");
      n && Ce(l, n, s);
    }) : r && r.forEach(function(a, t) {
      a.split(",").forEach(function(n) {
        Ce(l, t, n);
      });
    }), l;
  }
  function ft(r) {
    var l = [];
    if (r)
      for (var a in r) {
        var t = r[a];
        t && l.push(a + ": " + (Array.isArray(t) ? t.join(",") : t).slice(0, 255));
      }
    if (l.length)
      return l.length > 20 ? (l.sort(function(n, s) {
        return ot(s) - ot(n);
      }), l.slice(0, 20)) : l;
  }
  var ot = function(r) {
    return r.toLowerCase().indexOf("kwaisign") === 0 || r.toLowerCase().indexOf("x-ks-") === 0 ? 1 : 0;
  }, ye = function(r) {
    return r.MOZ_CHUNK = "moz-chunked-arraybuffer", r.UNKNOW = "unknow", r.UNSUPPORT = "", r;
  }({}), Pe = function() {
    function r() {
      var a = this;
      this.tag = "xhr", this._xhr = null, this._context = void 0, this._callbacks = null, this._progress = ye.UNKNOW, this._onReadyStateChange = function() {
        if (a._xhr) {
          var t = a._xhr;
          t.readyState === 2 && (a._context.responseUrl = t.responseURL, a._context.responseHeader = Ke(t.getAllResponseHeaders()), a._callbacks && a._callbacks.onConnect && a._callbacks.onConnect(a._context, t.status), (t.status < 200 || t.status > 299) && a._onError());
        }
      }, this._onProgress = function() {
        if (a._xhr) {
          var t = a._xhr.response;
          a._callbacks && a._callbacks.onProgress && t && a._callbacks.onProgress(a._context, t);
        }
      }, this._onLoadEnd = function() {
        var t = null, n = a._xhr;
        !a._progress && n && (t = n.response), a._callbacks && a._callbacks.onEnd(a._context, t);
      }, this._onError = function() {
        var t;
        if (a._callbacks && a._callbacks.onError) {
          var n = new Error("xhr load error.");
          n.name = qe.XHR_ERROR_NAME, a._callbacks.onError(n);
        }
        (t = a._xhr) == null || t.abort();
      }, this._xhr = null;
    }
    r.isSupportChunk = function() {
      if (r._supportChunk !== ye.UNKNOW)
        return r._supportChunk;
      try {
        var a = new XMLHttpRequest();
        if (a.open("GET", "https://example.com", !0), a.responseType = ye.MOZ_CHUNK, a.responseType === ye.MOZ_CHUNK)
          return r._supportChunk = ye.MOZ_CHUNK, r._supportChunk;
      } catch (t) {
        r._supportChunk = ye.UNSUPPORT;
      }
      return ye.UNSUPPORT;
    };
    var l = r.prototype;
    return l.load = function(a, t) {
      this._callbacks = t, this._context = a, this._progress = ye.UNSUPPORT, a.progress && a.responseType === "arraybuffer" && (this._progress = r.isSupportChunk());
      var n = this._xhr = new XMLHttpRequest();
      n.open(a.requestMethod ? a.requestMethod : "GET", this._context.url, !0), this._progress === ye.MOZ_CHUNK ? (n.responseType = ye.MOZ_CHUNK, n.onprogress = this._onProgress, n.onload = this._onLoadEnd) : (n.responseType = a.responseType || "arraybuffer", n.onload = this._onLoadEnd), n.onreadystatechange = this._onReadyStateChange, n.onerror = this._onError, n.withCredentials = !!a.credentials, a.range && n.setRequestHeader("Range", a.range), a.headers && a.headers.forEach(function(s) {
        n.setRequestHeader(s.header, s.value);
      }), n.send(a.requestBody);
    }, l.abort = function() {
      this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr.abort(), this._xhr = null);
    }, l.destroy = function() {
      this._callbacks = null, this.abort();
    }, r;
  }();
  Pe._supportChunk = ye.UNKNOW;
  var Ot = [g.hls, g.hls_ts, g.hls_fmp4];
  function ze(r) {
    return !!r && Ot.indexOf(r) !== -1;
  }
  var vt = {};
  (function(r) {
    if (typeof navigator < "u") {
      r = r ? r.toLowerCase() : navigator.userAgent.toLowerCase();
      var l = /(edge)\/([\w.]+)/.exec(r) || /(edg)\/([\w.]+)/.exec(r) || /(opr)[\/]([\w.]+)/.exec(r) || /(chrome)[ \/]([\w.]+)/.exec(r) || /(iemobile)[\/]([\w.]+)/.exec(r) || /(version)(applewebkit)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(r) || /(webkit)[ \/]([\w.]+).*(version)[ \/]([\w.]+).*(safari)[ \/]([\w.]+)/.exec(r) || /(webkit)[ \/]([\w.]+)/.exec(r) || /(opera)(?:.*version|)[ \/]([\w.]+)/.exec(r) || /(msie) ([\w.]+)/.exec(r) || r.indexOf("trident") >= 0 && /(rv)(?::| )([\w.]+)/.exec(r) || r.indexOf("compatible") < 0 && /(firefox)[ \/]([\w.]+)/.exec(r) || [], a = /(ipad)/.exec(r) || /(ipod)/.exec(r) || /(windows phone)/.exec(r) || /(iphone)/.exec(r) || /(kindle)/.exec(r) || /(android)/.exec(r) || /(windows)/.exec(r) || /(mac)/.exec(r) || /(linux)/.exec(r) || /(cros)/.exec(r) || [], t = /(?:iphone|ipad|cpu) os (\d+)[._]\d+/.exec(r) || /android ([\d\.]+)/.exec(r) || [], n = { browser: l[5] || l[3] || l[1] || "", version: l[2] || l[4] || "0", majorVersion: l[4] || l[2] || "0", platform: a[0] || "", platformVersion: t[1] || "" }, s = { x5: / tbs\//.test(r), xweb: / xweb\//.test(r) };
      if (n.browser) {
        s[n.browser] = !0;
        var u = n.majorVersion.split(".");
        s.version = { major: parseInt(n.majorVersion, 10), string: n.version }, u.length > 1 && (s.version.minor = parseInt(u[1], 10)), u.length > 2 && (s.version.build = parseInt(u[2], 10));
      }
      n.platform && (s[n.platform] = !0), (s.chrome || s.opr || s.safari) && (s.webkit = !0), (s.rv || s.iemobile) && (s.rv && delete s.rv, n.browser = "msie", s.msie = !0), (s.edg || s.edge) && (delete s.edg, delete s.edge, n.browser = "msedge", s.msedge = !0), s.opr && (n.browser = "opera", s.opera = !0), s.safari && s.android && (n.browser = "android", s.android = !0);
      for (var h in (s.android || s.iphone || s.ipad) && (s.mobile = !0), s.ios = s.iphone || s.ipad, s.name = n.browser, s.platform = n.platform, s.platformVersion = n.platformVersion, vt)
        vt.hasOwnProperty(h) && delete vt[h];
      d()(vt, s);
    }
  })();
  var $ = vt;
  function It(r, l) {
    var a = r.toString();
    return a.toLowerCase().indexOf("[native code]") !== -1 && a.indexOf(l) !== -1 ? be.UNKNOWN : be.PROBABLY;
  }
  var X = function() {
    function r(a) {
      this.tag = "fetch", this._logger = void 0, this._context = void 0, this._callbacks = null, this._controller = null, this._reader = null, this._abort = !1, this._logger = a;
    }
    r.isSupported = function() {
      return typeof fetch < "u" && typeof ReadableStream < "u";
    };
    var l = r.prototype;
    return l.load = function(a, t) {
      var n = this;
      this._context = a, this._callbacks = t;
      var s = new Headers();
      a.headers && a.headers.forEach(function(m) {
        s.append(m.header, m.value);
      }), a.range && s.append("Range", a.range);
      var u = { method: a.requestMethod ? a.requestMethod : "GET", headers: s, mode: "cors", cache: "default", referrerPolicy: "no-referrer-when-downgrade", signal: this._getAbortSignal() };
      a.requestBody && (u.body = a.requestBody), a.credentials && (u.credentials = "include");
      var h = fetch;
      if (a.preferNative === !0) {
        var p = this._getNativeFetch();
        h = p.func, a.monkeyPatched = p.patched, a.useResetNativeFetch = p == null ? void 0 : p.resetNativeFetch;
      } else
        a.monkeyPatched = It(h, "fetch");
      h(a.url, u).then(function(m) {
        if (a.responseUrl = m.url, a.redirected = m.redirected, a.responseHeader = Ke(m.headers), n._callbacks && n._callbacks.onConnect && n._callbacks.onConnect(a, m.status), m.ok)
          return n._abort ? void (m.body && m.body.getReader().cancel().catch(function(U) {
            return n._logger.i(n.tag, U);
          })) : a.responseType === "arraybuffer" ? a.progress ? void (m.body && (n._reader = m.body.getReader(), n._pump(n._reader))) : void m.arrayBuffer().then(function(U) {
            n._onEnd(a, U);
          }).catch(function(U) {
            if (!n._abort) {
              var C = new Error("arraybuffer error. " + m.status + " " + U);
              C.name = qe.FETCH_ERROR_NAME, n._onError(C);
            }
          }) : void m.text().then(function(U) {
            n._onEnd(a, U);
          }).catch(function(U) {
            if (!n._abort) {
              var C = new Error("text error. " + m.status + " " + U);
              C.name = qe.FETCH_ERROR_NAME, n._onError(C);
            }
          });
        var O = new Error("res not ok. " + m.status + " " + m.statusText);
        O.name = qe.FETCH_ERROR_NAME, n._onError(O);
      }).catch(function(m) {
        m.name !== "AbortError" && n._onError(m);
      });
    }, l.abort = function() {
      this._controller && (this._controller.abort(), this._controller = null), this._reader && (this._reader.cancel().catch(function() {
      }), this._reader = null), this._abort = !0;
    }, l.destroy = function() {
      this._callbacks = null, this.abort();
    }, l._onProgress = function(a, t) {
      this._callbacks && this._callbacks.onProgress && this._callbacks.onProgress(a, t);
    }, l._onEnd = function(a, t) {
      this._callbacks && this._callbacks.onEnd && (this._reader = null, this._controller = null, this._callbacks.onEnd(a, t));
    }, l._onError = function(a) {
      this._callbacks && this._callbacks.onError && this._callbacks.onError(a);
    }, l._pump = function(a) {
      var t = this;
      a.read().then(function(n) {
        if (t._abort)
          return a.cancel(), null;
        if (n.done)
          return t._onEnd(t._context, null), null;
        var s = n.value.buffer;
        return t._context.useResetNativeFetch && $.safari && (s = new Uint8Array(new Uint8Array(s).subarray()).buffer), t._onProgress(t._context, s), t._pump(a);
      }).catch(function(n) {
        n.name !== "AbortError" && (n.name = qe.FETCH_READ_ERROR_NAME, t._onError(n));
      });
    }, l._getAbortSignal = function() {
      try {
        if (AbortController)
          return this._controller = new AbortController(), this._controller.signal;
      } catch (a) {
        return null;
      }
      return null;
    }, l._getNativeFetch = function() {
      if (r._nativeFetch !== void 0)
        return r._nativeFetch;
      if (It(fetch, "fetch") === be.PROBABLY) {
        var a = function(t) {
          var n, s, u = document.createElement("iframe");
          document.body.appendChild(u);
          var h = (n = ((s = u.contentWindow) == null ? void 0 : s.fetch) || null) == null ? void 0 : n.bind(t);
          return document.body.removeChild(u), h;
        }(window);
        this._logger.i(this.tag, "detected io monkey patched. get native io, fetch: " + !!a), r._nativeFetch = a ? { func: a, patched: be.PROBABLY, resetNativeFetch: !0 } : { func: fetch, patched: be.PROBABLY, resetNativeFetch: !1 };
      } else
        r._nativeFetch = { func: fetch, patched: be.UNKNOWN, resetNativeFetch: !1 };
      return r._nativeFetch;
    }, r;
  }();
  X._nativeFetch = void 0;
  var De = o(5), Y = o.n(De), Le = { alwaysSeekKeyframe: !1, lazyLoadMaxDuration: -1, lazyLoadRecoverDuration: 20, webWorker: !0, appendErrorMaxRetry: 3, credentials: !1, streamingMux: !0, autoPlaybackRate: !0, autoPlaybackRateConf: void 0, enableSoftwareAES: !0, startPlayBufferSec: 0, startFromSec: 0, startFromKeyframe: !0, defaultSpts: -5e3, resourceBuffer: !0, resourceBufferSize: 500, ntp: !0, ensureVideo: !1, adaptive: !0, abrSpeedTest: !0, httpRangeType: x.STANDARD, enableAacPriv: !1, maxAudioFramesDrift: 5, forceKeyFrameOnDiscontinuity: !1, videoDropFramePolicy: T.AUTO, videoDecBlockPolicy: R.WAITING, videoFrameBufferSize: 536870912, maxVideoDecThreads: 8, mainThreadRendering: !1, mainThreadDecoding: !1, wasmDecoderEnabled: !$.mobile, maxRetry: 3, connectionTimeout: 1e4, transmissionTimeout: 3e4, retryDelay: 100, maxFragFailSec: 11, flvLoadEndError: !0, catchUpPausedLive: !0, breakpointContinuation: !0, manifestLoadingMaxRetry: 3, manifestConnectionTimeout: 1e4, manifestTransmissionTimeout: 1e4, manifestLoadingRetryDelay: 1, levelLoadingMaxRetry: 3, levelConnectionTimeout: 1e4, levelTransmissionTimeout: 1e4, levelLoadingRetryDelay: 100, emeEnabled: !0, widevineLicenseUrl: "", playreadyLicenseUrl: "", fairplayLicenseUrl: "", keyLoadingMaxRetry: 3, keyConnectionTimeout: 1e4, keyTransmissionTimeout: 5e3, keyLoadingRetryDelay: 300, sdpConnectionTimeout: 1e4, peerConnectionTimeout: 1e4, peerConnectionMaxRetry: 5, peerConnectionRetryDelay: 3e3, decLibLoadingMaxRetry: 2, decLibConnectionTimeout: 5e3, decLibLoadingRetryDelay: 300, liveDelayFragNum: 3, liveShiftType: q.NONE, preferNativeLoader: void 0, playbackAbilityCacheTimeout: 864e5 }, Rt = { maxRetry: 1, retryDelay: 100, connectionTimeout: 1e4, levelConnectionTimeout: 1e4, manifestConnectionTimeout: 1e4 }, St = function() {
    function r() {
    }
    return r.isStreamingSupported = function() {
      return r._streamingSupported === void 0 && (r._streamingSupported = X.isSupported() || !!Pe.isSupportChunk()), r._streamingSupported;
    }, r.processConfig = function(l) {
      if (l) {
        var a = l.src, t = l.preprocessUrl, n = l.logger;
        l = d()(JSON.parse(JSON.stringify(l)), { src: a, preprocessUrl: t, logger: n });
      }
      l.isLive ? Le.videoFrameBufferSize = 104857600 : Le.videoFrameBufferSize = 536870912;
      var s = ze(l.box) ? d()({}, Le, Rt) : d()({}, Le);
      return d()(s, l), s.wasmDecoderEnabled = s.wasmDecoderEnabled && !!Y.a, s.startPlayBufferSec = Math.min(5, Math.max(0, s.startPlayBufferSec)), this._initPlayBackRateRule(s), Worker || (s.webWorker = !1), s;
    }, r._initPlayBackRateRule = function(l) {
      var a = l.autoPlaybackRateConf;
      if (a) {
        var t = a.rule;
        if (t && Array.isArray(t) && ((t = t.filter(function(n) {
          return n.upper > n.lower && n.rate > 0;
        })).sort(function(n, s) {
          return s.rate - n.rate;
        }), t.length > 1))
          return a.rule = t, void (l.autoPlaybackRateConf = a);
      }
    }, r;
  }();
  St._streamingSupported = void 0;
  var Ze = function(r) {
    return r.UNKNOWN = "unknown", r.FLV = "flv", r.FMP4 = "fmp4", r.TS = "ts", r.MP4 = "mp4", r.RAW = "raw", r.IVF = "ivf", r.YUV = "yuv", r;
  }({}), kt = function(r) {
    return r.MANIFEST = "manifest", r.LEVEL = "level", r.AUDIO_TRACK = "audioTrack", r.SUBTITLE_TRACK = "subtitleTrack", r;
  }({}), Re = function(r) {
    return r.NETWORK_ERROR = "networkError", r.MEDIA_ERROR = "mediaError", r.KEY_SYSTEM_ERROR = "keySystemError", r.MUX_ERROR = "muxError", r.OTHER_ERROR = "otherError", r.MSE_ERROR = "mseError", r.DECODER_ERROR = "decoderError", r.RENDERER_ERROR = "rendererError", r;
  }({}), J = function(r) {
    return r[r.LOAD_ERROR = 10] = "LOAD_ERROR", r[r.MANIFEST_LOAD_ERROR = 11] = "MANIFEST_LOAD_ERROR", r[r.LEVEL_LOAD_ERROR = 12] = "LEVEL_LOAD_ERROR", r[r.AUDIO_TRACK_LOAD_ERROR = 13] = "AUDIO_TRACK_LOAD_ERROR", r[r.KEY_LOAD_ERROR = 14] = "KEY_LOAD_ERROR", r[r.KEY_SYSTEM_LICENSE_REQUEST_FAILED = 15] = "KEY_SYSTEM_LICENSE_REQUEST_FAILED", r[r.DEC_LIB_LOAD_ERROR = 16] = "DEC_LIB_LOAD_ERROR", r[r.RTC_SDP_LOAD_ERROR = 17] = "RTC_SDP_LOAD_ERROR", r[r.SUBTITLE_TRACK_LOAD_ERROR = 18] = "SUBTITLE_TRACK_LOAD_ERROR", r[r.CANNOT_SEEK = 100] = "CANNOT_SEEK", r[r.VIDEO_ERROR = 101] = "VIDEO_ERROR", r[r.UNSUPPORTED = 102] = "UNSUPPORTED", r[r.CONFIG_ERROR = 103] = "CONFIG_ERROR", r[r.OTHER = 104] = "OTHER", r[r.UNKNOWN = 105] = "UNKNOWN", r[r.CANNOT_SEEK_BY_FRAME_INDEX = 106] = "CANNOT_SEEK_BY_FRAME_INDEX", r[r.SRC_EMPTY = 107] = "SRC_EMPTY", r[r.VIDEO_NO_SIZE = 108] = "VIDEO_NO_SIZE", r[r.VIDEO_ERROR_1 = 111] = "VIDEO_ERROR_1", r[r.VIDEO_ERROR_2 = 112] = "VIDEO_ERROR_2", r[r.VIDEO_ERROR_3 = 113] = "VIDEO_ERROR_3", r[r.VIDEO_ERROR_4 = 114] = "VIDEO_ERROR_4", r[r.MEDIASOURCE_ERROR = 200] = "MEDIASOURCE_ERROR", r[r.ADDSOURCEBUFFER_ERROR = 201] = "ADDSOURCEBUFFER_ERROR", r[r.SOURCEBUFFER_ERROR = 202] = "SOURCEBUFFER_ERROR", r[r.ENDOFSTREAM_ERROR = 203] = "ENDOFSTREAM_ERROR", r[r.APPENDBUFFER_ERROR = 204] = "APPENDBUFFER_ERROR", r[r.CHANGETYPE_ERROR = 205] = "CHANGETYPE_ERROR", r[r.MSE_CAPABILITY_ERROR = 206] = "MSE_CAPABILITY_ERROR", r[r.PARSING_ERROR = 301] = "PARSING_ERROR", r[r.REMUX_ERROR = 302] = "REMUX_ERROR", r[r.REMUX_ALLOC_ERROR = 303] = "REMUX_ALLOC_ERROR", r[r.REMUX_WORKER_ERROR = 304] = "REMUX_WORKER_ERROR", r[r.DEMUX_NOT_FOUND = 305] = "DEMUX_NOT_FOUND", r[r.MANIFEST_PARSING_ERROR = 400] = "MANIFEST_PARSING_ERROR", r[r.KEY_SYSTEM_NO_ACCESS = 500] = "KEY_SYSTEM_NO_ACCESS", r[r.KEY_SYSTEM_NO_SESSION = 501] = "KEY_SYSTEM_NO_SESSION", r[r.KEY_SYSTEM_URL_ERROR = 502] = "KEY_SYSTEM_URL_ERROR", r[r.KEY_SYSTEM_NO_KEYS = 505] = "KEY_SYSTEM_NO_KEYS", r[r.FRAG_DECRYPT_ERROR = 506] = "FRAG_DECRYPT_ERROR", r[r.KEY_SYSTEM_NO_INIT_DATA = 507] = "KEY_SYSTEM_NO_INIT_DATA", r[r.KEY_SYSTEM_UNSUPPORTED = 508] = "KEY_SYSTEM_UNSUPPORTED", r[r.DECODER_LOAD_ERROR = 600] = "DECODER_LOAD_ERROR", r[r.DECODER_INIT_ERROR = 601] = "DECODER_INIT_ERROR", r[r.DECODER_DRAW_ERROR = 602] = "DECODER_DRAW_ERROR", r[r.DECODER_WEBGL_ERROR = 603] = "DECODER_WEBGL_ERROR", r[r.DECODER_UNSUPPORTED = 604] = "DECODER_UNSUPPORTED", r[r.DECODER_COPY_YUV_ERROR = 605] = "DECODER_COPY_YUV_ERROR", r[r.DECODER_DEC_ERROR = 606] = "DECODER_DEC_ERROR", r[r.PRELOAD_ERROR = 700] = "PRELOAD_ERROR", r[r.LIVE_DISCONNECTED_ERROR = 1009] = "LIVE_DISCONNECTED_ERROR", r[r.WEBRTC_DISCONNECTED_ERROR = 1010] = "WEBRTC_DISCONNECTED_ERROR", r[r.WEBRTC_FAILED_ERROR = 1011] = "WEBRTC_FAILED_ERROR", r[r.WEBRTC_CLOSED_ERROR = 1012] = "WEBRTC_CLOSED_ERROR", r[r.WEBRTC_ICE_CANDIDATE_ERROR = 1013] = "WEBRTC_ICE_CANDIDATE_ERROR", r[r.WEBRTC_ICE_CONNECTION_ERROR = 1014] = "WEBRTC_ICE_CONNECTION_ERROR", r[r.WEBRTC_OFFER_ERROR = 1015] = "WEBRTC_OFFER_ERROR", r[r.WEBRTC_ANSWER_ERROR = 1016] = "WEBRTC_ANSWER_ERROR", r[r.WEBRTC_TRANSMISSION_DATA_NULL = 1017] = "WEBRTC_TRANSMISSION_DATA_NULL", r[r.WEBRTC_CONNECT_TIMEOUT = 1018] = "WEBRTC_CONNECT_TIMEOUT", r[r.WEBRTC_CONNECT_FAILED = 1019] = "WEBRTC_CONNECT_FAILED", r;
  }({}), ei = [J.VIDEO_ERROR, J.VIDEO_ERROR_1, J.VIDEO_ERROR_2, J.VIDEO_ERROR_3, J.VIDEO_ERROR_4];
  function pe(r, l, a, t) {
    var n = { type: r, details: l, code: 0, fatal: !0, reason: a };
    if (t)
      for (var s in t) {
        var u = t[s];
        u !== void 0 && (n[s] = u);
      }
    return n;
  }
  var Je = { 400: "01", 401: "02", 403: "03", 404: "04", other4xx: "05", serverError: "06", timeoutOpen: "07", timeoutIO: "08", 200: "09", 206: "09", other: "99" };
  function Ct(r, l, a) {
    if (a === void 0 && (a = 0), r >= 100)
      return r;
    var t = "00";
    return l === Ne.LOADER_CONNECT_TIMEOUT ? t = Je.timeoutOpen : l === Ne.LOADER_TRANS_TIMEOUT ? t = Je.timeoutIO : Object.prototype.hasOwnProperty.call(Je, a) ? t = a !== 200 && a !== 206 || !l ? Je[a] : Je.other : /^4\d{2}$/.test(a.toString()) ? t = Je.other4xx : /^5\d{2}$/.test(a.toString()) && (t = Je.serverError), parseInt(r + t, 10);
  }
  var ae = /\.[^./\\?#]+(?=$|[?#])/i, he = { ".mp4": g.mp4, ".m4s": g.mp4, ".mov": g.mp4, ".m4a": g.mp4, ".flv": g.flv, ".m3u8": g.hls, ".sdp": g.webrtc, ".webm": g.matroska, ".mkv": g.matroska, ".mka": g.matroska, ".mp3": g.mp3, ".wav": g.wav, ".aac": g.aac, ".ts": g.ts, ".yuv": g.yuv, ".slice": g.flv };
  function te(r) {
    var l = function(a) {
      var t = a.toLocaleLowerCase().match(ae);
      return t ? t[0] : "";
    }(r);
    return l && he[l] || g.unknown;
  }
  var Se = o(4), ie = o.n(Se), Kt = /^[^_][A-Za-z0-9_-]*$/, me = /_([A-Za-z0-9]+)_/;
  function Mt(r) {
    var l = new ie.a(r).pathname, a = te(r), t = a === g.flv || ze(a) || a === g.ts, n = "", s = "", u = l.split("/"), h = u[u.length - 1] || "";
    if (t) {
      try {
        var p = l.lastIndexOf("/");
        p >= 0 && (l = l.slice(p + 1));
        var m = l.split(".")[0].split("_");
        m.length === 1 ? (n = wt(m[0]), s = st(r)) : m.length === 2 ? (n = wt(m[0]), s = wt(m[1])) : m.length > 2 && (n = wt(m.slice(0, m.length - 1).join("_")), s = wt(m[m.length - 1]));
      } catch (O) {
      }
      return { streamID: n, transcodingTpl: s, filename: h };
    }
    return { streamID: "", transcodingTpl: st(r), filename: h };
  }
  var st = function(r) {
    var l = r.match(me), a = "";
    return l != null && l.length && l.length > 1 && (a = l[1]), wt(a);
  }, wt = function(r) {
    return Kt.test(r) ? r : "";
  };
  function hi(r) {
    var l;
    performance.addEventListener && (l = r, performance && (typeof performance.setResourceTimingBufferSize == "function" ? performance.setResourceTimingBufferSize(l) : typeof performance.webkitSetResourceTimingBufferSize == "function" && performance.webkitSetResourceTimingBufferSize(l)), performance.addEventListener("resourcetimingbufferfull", Cr));
  }
  var _i, Cr = function() {
    performance && (typeof performance.clearResourceTimings == "function" ? performance.clearResourceTimings() : typeof performance.webkitClearResourceTimings == "function" && performance.webkitClearResourceTimings());
  }, Co = function(r) {
    return r.FAIL = "FAIL", r.ABORT = "ABORT", r.SUCCESS = "SUCCESS", r.CONNECTED = "CONNECTED", r;
  }({});
  (_i = {})[kt.MANIFEST] = J.MANIFEST_LOAD_ERROR, _i[kt.LEVEL] = J.LEVEL_LOAD_ERROR, _i[kt.AUDIO_TRACK] = J.AUDIO_TRACK_LOAD_ERROR, _i[kt.SUBTITLE_TRACK] = J.SUBTITLE_TRACK_LOAD_ERROR;
  var Ai, Ue, Yi, Dr = function(r) {
    return r.METADATA = "metadata", r.MEDIA_INFO = "mediaInfo", r.PARSING_INIT_SEGMENT = "parsingInitSegment", r.PARSING_DATA = "parsingData", r.PARSED_DATA = "parsedData", r.SCRIPT_PARSED = "scriptParsed", r.KEY_FRAME_INDEXS = "keyFrameIndexs", r.VIDEO_FRAME_INFO = "videoFrameInfo", r.DISCONTINUITY = "discontinuity", r.REPORT = "report", r.LOAD_END = "loadEnd", r.ERROR = "error", r.MANIFEST_LOADED = "manifestLoaded", r.MANIFEST_PARSED = "manifestParsed", r.LEVEL_SWITCHING = "levelSwitching", r.LEVEL_SWITCHED = "levelSwitched", r.LEVEL_SWITCH_PLAYING = "levelSwitchPlaying", r.LEVEL_SWITCH_FAILED = "levelSwitchFailed", r.LEVEL_LOADED = "levelLoaded", r.LEVEL_UPDATED = "levelUpdated", r.AUDIO_TRACK_SWITCHING = "audioTrackSwitching", r.AUDIO_TRACK_SWITCHED = "audioTrackSwitched", r.AUDIO_TRACK_UPDATED = "audioTrackUpdated", r.HLS_MANIFEST_PARSED = "hlsManifestParsed", r.HLS_KEY_LOADED = "hlsKeyLoaded", r.AUDIO_TRACK_LOADED = "audioLoaded", r.SUBTITLE_TRACK_LOADED = "subtitleTrackLoaded", r.SUBTITLE_LOADED = "subtitleLoaded", r.SUBTITLE_TRACK_SWITCHED = "subtitleTrackSwitched", r.SUBTITLE_TRACK_UPDATED = "subtitleTrackUpdated", r.BUFFER_CLEANING = "bufferCleaning", r.VIDEO_SEEK = "vdeoSeek", r.PRELOAD_COMPLETE = "preloadComplete", r.ABR_NEXT = "abrNext", r.PRIV_NAL = "privNal", r.SEI = "sei", r.AAC_PRIV = "aacPriv", r.RAW_DATA = "rawData", r.MP4_NOT_FASTSTART = "mp4NotFaststart", r.VIDEO_CODEC_DETECTED = "videoCodecChange", r.H265_DETECTED = "h265Detected", r.VIDEO_RENDERER_CHANGE = "videoRendererChange", r.DEC_LIB_LOADED = "decLibLoaded", r.DEC_INIT_COMPLETE = "decoderInitComplete", r.DEC_VIDEO_READY = "decVideoReady", r.STEP = "step", r.RENDERER_BUF_EXPIRED = "rendererBufExpired", r.RENDERER_SEEK = "rendererSeek", r.RENDERER_BUF_UPDATE = "rendererBufUpdate", r.RENDERER_DRAW = "rendererDraw", r.DECODER_FRAME = "decoderFrame", r.DECODER_IMG = "decoderImg", r.DECODER_SEEK = "decoderSeek", r.DECODER_SEEK_ABORT = "decoderSeekAbort", r.DECODER_WAITING = "decoderWaiting", r.DECODER_DATA_END = "decoderDataEnd", r.DECODER_BUF_LOW = "decoderDataEmpty", r.DECODER_DROP_FRAME = "decocerDropFrame", r.DECODER_MEDIA_INFO = "decoderMediaInfo", r.MEDIA_CONNECTED = "mediaConnected", r.LOADER_CHUNK_ARRIVAL = "loaderChunkArrival", r.DEMUXER_DETECTED = "demuxerDetected", r.MEDIA_DEMUX = "mediaDemux", r.KEY_FRAME = "keyFrame", r.USE_BACKUP = "useBackup", r.NEW_SOURCE = "newSource", r.DOWNLOAD = "download", r.STOP_LOAD = "stopLoad", r.LOAD = "load", r.WAITING = "waiting", r.LOADEDMETADATA = "loadedmetadata", r.LOADEDDATA = "loadeddata", r.CANPLAY = "canplay", r.SEEKING = "seeking", r.SEEK_WITH_LOAD = "seekWithLoad", r.SEEKED = "seeked", r.PLAYING = "playing", r.PAUSE = "pause", r.PLAY = "play", r.ENDED = "ended", r.TIMEUPDATE = "timeupdate", r.PROGRESS = "progress", r.RATE_CHANGE = "ratechange", r.DURATION_CHANGE = "durationchange", r.HEARTBEAT = "heartbeat", r.MSE_UPDATE = "mseUpdate", r.MSE_BUFFER_FULL = "mseBufferFull", r.RETRY = "retry", r.WORKER_LOG = "workerLog", r;
  }(Dr || {}), F = Dr, Do = function() {
    function r(a, t) {
      this._logger = void 0, this._consumer = [], this._evt = void 0, a.i("event-bus-consumer-manager", "constructor"), this._logger = a, this._evt = t, this._addListeners();
    }
    var l = r.prototype;
    return l.destroy = function() {
      this._logger.i("event-bus-consumer-manager", "destroy"), this._evt.removeAllListeners(), this._consumer.splice(0, this._consumer.length);
    }, l.register = function(a, t) {
      t === void 0 && (t = !1), this._logger.i("event-bus-consumer-manager", "register", a), t ? this._consumer.unshift(a) : this._consumer.push(a), a.setEvtEmitter(this._evt);
    }, l.unregister = function(a) {
      for (var t = this._consumer.length - 1; t >= 0; t--)
        a === this._consumer[t] && this._consumer.splice(t, 1);
    }, l._addListeners = function() {
      var a = this;
      Object.values(F).forEach(function(t) {
        var n = "on" + t.charAt(0).toUpperCase() + t.slice(1);
        a._evt.on(t, function() {
          for (var s = arguments.length, u = new Array(s), h = 0; h < s; h++)
            u[h] = arguments[h];
          for (var p = 0; p < a._consumer.length; p++) {
            var m = a._consumer[p];
            if (n in m) {
              var O, U = (O = m[n]).call.apply(O, [m].concat(u));
              if (U != null && U.stop)
                break;
            }
          }
        });
      });
    }, v()(r, [{ key: "evt", get: function() {
      return this._evt;
    } }]), r;
  }(), Ee = function(r) {
    return r.PLAY = "PLAY", r.END = "END", r.PAUSE = "PAUSE", r.LOAD = "LOAD", r.BLOCK_START = "BLOCK_START", r.BLOCK_END = "BLOCK_END", r.SEEK_START = "SEEK_START", r.SEEK_END = "SEEK_END", r.LIVE_STOP = "LIVE_STOP", r.ERROR = "ERROR", r.DESTORY = "DESTORY", r.QUALITY_CHANGE = "QUALITY_CHANGE", r.QUALITY_CHANGE_DATA = "QUALITY_CHANGE_DATA", r.QUALITY_CHANGE_RENDER = "QUALITY_CHANGE_RENDER", r.SPEED_CHANGE = "SPEED_CHANGE", r.RETRY = "RETRY", r.NETWORK_CHANGE = "NETWORK_CHANGE", r.FIRST_SCREEN_RENDER = "FIRST_SCREEN_RENDER", r.METADATA_LOAD = "METADATA_LOAD", r.LIVE_SHIFT = "LIVE_SHIFT", r.AUDIO_CHANGE = "AUDIO_CHANGE", r;
  }({}), Or = function(r) {
    function l() {
      for (var t, n = arguments.length, s = new Array(n), u = 0; u < n; u++)
        s[u] = arguments[u];
      return (t = r.call.apply(r, [this].concat(s)) || this)._evt = void 0, t;
    }
    y()(l, r);
    var a = l.prototype;
    return a.setEvtEmitter = function(t) {
      this._evt = t;
    }, a.emit = function(t, n) {
      var s;
      return ((s = this._evt) == null ? void 0 : s.emit(t, n)) || !1;
    }, a.onWorkerLog = function(t) {
    }, l;
  }(W), Oo = function(r) {
    function l(t, n) {
      var s;
      return (s = r.call(this) || this)._ctx = void 0, s._exposed = void 0, s._ctx = t, s._exposed = n, s;
    }
    y()(l, r);
    var a = l.prototype;
    return a.onReport = function(t) {
      this._exposed.emit(F.REPORT, t);
    }, a.onError = function(t) {
      if ((t == null || !t.preventFollowUp) && t.fatal) {
        var n = d()({}, t);
        if (this._ctx.stat.coreType === N.native) {
          var s = this._ctx.stat.retryInfo.getLastMseError();
          s && (this._ctx.logger.i("exposed-event", "replace error info by mse error."), d()(n, { type: s.type, details: s.details, reason: s.reason, code: s.code }), s.url !== void 0 && (n.url = s.url), s.statusCode !== void 0 && (n.statusCode = s.statusCode));
        }
        this._exposed.emit(F.ERROR, n);
      }
    }, a.onManifestParsed = function(t) {
      this._exposed.emit(F.MANIFEST_PARSED, t);
    }, a.onLevelSwitching = function(t) {
      this._exposed.emit(F.LEVEL_SWITCHING, t);
    }, a.onLevelSwitched = function(t) {
      this._exposed.emit(F.LEVEL_SWITCHED, t);
    }, a.onLevelSwitchFailed = function() {
      this._exposed.emit(F.LEVEL_SWITCH_FAILED);
    }, a.onLevelUpdated = function(t) {
      this._exposed.emit(F.LEVEL_UPDATED, t);
    }, a.onLevelSwitchPlaying = function(t) {
      this._exposed.emit(F.LEVEL_SWITCH_PLAYING, t);
    }, a.onAudioTrackSwitching = function(t) {
      this._exposed.emit(F.AUDIO_TRACK_SWITCHING, t);
    }, a.onAudioTrackSwitched = function(t) {
      this._exposed.emit(F.AUDIO_TRACK_SWITCHED, t);
    }, a.onAudioTrackUpdated = function(t) {
      this._exposed.emit(F.AUDIO_TRACK_UPDATED, t);
    }, a.onSubtitleTrackSwitched = function(t) {
      this._exposed.emit(F.SUBTITLE_TRACK_SWITCHED, t);
    }, a.onLoadEnd = function(t) {
      t != null && t.preventFollowUp || this._exposed.emit(F.LOAD_END);
    }, a.onVideoRendererChange = function(t) {
      this._exposed.emit(F.VIDEO_RENDERER_CHANGE, t);
    }, a.onH265Detected = function(t) {
      this._exposed.emit(F.H265_DETECTED, t);
    }, l;
  }(Or), Mo = o(3), Ie = o.n(Mo), ti = function(r) {
    function l(t) {
      var n;
      return (n = r.call(this) || this)._ctx = void 0, n._logger = void 0, n._alreadyRun = !1, n._retryFunc = void 0, n._ctx = t, n._logger = t.logger, t.logger.i(Ie()(n), "constructor"), n;
    }
    y()(l, r);
    var a = l.prototype;
    return a.reset = function() {
      return this._ctx.logger.i("fallback", "reset"), this._alreadyRun = !1, this;
    }, a.stop = function() {
      return this;
    }, a.setRetryFunc = function(t) {
      return this._retryFunc = t, this;
    }, a.destroy = function() {
      this._logger.i("fallback", "fallback: " + this.constructor.name + " destroy."), this._retryFunc = void 0, r.prototype.destroy.call(this);
    }, a.getAvailable = function() {
      return !this._alreadyRun;
    }, a._callRetryFunc = function(t) {
      if (this._retryFunc && this._retryFunc() !== !1)
        return this._alreadyRun = !0, t;
    }, a.emit = function(t, n) {
      return this._ctx.evt.emit(t, n);
    }, l;
  }(W), No = function(r) {
    function l() {
      return r.apply(this, arguments) || this;
    }
    return y()(l, r), l.prototype.run = function(a) {
      if (this._retryFunc && this.getAvailable() && this._ctx.hasNextMediaDesc() && (this._ctx.stat.coreType === N.mse || this._ctx.stat.coreType === N.native) && (this._logger.i("fallback-next-desc", "run"), this._ctx.nextMediaDesc()))
        return this._callRetryFunc({ type: H.FALLBACK, message: "use next media description." });
    }, l;
  }(ti), Mr = { preferLowPowerToHighPerformance: !0, preserveDrawingBuffer: !0 };
  function Nr(r) {
    return r.getContext("webgl", Mr);
  }
  function qi() {
    if (!Ai) {
      var r = typeof HTMLCanvasElement > "u" ? new OffscreenCanvas(1, 1) : document.createElement("canvas");
      Pr(r, Ai = { webGL: !1, performance: !1 }, !0) || Pr(r, Ai, !1);
    }
    return Ai;
  }
  function Pr(r, l, a) {
    a === void 0 && (a = !1);
    var t = !1, n = d()({ failIfMajorPerformanceCaveat: a }, Mr);
    try {
      var s = r.getContext("webgl", n);
      if (s) {
        var u = s.getExtension("WEBGL_debug_renderer_info");
        l.webGL = !0, l.performance = a, u != null && u.UNMASKED_VENDOR_WEBGL && (l.vendor = s.getParameter(u == null ? void 0 : u.UNMASKED_VENDOR_WEBGL)), u != null && u.UNMASKED_RENDERER_WEBGL && (l.renderer = s.getParameter(u == null ? void 0 : u.UNMASKED_RENDERER_WEBGL)), t = !0;
        var h = s.getExtension("WEBGL_lose_context");
        h && h.loseContext();
      }
    } catch (p) {
    }
    return t;
  }
  function pi() {
    return typeof navigator > "u" ? 0 : navigator.hardwareConcurrency || 0;
  }
  function ht() {
    return typeof window != "object" || typeof document != "object" || typeof document.createElement != "function";
  }
  function Qi() {
    var r, l, a;
    if (!ht())
      return ((r = window) == null ? void 0 : r.ManagedMediaSource) || ((l = window) == null ? void 0 : l.MediaSource) || ((a = window) == null ? void 0 : a.WebKitMediaSource);
  }
  function Ur() {
    var r, l, a;
    if (!ht())
      return ((r = window) == null ? void 0 : r.ManagedSourceBuffer) || ((l = window) == null ? void 0 : l.SourceBuffer) || ((a = window) == null ? void 0 : a.WebKitSourceBuffer);
  }
  var Po = { av1: ['video/mp4; codecs="av01.0.08M.08,mp4a.40.2"'], hevc: ['video/mp4; codecs="hev1.1.6.L120.90,mp4a.40.2"', 'video/mp4; codecs="hvc1.1.6.L120.90,mp4a.40.2"'], h264: ['video/mp4; codecs="avc1.4D4028,mp4a.40.2"'], opus: ['video/mp4; codecs="opus"'], mp3: ['video/mp4; codecs="mp3"'], aac: ['video/mp4; codecs="mp4a.40.2"'] }, Uo = { av1: ['video/mp4; codecs="av01.0.08M.10"'], hevc: ['video/mp4; codecs="hev1.2.2.L120.90"', 'video/mp4; codecs="hvc1.2.2.L120.90"'], h264: ['video/mp4; codecs="avc1.6e0028"'] }, Fo = { av1: ['video/mp4; codecs="av01.0.12M.08"'], hevc: ['video/mp4; codecs="hev1.1.6.L150.90"', 'video/mp4; codecs="hvc1.1.6.L150.90"'], h264: ['video/mp4; codecs="avc1.4D4033"'] }, Bo = { av1: ['video/mp4; codecs="av01.0.12M.10"'], hevc: ['video/mp4; codecs="hev1.2.2.L150.90"', 'video/mp4; codecs="hvc1.2.2.L150.90"'], h264: ['video/mp4; codecs="avc1.6e0028"'] }, Vo = { mp4: ["video/mp4", "video/quicktime"], flv: ["video/x-flv"], ts: ["video/mp2t"], matroska: ["video/x-matroska", "video/webm"], hls: ["application/vnd.apple.mpegURL", "application/x-mpegURL"], hls_ts: ["application/vnd.apple.mpegURL", "application/x-mpegURL"], hls_fmp4: ["application/vnd.apple.mpegURL", "application/x-mpegURL"], aac: ["audio/aac"], mp3: ["audio/mpeg", "audio/mp3"] }, mt = function() {
    function r() {
    }
    return r.isMSEAvailable = function() {
      if (r._mseAvailable !== void 0)
        return r._mseAvailable;
      if (!Y.a)
        return r._mseAvailable = !1, !1;
      var l = Qi(), a = Ur();
      if (r._mseApiAvailable = !!(l && a && a.prototype && typeof a.prototype.appendBuffer == "function" && typeof a.prototype.remove == "function"), l && $.mobile && r._mseApiAvailable)
        try {
          var t = new l(), n = document.createElement("video");
          n.src = URL.createObjectURL(t), URL.revokeObjectURL(n.src), r._mseAvailable = !0;
        } catch (s) {
          r._mseAvailable = !1;
        }
      else
        r._mseAvailable = r._mseApiAvailable;
      return r._mseAvailable;
    }, r.isMSECodecCapabilityNormal = function() {
      return r.isMSEAvailable() && r.TYPE_SUPPORTED.h264;
    }, r.isSupported = function(l) {
      return l === void 0 && (l = A.h264), r.isMSECodecSupported(l) && r.isMSEAvailable();
    }, r.isMSECodecSupported = function(l, a, t) {
      if (l === void 0 && (l = A.h264), a === void 0 && (a = S.FHD), t === void 0 && (t = !1), $.msedge || $.msie)
        return r.isMSEAvailable() && l === A.h264;
      if (r._playHEVCTestSupported(l, a) === !1)
        return !1;
      var n = r._getCStr(l, a, t);
      return !!n && n.reduce(function(s, u) {
        return s || r.isMSECodecStrSupported(u);
      }, !1);
    }, r.isVideoCodecSupported = function(l, a, t) {
      if (l === void 0 && (l = A.h264), a === void 0 && (a = S.FHD), t === void 0 && (t = !1), $.msedge || $.msie)
        return l === A.h264;
      if (r._playHEVCTestSupported(l, a) === !1)
        return !1;
      var n = r._getCStr(l, a, t);
      return !!n && n.reduce(function(s, u) {
        return s || !(!r._testVideo || !r._testVideo.canPlayType(u));
      }, !0);
    }, r.isVideoBoxSupported = function(l) {
      if (l === void 0 && (l = g.mp4), l === g.unknown)
        return !0;
      var a = Vo[l];
      return !!a && a.reduce(function(t, n) {
        return t || !(!r._testVideo || !r._testVideo.canPlayType(n));
      }, !1);
    }, r.isVideoCodecStrSupportedInMp4 = function(l, a) {
      a === void 0 && (a = "");
      try {
        return !(!r._testVideo || !r._testVideo.canPlayType((a || "video") + '/mp4;codecs="' + l + '"'));
      } catch (t) {
      }
      return !1;
    }, r.isWebRTCSupported = function() {
      return "RTCPeerConnection" in window && "RTCRtpTransceiver" in window;
    }, r.isMSECodecStrSupportedInMp4 = function(l, a) {
      var t;
      return a === void 0 && (a = ""), !((t = Qi()) == null || !t.isTypeSupported((a || "video") + '/mp4;codecs="' + l + '"'));
    }, r.isMSECodecStrSupported = function(l) {
      var a = Qi();
      return !(!a || typeof a.isTypeSupported != "function" || !a.isTypeSupported(l));
    }, r.isChangeTypeSupported = function() {
      if (r._changeTypeSupported === void 0) {
        var l = Ur();
        r._changeTypeSupported = !(!l || l.prototype.changeType === void 0);
      }
      return r._changeTypeSupported;
    }, r.getVideoCodecCompatibilityByCodec = function(l, a, t) {
      a === void 0 && (a = S.FHD), t === void 0 && (t = !1);
      var n = L.unsupported, s = !0;
      l === A.h264 ? n = a === S.UHD_4K ? (t ? r.TYPE_SUPPORTED.h264Hdr4k : r.TYPE_SUPPORTED.h2644k) ? L.buildin : L.unsupported : (t ? r.TYPE_SUPPORTED.h264Hdr : r.TYPE_SUPPORTED.h264) ? L.buildin : L.unsupported : l === A.av1 ? (n = a === S.UHD_4K ? (t ? r.TYPE_SUPPORTED.av1Hdr4k : r.TYPE_SUPPORTED.av14k) ? L.buildin : L.unsupported : (t ? r.TYPE_SUPPORTED.av1Hdr : r.TYPE_SUPPORTED.av1) ? L.buildin : L.unsupported, s = pi() >= 2) : l === A.hevc ? (n = a === S.UHD_4K ? (t ? r.TYPE_SUPPORTED.hevcHdr4k : r.TYPE_SUPPORTED.hevc4k) ? L.buildin : L.unsupported : (t ? r.TYPE_SUPPORTED.hevcHdr : r.TYPE_SUPPORTED.hevc) ? L.buildin : L.unsupported) === L.buildin ? ($.msedge && (n = L.unsupported), s = pi() >= 2 || $.safari) : s = r.wasmSmooth : l !== A.kvc3 && l !== A.kvc4 && l !== A.kvc5 && l !== A.kvc6 && l !== A.vvc && l !== A.kvc30 && l !== A.bvc2 || (n = typeof WebAssembly < "u" ? L.wasm : L.unsupported, s = r.wasmSmooth);
      var u = !1;
      return n === L.buildin && (u = r.isChangeTypeSupported(), l === A.hevc && r._playHEVCTestSupported(l, a) === !1 && (n = L.wasm)), { decoder: n, smooth: n !== L.unsupported && s, mix: u };
    }, r.getPlayTestDefinition = function(l) {
      if (typeof l.width == "number" && typeof l.height == "number") {
        if ((l == null ? void 0 : l.width) > 1920 || (l == null ? void 0 : l.height) > 1920)
          return S.UHD_4K;
      } else if (l.qualityType.toLowerCase().indexOf("4k") !== -1)
        return S.UHD_4K;
      return S.FHD;
    }, r._getCStr = function(l, a, t) {
      a === void 0 && (a = S.FHD), t === void 0 && (t = !1), l === A.unknown && (l = A.h264);
      var n = t ? Uo : Po, s = t ? Bo : Fo;
      return a === S.UHD_4K && s[l] || n[l];
    }, r._playHEVCTestSupported = function(l, a) {
      if (a === void 0 && (a = S.FHD), l === A.hevc && r.playHEVCTest && (a === S.UHD_4K && r.playHEVCTest[a] === !1 || a !== S.UHD_4K && r.playHEVCTest[S.FHD] === !1))
        return !1;
    }, r._threads = function() {
      try {
        return typeof WebAssembly < "u" && typeof MessageChannel < "u" && new MessageChannel().port1.postMessage(new SharedArrayBuffer(1)), WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 4, 1, 96, 0, 0, 3, 2, 1, 0, 5, 4, 1, 3, 1, 1, 10, 11, 1, 9, 0, 65, 0, 254, 16, 2, 0, 26, 11]));
      } catch (l) {
        return !1;
      }
    }, r._simd = function() {
      return typeof WebAssembly < "u" && WebAssembly.validate(new Uint8Array([0, 97, 115, 109, 1, 0, 0, 0, 1, 5, 1, 96, 0, 1, 123, 3, 2, 1, 0, 10, 10, 1, 8, 0, 65, 0, 253, 15, 253, 98, 11]));
    }, v()(r, null, [{ key: "isSupportSimd", get: function() {
      return r._isSupportSimd === void 0 && (r._isSupportSimd = r._simd()), r._isSupportSimd;
    } }, { key: "isSupportThreads", get: function() {
      return r._isSupportThreads === void 0 && (r._isSupportThreads = r._threads()), r._isSupportThreads;
    } }, { key: "wasmSmooth", get: function() {
      if (r._wasmSmooth === void 0) {
        var l = pi();
        r._wasmSmooth = !!(r.isSupportHW && r.isSupportThreads && l && l >= 6);
      }
      return r._wasmSmooth;
    } }, { key: "isSupportHW", get: function() {
      return !!qi().performance;
    } }, { key: "playHEVCTest", get: function() {
      return this._playHEVCTest;
    }, set: function(l) {
      this._playHEVCTest = l;
    } }, { key: "_testVideo", get: function() {
      return Yi || ht() || (Yi = document.createElement("video")), Yi;
    } }]), r;
  }();
  Ue = mt, mt._changeTypeSupported = void 0, mt._mseAvailable = void 0, mt._mseApiAvailable = void 0, mt._isSupportSimd = void 0, mt._isSupportThreads = void 0, mt._wasmSmooth = void 0, mt._playHEVCTest = void 0, mt.TYPE_SUPPORTED = { mpeg: Ue.isMSECodecStrSupported("audio/mpeg"), mp3: Ue.isMSECodecSupported(A.mp3), opus: Ue.isMSECodecSupported(A.opus), aac: Ue.isMSECodecSupported(A.aac), hevc: Ue.isMSECodecSupported(A.hevc), hevc4k: Ue.isMSECodecSupported(A.hevc, S.UHD_4K), hevcHdr: Ue.isMSECodecSupported(A.hevc, S.FHD, !0), hevcHdr4k: Ue.isMSECodecSupported(A.hevc, S.UHD_4K, !0), av1: Ue.isMSECodecSupported(A.av1), av14k: Ue.isMSECodecSupported(A.av1, S.UHD_4K), av1Hdr: Ue.isMSECodecSupported(A.av1, S.FHD, !0), av1Hdr4k: Ue.isMSECodecSupported(A.av1, S.UHD_4K, !0), h264: Ue.isMSECodecSupported(A.h264), h2644k: Ue.isMSECodecSupported(A.h264, S.UHD_4K), h264Hdr: Ue.isMSECodecSupported(A.h264, S.FHD, !0), h264Hdr4k: Ue.isMSECodecSupported(A.h264, S.UHD_4K, !0) };
  var Z = mt, Ho = function(r) {
    function l() {
      return r.apply(this, arguments) || this;
    }
    return y()(l, r), l.prototype.run = function(a) {
      var t;
      if (this._retryFunc && this.getAvailable() && a.type === Re.MEDIA_ERROR && (a.details === J.VIDEO_ERROR || a.details === J.VIDEO_ERROR_3 || a.details === J.VIDEO_ERROR_4 || a.details === J.VIDEO_NO_SIZE) && this._ctx.canCodecFallback && this._ctx.video && (this._ctx.stat.coreType === N.mse || this._ctx.stat.coreType === N.native && ((t = this._ctx.video) == null || !t.videoWidth)) && this._ctx.stat.codecType !== A.h264 && this._ctx.stat.decoder === L.buildin) {
        var n = "metadata video size: " + this._ctx.video.videoWidth + ". fallback 264";
        this._logger.i("fallback-swap-to-264", "run"), this._ctx.reProcessSrc(A.h264, this._ctx.stat.native);
        var s = this._callRetryFunc({ type: H.FALLBACK, message: n });
        return Z.playHEVCTest === void 0 && (this._logger.i("fallback-swap-to-264", "play hevc test start"), this._ctx.hevcTest.start()), s;
      }
    }, l;
  }(ti), Go = function(r) {
    function l() {
      return r.apply(this, arguments) || this;
    }
    return y()(l, r), l.prototype.run = function(a) {
      if (this._retryFunc && this.getAvailable() && this._ctx.stat.coreType === N.native && this._ctx.stat.native && a.statusCode !== 0 && Z.isMSEAvailable()) {
        var t = "box: " + this._ctx.stat.box + " native startup failed. switch to mse";
        return this._logger.i("fallback-swap-to-mse", "run"), this._ctx.reProcessSrc(void 0, !1), this._callRetryFunc({ type: H.FALLBACK, message: t });
      }
    }, l;
  }(ti), Wo = function(r) {
    function l() {
      return r.apply(this, arguments) || this;
    }
    return y()(l, r), l.prototype.run = function(a) {
      if (this._retryFunc && this.getAvailable() && this._ctx.stat.coreType === N.mse && !this._ctx.stat.native) {
        var t = a.reason, n = !1;
        if (a.details === J.DEMUX_NOT_FOUND ? (t = "demux not found", n = !0) : this._ctx.stat.box !== g.mp4 && this._ctx.stat.box !== g.unknown || this._ctx.stat.decoder !== L.buildin || a.details !== J.SOURCEBUFFER_ERROR && a.details !== J.MEDIASOURCE_ERROR && a.details !== J.ADDSOURCEBUFFER_ERROR && (a.type !== Re.NETWORK_ERROR || a.details === J.DEC_LIB_LOAD_ERROR || a.details === J.KEY_SYSTEM_LICENSE_REQUEST_FAILED || a.statusCode !== 0) || (n = !0), n)
          return this._logger.i("fallback-swap-to-native", "run"), this._ctx.reProcessSrc(void 0, !0), this._callRetryFunc({ type: H.FALLBACK, message: t + ". swap to native." });
      }
    }, l;
  }(ti), oe = function(r) {
    return r.FLV_LIVE_RELOAD = "flvLiveReload", r.USE_BACKUP = "useBackup", r.USE_BACKUP_MULTIPART = "useBackupMultipart", r.NO_WORKER = "noWorker", r.SWAP_REMUX_TYPE = "swapRemuxType", r.SWAP_AUDIO_CODECSTR = "swapAudioCodecStr", r.NEXT_DESC = "nextDesc", r.SWAP_WASM_DECODER = "swapWasmDecoder", r.SWAP_CORE = "swapCore", r.SWAP_264 = "swap264", r.RELOAD_WASM = "reloadWasm", r;
  }({}), Ko = function(r) {
    function l(t) {
      var n;
      return (n = r.call(this) || this)._ctx = void 0, n._fallbackFuncMap = {}, n._fallbackPolicy = void 0, n._onError = function(s) {
        if (n._ctx.logger.i("fallback", "on error", s, Object.keys(n._fallbackFuncMap)), n._fallbackPolicy || (n._fallbackPolicy = n._generateFallbackPolicy()), s.fatal) {
          n._ctx.logger.i("fallback", "error. type: " + s.type + " details: " + s.details + " reason: " + s.reason);
          for (var u = 0; u < n._fallbackPolicy.actions.length; u++) {
            var h = n._fallbackPolicy.actions[u];
            if (h) {
              var p = n._fallbackFuncMap[h.type];
              if (p != null && p.getAvailable()) {
                var m = n._ctx.stat.coreType, O = p.run(s);
                if (O)
                  return n._ctx.logger.i("fallback", "fallback run. type: " + h.type + " " + u + "/" + n._fallbackPolicy.actions.length), s.preventFollowUp = !0, O.code = Ct(s.details, s.reason, s.statusCode), O.errorData = d()({}, s), O.core = m, n._ctx.evt.emit(F.RETRY, O), void n._updatePolicy(u);
                n._ctx.logger.i("fallback", "fallback type: " + h.type + " ineligible. skip.");
              } else
                n._ctx.logger.i("fallback", "fallback type: " + h.type + " no action, skip.");
            }
          }
        }
      }, n._ctx = t, n._destroyableList.push(n._ctx.evt.prependListener(F.ERROR, n._onError)), n;
    }
    y()(l, r);
    var a = l.prototype;
    return a.register = function(t, n) {
      var s = this;
      return this._ctx.logger.i("fallback", "register " + t + " " + n.constructor.name), this._fallbackFuncMap[t] && (this._ctx.logger.i("fallback", t + " existed."), this._destroyableList.destroyItem(n)), this._fallbackFuncMap[t] = n, this._destroyableList.push(n), { destroy: function() {
        return s.unregisterAndDestroy(t);
      } };
    }, a.unregisterAndDestroy = function(t) {
      var n = this._fallbackFuncMap[t];
      return n && (this._destroyableList.destroyItem(n), n.destroy(), delete this._fallbackFuncMap[t], this._ctx.logger.i("fallback", "unregisterAndDestroy " + t)), this;
    }, a.hasFallback = function(t) {
      return !!this._fallbackFuncMap[t];
    }, a.reset = function() {
      for (var t in this._ctx.logger.i("fallback", "reset"), this._fallbackFuncMap)
        this.unregisterAndDestroy(t);
      this._fallbackFuncMap = {}, this._fallbackPolicy = void 0;
    }, a.stop = function() {
      for (var t in this._fallbackFuncMap)
        this._fallbackFuncMap[t].stop();
    }, a._updatePolicy = function(t) {
      if (this._fallbackPolicy) {
        var n = this._fallbackPolicy.actions[t];
        n.type !== oe.SWAP_CORE && n.type !== oe.NO_WORKER || (this._resetAction(oe.USE_BACKUP), this._resetAction(oe.USE_BACKUP_MULTIPART), this._resetAction(oe.FLV_LIVE_RELOAD));
      }
    }, a._generateFallbackPolicy = function() {
      this._ctx.logger.i("fallback", "generate fallback policy.");
      var t = this._ctx, n = ($.mobile, { core: t.stat.coreType, actions: [] });
      return t.stat.coreType === N.mse ? n.actions.push({ type: oe.RELOAD_WASM }, { type: oe.FLV_LIVE_RELOAD }, { type: oe.USE_BACKUP_MULTIPART }, { type: oe.USE_BACKUP }, { type: oe.NO_WORKER }, { type: oe.SWAP_REMUX_TYPE }, { type: oe.SWAP_AUDIO_CODECSTR }, { type: oe.SWAP_264 }, { type: oe.NEXT_DESC }, { type: oe.SWAP_WASM_DECODER }, { type: oe.SWAP_CORE }) : t.stat.coreType === N.native && n.actions.push({ type: oe.USE_BACKUP }, { type: oe.SWAP_264 }, { type: oe.NEXT_DESC }, { type: oe.SWAP_CORE }, { type: oe.RELOAD_WASM }, { type: oe.FLV_LIVE_RELOAD }, { type: oe.USE_BACKUP_MULTIPART }, { type: oe.NO_WORKER }, { type: oe.SWAP_REMUX_TYPE }, { type: oe.SWAP_AUDIO_CODECSTR }, { type: oe.SWAP_WASM_DECODER }), n;
    }, a._resetAction = function(t) {
      var n;
      (n = this._fallbackFuncMap[t]) == null || n.reset();
    }, l;
  }(W), Fr = function() {
    function r() {
      this.timeout = 6048e5;
    }
    var l = r.prototype;
    return l.write = function(a, t) {
      if (r.available)
        try {
          localStorage.setItem(a, JSON.stringify({ value: t, time: Date.now() }));
        } catch (n) {
        }
    }, l.read = function(a, t) {
      if (t === void 0 && (t = !0), r.available)
        try {
          var n = localStorage.getItem(a);
          if (n) {
            var s = JSON.parse(n), u = s.value, h = s.time, p = h === void 0 ? 0 : h;
            if (!t || Date.now() - p < (typeof t == "number" ? t : this.timeout))
              return u;
          }
        } catch (m) {
        }
    }, v()(r, null, [{ key: "available", get: function() {
      if (r._available === void 0)
        try {
          localStorage.setItem("alg", "test"), r._available = !0;
        } catch (a) {
          r._available = !1;
        }
      return r._available;
    } }]), r;
  }();
  Fr._available = void 0;
  var Nt, fi = Fr, ke = function(r) {
    return r.NONE = "none", r.ERROR = "e", r.WARN = "w", r.INFO = "i", r.DEBUG = "d", r.VERBOSE = "v", r;
  }({}), Br = ke.ERROR, Xi = ((Nt = {})[ke.NONE] = { value: 1, str: "N" }, Nt[ke.ERROR] = { value: 100, str: "E" }, Nt[ke.WARN] = { value: 200, str: "W" }, Nt[ke.INFO] = { value: 300, str: "I" }, Nt[ke.DEBUG] = { value: 400, str: "D" }, Nt[ke.VERBOSE] = { value: 500, str: "V" }, Nt), Zi = function() {
    function r(a) {
      if (this._name = "kwai-k", this._level = Br, this._id = -1, this._output = void 0, this._workerTag = "main", typeof location < "u" && location.protocol === "blob:") {
        var t = new ie.a(location.href).pathname.match(/\/(\w+)-/);
        t && (this._workerTag = a ? a + "-" + t[1] : t[1]);
      } else
        a && (this._workerTag = a);
    }
    r.loadLogLevel = function() {
      if (location.href) {
        var a = location.href.match(/kwaiKernelLog=([a-z]{1})/);
        if (a && a.length > 1) {
          var t = a[1];
          if (this._isValueInLevel(t))
            return t;
        }
      }
      var n = new fi().read("kwai-kernel-log");
      if (this._isValueInLevel(n))
        return n;
    }, r._isValueInLevel = function(a) {
      return Object.values(ke).indexOf(a) !== -1;
    };
    var l = r.prototype;
    return l.setOutput = function(a) {
      return this._output = a, this;
    }, l.setLevel = function(a) {
      return this._level = a, this;
    }, l.setId = function(a) {
      return this._id = a, this;
    }, l.setName = function(a) {
      return this._name = a, this;
    }, l.getLevel = function() {
      return this._level;
    }, l.hasOutput = function() {
      return !!this._output;
    }, l.e = function(a) {
      if (this.isLevelEnabled(this._level, ke.ERROR)) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
          n[s - 1] = arguments[s];
        var u = this._printLog(ke.ERROR, a, n);
        try {
          var h;
          (h = this._output) == null || h.e.apply(h, [u].concat(n));
        } catch (p) {
        }
      }
    }, l.w = function(a) {
      if (this.isLevelEnabled(this._level, ke.WARN)) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
          n[s - 1] = arguments[s];
        var u = this._printLog(ke.WARN, a, n);
        try {
          var h;
          (h = this._output) == null || h.w.apply(h, [u].concat(n));
        } catch (p) {
        }
      }
    }, l.i = function(a) {
      if (this.isLevelEnabled(this._level, ke.INFO)) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
          n[s - 1] = arguments[s];
        var u = this._printLog(ke.INFO, a, n);
        try {
          var h;
          (h = this._output) == null || h.i.apply(h, [u].concat(n));
        } catch (p) {
        }
      }
    }, l.d = function(a) {
      if (this.isLevelEnabled(this._level, ke.DEBUG)) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
          n[s - 1] = arguments[s];
        var u = this._printLog(ke.DEBUG, a, n);
        try {
          var h;
          (h = this._output) == null || h.d.apply(h, [u].concat(n));
        } catch (p) {
        }
      }
    }, l.v = function(a) {
      if (this.isLevelEnabled(this._level, ke.VERBOSE)) {
        for (var t = arguments.length, n = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)
          n[s - 1] = arguments[s];
        var u = this._printLog(ke.VERBOSE, a, n);
        try {
          var h;
          (h = this._output) == null || h.v.apply(h, [u].concat(n));
        } catch (p) {
        }
      }
    }, l.isLevelEnabled = function(a, t) {
      return Xi[a].value >= Xi[t].value;
    }, l._printLog = function(a, t, n) {
      var s, u, h = typeof t;
      if (h === "object")
        t = ((u = t) == null ? void 0 : u.constructor.name) || "unknown";
      else if (h === "function") {
        var p;
        t = ((p = Object.getOwnPropertyDescriptor(t, "name")) == null ? void 0 : p.value) || "unknown";
      }
      var m, O, U = (((s = Xi[a]) == null ? void 0 : s.str) || "") + "|" + this._name + "[" + this._id + "][" + this._workerTag + "]::" + t;
      return a === ke.ERROR ? (m = console).error.apply(m, [U].concat(n.slice(0))) : (O = console).log.apply(O, [U].concat(n.slice(0))), U;
    }, r;
  }(), et = (new Zi(), function(r) {
    return r.METADATA = "metadata", r.MEDIA_INFO = "mediaInfo", r.HEARTBEAT = "heartbeat", r.DOWNLOAD = "download", r.REALTIME_BEACON = "realtimeBeacon", r.DISCONTINUITY = "discontinuity", r.KEY_FRAME = "keyFrame", r.PRIV_NAL = "privNal", r.SEI = "sei", r.AAC_PRIV = "aacPriv", r.EVENT = "event", r;
  }({})), zo = function(r) {
    function l() {
      return r.apply(this, arguments) || this;
    }
    return y()(l, r), l.prototype.run = function(a) {
      if (this._retryFunc && this.getAvailable() && (this._ctx.stat.coreType === N.mse && a.type === Re.NETWORK_ERROR && a.details !== J.DEC_LIB_LOAD_ERROR && a.details !== J.KEY_SYSTEM_LICENSE_REQUEST_FAILED && !this._ctx.stat.multipart || this._ctx.stat.coreType === N.native && a.details !== J.KEY_SYSTEM_UNSUPPORTED)) {
        var t = this._ctx.lctx.current;
        if (t && t.urlId < t.url.length - 1)
          return this._logger.i("fallback-backup", "run"), t.urlId++, this._callRetryFunc({ type: H.BACKUP, message: "trans error. use backup url." });
      }
    }, l;
  }(ti), $o = function() {
    function r() {
      var a = this;
      this._timer = void 0, this._xhr = void 0, this._callbackFunc = void 0, this._onEnd = function() {
        a._detectEnd();
      }, this._onReadystatechange = function() {
        a._xhr && a._xhr.readyState >= 2 && a._detectEnd();
      }, this._detectEnd = function() {
        a._xhr && a._callbackFunc && a._callbackFunc(a._xhr.status), a.stop();
      };
    }
    var l = r.prototype;
    return l.start = function(a, t) {
      this._callbackFunc = t, this._xhr && this.stop();
      var n = this._xhr = new XMLHttpRequest();
      n.open("GET", a, !0), n.onreadystatechange = this._onReadystatechange, n.onerror = this._onEnd, n.onload = this._onEnd, n.send(), this._timer = setTimeout(this._detectEnd, 1e3);
    }, l.stop = function() {
      this._timer && (clearTimeout(this._timer), this._timer = void 0), this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr.abort(), this._xhr = void 0), this._callbackFunc = void 0;
    }, r;
  }(), jo = { audio: { a3ds: !0, "ac-3": !0, "ac-4": !0, alac: !0, alaw: !0, dra1: !0, "dts+": !0, "dts-": !0, dtsc: !0, dtse: !0, dtsh: !0, "ec-3": !0, enca: !0, g719: !0, g726: !0, m4ae: !0, mha1: !0, mha2: !0, mhm1: !0, mhm2: !0, mlpa: !0, mp4a: !0, "raw ": !0, Opus: !0, samr: !0, sawb: !0, sawp: !0, sevc: !0, sqcp: !0, ssmv: !0, twos: !0, ulaw: !0 }, video: { avc1: !0, avc2: !0, avc3: !0, avc4: !0, avcp: !0, drac: !0, dvav: !0, dvhe: !0, encv: !0, hev1: !0, hvc1: !0, mjp2: !0, mp4v: !0, mvc1: !0, mvc2: !0, mvc3: !0, mvc4: !0, resv: !0, rv60: !0, s263: !0, svc1: !0, svc2: !0, "vc-1": !0, vp08: !0, vp09: !0 } };
  function Vr(r) {
    var l = {};
    return (r || "").split(/[ ,]+/).forEach(function(a) {
      a.indexOf("avc1") !== 0 && a.indexOf("hev1") !== 0 && a.indexOf("av01") !== 0 && a.indexOf("kvc") !== 0 || (l.video = a), a.indexOf("mp4a") === 0 && (l.audio = a);
    }), l;
  }
  function Yo(r, l) {
    var a = [].concat(r.split(/[ ,]+/));
    ["video", "audio"].forEach(function(t) {
      var n = a.filter(function(u) {
        return function(h, p) {
          var m = jo[p];
          return !!m && m[h.slice(0, 4)] === !0;
        }(u, t);
      });
      if (n.length) {
        var s = n.filter(function(u) {
          return u.lastIndexOf("avc1", 0) === 0 || u.lastIndexOf("av01", 0) === 0 || u.lastIndexOf("hev1", 0) === 0 || u.lastIndexOf("hvc1", 0) === 0 || u.lastIndexOf("mp4a", 0) === 0;
        });
        l[t + "Codec"] = s.length > 0 ? s[0] : n[0], a = a.filter(function(u) {
          return n.indexOf(u) === -1;
        });
      }
    }), l.codec = a.join(",");
  }
  function Hr(r) {
    return r.indexOf("avc1") === 0 ? A.h264 : r.indexOf("hev1") === 0 || r.indexOf("hvc1") === 0 ? A.hevc : r.indexOf("av01") === 0 ? A.av1 : A.unknown;
  }
  var lt = function(r) {
    return r[r.NONE = 0] = "NONE", r[r.WAITING = 1] = "WAITING", r[r.SEEK = 2] = "SEEK", r[r.SELECT_BITRATE = 3] = "SELECT_BITRATE", r[r.INIT = 4] = "INIT", r[r.LOADING = 5] = "LOADING", r;
  }({}), Qe = "kernel-base", Gr = function(r) {
    function l(t) {
      var n;
      if ((n = r.call(this) || this)._ctx = void 0, n._video = void 0, n._error = void 0, n._hbTimer = void 0, n._stat = lt.INIT, n._mediaInfo = void 0, n._levelSwitchId = 0, n._nextLevel = [], n._nextAudio = void 0, n._eventHandlers = void 0, !t.video)
        throw new Error("video is null");
      return n._ctx = t, n._video = t.video, n._eventHandlers = { loadedmetadata: n._onVideoLoadedmetadata.bind(Ie()(n)), loadeddata: n._onVideoLoadeddata.bind(Ie()(n)), canplay: n._onVideoCanplay.bind(Ie()(n)), seeking: n._onVideoSeeking.bind(Ie()(n)), seeked: n._onVideoSeeked.bind(Ie()(n)), waiting: n._onVideoWaiting.bind(Ie()(n)), playing: n._onVideoPlaying.bind(Ie()(n)), pause: n._onVideoPause.bind(Ie()(n)), play: n._onVideoPlay.bind(Ie()(n)), error: n._onVideoError.bind(Ie()(n)), ended: n._onVideoEnded.bind(Ie()(n)), ratechange: n._onVideoRatechange.bind(Ie()(n)), durationchange: n._onVideoDurationchange.bind(Ie()(n)), timeupdate: n._onVideoTimeupdate.bind(Ie()(n)), progress: n._onVideoProgress.bind(Ie()(n)), emptied: n._onVideoEmptied.bind(Ie()(n)), resize: n._onVideoResize.bind(Ie()(n)) }, n._bindVideoEvents(), n;
    }
    y()(l, r);
    var a = l.prototype;
    return a.destroy = function() {
      this._ctx.logger.i(Qe, "destroy"), this._stopHeartbeat(), this._unbindVideoEvents(), r.prototype.destroy.call(this);
    }, a.getTrackBufInfo = function() {
    }, a.load = function() {
      this._video.load();
    }, a.resume = function() {
      this._video.paused && this._video.play();
    }, a.refresh = function() {
    }, a.stopLoad = function() {
    }, a._getNextFrameTime = function() {
      var t = this._mediaInfo && this._mediaInfo.fps ? this._mediaInfo.fps : 30;
      return this._video.duration && !this._video.ended ? this._video.currentTime + 1 / t : -1;
    }, a._getPrevFrameTime = function() {
      var t = this._mediaInfo && this._mediaInfo.fps ? this._mediaInfo.fps : 30;
      return this._video.duration && this._video.currentTime - 1 / t >= 0 ? this._video.currentTime - 1 / t : -1;
    }, a._bindVideoEvents = function() {
      if (this._video)
        for (var t in this._eventHandlers)
          this._video.addEventListener(t, this._eventHandlers[t]);
    }, a._unbindVideoEvents = function() {
      if (this._video)
        for (var t in this._eventHandlers)
          this._video.removeEventListener(t, this._eventHandlers[t]);
    }, a._onVideoLoadedmetadata = function() {
      this._ctx.logger.i(Qe, "loadedmetadata"), this.emit(F.LOADEDMETADATA);
    }, a._onVideoLoadeddata = function() {
      this._ctx.logger.i(Qe, "loadeddata"), this.emit(F.LOADEDDATA);
    }, a._onVideoCanplay = function() {
      this._ctx.logger.i(Qe, "canplay " + !!this._stat), this.emit(F.CANPLAY);
    }, a._onVideoSeeking = function() {
      this._ctx.logger.i(Qe, "seeking " + this._video.currentTime), this.emit(F.SEEKING);
    }, a._onVideoSeeked = function() {
      this._ctx.logger.i(Qe, "seeked"), this.emit(F.SEEKED);
    }, a._onVideoWaiting = function() {
    }, a._onVideoPlaying = function() {
      this._ctx.logger.i(Qe, "playing"), this._error || (this._stat = lt.NONE, this._startHeartbeat(), this.emit(F.PLAYING));
    }, a._onVideoPause = function() {
      this._ctx.logger.i(Qe, "pause. seeking: " + this._video.seeking), this._video.ended || this.emit(F.PAUSE);
    }, a._onVideoPlay = function() {
      this._ctx.logger.i(Qe, "play", this._error), this.emit(F.PLAY);
    }, a._onVideoError = function(t) {
      this._ctx.logger.i(Qe, "error", t);
    }, a._onVideoEnded = function() {
      this._ctx.logger.i(Qe, "ended"), this.emit(F.ENDED), this._stopHeartbeat();
    }, a._onVideoRatechange = function() {
      this._ctx.logger.i(Qe, "ratechange " + this._video.playbackRate), this.emit(F.RATE_CHANGE);
    }, a._onVideoDurationchange = function() {
      this._ctx.logger.i(Qe, "durationchange " + this._video.duration), this.emit(F.DURATION_CHANGE);
    }, a._onVideoTimeupdate = function() {
      this.emit(F.TIMEUPDATE);
    }, a._onVideoProgress = function() {
      this.emit(F.PROGRESS);
    }, a._onVideoEmptied = function() {
      this._ctx.logger.i(Qe, "video emptied");
    }, a._onVideoResize = function() {
      this._ctx.logger.i(Qe, "video resize");
    }, a._heartbeat = function() {
      this.emit(F.HEARTBEAT);
    }, a._startHeartbeat = function() {
      this._hbTimer || (this._hbTimer = setInterval(this._heartbeat.bind(this), 1e3));
    }, a._stopHeartbeat = function() {
      this._hbTimer && (clearInterval(this._hbTimer), this._hbTimer = void 0);
    }, a.emit = function(t, n) {
      return this._ctx.evt.emit(t, n);
    }, v()(l, [{ key: "type", get: function() {
      return N.unknown;
    } }]), l;
  }(W), qo = function(r) {
    function l(t) {
      var n;
      return (n = r.call(this, t) || this)._httpStatusDetector = void 0, n._setStartFromOnTimeupdate = !1, n._destroyableList.push(n._ctx.fallback.register(oe.USE_BACKUP, new zo(t).setRetryFunc(n._reload.bind(Ie()(n))))), n;
    }
    y()(l, r);
    var a = l.prototype;
    return a._reload = function(t) {
      this._load(G.retry);
    }, a.load = function(t) {
      var n;
      this._ctx.logger.i("kernel-native", "load", this._ctx.stat.startFromSec);
      var s = this._ctx.lctx.levels;
      if (s.length || this.emit(F.ERROR, pe(Re.OTHER_ERROR, J.MANIFEST_PARSING_ERROR, "manifest parse error. core: native")), this._ctx.stat.drm)
        this.emit(F.ERROR, pe(Re.KEY_SYSTEM_ERROR, J.KEY_SYSTEM_UNSUPPORTED, "DRM unsupported."));
      else {
        var u = this._ctx.lctx.default, h = this._ctx.lctx.startIdx;
        typeof h == "number" && h >= 0 && h < s.length && (u = h, this._ctx.logger.i("kernel-native", "set level from level startIdx.")), this._ctx.logger.i("kernel-native", "level: " + u + " " + ((n = s[u]) == null ? void 0 : n.qualityType)), this._ctx.lctx.currentIdx = this._ctx.lctx.nextIdx = u, this._ctx.lctx.abr = !1, this.emit(F.MANIFEST_PARSED, { levels: [], currentLevel: 0 }), this._load(t);
      }
    }, a.onAbrLevelsUpdated = function() {
    }, a.refresh = function() {
      var t, n = this;
      this._ctx.stat.startFromSec = this._video.currentTime, this._load(G.retry), (t = this._video.play()) == null || t.catch(function(s) {
        return n._ctx.logger.i("kernel-native", "refresh. call play() fail.", s);
      });
    }, a.stopLoad = function() {
      this.emit(F.STOP_LOAD), this._stopHeartbeat();
    }, a.setCurrentLevel = function(t) {
      this._ctx.logger.i("kernel-native", "set current level: " + t + " @ " + this._video.currentTime);
      var n = this._ctx;
      if (n.lctx.levels.length) {
        if (t >= 0 && t < n.lctx.levels.length && n.lctx.currentIdx !== t) {
          n.lctx.currentIdx = n.lctx.nextIdx = t;
          var s = n.lctx.current;
          if (s)
            return this._stat = lt.SELECT_BITRATE, n.stat.startFromSec = this._video.currentTime, this._levelSwitchId++, this.emit(F.LEVEL_SWITCHING, { time: n.currentTime, bitrate: s.bitrate, level: t, smooth: !1, auto: !1, id: this._levelSwitchId }), this._startLoadLevel(n.lctx.currentIdx), this._video.paused || this._video.play(), void this.emit(F.LEVEL_SWITCHED, { time: n.currentTime, bitrate: s.bitrate, level: t, smooth: !1, auto: !1, id: this._levelSwitchId });
        }
        this.emit(F.LEVEL_SWITCH_FAILED);
      } else
        n.lctx.currentIdx = n.lctx.nextIdx = t;
    }, a.setNextLevel = function(t) {
      this.setCurrentLevel(t);
    }, a.liveEnd = function() {
    }, a.jumpToLiveTime = function(t) {
      return this._ctx.logger.i("kernel-native", "jump to live time. isLive: " + this._ctx.stat.isLive + " type: " + this._ctx.stat.liveShiftType, t), this._ctx.stat.liveShiftType === q.GENERAL && (this._ctx.stat.liveShiftParams = t, this.refresh(), !0);
    }, a.destroy = function() {
      this._ctx.logger.i("kernel-native", "destroy"), this._httpStatusDetector && (this._httpStatusDetector.stop(), this._httpStatusDetector = void 0), r.prototype.destroy.call(this), this._video.src = "";
    }, a._onVideoPlay = function() {
      this._error || this._video.src || this.load(), r.prototype._onVideoPlay.call(this);
    }, a._onVideoCanplay = function() {
      var t = this._ctx, n = t.lctx.current;
      n && this._stat === lt.SELECT_BITRATE && this.emit(F.LEVEL_SWITCH_PLAYING, { time: t.currentTime, bitrate: n.bitrate, level: t.lctx.currentIdx, smooth: !1, auto: !1, id: this._levelSwitchId }), this._stat !== lt.NONE && (this._stat = lt.NONE), r.prototype._onVideoCanplay.call(this);
    }, a._onVideoTimeupdate = function() {
      var t = this._ctx;
      r.prototype._onVideoTimeupdate.call(this), this._setStartFromOnTimeupdate && (this._ctx.logger.i("kernel-native", "timeupdate start from: " + t.stat.startFromSec), this._applyStartFrom(), this._setStartFromOnTimeupdate = !1);
    }, a._onVideoWaiting = function() {
      this._ctx.logger.i("kernel-native", "video waiting"), this._stat = this._stat || lt.WAITING;
      var t = this._ctx.bufferedSec, n = !this._video.ended && !this._video.seeking && this._stat === lt.WAITING;
      this.emit(F.WAITING, { block: n, bufferedSec: t });
    }, a._onVideoDurationchange = function() {
      var t;
      ($.android || this._ctx.stat.isLive === void 0 || ((t = this._mediaInfo) == null ? void 0 : t.width) === 0) && this._mediaInfo && this._video.duration > 0 && (this._mediaInfo.isLive = this._ctx.stat.isLive = !isFinite(this._video.duration), this._mediaInfo.width = this._video.videoWidth, this._mediaInfo.height = this._video.videoHeight, this.emit(F.MEDIA_INFO, this._mediaInfo)), this._androidWechatHls && this._video.duration > 0 && (this._ctx.logger.i("kernel-native", "check video dec failed. on android wechat hls duration change."), this._checkVDecodeFailedAndFallback()), r.prototype._onVideoDurationchange.call(this);
    }, a._onVideoLoadeddata = function() {
      if (this._ctx.logger.i("kernel-native", "video loadeddata. duration: " + this._video.duration + " box: " + this._ctx.stat.box + " width: " + this._video.videoWidth + " height: " + this._video.videoHeight), this._androidWechatHls || (this._ctx.logger.i("kernel-native", "check video dec failed. on video loaded data."), !this._checkVDecodeFailedAndFallback())) {
        this._ctx.stat.isLive === void 0 && this._video.duration > 0 && (this._ctx.stat.isLive = !isFinite(this._video.duration)), this._mediaInfo = { width: this._video.videoWidth, height: this._video.videoHeight, videoDecoder: L.buildin };
        var t = this._ctx, n = t.lctx.current;
        if (t.cOutput.updateRendererType(b.video), t.cOutput.rendererType === b.canvas && this.emit(F.VIDEO_RENDERER_CHANGE, { enabled: !0, canvas: t.cOutput.canvas, type: b.canvas }), n && n.codec) {
          var s = Vr(n.codec);
          this._mediaInfo.audioCodec = s.audio, this._mediaInfo.videoCodec = s.video, s.video && (t.stat.codecType = Hr(s.video));
        }
        this._mediaInfo.videoCodecType = t.stat.codecType, $.android ? t.stat.startFromSec && (this._setStartFromOnTimeupdate = !0) : this._applyStartFrom(), this.emit(F.MEDIA_INFO, this._mediaInfo);
      }
    }, a._onVideoSeeking = function() {
      this._ctx.logger.i("kernel-native", "seeking " + this._video.currentTime);
      var t = this._video.currentTime;
      this.emit(F.SEEKING), this._ctx.isTimeinBuffered(t) || this.emit(F.SEEK_WITH_LOAD);
    }, a._onVideoError = function(t) {
      var n, s = this;
      this._ctx.logger.e("kernel-native", "video error", t);
      var u = ((n = this._video.error) == null ? void 0 : n.code) || 0, h = Ct(ei[u], "video error");
      if (u === 4 && this._ctx.canCodecFallback)
        this.emit(F.ERROR, pe(Re.MEDIA_ERROR, h, "buildin " + this._ctx.stat.codecType + " dec error. video error: " + u));
      else {
        var p = "video error";
        this._video && this._video.error && (p += " code:" + u + " message:" + this._video.error.message);
        var m = pe(Re.MEDIA_ERROR, (u ? ei[u] : J.VIDEO_ERROR) || J.VIDEO_ERROR, p, { url: this._video.src });
        u === 2 || u === 4 ? (this._httpStatusDetector || (this._httpStatusDetector = new $o()), this._ctx.logger.i("kernel-native", "video error start detect status code."), this._httpStatusDetector.start(this._video.src, function(O) {
          s._ctx.logger.i("kernel-native", "video error check http status code:", O), (u === 2 || u === 4 && O > 0) && (O < 200 || O > 299) ? s.emit(F.ERROR, pe(Re.NETWORK_ERROR, J.LOAD_ERROR, p, { statusCode: O, url: s._video.src })) : (O === 0 && (m.statusCode = 0), s.emit(F.ERROR, m));
        })) : this.emit(F.ERROR, m);
      }
    }, a._load = function(t) {
      this._ctx.logger.i("kernel-native", "_load type: " + t), this._mediaInfo = void 0, this._error = void 0, this._stat = lt.LOADING, this.emit(F.LOAD, { type: t }), this._startLoadLevel(this._ctx.lctx.currentIdx), this._startHeartbeat();
    }, a._startLoadLevel = function(t) {
      var n = this._ctx, s = n.lctx.current;
      if (s) {
        var u, h;
        this._ctx.logger.i("kernel-native", "level", t);
        var p, m = s.currentUrl;
        this.emit(F.NEW_SOURCE, { sync: n.stat.startFromSec || 0 }), (u = this._ctx.config.preprocessUrl) != null && u.stream && (this._ctx.logger.d("kernel-native", "preprocessUrl stream"), m = (p = this._ctx.config.preprocessUrl) == null ? void 0 : p.stream(m)), n.stat.liveShiftType === q.GENERAL && (h = n.stat.liveShiftParams) != null && h.urlParams && (m = n.getGeneralLiveShiftUrl(m)), this._ctx.logger.i("kernel-native", "play: " + m), this._video.src = m;
      }
    }, a._applyStartFrom = function() {
      var t = this._ctx;
      t.stat.startFromSec > 0 && (this._ctx.logger.i("kernel-native", "start from: " + t.stat.startFromSec), this._video.currentTime = t.stat.startFromSec, t.stat.startFromSec = 0);
    }, a._checkVDecodeFailedAndFallback = function() {
      return this._ctx.logger.i("kernel-native", "check video dec failed. width: " + this._video.videoWidth), !(this._video.videoWidth || !this._ctx.canCodecFallback) && (this.emit(F.ERROR, pe(Re.MEDIA_ERROR, J.VIDEO_NO_SIZE, "buildin " + this._ctx.stat.codecType + " dec no width.")), !0);
    }, v()(l, [{ key: "type", get: function() {
      return N.native;
    } }, { key: "_androidWechatHls", get: function() {
      return $.android && ($.xweb || $.x5) && ze(this._ctx.stat.box);
    } }]), l;
  }(Gr), Qo = o(8), Wr = o.n(Qo), Xo = 0, Ji = function() {
    var r = l.prototype;
    function l(a) {
      var t = this;
      this._logger = void 0, this._context = void 0, this._loader = void 0, this._callbacks = null, this._config = void 0, this._loaderCallback = void 0, this._stats = void 0, this._retryDelay = 0, this._loading = !1, this._aborted = !1, this._connectTimer = void 0, this._transTimer = void 0, this._retryTimer = void 0, this._rangeStart = void 0, this._progressTime = 0, this._index = 0, this._loadInternal = function() {
        var n;
        t._loading = !0, t._aborted = !1;
        var s = t._stats, u = t._context;
        (n = t._callbacks) != null && n.onLoad && t._callbacks.onLoad(u, s), s.code = 0, s.tfirst = 0, s.loaded = 0, t._stopRetryTimer(), t._loader = new (t._getInternalLoader())(t._logger), s.type = t._loader instanceof X ? We.FETCH : We.XHR, t._loader && (s.id = t._loader.tag + "-" + t._index, t._config.connectionTimeout && (t._connectTimer = setTimeout(function() {
          return t._onTimeout(Ne.LOADER_CONNECT_TIMEOUT);
        }, t._config.connectionTimeout)), t._httpRange(u), s.tsload = Date.now(), s.tstart = performance.now(), t._logger.i("loader", "[" + t._index + "]load: " + t._loader.tag + " " + u.url + " progress: " + u.progress + " type: " + u.type + " responseType: " + u.responseType + " range: " + u.range), t._loader.load(u, t._loaderCallback));
      }, this._onConnect = function(n, s) {
        t._stopConnectTimer();
        var u = t._stats;
        t._getContentLen(n, u), t._startTransmissionTimer(), u.code = s, u.tfirst = Math.max(u.trequest, performance.now()), t._logger.i("loader", "[" + t._index + "]connect code: " + s), t._callbacks && t._callbacks.onConnect && t._callbacks.onConnect(n, u), typeof n.rangeStart == "number" && n.rangeStart > 0 && u.code !== 206 && t._callbacks && t._callbacks.onError && setTimeout(function() {
          t._onError(new Error("range error. " + n.range + " statu code:" + u.code));
        }, 0);
      }, this._onProgress = function(n, s) {
        var u = t._stats;
        if (t._progressTime = performance.now(), !n.breakpointContinuation && u.output > u.loaded) {
          if (u.loaded + s.byteLength - u.output > 0) {
            var h = s.slice(u.output - u.loaded);
            t._callProgress(t._context, h, u);
          }
          u.loaded += s.byteLength;
        } else
          u.loaded += s.byteLength, t._callProgress(t._context, s, u);
      }, this._onError = function(n) {
        t._stopTimer(), t._destroyLoader();
        var s, u = t._stats, h = t._config, p = t._context, m = u.type === We.FETCH && p.monkeyPatched && p.preferNative === void 0;
        t._loading = !1, t._logger.i("loader", "[" + t._index + "]error: " + n.name + " " + (n == null ? void 0 : n.message) + " code: " + u.code + " retry: " + u.retry + "/" + h.maxRetry + " " + (m ? "monkeyPatchedFetch" : "")), t._context.breakpointContinuation && u.code === 416 || m && t._stats.output === u.loaded && u.loaded > 0 ? (s = t._callbacks) != null && s.onEnd && t._callbacks.onEnd(t._context, null, u) : (u.fatal = !h.maxRetry || u.retry >= h.maxRetry || !h.maxRetry, u.errName = n.name, u.errMessage = n.name + ": " + n.message + ". status: " + u.code, m && (n.name === qe.FETCH_READ_ERROR_NAME && !t._stats.loaded || n.message === Ne.LOADER_TRANS_TIMEOUT && !t._stats.loaded || n.message === Ne.LOADER_CONNECT_TIMEOUT || !t._stats.code) && (t._context.preferNative = !0, t._logger.i("loader", "monkey patched fetch error. switch to native fetch.")), t._callbacks && t._callbacks.onError && t._callbacks.onError(t._context, u), u.fatal || (h.breakpointContinuation && t._stats.contentTotalLength && (t._logger.i("loader", "[" + t._index + "]breakpointContinuation. " + t._stats.loaded + " / " + t._stats.contentTotalLength), t._stats.output && t._stats.loaded > 0 ? (t._rangeStart ? t._context.rangeStart = t._rangeStart + t._stats.output : t._context.rangeStart = t._stats.output, t._context.breakpointContinuation = !0) : (t._context.rangeStart = t._rangeStart, t._context.breakpointContinuation = !1)), u.retry++, t._callbacks && (t._retryDelay ? (t._retryTimer = setTimeout(t._loadInternal, t._retryDelay), t._retryDelay = 2 * t._retryDelay) : t._loadInternal())));
      }, this._onTimeout = function(n) {
        t._loading = !1, t._abortInternal();
        var s = new Error(n);
        t._onError(s);
      }, this._logger = a, this._index = Xo += 1, this._logger.i("loader", "[" + this._index + "]constructor"), this._loader = null, this._config = { connectionTimeout: 0, transmissionTimeout: 0, maxRetry: 0, retryDelay: 0 }, this._loaderCallback = { onConnect: this._onConnect, onProgress: this._onProgress, onEnd: this._onEnd.bind(this), onError: this._onError };
    }
    return r._getInternalLoader = function() {
      return l._chunkLoaderDef !== void 0 || (l._chunkLoaderDef = Pe, $.msie || $.msedge ? Pe.isSupportChunk() ? l._chunkLoaderDef = Pe : X.isSupported() && (l._chunkLoaderDef = X) : X.isSupported() ? l._chunkLoaderDef = X : Pe.isSupportChunk() && (l._chunkLoaderDef = Pe)), l._chunkLoaderDef;
    }, r.load = function(a, t, n) {
      this._init(a, t, n), this._loadInternal();
    }, r.destroy = function() {
      this._loader && this._logger.i("loader", "[" + this._index + "]destroy."), this._stopTimer(), this._abortInternal(!1), this._destroyLoader(), this._callbacks = null;
    }, r.abort = function() {
      this._stopTimer(), this._abortInternal();
    }, r._init = function(a, t, n) {
      this._context = a, this._rangeStart = a.rangeStart, this._callbacks = t, this._config = n || this._config, this._stats = { id: "", type: We.UNKNOWN, trequest: performance.now(), retry: 0, loaded: 0, code: 0, output: 0, tfirst: 0, tload: 0, total: 0, tsload: 0, tstart: 0, fatal: !1, errName: "", errMessage: "" }, this._config.retryDelay && (this._retryDelay = this._config.retryDelay);
    }, r._destroyLoader = function() {
      this._loader && (this._loader.destroy(), this._loader = null);
    }, r._abortInternal = function(a) {
      a === void 0 && (a = !0), a && this._callbacks && this._callbacks.onAbort && !this._aborted && this._loading && this._callbacks.onAbort(this._context, this._stats), this._aborted = !0, this._loader && this._loader.abort();
    }, r._stopTimer = function() {
      this._stopConnectTimer(), this._stopRetryTimer(), this._stopTransmissionTimer();
    }, r._callProgress = function(a, t, n) {
      this._stats.output += t.byteLength, this._callbacks && this._callbacks.onProgress && this._callbacks.onProgress(a, t, n);
    }, r._onEnd = function(a, t) {
      this._stopTimer();
      var n = this._stats;
      this._getContentLen(a, n), n.total = t ? n.loaded = typeof t == "string" ? t.length || 0 : t.byteLength || 0 : n.loaded, n.tload = Math.max(n.tfirst, performance.now()), this._loading = !1, n.output = 0, this._logger.i("loader", "[" + this._index + "]end size: " + n.total + " duration: " + n.trequest + "-" + n.tload), this._callbacks && this._callbacks.onEnd(a, t, n);
    }, r._startTransmissionTimer = function() {
      var a = this;
      this._stopTransmissionTimer(), this._progressTime = performance.now();
      var t = this._config.transmissionTimeout || 0;
      t && (this._transTimer = setInterval(function() {
        performance.now() - a._progressTime > t && a._onTimeout(Ne.LOADER_TRANS_TIMEOUT);
      }, 1e3));
    }, r._stopTransmissionTimer = function() {
      this._transTimer && (clearInterval(this._transTimer), this._transTimer = void 0);
    }, r._stopConnectTimer = function() {
      this._connectTimer && (clearTimeout(this._connectTimer), this._connectTimer = void 0);
    }, r._stopRetryTimer = function() {
      this._retryTimer && (clearTimeout(this._retryTimer), this._retryTimer = void 0);
    }, r._httpRange = function(a) {
      if (a.rangeEnd || a.rangeStart)
        if (a.rangeType && a.rangeType !== x.STANDARD && typeof a.url == "string") {
          var t = new ie.a(a.url, !0);
          a.rangeEnd ? (t.query.start = (a.rangeStart || 0).toString(), t.query.end = (a.rangeEnd - 1).toString()) : a.rangeStart && (t.query.start = a.rangeStart.toString()), a.url = t.toString();
        } else
          a.rangeEnd ? a.range = "bytes=" + (a.rangeStart || 0) + "-" + (a.rangeEnd - 1) : a.rangeStart && (a.range = "bytes=" + a.rangeStart + "-");
    }, r._getContentLen = function(a, t) {
      if (!t.contentTotalLength || !t.contentLength) {
        var n = a.responseHeader;
        if (n) {
          if (a.range || typeof a.rangeStart == "number") {
            var s = n["content-range"];
            s && (t.contentTotalLength = parseInt((Array.isArray(s) ? s[0] : s).split("/")[1]) || 0);
          }
          var u = n["content-length"];
          u && (t.contentLength = parseInt(Array.isArray(u) ? u[0] : u) || 0);
        }
      }
    }, v()(l, [{ key: "context", get: function() {
      return this._context;
    } }, { key: "config", get: function() {
      return this._config;
    } }]), l;
  }();
  Ji._chunkLoaderDef = void 0;
  var Zo = function() {
    function r() {
      this._prevVideoTimestamp = 0, this._prevAudioTimestamp = 0, this._prevVideoReceived = 0, this._prevAudioReceived = 0, this._result = void 0, this._result = this._newInfo();
    }
    var l = r.prototype;
    return l.reset = function() {
      this._result = this._newInfo(), this._prevVideoTimestamp = 0, this._prevAudioTimestamp = 0, this._prevVideoReceived = 0, this._prevAudioReceived = 0;
    }, l.parse = function(a) {
      var t = this, n = this._result, s = 0, u = 0, h = "", p = "", m = "", O = "";
      n.totalReceive = 0, a.forEach(function(M) {
        if (M.type === "inbound-rtp") {
          if (M.mediaType === "video") {
            var j = M.timestamp - t._prevVideoTimestamp;
            t._prevVideoTimestamp && (s = (M.bytesReceived - t._prevVideoReceived) / j), t._prevVideoReceived = M.bytesReceived, t._prevVideoTimestamp = M.timestamp, n.key = M.keyFramesDecoded, n.videoPacketsLost = M.packetsLost, p = M.codecId, O = M.trackId;
          } else if (M.mediaType === "audio") {
            var le = M.timestamp - t._prevAudioTimestamp;
            t._prevAudioReceived && (u = (M.bytesReceived - t._prevAudioReceived) / le), t._prevAudioReceived = M.bytesReceived, n.audioPacketsLost = M.packetsLost, h = M.codecId, m = M.trackId;
          }
          n.totalReceive += M.bytesReceived, t._prevAudioTimestamp = M.timestamp;
        }
      }), n.audioDataRate = Math.round(7.8125 * u), n.videoDataRate = Math.round(7.8125 * s), n.speed = 1e3 * (s + u), a.forEach(function(M) {
        M.type === "codec" ? M.id === p ? n.videoCodec = M.mimeType : M.id === h && (n.audioCodec = M.mimeType, n.audioChannelCount = M.channels, n.audioSampleRate = M.clockRate) : M.type === "track" && (M.id === O ? (n.width = M.frameWidth, n.height = M.frameHeight, n.videoAvgJitterBufferDelay = M.jitterBufferDelay / M.jitterBufferEmittedCount) : M.id === m && (n.audioAvgJitterBufferDelay = M.jitterBufferDelay / M.jitterBufferEmittedCount));
      });
      var U = null, C = null;
      return a.forEach(function(M) {
        M.type === "transport" && (U = a == null ? void 0 : a.get(M.selectedCandidatePairId));
      }), U || a.forEach(function(M) {
        M.type === "candidate-pair" && M.selected && (U = M);
      }), U && U.remoteCandidateId && (C = a == null ? void 0 : a.get(U.remoteCandidateId)), C && (n.rtcRemoteAddress = C.address || C.ip || C.ipAddress, n.rtcRemotePort = C.port || C.portNumber), this._result = n, n;
    }, l._newInfo = function() {
      return { totalReceive: 0, speed: 0, rtcRemoteAddress: "", rtcRemotePort: 0, width: 0, height: 0, audioCodec: "", videoCodec: "", audioChannelCount: 0, audioSampleRate: 0, videoDataRate: 0, audioDataRate: 0, key: 0, audioPacketsLost: 0, videoPacketsLost: 0, audioAvgJitterBufferDelay: 0, videoAvgJitterBufferDelay: 0 };
    }, v()(r, [{ key: "result", get: function() {
      return this._result;
    } }]), r;
  }();
  function Kr(r, l) {
    var a = Object.keys(r);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(r);
      l && (t = t.filter(function(n) {
        return Object.getOwnPropertyDescriptor(r, n).enumerable;
      })), a.push.apply(a, t);
    }
    return a;
  }
  function zr(r) {
    for (var l = 1; l < arguments.length; l++) {
      var a = arguments[l] != null ? arguments[l] : {};
      l % 2 ? Kr(Object(a), !0).forEach(function(t) {
        Wr()(r, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(a)) : Kr(Object(a)).forEach(function(t) {
        Object.defineProperty(r, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return r;
  }
  var $r = function(r) {
    function l(t) {
      var n;
      return (n = r.call(this, t) || this)._loader = void 0, n._pc = void 0, n._loaderConfig = void 0, n._stream = void 0, n._src = "", n._rtcStatParser = void 0, n._retrying = !1, n._retryTimer = null, n._retryCount = 0, n._transmissionTimeoutTimer = null, n._transmissionTimeout = void 0, n._peerConnectionTimeout = void 0, n._peerConnectionMaxRetry = void 0, n._peerConnectionRetryDelay = void 0, n._parseStats = function(s) {
        n._pc && n._pc.getStats(null).then(function(u) {
          var h = n._rtcStatParser.parse(u);
          s(h);
        }, function(u) {
          return console.log(u);
        });
      }, n._loaderConfig = { connectionTimeout: n._ctx.config.sdpConnectionTimeout || 1e4, maxRetry: 0, retryDelay: n._ctx.config.retryDelay || 1e3 }, n._transmissionTimeout = n._ctx.config.transmissionTimeout || 1e4, n._peerConnectionTimeout = n._ctx.config.peerConnectionTimeout || 1e5, n._peerConnectionMaxRetry = n._ctx.config.peerConnectionMaxRetry || 5, n._peerConnectionRetryDelay = n._ctx.config.peerConnectionRetryDelay || 3e3, n._rtcStatParser = new Zo(), n;
    }
    y()(l, r);
    var a = l.prototype;
    return a.load = function(t) {
      this._ctx.logger.i("kernel-rtc", "load");
      var n = this._ctx.lctx.current;
      n && (this._src = n.url[n.urlId]), this._load(t);
    }, a.resume = function() {
      this._video.paused && this.refresh();
    }, a.destroy = function() {
      r.prototype.destroy.call(this), this._stopRetry(), this._disposeLoader(), this._video && (this._video.srcObject = null), this._disconnect(), this._stream = void 0, this._stopVideo();
    }, a.refresh = function() {
      this._disconnect(), this._load(G.retry);
    }, a.stopLoad = function() {
      this.emit(F.STOP_LOAD), this._pc && (this._pc.close(), this._pc = null), this._stopRetry(), this._stopHeartbeat();
    }, a.liveEnd = function() {
    }, a._onVideoLoadedmetadata = function() {
      var t = this;
      this._ctx.cOutput.updateRendererType(b.video), this._ctx.cOutput.rendererType === b.canvas && this.emit(F.VIDEO_RENDERER_CHANGE, { enabled: !0, canvas: this._ctx.cOutput.canvas, type: b.canvas }), this._parseStats(function(n) {
        t._mediaInfo || (t._mediaInfo = {}), t._mediaInfo.width = n.width, t._mediaInfo.height = n.height, t._mediaInfo.audioCodec = n.audioCodec, t._mediaInfo.audioSampleRate = n.audioSampleRate, t._mediaInfo.channel = n.audioChannelCount, t._mediaInfo.videoCodec = n.videoCodec, t._mediaInfo.hasVideo = !!n.videoCodec, t._mediaInfo.hasAudio = !!n.audioCodec, t._mediaInfo.streamHost = n.rtcRemoteAddress;
      }), r.prototype._onVideoLoadedmetadata.call(this);
    }, a._heartbeat = function() {
      var t = this;
      this._parseStats(function(n) {
        var s;
        n.speed || t._transmissionTimeoutTimer || ((s = t._pc) == null ? void 0 : s.connectionState) !== "connected" ? n.speed && (t._transmissionTimeoutTimer && clearTimeout(t._transmissionTimeoutTimer), t._transmissionTimeoutTimer = null) : t._transmissionTimeoutTimer = +setTimeout(function() {
          var u = pe(Re.NETWORK_ERROR, J.WEBRTC_TRANSMISSION_DATA_NULL, "transmission timeout " + t._transmissionTimeout, { fatal: !1, url: t._src });
          t.emit(F.ERROR, u), t._retry(u.reason);
        }, t._transmissionTimeout), t._ctx.loadRec.setRTCStats(n), t.emit(F.HEARTBEAT);
      });
    }, a._onVideoCanplay = function() {
      this._stat !== lt.NONE && (this._stat = lt.NONE), r.prototype._onVideoCanplay.call(this);
    }, a._load = function(t) {
      var n = this;
      this._rtcStatParser.reset(), this._stat = lt.LOADING, this.emit(F.LOAD, { type: t }), this.emit(F.NEW_SOURCE, { sync: 0 }), this._pc && this._pc.close(), this._createPeerConnection(), this._connect().catch(function(s) {
        n._retry(s == null ? void 0 : s.reason);
      });
    }, a._stopVideo = function() {
      this._video && (this._video.srcObject = null);
    }, a._retry = function(t) {
      var n = this;
      this._retrying = !0, this._pc && this._pc.close(), this._stopRetry(), this._retryCount < this._peerConnectionMaxRetry && (this._transmissionTimeoutTimer && clearTimeout(this._transmissionTimeoutTimer), this._retryTimer && clearTimeout(this._retryTimer), this._retryTimer = +setTimeout(function() {
        n._retryCount++, n._ctx.logger.i("kernel-rtc", "retry", n._retryCount, t, n._src), n.emit(F.RETRY, { type: H.RTC, message: "reason: " + t + ". retry: " + n._retryCount, code: J.WEBRTC_FAILED_ERROR }), n._retryTimer = null, n._createPeerConnection(), n._connect().then(function() {
          n._retryCount = 0, n._retrying = !1;
        }, function(s) {
          n._retryCount < n._peerConnectionMaxRetry ? n._retry(t) : n.emit(F.ERROR, zr(zr({}, s), {}, { fatal: !0, url: n._src }));
        });
      }, this._peerConnectionRetryDelay));
    }, a._stopRetry = function() {
      this._retryTimer && (clearTimeout(this._retryTimer), this._retryTimer = null);
    }, a._fetchAnwserSdp = function(t) {
      var n = this;
      this._disposeLoader();
      var s = this._loader = new Ji(this._ctx.logger), u = { url: this._src, responseType: "text", requestBody: t, requestMethod: "POST", progress: !1, headers: [{ header: "Content-type", value: "application/json" }] };
      return new Promise(function(h, p) {
        s.load(u, { onEnd: function(m, O) {
          if (n._disposeLoader(), typeof O == "string") {
            var U = JSON.parse(O);
            n.emit(F.LEVEL_UPDATED), h(U.sdp);
          }
        }, onError: function(m, O) {
          if (n._ctx.logger.e("kernel-rtc", "loadSdp", O), O.fatal) {
            var U = { type: Re.NETWORK_ERROR, details: J.RTC_SDP_LOAD_ERROR, reason: O.errMessage, fatal: O.fatal, url: n._src };
            n._disposeLoader(), p(U);
          }
        }, onAbort: function() {
          n._disposeLoader(), p();
        } }, n._loaderConfig);
      }).catch(function(h) {
        return Promise.reject(h);
      });
    }, a._createPeerConnection = function() {
      var t = this, n = this._pc = new RTCPeerConnection();
      return n.addEventListener("track", function(s) {
        return t._onPCTrack(s);
      }), n.addEventListener("connectionstatechange", function(s) {
        return t._onPCConnectionStateChange(s);
      }), n.addEventListener("icecandidateerror", function(s) {
        return t._onPCIceCandidateError(s);
      }), n.addEventListener("signalingstatechange", function(s) {
        return t._onPCSignalingStateChange(s);
      }), n.addEventListener("iceconnectionstatechange", function(s) {
        return t._onPCIceConnecttionStateChange(s);
      }), n.addEventListener("icegatheringstatechange", function(s) {
        return t._onIceGatheringStateChange(s);
      }), n.addTransceiver("audio", { direction: "recvonly" }), n.addTransceiver("video", { direction: "recvonly" }), n;
    }, a._disconnect = function() {
      this._pc && this._pc.close(), this._pc = null;
    }, a._connect = function() {
      var t = this, n = this._pc;
      return n || Promise.reject("PeerConnection isn't exist"), this._createOffer().then(function(s) {
        return t._fetchAnwserSdp(JSON.stringify({ sdp: s.sdp }));
      }).then(function(s) {
        return t._setAnwser(s);
      }).then(function() {
        return n ? new Promise(function(s, u) {
          var h = setTimeout(function() {
            var p = pe(Re.NETWORK_ERROR, J.WEBRTC_CONNECT_TIMEOUT, "webrtc connect timeout", { fatal: !1, url: t._src });
            t.emit(F.ERROR, p), u(p);
          }, t._peerConnectionTimeout);
          n.addEventListener("connectionstatechange", function p() {
            switch (n.connectionState) {
              case "connected":
                s(void 0), clearTimeout(h), n.removeEventListener("connectionstatechange", p);
                break;
              case "closed":
              case "disconnected":
              case "failed":
                clearTimeout(h), n.removeEventListener("connectionstatechange", p), u({ type: Re.NETWORK_ERROR, details: J.WEBRTC_CONNECT_FAILED, fatal: !1, reason: n.onconnectionstatechange });
            }
          });
        }) : Promise.reject("PeerConnection isn't exist");
      }).catch(function(s) {
        return t._ctx.logger.e("kernel-rtc", s), Promise.reject(s);
      });
    }, a._createOffer = function() {
      var t = this, n = this._pc;
      return n ? n.createOffer().then(function(s) {
        return t._ctx.logger.i("kernel-rtc", "offer", s), n.setLocalDescription(s).then(function() {
          return s;
        });
      }, function(s) {
        t._ctx.logger.e("kernel-rtc", "offer", s);
        var u = pe(Re.NETWORK_ERROR, J.WEBRTC_OFFER_ERROR, "webrtc createoffer error" + s, { fatal: !1, url: t._src });
        return t.emit(F.ERROR, u), Promise.reject(u);
      }) : Promise.reject();
    }, a._setAnwser = function(t) {
      var n = this, s = this._pc;
      if (!s || s.signalingState === "closed")
        return Promise.reject();
      var u = new RTCSessionDescription({ type: "answer", sdp: t });
      return s.setRemoteDescription(u).then(function() {
        n._ctx.logger.i("kernel-rtc", "answer", u);
      }, function(h) {
        n._ctx.logger.e("kernel-rtc", "answer", h);
        var p = pe(Re.NETWORK_ERROR, J.WEBRTC_ANSWER_ERROR, "webrtc answer error", { fatal: !1, url: n._src });
        return n.emit(F.ERROR, p), Promise.reject(p);
      });
    }, a._onPCTrack = function(t) {
      if (this._ctx.video && t.streams && this._stream !== t.streams[0]) {
        var n = this._stream = t.streams[0];
        this._ctx.video.srcObject = n;
        var s = this._mediaInfo = { videoDecoder: L.buildin };
        t.streams[0].getTracks().forEach(function(u) {
          var h = u.getSettings();
          s.width = h.width || s.width, s.height = h.height || s.height, s.fps = h.frameRate || s.fps;
        });
      }
    }, a._onPCConnectionStateChange = function(t) {
      var n = this._pc;
      if (n)
        switch (this._ctx.logger.i("kernel-rtc", "pcConnectionStateChange", n.connectionState, t), n.connectionState) {
          case "connecting":
          case "connected":
            break;
          case "disconnected":
          case "failed":
          case "closed":
            this.emit(F.ERROR, pe(Re.NETWORK_ERROR, J.WEBRTC_DISCONNECTED_ERROR, n.connectionState, { fatal: !1, url: this._src })), !this._retrying && this._retry("PeerConnection state is " + n.connectionState);
        }
    }, a._onPCIceCandidateError = function(t) {
      var n;
      this._ctx.logger.i("kernel-rtc", "iceCandidateError", t), this.emit(F.ERROR, pe(Re.NETWORK_ERROR, J.WEBRTC_ICE_CANDIDATE_ERROR, ((n = this._pc) == null ? void 0 : n.iceConnectionState) || "", { fatal: !1 })), !this._retrying && this._retry("iceCandidateError");
    }, a._onPCSignalingStateChange = function(t) {
      var n;
      this._ctx.logger.i("kernel-rtc", "signalingStateChange", (n = this._pc) == null ? void 0 : n.signalingState, t);
    }, a._onPCIceConnecttionStateChange = function(t) {
      var n;
      this._ctx.logger.i("kernel-rtc", "iceConnecttionStateChange", (n = this._pc) == null ? void 0 : n.iceConnectionState, t);
    }, a._onIceGatheringStateChange = function(t) {
      var n;
      this._ctx.logger.i("kernel-rtc", "iceGatheringStateChange", (n = this._pc) == null ? void 0 : n.iceGatheringState, t);
    }, a._disposeLoader = function() {
      this._loader && (this._loader.destroy(), this._loader = void 0);
    }, v()(l, [{ key: "type", get: function() {
      return N.rtc;
    } }]), l;
  }(Gr), er = "kwai-kernel-id", tr = function() {
    function r() {
    }
    return r.next = function() {
      if (fi.available) {
        var l = r._ls.read(er, !1), a = r._id;
        return typeof l == "number" ? (a = this.getNextId(l), this._ls.write(er, a)) : (a = this.getNextId(a), this._ls.write(er, a)), r._id = a, a;
      }
      return r._id = r.getNextId(r._id), r._id;
    }, r.getNextId = function(l) {
      return ++l > r.MAX_ID ? 0 : l;
    }, v()(r, null, [{ key: "MAX_ID", get: function() {
      return 999;
    } }]), r;
  }();
  tr._id = 0, tr._ls = new fi();
  var Jo = { search: function(r, l) {
    for (var a = 0, t = r.length - 1, n = null, s = null; a <= t; ) {
      var u = l(s = r[n = (a + t) / 2 | 0]);
      if (u > 0)
        a = n + 1;
      else {
        if (!(u < 0))
          return s;
        t = n - 1;
      }
    }
    return null;
  }, searchIndex: function(r, l) {
    for (var a = 0, t = r.length - 1, n = null; a <= t; ) {
      var s = l(r[n = (a + t) / 2 | 0]);
      if (s > 0)
        a = n + 1;
      else {
        if (!(s < 0))
          return n;
        t = n - 1;
      }
    }
    return -1;
  } }, es = function(r) {
    function l(t) {
      var n;
      return (n = r.call(this) || this)._logger = void 0, n._ctx = void 0, n._keyTimes = [], n._localTimeOffset = void 0, n._onParsing = function(s) {
        s.segments.forEach(function(u) {
          var h;
          u.type === B.VIDEO && u.keyTime && ((h = n._keyTimes).push.apply(h, u.keyTime.map(function(p) {
            return d()({ frag: s.frag }, p);
          })), n._keyTimes.sort(function(p, m) {
            return p.pts - m.pts;
          })), u.type === B.AUDIO && u.originFirstDTS && (n._localTimeOffset = u.originFirstDTS - u.startDTS);
        });
      }, n._onRawData = function(s) {
        var u;
        s.keyTime && (u = n._keyTimes).push.apply(u, s.keyTime.map(function(h) {
          return d()({ frag: s.frag }, h);
        }));
      }, n._onSeekWithLoad = function() {
        var s, u = ((s = n._ctx.video) == null ? void 0 : s.currentTime) || 0, h = n._ctx.lctx.current, p = 0;
        if (n._logger.i("stream-time", "on seek with load. current time: " + n._ctx.currentTime), n._ctx.stat.multipart && Object.prototype.hasOwnProperty.call(h, "fragments")) {
          var m = function(C, M) {
            return M ? Jo.search(M, function(j) {
              return C < j.start ? -1 : C > j.start + j.duration ? 1 : 0;
            }) : null;
          }(u, h.fragments);
          if (!m)
            return n._logger.i("stream-time", "no frag. clear video key time."), void n._keyTimes.splice(0, n._keyTimes.length);
          for (var O = n._keyTimes.length - 1; O >= 0; O--) {
            var U;
            if (((U = n._keyTimes[O].frag) == null ? void 0 : U.sn) === m.sn || n._keyTimes[O].originPTS < u) {
              p = O;
              break;
            }
          }
        }
        n._logger.i("stream-time", "clear video key time. st: " + p), n._keyTimes.splice(p, n._keyTimes.length - p);
      }, t.logger.i("stream-time", "constructor"), n._ctx = t, n._logger = t.logger, n._destroyableList.push(n._ctx.evt.on(F.PARSING_DATA, n._onParsing), n._ctx.evt.on(F.RAW_DATA, n._onRawData), n._ctx.evt.on(F.SEEK_WITH_LOAD, n._onSeekWithLoad)), n;
    }
    y()(l, r);
    var a = l.prototype;
    return a.reset = function() {
      this._logger.i("stream-time", "reset"), this._localTimeOffset = void 0, this._keyTimes = [];
    }, a.getLocalTime = function(t) {
      if (!(t < 0)) {
        if (this._keyTimes.length) {
          var n = this._findKeyTimeByStream(t, this._keyTimes);
          if (n)
            return this._logger.i("stream-time", "get local time by video. stream: " + t + " pts: " + n.pts + " originPTS: " + n.originPTS), t - n.originPTS + n.pts;
        }
        return this._logger.i("stream-time", "get local time by audio. stream: " + t + " offset: " + this._localTimeOffset), typeof this._localTimeOffset == "number" ? t - this._localTimeOffset : void 0;
      }
    }, a.getStreamTime = function(t) {
      if (!(t < 0)) {
        if (this._keyTimes.length) {
          var n, s = this._findKeyTimeByLocal(t, this._keyTimes);
          if (s)
            return this._logger.i("stream-time", "get stream time by video. local: " + t + " pts: " + s.pts + " originPTS: " + s.originPTS + " sn: " + ((n = s.frag) == null ? void 0 : n.sn)), t - s.pts + s.originPTS;
        }
        return this._logger.i("stream-time", "get local time by audio. local: " + t + " offset: " + this._localTimeOffset), typeof this._localTimeOffset == "number" ? t + this._localTimeOffset : void 0;
      }
    }, a._findKeyTimeByLocal = function(t, n) {
      if (n) {
        for (var s = n.length - 1; s >= 0; s--)
          if (n[s].pts <= t)
            return n[s];
      }
    }, a._findKeyTimeByStream = function(t, n) {
      if (n) {
        for (var s = n.length - 1; s >= 0; s--)
          if (n[s].originPTS <= t)
            return n[s];
      }
    }, v()(l, [{ key: "localTimeOffset", get: function() {
      return this._localTimeOffset;
    }, set: function(t) {
      this._localTimeOffset = t;
    } }]), l;
  }(W);
  function jr(r, l, a) {
    l === void 0 && (l = 3), r = Math.round(r), !a || a.startDelay === r || r <= 0 || (a.startDelay = r, a.rule = [{ rate: 1.5, lower: r + 2 * l + 1, upper: Number.MAX_SAFE_INTEGER }, { rate: 1.25, lower: r + l + 1, upper: r + 2 * l }, { rate: 1.1, lower: r + 1, upper: r + l }, { rate: 1, lower: 0, upper: r }]);
  }
  var Fe = function(r) {
    return r.SERIES_12 = "15_pro_max/15_plus/14_pro_max", r.SERIES_11 = "15_pro/15/14_pro", r.SERIES_10 = "14_plus/13_pro_max/12_pro_max", r.SERIES_9 = "14/13/13_pro/12/12_pro", r.SERIES_8 = "se_3/se_2/8/7/6s/6", r.SERIES_7 = "13_mini/12/11_pro/xs/x", r.SERIES_6 = "11_pro_max/xs_max", r.SERIES_5 = "11/xr", r.SERIES_4 = "8_plus/7_plus/6s_plus/6_plus", r.SERIES_3 = "se/5c/5s/5", r.SERIES_2 = "4s/4", r.SERIES_1 = "3gs/3g/1", r;
  }({}), ts = { "430_932_3": Fe.SERIES_12, "393_852_3": Fe.SERIES_11, "428_926_3": Fe.SERIES_10, "390_844_3": Fe.SERIES_9, "375_667_2": Fe.SERIES_8, "375_812_3": Fe.SERIES_7, "414_896_3": Fe.SERIES_6, "414_896_2": Fe.SERIES_5, "414_736_3": Fe.SERIES_4, "320_568_2": Fe.SERIES_3, "320_480_2": Fe.SERIES_2, "320_480_1": Fe.SERIES_1 };
  function Yr() {
    if ($.iphone && typeof window < "u" && window.screen) {
      var r = window.screen.width + "_" + window.screen.height + "_" + window.devicePixelRatio;
      return ts[r] || "unknown";
    }
    return "unknown";
  }
  var vi = function(r) {
    return r[r.AV_PIX_FMT_MONO = 0] = "AV_PIX_FMT_MONO", r[r.AV_PIX_FMT_YUV420P = 1] = "AV_PIX_FMT_YUV420P", r[r.AV_PIX_FMT_YUV422P = 2] = "AV_PIX_FMT_YUV422P", r[r.AV_PIX_FMT_YUV444P = 3] = "AV_PIX_FMT_YUV444P", r;
  }({}), is = new RegExp("_([0-9]+)x([0-9]+)(_([0-9]+))?(_([0-9]+))?(_(420|422|444|mono))?"), rs = ["mono", "420", "422", "444"], qr = function() {
    function r() {
      this._list = [];
    }
    var l = r.prototype;
    return l.append = function(a) {
      this._list.push(a);
    }, l.clear = function() {
      this._list = [];
    }, l.getLastMseError = function() {
      for (var a = this._list.length - 1; a >= 0; a--)
        if (this._list[a].core === N.mse)
          return this._list[a].errorData;
    }, l._toBeacon = function(a) {
      return a.map(function(t) {
        var n = { message: t.message, pos: t.pos, ts: t.ts };
        return t.code !== void 0 && (n.code = t.code), t.core !== void 0 && (n.core = t.core), t.count !== void 0 && (n.count = t.count), n;
      });
    }, v()(r, [{ key: "hasData", get: function() {
      return !!this._list.length;
    } }, { key: "retryCount", get: function() {
      return this._list.reduce(function(a, t) {
        return (typeof t.count == "number" && t.count > 0 ? t.count : 1) + a;
      }, 0);
    } }, { key: "mergedBeacon", get: function() {
      var a = [];
      return this._list.forEach(function(t) {
        var n;
        if (a.length && t.type === H.LOADER && ((n = a[a.length - 1]) == null ? void 0 : n.type) === H.LOADER) {
          var s = a[a.length - 1].count;
          a[a.length - 1].count = s ? s + 1 : 2;
        } else
          a.push(d()({}, t));
      }), this._toBeacon(a.slice(-10));
    } }, { key: "beacon", get: function() {
      return this._toBeacon(this._list.slice(-10));
    } }]), r;
  }(), ns = function() {
    function r() {
      this.coreType = N.unknown, this.native = !1, this.codecType = A.unknown, this.gopRemux = !1, this.audioCodec = "", this.recoverSwapRemux = !1, this.recoverSwapAudioCodec = !1, this.box = void 0, this.isLive = void 0, this.autoLazyLoad = !0, this.lazyLoadRecoverDuration = 12.8, this.lazyLoadMaxDuration = 16, this.firstFrameLoaded = !1, this.startFromSec = -1, this.webWorker = !0, this.muxWorker = void 0, this.isNetworkInUse = !1, this.srcType = k.OTHERS, this.isPreload = void 0, this.videoPlaybackQuality = void 0, this.drm = void 0, this.hasVideo = void 0, this.hasAudio = void 0, this.multipartLiveDelay = void 0, this.mixContainerInput = void 0, this.mixCodecInput = void 0, this.mixCodecAvailable = void 0, this.mixQualityList = void 0, this.srcMeta = void 0, this.multipart = void 0, this.demuxerType = void 0, this.retryInfo = new qr(), this.mainThreadRendering = void 0, this.stereoType = void 0, this.decoder = L.buildin, this.wasmDecoder = void 0, this.wasmSimd = void 0, this.wasmThreads = void 0, this.wasmThreadsEnabled = void 0, this.wasmLibHitCache = void 0, this.isKwaiSlice = void 0, this.autoPlaybackRateConf = void 0, this.preferNativeLoader = void 0, this.avSeparated = !1, this.mms = !1, this.hevcFallbackWasm = !1, this._liveShift = !1, this._liveShiftType = q.NONE, this._liveShiftParams = void 0;
    }
    return r.prototype.reset = function() {
      this.coreType = N.unknown, this.codecType = A.unknown, this.audioCodec = "", this.recoverSwapRemux = !1, this.recoverSwapAudioCodec = !1, this.box = g.unknown, this.autoLazyLoad = !0, this.firstFrameLoaded = !1, this.isNetworkInUse = !1, this.srcType = k.OTHERS, this.retryInfo.clear(), this.decoder = L.buildin, this.lazyLoadMaxDuration = 16, this.lazyLoadRecoverDuration = 0.8 * this.lazyLoadMaxDuration, this.isKwaiSlice = !1, this.avSeparated = !1, this.mms = !1, this.hevcFallbackWasm = !1, this._liveShift = !1, this._liveShiftType = q.NONE, this._liveShiftParams = void 0, this.drm = this.hasVideo = this.hasAudio = this.isPreload = this.videoPlaybackQuality = this.mixContainerInput = this.mixCodecInput = this.mixCodecAvailable = this.mixQualityList = this.multipart = this.stereoType = this.mainThreadRendering = this.wasmDecoder = this.wasmSimd = this.wasmThreads = this.wasmLibHitCache = void 0;
    }, v()(r, [{ key: "liveShift", get: function() {
      return this.liveShiftType !== q.NONE && this._liveShift;
    }, set: function(l) {
      this._liveShift = l;
    } }, { key: "liveShiftType", get: function() {
      return !this.isLive || this._liveShiftType === q.KWAI && $.mobile || !ze(this.box) ? q.NONE : this._liveShiftType;
    }, set: function(l) {
      this._liveShiftType = l;
    } }, { key: "liveShiftParams", get: function() {
      return this._liveShiftParams;
    }, set: function(l) {
      this._liveShiftParams = l;
    } }]), r;
  }(), ir = function(r) {
    return r[r.normal = 0] = "normal", r[r.fill = 1] = "fill", r;
  }({}), as = function(r) {
    function l() {
      for (var t, n = arguments.length, s = new Array(n), u = 0; u < n; u++)
        s[u] = arguments[u];
      return (t = r.call.apply(r, [this].concat(s)) || this)._vppList = [], t._originSizeCanvas = void 0, t._originSizeGL = null, t._video = void 0, t._webGLFrameSink = void 0, t._inputRendererType = b.video, t._draw = function() {
        t._vppList.forEach(function(h) {
          return h.vpp.draw();
        });
      }, t;
    }
    y()(l, r);
    var a = l.prototype;
    return a.reset = function() {
      r.prototype.reset.call(this), this._destroyOriginSizeCanvas(), this._webGLFrameSink = void 0, this._inputRendererType = b.video;
    }, a.updateFormatSize = function(t, n, s) {
      var u = !1, h = s % 180 == 90 || s % 180 == -90, p = h ? n : t, m = h ? t : n;
      return p === this._fSize.w && m === this._fSize.h || (u = !0, this._fSize.w = p, this._fSize.h = m, this._calculateUpperSize(), this._originSizeCanvas && (this._logger.i("canvas-output-vpp", "updateFormatSize. w:" + t + " h:" + n + " rotation:" + s), this._originSizeCanvas.width = t, this._originSizeCanvas.height = n, this._originSizeGL && (this._originSizeGL.canvas.width = t, this._originSizeGL.canvas.height = n)), this._calculateDisplaySize()), u;
    }, a.setVideo = function(t) {
      this._logger.i("canvas-output-vpp", "setVideo", t), this._video = t, this._applayVPP();
    }, a.setWebGLFrameSink = function(t) {
      this._logger.i("canvas-output-vpp", "setWebGLFrameSink"), this._webGLFrameSink = t, this._applayVPP(), t.afterDraw(this._draw);
    }, a.updateRendererType = function(t) {
      this._logger.i("canvas-output-vpp", "updateRendererType: " + t);
      var n = this.rendererType;
      return t !== b.canvas && !this.hasVPP || this._canvas || this._createOutputCanvas(), this._inputRendererType = t, this._applayVPP(), n !== this.rendererType;
    }, a.bindVPP = function(t) {
      this._logger.i("canvas-output-vpp", "bind vpp");
      for (var n = this.rendererType, s = 0; s < this._vppList.length; s++)
        if (this._vppList[s].vpp === t)
          return this._logger.i("canvas-output-vpp", "vpp has been bound."), !1;
      return this._vppList.push({ vpp: t, originSize: t.originalSizeInput }), this._canvas || this._createOutputCanvas(), this._applayVPP(), n !== this.rendererType;
    }, a.unbindVPP = function(t) {
      this._logger.i("canvas-output-vpp", "unbind vpp");
      var n = this.rendererType;
      if (!this.hasVPP)
        return !1;
      if (t) {
        for (var s = 0; s < this._vppList.length; s++)
          if (t === this._vppList[s].vpp) {
            var u = this._vppList.splice(s, 1);
            u.length && (u[0].vpp.detachSource(), u[0].vpp.detachOutputCanvas());
            break;
          }
      } else
        this._vppList.forEach(function(h) {
          h.vpp.detachSource(), h.vpp.detachOutputCanvas();
        }), this._vppList.splice(0);
      return this.hasVPP ? this._applayVPP() : (this._logger.i("canvas-output-vpp", "unbind all vpp"), this._inputRendererType === b.video && this._canvas && this._destroyCanvas(), this._inputRendererType === b.canvas && this._webGLFrameSink && (this.webgl && this._webGLFrameSink.setWebGLCtx(this.webgl, ir.normal), this._webGLFrameSink.drawToCanvas(), this._webGLFrameSink.reDraw())), n !== this.rendererType;
    }, a.destroy = function() {
      r.prototype.destroy.call(this), this._destroyOriginSizeCanvas();
    }, a._calculateUpperSize = function() {
      r.prototype._calculateUpperSize.call(this), this._draw();
    }, a._applayVPP = function() {
      var t = this;
      if (this._canvas && this.hasVPP) {
        var n, s = this.webgl;
        if (this._inputRendererType === b.canvas) {
          if (!this._webGLFrameSink)
            return;
          n = this._canvas;
        } else
          this._inputRendererType === b.video && (n = this._video);
        if (n && s) {
          if (this._inputRendererType === b.canvas)
            if (this._vppList[0].originSize) {
              var u, h;
              this._originSizeGL || this._createOriginSizeCanvas(), this._originSizeGL && (this._logger.i("canvas-output-vpp", "webgl set origin size", this._originSizeGL), (u = this._webGLFrameSink) == null || u.setWebGLCtx(this._originSizeGL, ir.fill), (h = this._webGLFrameSink) == null || h.drawToCanvas()), n = this._originSizeCanvas;
            } else {
              var p, m;
              (p = this._webGLFrameSink) == null || p.setWebGLCtx(s, ir.normal), (m = this._webGLFrameSink) == null || m.drawToFBO();
            }
          this._logger.i("canvas-output-vpp", "apply vpp", n, s, JSON.stringify(this._fSize)), this._vppList.forEach(function(O, U) {
            n && (O.vpp.attachOutputCanvas(s), O.vpp.attachSource(n), U < t._vppList.length - 1 && (n = O.vpp.drawToFBO())), O.vpp.draw();
          });
        }
      }
    }, a._createOriginSizeCanvas = function() {
      this._originSizeCanvas = this._createCanvas(this._fSize), !this._originSizeGL && this._originSizeCanvas && (this._originSizeGL = Nr(this._originSizeCanvas));
    }, a._destroyOriginSizeCanvas = function() {
      if (this._logger.i("canvas-output-vpp", "destroy origin size canvas"), this._originSizeGL) {
        this._logger.i("canvas-output-vpp", "origin size lose ctx");
        var t = this._originSizeGL.getExtension("WEBGL_lose_context");
        t && t.loseContext(), this._originSizeGL = null;
      }
      this._originSizeCanvas && (this._originSizeCanvas = void 0);
    }, v()(l, [{ key: "rendererType", get: function() {
      return this._inputRendererType === b.video ? this.hasVPP ? b.canvas : b.video : b.canvas;
    } }, { key: "output", get: function() {
      return this.rendererType === b.video ? this._video : this._canvas;
    } }, { key: "hasVPP", get: function() {
      return this._vppList.length > 0;
    } }]), l;
  }(function() {
    function r(a, t) {
      this._logger = void 0, this._canvas = void 0, this._gl = null, this._cSize = { w: 0, h: 0 }, this._fSize = { w: 0, h: 0 }, this._dSize = { w: 0, h: 0 }, this._canvas = t, this._logger = a, a.i("canvas-output", "constructor");
    }
    var l = r.prototype;
    return l.reset = function() {
      this._logger.i("canvas-output", "reset"), this._destroyCanvas();
    }, l.updateCanvasSize = function(a, t) {
      var n = !1;
      return a === this._cSize.w && t === this._cSize.h || (n = !0, this._cSize.w = a, this._cSize.h = t, this._calculateUpperSize()), this._calculateDisplaySize(), n;
    }, l.updateFormatSize = function(a, t, n) {
      var s = !1, u = n % 180 == 90 || n % 180 == -90, h = u ? t : a, p = u ? a : t;
      return h === this._fSize.w && p === this._fSize.h || (s = !0, this._fSize.w = h, this._fSize.h = p, this._calculateUpperSize(), this._calculateDisplaySize()), s;
    }, l.destroy = function() {
      this._logger.i("canvas-output", "destroy"), this._destroyCanvas();
    }, l._calculateUpperSize = function() {
      if (this._canvas && this._cSize.h) {
        var a = this._cSize, t = a.w, n = a.h, s = this._fSize, u = s.w, h = s.h;
        if (h) {
          var p = t / n;
          p > u / h ? n > h && (t = (n = h) * p) : t > u && (n = (t = u) / p);
        }
        this._canvas.width = t, this._canvas.height = n, this._logger.i("canvas-output", "update canvas size", t, n);
      }
    }, l._calculateDisplaySize = function() {
      var a, t, n = ((a = this._canvas) == null ? void 0 : a.width) || this._cSize.w, s = ((t = this._canvas) == null ? void 0 : t.height) || this._cSize.h, u = this._fSize, h = u.w / u.h;
      h > n / s ? (this._dSize.w = n, this._dSize.h = Math.round(n / h)) : (this._dSize.w = Math.round(s * h), this._dSize.h = s);
    }, l._createCanvas = function(a) {
      this._logger.i("canvas-output", "create canvas");
      var t = document.createElement("canvas");
      return a.w ? (t.width = a.w, t.height = a.h) : (a.w = t.width, a.h = t.height), t;
    }, l._createOutputCanvas = function() {
      this._canvas || (this._canvas = this._createCanvas(this._cSize));
    }, l._destroyCanvas = function() {
      if (this._logger.i("canvas-output", "destroy canvas"), this._gl) {
        var a = this._gl.getExtension("WEBGL_lose_context");
        a && a.loseContext();
      }
      this._gl = null, this._canvas && (typeof HTMLCanvasElement < "u" && this._canvas instanceof HTMLCanvasElement && this._canvas.remove(), this._canvas = void 0);
    }, v()(r, [{ key: "canvas", get: function() {
      return this._canvas;
    } }, { key: "webgl", get: function() {
      return !this._gl && this._canvas && (this._gl = Nr(this._canvas)), this._gl;
    } }, { key: "canvasSize", get: function() {
      return this._cSize;
    } }, { key: "formatSize", get: function() {
      return this._fSize;
    } }, { key: "displaySize", get: function() {
      return this._dSize;
    } }]), r;
  }()), os = function() {
    function r() {
      this._lastDroppedFrames = 0, this._lastDecodedFrames = 0, this._lastTime = 0, this._decoded = 0, this._dropped = 0;
    }
    var l = r.prototype;
    return l.reset = function() {
      this._lastTime = performance.now(), this._lastDroppedFrames = this._lastDecodedFrames = this._decoded = this._dropped = 0;
    }, l.getFPS = function(a) {
      if (a) {
        var t, n = performance.now(), s = a.totalVideoFrames, u = a.droppedVideoFrames;
        if (s) {
          s < this._lastDecodedFrames && (this._lastDecodedFrames = 0, this._lastDroppedFrames = 0);
          var h = n - this._lastTime, p = u - this._lastDroppedFrames, m = s - this._lastDecodedFrames, O = 0, U = 0;
          this._lastTime && (O = parseFloat((1e3 * p / h).toFixed(2)), U = parseFloat((1e3 * m / h).toFixed(2))), this._decoded = this._decoded += m, this._dropped = this._dropped += p, this._lastTime = n, this._lastDroppedFrames = u, this._lastDecodedFrames = s, t = { decoded: this._decoded, dropped: this._dropped, decodedFPS: U, droppedFPS: O };
        }
        return this._lastTime = n, t;
      }
    }, r;
  }(), ss = function() {
    function r() {
      this._$evt = new D.EventEmitter();
    }
    var l = r.prototype;
    return l.on = function(a, t) {
      var n = this;
      return this._$evt.on(a, t), { destroy: function() {
        return n._$evt.off(a, t);
      } };
    }, l.prependListener = function(a, t) {
      var n = this;
      return this._$evt.prependListener(a, t), { destroy: function() {
        return n._$evt.off(a, t);
      } };
    }, l.removeAllListeners = function(a) {
      this._$evt.removeAllListeners(a);
    }, l.off = function(a, t) {
      this._$evt.off(a, t);
    }, l.listeners = function(a) {
      return this._$evt.listeners(a);
    }, l.emit = function(a, t) {
      return this._$evt.emit(a, t);
    }, l.listenerCount = function(a) {
      return this._$evt.listenerCount(a);
    }, r;
  }(), Qr = function() {
    function r(a, t) {
      this._logger = void 0, this._abr = !1, this._startIdx = -1, this._currentIdx = 0, this._nextIdx = 0, this._levels = [], this._audioIdx = 0, this._audioTracks = [], this._subtitleIdx = 0, this._subtitleTracks = [], this._abrLevels = [], this._default = void 0, this._availableList = void 0, a.i("level-ctx", "constructor abr:" + t), this._logger = a, this._abr = t;
    }
    var l = r.prototype;
    return l.getLevel = function(a) {
      return a === void 0 && (a = w.MAIN), a === w.MAIN ? this._levels[this._currentIdx] : a === w.AUDIO ? this._audioTracks[this._audioIdx] : a === w.SUBTITLE ? this._subtitleTracks[this._subtitleIdx] : void 0;
    }, l.setLevelIdx = function(a, t) {
      t === void 0 && (t = w.MAIN), t === w.MAIN ? this.currentIdx = a : t === w.AUDIO ? this.audioIdx = a : t === w.SUBTITLE && (this.subtitleIdx = a);
    }, l.getLevelIdx = function(a) {
      return a === void 0 && (a = w.MAIN), a === w.MAIN ? this._currentIdx : a === w.AUDIO ? this._audioIdx : a === w.SUBTITLE ? this._subtitleIdx : -1;
    }, l.setNextIdx = function(a, t) {
      t === void 0 && (t = w.MAIN), t === w.MAIN && (this.nextIdx = a);
    }, l.getNextIdx = function(a) {
      return a === void 0 && (a = w.MAIN), a === w.MAIN ? this._nextIdx : -1;
    }, l.clearFrag = function() {
      this._logger.i("level-ctx", "clear"), [this._levels, this._audioTracks, this._subtitleTracks].forEach(function(a) {
        a.forEach(function(t) {
          var n = t;
          n.fragments && n.clear();
        });
      });
    }, l.abrIndexToOrign = function(a) {
      var t = this._abrLevels[a];
      return t ? t.index : 0;
    }, l.orignIndexToAbr = function(a) {
      var t = 0;
      return this._abrLevels.forEach(function(n, s) {
        n.index !== a || (t = s);
      }), t;
    }, l._generateAbrList = function() {
      var a = this, t = this._availableList;
      this._default = 0, this._abrLevels = [], this._levels.forEach(function(n, s) {
        n.default && !t && (a._default = s), n.enableAdaptive && (!t || t && t.indexOf(s) !== -1) && a._abrLevels.push(n);
      }), this._abrLevels.sort(function(n, s) {
        return n.bitrate - s.bitrate;
      });
    }, v()(r, [{ key: "abr", get: function() {
      return this._abr;
    }, set: function(a) {
      this._abr = a;
    } }, { key: "startIdx", get: function() {
      return this._startIdx;
    }, set: function(a) {
      this._startIdx = a;
    } }, { key: "currentIdx", get: function() {
      return this._currentIdx;
    }, set: function(a) {
      a >= 0 && (this._currentIdx = a);
    } }, { key: "nextIdx", get: function() {
      return this._nextIdx;
    }, set: function(a) {
      a >= 0 && (this._nextIdx = a);
    } }, { key: "levels", get: function() {
      return this._levels;
    }, set: function(a) {
      this._levels = a, this._generateAbrList();
    } }, { key: "current", get: function() {
      return this._levels[this._currentIdx];
    } }, { key: "currentUrl", get: function() {
      var a = this._levels[this._currentIdx];
      return a ? a.url[a.urlId] : "";
    } }, { key: "audioIdx", get: function() {
      return this._audioIdx;
    }, set: function(a) {
      a >= 0 && (this._audioIdx = a);
    } }, { key: "audioTracks", get: function() {
      return this._audioTracks;
    }, set: function(a) {
      this._audioTracks = a;
    } }, { key: "audio", get: function() {
      return this._audioTracks[this._audioIdx];
    } }, { key: "subtitleIdx", get: function() {
      return this._subtitleIdx;
    }, set: function(a) {
      a >= 0 && (this._subtitleIdx = a);
    } }, { key: "subtitleTracks", get: function() {
      return this._subtitleTracks;
    }, set: function(a) {
      this._subtitleTracks = a;
    } }, { key: "subtitle", get: function() {
      return this._subtitleTracks[this._subtitleIdx];
    } }, { key: "abrLevels", get: function() {
      return this._abrLevels;
    } }, { key: "availableList", set: function(a) {
      this._availableList = a, this._generateAbrList();
    } }, { key: "default", get: function() {
      return this._default || 0;
    }, set: function(a) {
      this._default = a;
    } }, { key: "abrDefault", get: function() {
      var a = 0;
      return this._abrLevels.forEach(function(t, n) {
        t.default && (a = n);
      }), a;
    } }]), r;
  }(), _t = { local: 0, server: 0 }, zt = function() {
    function r(a) {
      var t = this;
      this._logger = void 0, this._loader = void 0, this._callback = void 0, this._loaderConfig = void 0, this._onLoaderError = function() {
        t._disposeLoader();
      }, this._onLoaderEnd = function(n, s) {
        if (t._disposeLoader(), typeof s == "string") {
          _t.local = performance.now();
          var u = s.split(",");
          _t.server = 1e3 * parseFloat(u[0]) + parseInt(u[1], 10) / 1e3 / 2;
        }
      }, this._logger = a, this._callback = { onError: this._onLoaderError, onEnd: this._onLoaderEnd }, this._loaderConfig = { connectionTimeout: 5e3 };
    }
    r.serverMs = function(a) {
      return _t.server ? a - _t.local + _t.server : null;
    }, r.clear = function() {
      _t.local = 0, _t.server = 0;
    };
    var l = r.prototype;
    return l.load = function(a) {
      this._disposeLoader();
      var t = { url: "https://ntp.nc.gifshow.com/", responseType: "text", progress: !1, preferNative: a };
      (this._loader = new Ji(this._logger)).load(t, this._callback, this._loaderConfig);
    }, l.destroy = function() {
      this._disposeLoader();
    }, l._disposeLoader = function() {
      this._loader && this._loader.destroy();
    }, v()(r, [{ key: "time", get: function() {
      return d()({}, _t);
    } }], [{ key: "serverNowMs", get: function() {
      return _t.server ? performance.now() - _t.local + _t.server : null;
    } }]), r;
  }(), Xr = function() {
    function r(a) {
      this._logger = void 0, this._ntp = void 0, this._priv = { abst: 0, originDTS: 0 }, this._vLastExtraInfo = void 0, this._aLastExtraInfo = void 0, this._logger = a, this._ntp = new zt(a);
    }
    var l = r.prototype;
    return l.init = function(a) {
      !zt.serverNowMs && this._ntp && this._ntp.load(a);
    }, l.onPrivNal = function(a) {
      a.abst && (this._priv.abst = a.abst, this._priv.originDTS = a.originDTS);
    }, l.onParsing = function(a) {
      var t = this;
      a.segments.forEach(function(n) {
        n.type === B.VIDEO ? t._vLastExtraInfo = { dts: n.startDTS, originDTS: n.originFirstDTS, parseTime: n.firstParseTime } : n.type === B.AUDIO && (t._aLastExtraInfo = { dts: n.startDTS, originDTS: n.originFirstDTS, parseTime: n.firstParseTime });
      });
    }, l.destroy = function() {
      this._ntp && (this._ntp.destroy(), this._ntp = void 0);
    }, l.getDisplayDelay = function(a) {
      return this._renderDelay(a, this._vLastExtraInfo);
    }, l.getAudioRenderDelay = function(a) {
      return this._renderDelay(a, this._aLastExtraInfo);
    }, l.getRecDelay = function() {
      var a = this._vLastExtraInfo;
      if (zt.serverNowMs && a != null && a.parseTime) {
        var t = this._priv, n = zt.serverMs(1e3 * a.parseTime + r._workerStartMs);
        if (n && t.originDTS && t.abst)
          return Math.round(n - 1e3 * (a.originDTS - t.originDTS + t.abst));
      }
      return 0;
    }, l._renderDelay = function(a, t) {
      var n = zt.serverNowMs, s = this._priv;
      return n && t && s.abst && s.originDTS ? Math.round(1e3 * (t.dts - a - (t.originDTS - s.originDTS + s.abst)) + n) : 0;
    }, v()(r, null, [{ key: "workerTimeOffset", set: function(a) {
      r._workerStartMs = a;
    } }]), r;
  }();
  Xr._workerStartMs = 0;
  var Zr = Xr, Jr = function() {
    function r() {
      this._traffic = 0, this._streams = [], this._download = [], this._trafficGroupedByVCodecType = {}, this._trafficGroupedByLevel = {}, this._currentLoad = void 0, this._contentLen = 0, this._muxA = 0, this._muxV = 0, this._fillA = 0, this._fillV = 0, this._droppedA = 0, this._droppedV = 0;
    }
    var l = r.prototype;
    return l.onStreamOpen = function(a, t, n, s) {
      if (this._streams.length > 10) {
        var u = this._streams.shift();
        if (u) {
          this._trafficGroupedByVCodecType[u.vCodecType] = (this._trafficGroupedByVCodecType[u.vCodecType] || 0) + u.traffic;
          var h = u.qualityType || "unknown";
          this._trafficGroupedByLevel[h] = (this._trafficGroupedByLevel[h] || 0) + u.traffic;
        }
      }
      var p = this._currentLoad ? this._currentLoad.index + 1 : 0;
      this._currentLoad = { index: p, startPos: a, url: t, bitrate: n, qualityType: s, traffic: 0, loadTimeCost: 0, keyFrame: 0, videoDataRate: 0, audioDataRate: 0, speed: 0, vCodecType: A.unknown, segments: [] }, this._streams.push(this._currentLoad);
    }, l.onMediaInfo = function(a) {
      var t = this._streams[this._streams.length - 1];
      t && (a.videoCodecType && (t.vCodecType = a.videoCodecType), t.mediaInfo = d()({}, a));
    }, l.setRTCStats = function(a) {
      var t = this._currentLoad;
      t && (t.traffic = a.totalReceive, t.audioDataRate = a.audioDataRate, t.videoDataRate = a.videoDataRate, t.speed = a.speed, t.keyFrame = a.key, this._traffic = t.traffic);
    }, l.onDataReceive = function(a) {
      this._traffic += a.byteLength;
      var t = this._download;
      t.length > 200 && t.pop(), t.unshift(a);
      var n = this._currentLoad;
      n && (n.traffic += a.byteLength, n.loadTimeCost += a.timeCost, n.speed = Math.round(n.traffic / n.loadTimeCost * 1e3) || 0);
    }, l.onParsing = function(a) {
      var t = this;
      a.segments.forEach(function(n) {
        if (t._calculateDataRate(n.type, 1e3 * (n.endDTS - n.startDTS), n.payload.byteLength), n.type === B.VIDEO) {
          var s = n.endDTS - n.startDTS;
          isNaN(s) || (t._muxV += Math.round(1e3 * s)), n.fillDuration && (t._fillV += Math.round(1e3 * n.fillDuration)), n.dropDuration && (t._droppedV += Math.round(1e3 * n.dropDuration));
        }
        if (n.type === B.AUDIO) {
          var u = n.endDTS - n.startDTS;
          isNaN(u) || (t._muxA += Math.round(1e3 * u)), n.fillDuration && (t._fillA += Math.round(1e3 * n.fillDuration)), n.dropDuration && (t._droppedA += Math.round(1e3 * n.dropDuration));
        }
      });
    }, l.onRaw = function(a) {
      if (a.samples.length) {
        var t = a.samples.reduce(function(s, u) {
          return u.yuv ? s + u.yuv.y.bytes.length + u.yuv.u.bytes.length + u.yuv.v.bytes.length : s + u.units.reduce(function(h, p) {
            return h + p.data.byteLength;
          }, 0);
        }, 0), n = a.samples[a.samples.length - 1].dts - a.samples[0].dts + (a.samples[a.samples.length - 1].duration || 0);
        this._calculateDataRate(B.VIDEO, n / 90, t);
      }
    }, l.downloadInfoByRange = function(a) {
      a === void 0 && (a = 1e3);
      var t = { size: 0, timeCost: 0 };
      if (this._download.length)
        for (var n = performance.now(), s = 0; s < this._download.length && this._download[s].ts > n - a; s++)
          t.size += this._download[s].byteLength, t.timeCost += this._download[s].timeCost;
      return t;
    }, l._calculateDataRate = function(a, t, n) {
      var s = this._streams[this._streams.length - 1];
      if (s) {
        var u = s.segments;
        u.push({ type: a, duration: t, byteLength: n }), u.length > 200 && u.shift();
        for (var h = 0, p = 0, m = 0; m < u.length; m++)
          u[m].type === a && (p += u[m].byteLength, h += u[m].duration);
        h > 0 && (a === B.VIDEO ? s.videoDataRate = Math.round(8 * p / h) : a === B.AUDIO && (s.audioDataRate = Math.round(8 * p / h)));
      }
    }, v()(r, [{ key: "smoothedDownloadSpeed", get: function() {
      var a = this._download, t = a[0];
      return t && !t.progress ? t.byteLength / t.timeCost * 1e3 : 1e3 * a.reduceRight(function(n, s) {
        var u = s.byteLength / s.timeCost;
        return n > 0 ? u * (1 - 0.9) + 0.9 * n : u;
      }, 0);
    } }, { key: "trafficGroupedByVCodecType", get: function() {
      var a = d()({}, this._trafficGroupedByVCodecType);
      return a.total = this._traffic, this._streams.forEach(function(t) {
        a[t.vCodecType] = (a[t.vCodecType] || 0) + t.traffic;
      }), a;
    } }, { key: "trafficGroupedByLevel", get: function() {
      var a = d()({}, this._trafficGroupedByLevel);
      return a.total = this._traffic, this._streams.forEach(function(t) {
        var n = t.qualityType || "unknown";
        a[n] = (a[n] || 0) + t.traffic;
      }), a;
    } }, { key: "traffic", get: function() {
      return this._traffic;
    } }, { key: "speed", get: function() {
      var a = this._currentLoad, t = this.downloadInfoByRange();
      return this._download.length ? t.timeCost ? Math.round(t.size / t.timeCost * 1e3) : 0 : (a == null ? void 0 : a.speed) || 0;
    } }, { key: "currentLoad", get: function() {
      return this._currentLoad;
    } }, { key: "streams", get: function() {
      return this._streams;
    } }, { key: "contentLen", get: function() {
      return this._contentLen;
    }, set: function(a) {
      this._contentLen = a;
    } }, { key: "muxA", get: function() {
      return this._muxA;
    } }, { key: "muxV", get: function() {
      return this._muxV;
    } }, { key: "fillA", get: function() {
      return this._fillA;
    } }, { key: "fillV", get: function() {
      return this._fillV;
    } }, { key: "droppedA", get: function() {
      return this._droppedA;
    } }, { key: "droppedV", get: function() {
      return this._droppedV;
    } }]), r;
  }(), mi = o(6), ls = function(r) {
    return r.WIDEVINE = "urn:uuid:edef8ba9-79d6-4ace-a3c8-27dcd51d21ed", r;
  }({});
  !ht() && window.navigator && window.navigator.requestMediaKeySystemAccess && window.navigator.requestMediaKeySystemAccess.bind(window.navigator);
  function en(r) {
    return !r.drmSchemaId || r.drmSchemaId === ls.WIDEVINE;
  }
  var cs = function() {
    function r(l, a) {
      this._uri = null, this.baseuri = void 0, this.reluri = void 0, this.method = null, this.key = null, this.iv = void 0, this.baseuri = l, this.reluri = a;
    }
    return v()(r, [{ key: "uri", get: function() {
      return !this._uri && this.reluri && (this._uri = Object(mi.buildAbsoluteURL)(this.baseuri, this.reluri, { alwaysNormalize: !0 })), this._uri;
    } }]), r;
  }(), tn = function(r) {
    return r.AUDIO = "audio", r.VIDEO = "video", r;
  }({}), rn = function() {
    function r() {
      var a;
      this._url = "", this._byteRange = null, this._decryptdata = null, this._elementaryStreams = ((a = {})[tn.AUDIO] = !1, a[tn.VIDEO] = !1, a), this.rawProgramDateTime = null, this.programDateTime = null, this.tagList = [], this.relurl = void 0, this.baseurl = void 0, this.duration = void 0, this.sn = 0, this.levelkey = void 0, this.level = 0, this.start = 0, this.cc = 0, this.maxStartPTS = 0, this.startPTS = void 0, this.endPTS = void 0, this.startDTS = void 0, this.endDTS = void 0, this.deltaPTS = void 0, this.dropped = 0, this.type = void 0, this.loader = void 0, this.title = null, this.urlId = 0, this.data = void 0;
    }
    var l = r.prototype;
    return l.setByteRange = function(a, t) {
      var n = a.split("@", 2), s = [];
      n.length === 1 ? s[0] = t ? t.byteRangeEndOffset : 0 : s[0] = parseInt(n[1], 10), s[1] = parseInt(n[0], 10) + s[0], this._byteRange = s;
    }, l.addElementaryStream = function(a) {
      this._elementaryStreams[a] = !0;
    }, l.hasElementaryStream = function(a) {
      return this._elementaryStreams[a] === !0;
    }, l.createInitializationVector = function(a) {
      for (var t = new Uint8Array(16), n = 12; n < 16; n++)
        t[n] = a >> 8 * (15 - n) & 255;
      return t;
    }, l.setDecryptDataFromLevelKey = function(a, t) {
      var n = a;
      return a && a.method && a.uri && !a.iv && ((n = new cs(a.baseuri, a.reluri)).method = a.method, n.iv = this.createInitializationVector(t)), n;
    }, v()(r, [{ key: "url", get: function() {
      return !this._url && this.relurl && (this._url = Object(mi.buildAbsoluteURL)(this.baseurl, this.relurl, { alwaysNormalize: !0 })), this._url;
    }, set: function(a) {
      this._url = a;
    } }, { key: "byteRange", get: function() {
      return this._byteRange ? this._byteRange : [];
    } }, { key: "byteRangeStartOffset", get: function() {
      return this.byteRange[0];
    } }, { key: "byteRangeEndOffset", get: function() {
      return this.byteRange[1];
    } }, { key: "decryptdata", get: function() {
      if (!this.levelkey && !this._decryptdata)
        return null;
      if (!this._decryptdata && this.levelkey) {
        var a = this.sn;
        typeof a != "number" && (a = 0), this._decryptdata = this.setDecryptDataFromLevelKey(this.levelkey, a);
      }
      return this._decryptdata;
    } }, { key: "endProgramDateTime", get: function() {
      if (this.programDateTime === null || !Number.isFinite(this.programDateTime))
        return null;
      var a = Number.isFinite(this.duration) ? this.duration : 0;
      return this.programDateTime + 1e3 * a;
    } }, { key: "encrypted", get: function() {
      return !(!this.decryptdata || this.decryptdata.uri === null || this.decryptdata.key !== null);
    } }]), r;
  }(), ii = function() {
    function r(l) {
      this.url = [], this.urlId = 0, this.bitrate = 0, this.maxBitrate = 0, this.qualityType = "", this.qualityLabel = "", this.id = 0, this.codec = "", this.audioCodec = "", this.videoCodec = "", this.hidden = !1, this.enableAdaptive = !0, this.default = !1, this.width = void 0, this.height = void 0, this.index = 0, this.drmSchemaId = "", this.drmToken = "", this.hdr = void 0, this.vCodecType = A.unknown, this.meta = void 0, this.fileName = void 0, this.fileSize = void 0, this.url = [l], this.urlId = 0;
    }
    return r.prototype.getKLevel = function() {
      return { width: this.width, height: this.height, qualityLabel: this.qualityLabel, qualityType: this.qualityType, bitrate: this.bitrate, maxBitrate: this.maxBitrate };
    }, v()(r, [{ key: "currentUrl", get: function() {
      return this.url[this.urlId] || "";
    } }]), r;
  }(), rr = function(r) {
    function l(t) {
      var n;
      return (n = r.call(this, t) || this).startSN = 0, n.endSN = 0, n.fragments = [], n.initSegment = null, n.live = !0, n.needSidxRanges = !1, n.startTimeOffset = null, n.targetduration = 0, n.totalduration = 0, n.type = null, n.version = null, n.ptsKnown = !1, n.m3u8Slice = void 0, n.audioGroupIds = void 0, n.attrs = void 0, n.averagetargetduration = void 0, n.name = void 0, n.lang = void 0, n.groupId = "", n.instreamId = "", n.autoselect = void 0, n.forced = void 0, n.size = 0, n.partOfData = !1, n.http416 = 0, n;
    }
    y()(l, r);
    var a = l.prototype;
    return a.clear = function() {
      this.fragments = [], this.startSN = 0, this.endSN = 0, this.initSegment = null, this.m3u8Slice = void 0, this.live = !0, this.needSidxRanges = !1, this.startTimeOffset = 0;
    }, a.mergeFrom = function(t, n) {
      if (n === void 0 && (n = !1), t.fragments.length) {
        var s = this.endSN;
        if (this.endSN = t.endSN, t.partOfData || (t.initSegment && !this.initSegment && (this.initSegment = t.initSegment), this.live = t.live, this.needSidxRanges = t.needSidxRanges, this.targetduration = t.targetduration, this.ptsKnown = t.ptsKnown, this.averagetargetduration = t.averagetargetduration, this.hasFrag || (this.m3u8Slice = t.m3u8Slice, this.audioGroupIds = t.audioGroupIds, this.attrs = t.attrs, this.name = t.name, this.lang = t.lang, this.groupId = t.groupId, this.instreamId = t.instreamId, this.autoselect = t.autoselect, this.forced = t.forced)), n && this.fragments.length) {
          for (var u, h = t.fragments.length, p = 0; p < t.fragments.length; p++) {
            var m = t.fragments[p].sn;
            if (typeof m == "number" && m > s) {
              h = p;
              break;
            }
          }
          if (this.fragments.length && t.fragments.splice(0, h), t.partOfData) {
            var O = this.fragments[this.fragments.length - 1].endPTS, U = this.fragments[this.fragments.length - 1].cc;
            O && t.fragments.forEach(function(C) {
              C.start = C.startPTS = O, C.endPTS = C.startPTS + C.duration, O = C.endPTS, C.cc = U + C.cc;
            });
          }
          (u = this.fragments).push.apply(u, t.fragments), this.totalduration = this.fragments.reduce(function(C, M) {
            return C + M.duration;
          }, 0), t.partOfData ? this.size += t.size : this.size = t.size;
        } else
          this.startSN = t.startSN, this.fragments = t.fragments, this.totalduration = t.totalduration, this.size = t.size;
      }
    }, a.getTimeInfoAfter = function(t) {
      t === void 0 && (t = 0);
      var n, s, u = [], h = [];
      return this.fragments.forEach(function(p) {
        typeof p.sn == "number" && (p.sn >= t && typeof s == "number" && s !== p.cc && (n ? n.push({ sn: p.sn, start: p.start }) : n = [{ sn: p.sn, start: p.start }]), s = p.cc, p.sn >= t && (u.push(p.start), typeof p.programDateTime == "number" && h.push(p.programDateTime)));
      }), { live: this.live, startSn: this.startSN, endSn: this.endSN, duration: this.totalduration, times: u, utcs: h, discontinuity: n, targetduration: this.targetduration };
    }, v()(l, [{ key: "timeInfo", get: function() {
      return this.getTimeInfoAfter();
    } }, { key: "hasProgramDateTime", get: function() {
      return !(!this.fragments[0] || typeof this.fragments[0].programDateTime != "number" || !Number.isFinite(this.fragments[0].programDateTime));
    } }, { key: "hasFrag", get: function() {
      return this.fragments.length > 0;
    } }]), l;
  }(ii), us = function(r) {
    return r[r.LongVideo = 1] = "LongVideo", r[r.ShortVideo = 2] = "ShortVideo", r[r.LiveGame = 3] = "LiveGame", r[r.LiveShow = 4] = "LiveShow", r[r.LivePlayBack = 5] = "LivePlayBack", r;
  }({}), ds = { 1: g.hls_ts, 2: g.mp4, 3: g.flv, 4: g.hls_fmp4 }, nn = { avc: A.h264, hevc: A.hevc, av1: A.av1, kvc3: A.kvc3, kvc4: A.kvc4, kvc5: A.kvc5, kvc6: A.kvc6, kvc30: A.kvc30 }, Lt = function() {
    function r() {
    }
    return r.verify = function(l) {
      return !!(l && l.adaptationSet && l.adaptationSet.length) && l.adaptationSet.reduce(function(a, t) {
        return !!(a && t.representation && t.representation.length);
      }, !0);
    }, r.parse = function(l, a) {
      a === void 0 && (a = !1);
      var t, n, s, u, h, p, m, O, U, C = [], M = !1, j = 0, le = [], re = {};
      if (r.verify(l)) {
        var Q = l;
        p = ds[Q.mediaType], m = Q.stereoType === 1 ? K.V360 : K.Normal, Q.businessType !== void 0 && (O = Q.businessType >= 3 && Q.businessType <= 5), Q.businessType === us.LivePlayBack && (U = !0), Q.version && (re.version = Q.version), Q.videoId && (re.videoId = Q.videoId), Q.videoBaseFeature && (re.videoBaseFeature = Q.videoBaseFeature), Q.videoAestheticFeature && (re.videoAestheticFeature = Q.videoAestheticFeature), Q.videoFeature && (re.videoFeature = Q.videoFeature), Q.adaptationSet.forEach(function(Ae) {
          var fe = Ae.duration / 1e3;
          O === void 0 && fe && (O = !1), !j && fe && (j = fe);
          var yi = Ae.drmSchemaId, ks = Ae.drmToken;
          Ae.drmSchemaId && (M = !0);
          var ut = w.MAIN;
          if (Ae.mimeType && (Ae.mimeType.indexOf("video") !== -1 ? re.videoMimeType = Ae.mimeType : Ae.mimeType.indexOf("audio") !== -1 ? (re.audioMimeType = Ae.mimeType, ut = w.AUDIO) : Ae.mimeType === "text/vtt" ? (re.subtitleMimeType = Ae.mimeType, ut = w.SUBTITLE) : ut = void 0), ut) {
            ut === w.MAIN ? re.videoDuration = Ae.duration : ut === w.AUDIO && (re.audioDuration = Ae.duration);
            var dr = Ae.representation.map(function(ce, ri) {
              var ne;
              if (!p && ce.m3u8Slice && (p = g.hls), p || (p = te(ce.url)), ze(p) ? ((ne = new rr(ce.url)).lang = Ae.language || "", ne.default = !!ce.defaultSelect, ne.id = ce.id || ri, ne.m3u8Slice = ce.m3u8Slice, ne.totalduration = fe || j) : ne = new ii(ce.url), typeof ce.fileSize == "number" && (ne.fileSize = ce.fileSize), ne.vCodecType = A.unknown, ne.hdr = ce.hdrType || 0, ne.maxBitrate = ce.maxBitrate || 0, ne.bitrate = ce.avgBitrate || ne.maxBitrate, ne.qualityType = ce.qualityType || "", ne.qualityLabel = ce.qualityLabel || "", ne.codec = ce.codecs || "", ne.codec) {
                var Cs = Vr(ne.codec);
                ne.videoCodec = Cs.video || "", ne.vCodecType = Hr(ne.videoCodec);
              }
              return ce.videoCodec && nn[ce.videoCodec] && (ne.vCodecType = nn[ce.videoCodec] || A.unknown), le.push(ne.vCodecType), Q.adaptationSet.length === 1 && (ne.audioCodec = ""), ce.width && ce.height && (ne.width = ce.width, ne.height = ce.height), ne.hidden = ce.hidden || !1, ne.enableAdaptive = ce.disableAdaptive === void 0 || !ce.disableAdaptive, ne.default = ce.defaultSelect || !1, ne.index = ri, ne.drmSchemaId = ce.drmSchemaId || yi, ne.drmToken = ce.drmToken || ks, ne.drmSchemaId && (M = !0), ce.backupUrl && ce.backupUrl.length && (ne.url = ne.url.concat(ce.backupUrl)), ne.urlId = 0, ne.default && s === void 0 && (ut === w.MAIN ? s = ri : ut === w.AUDIO ? u = ri : ut === w.SUBTITLE && (h = ri)), (ce.comment || ce.kvqScore) && (ne.meta = { comment: ce.comment, kvqScore: ce.kvqScore }), ne;
            });
            ut === w.MAIN ? C = C.concat(dr) : ut === w.AUDIO ? (t || (t = []), t = t.concat(dr)) : ut === w.SUBTITLE && (n || (n = []), n = n.concat(dr));
          }
        });
      }
      if (n && r.processingSubtitleType(n, j), a)
        return [{ codecType: le.length === 1 ? le[0] : A.unknown, mediaLevels: { levels: C, def: s || 0, audioTracks: t, defAudio: u || 0, subtitleTracks: n, defSubtitle: h || 0, drm: M, box: p, stereoType: m, isLive: O, meta: re } }];
      var we = {};
      C.forEach(function(Ae) {
        var fe = we[Ae.vCodecType];
        fe || (we[Ae.vCodecType] = fe = { def: 0, levels: [] }), Ae.default && (fe.def = fe.levels.length), fe.levels.push(Ae);
      });
      var $e = [];
      for (var tt in we) {
        var Me = we[tt];
        Me && $e.push({ codecType: tt, mediaLevels: { levels: Me.levels, def: Me.def, audioTracks: t, defAudio: u || 0, subtitleTracks: n, defSubtitle: h || 0, drm: M, box: p, stereoType: m, isLive: O, isLiveShift: U, meta: re } });
      }
      return $e;
    }, r.processingSubtitleType = function(l, a) {
      l.forEach(function(t, n) {
        if (te(t.currentUrl) === g.hls) {
          t.live = !1, t.index = n, t.totalduration = a, t.targetduration = a, t.endSN = 1;
          var s = new rn();
          s.type = w.SUBTITLE, s.start = 0, s.sn = 1, s.level = n, s.cc = 0, s.url = t.currentUrl, s.duration = a, t.fragments = [s];
        }
      });
    }, r.getAdaptationIdxByType = function(l, a) {
      for (var t = 0; t < l.adaptationSet.length; t++) {
        var n;
        if (l.adaptationSet[t].mimeType === void 0)
          return a === "video" ? 0 : -1;
        if (((n = l.adaptationSet[t].mimeType) == null ? void 0 : n.indexOf(a)) === 0)
          return t;
      }
      return -1;
    }, r;
  }();
  function an(r, l, a) {
    var t = Math.min(r, l);
    return t > 1080 || t === 1080 && a > 35;
  }
  var hs = new RegExp('codecs="((/w|.)+)"'), nr = [{ k: "video/mp4", v: g.mp4 }, { k: "video/quicktime", v: g.mp4 }, { k: "video/x-flv", v: g.flv }, { k: "video/webm", v: g.matroska }, { k: "video/x-matroska", v: g.matroska }, { k: "video/mp2t", v: g.ts }, { k: "audio/x-matroska", v: g.matroska }, { k: "audio/mp4", v: g.mp4 }, { k: "audio/mpeg", v: g.mp3 }, { k: "audio/aac", v: g.aac }, { k: "application/vnd.apple.mpegurl", v: g.hls }, { k: "application/x-mpegurl", v: g.hls }, { k: "audio/wave", v: g.wav }, { k: "audio/wav", v: g.wav }, { k: "audio/x-wav", v: g.wav }, { k: "audio/x-pn-wav", v: g.wav }];
  function on(r) {
    for (var l = { type: r, box: g.unknown, vCodec: A.unknown }, a = 0; a < nr.length; a++)
      if (r.toLocaleLowerCase().indexOf(nr[a].k) === 0) {
        l.box = nr[a].v;
        var t = r.match(hs);
        t && t.length > 2 && t[1].split(",").forEach(function(n) {
          n.indexOf("avc1") === 0 ? l.vCodec = A.h264 : n.indexOf("av01") === 0 ? l.vCodec = A.av1 : n.indexOf("hev1") !== 0 && n.indexOf("hvc1") !== 0 || (l.vCodec = A.hevc);
        });
        break;
      }
    return l;
  }
  var ar, gi = function() {
    function r() {
    }
    return r.verify = function(l) {
      return !!(l && Object.prototype.hasOwnProperty.call(l, "version") && Object.prototype.hasOwnProperty.call(l, "adaptationSet") && Object.prototype.hasOwnProperty.call(l.adaptationSet, "representation") && Array.isArray(l.adaptationSet.representation) && l.adaptationSet.representation.length > 0) && l.adaptationSet.representation.reduce(function(a, t) {
        return !!(a && t.url && t.bitrate && t.qualityType);
      }, !0);
    }, r.parse = function(l) {
      var a, t = [];
      return r.verify(l) && l.adaptationSet.representation.forEach(function(n, s) {
        var u = new ii(n.url);
        u.id = n.id || s, u.maxBitrate = n.bitrate || 0, u.bitrate = n.averageBitrate || u.maxBitrate, u.qualityType = n.qualityType || "", u.qualityLabel = n.name || "", u.codec = n.codec || "", u.hidden = n.hidden || !1, u.enableAdaptive = n.enableAdaptive === void 0 || !!n.enableAdaptive, u.default = n.defaultSelect || !1, u.index = s, t.push(u), u.default && a === void 0 && (a = s);
      }), { levels: t, def: a || 0, srcType: k.KWAI_FLV_ABR };
    }, r;
  }(), sn = function() {
    function r() {
    }
    return r.verify = function(l) {
      return !!(l && Object.prototype.hasOwnProperty.call(l, "segments") && Array.isArray(l.segments) && l.segments.length > 0) && (l.segments.forEach(function(a) {
        if (!a.url || !a.duration || !a.time)
          return !1;
      }), !0);
    }, r.parse = function(l, a) {
      a === void 0 && (a = "");
      var t = [], n = { levels: t, withCredentials: !1, hasVideo: !0, hasAudio: !0 };
      if (r.verify(l)) {
        var s = new rr("");
        t.push(s);
        var u = l;
        n.withCredentials = !!u.withCredentials, u.hasAudio !== void 0 && (n.hasAudio = !!u.hasAudio), u.hasVideo !== void 0 && (n.hasVideo = !!u.hasVideo);
        var h = 0, p = 0, m = 0, O = 0, U = 0;
        u.segments.forEach(function(C, M) {
          var j = new rn();
          j.sn = M, typeof C.startUtcTime == "string" ? j.programDateTime = parseInt(C.startUtcTime) : typeof C.startUtcTime == "number" && (j.programDateTime = C.startUtcTime), typeof C.duration == "string" ? j.duration = (parseFloat(C.duration) || 0) / 1e3 : j.duration = (C.duration || 0) / 1e3, j.start = h, j.baseurl = a, j.relurl = C.url, C.filesize && (U += C.filesize), j.duration > O && (O = j.duration), h += j.duration, M > 0 && m !== C.periodId && (j.tagList.push(["DIS"]), p++), j.cc = p, m = C.periodId, s.fragments.push(j);
        }), s.bitrate = 8 * U / 1024 / s.totalduration, s.live = !1, s.type = w.MAIN, s.startSN = 0, s.endSN = s.fragments.length - 1, s.totalduration = h, s.targetduration = O, s.averagetargetduration = h / s.fragments.length;
      }
      return n;
    }, r;
  }(), ln = function() {
    function r() {
    }
    return r.verify = function(l) {
      return !!(l && l.adaptationSet && l.adaptationSet.representation && l.adaptationSet.representation.length) && l.adaptationSet.representation.reduce(function(a, t) {
        return !!(t.url && t.bandwidth && a);
      }, !0);
    }, r.parse = function(l) {
      var a = [];
      return r.verify(l) && l.adaptationSet.representation.forEach(function(t) {
        if (t && (t.url || t.m3u8)) {
          var n = new rr(t.baseUrl ? Object(mi.buildAbsoluteURL)(t.baseUrl, t.url, { alwaysNormalize: !0 }) : t.url);
          n.bitrate = Math.floor(t.bandwidth / 1e3), n.maxBitrate = Math.floor(t.bandwidth / 1e3), n.qualityType = t.qualityType || "", n.qualityLabel = t.qualityLabel || "", t.width && t.height && (n.width = t.width, n.height = t.height), Yo(t.codecs || "", n), n.audioCodec = "", n.m3u8Slice = t.m3u8 || t.m3u8Slice, n.totalduration = t.duration, t.backupUrl && t.backupUrl.length && (n.url = n.url.concat(t.backupUrl)), n.default = t.defaultSelect || !1, n.urlId = 0, a.push(n);
        }
      }), { levels: a, def: 0 };
    }, r;
  }(), cn = new RegExp("^((http|https)://)|blob:"), _s = [g.matroska, g.mp3, g.aac], As = [g.flv, g.raw, g.webrtc, g.ivf], ps = [g.mp4, g.flv, g.hls, g.raw, g.hls_fmp4, g.hls_ts, g.ts, g.ivf], un = Object.values(A), dn = function() {
    function r() {
    }
    return r.verifyMix = function(l) {
      var a = 0;
      for (var t in l)
        un.indexOf(t) !== -1 && a++;
      return a > 0;
    }, r.isSrcEmpty = function(l) {
      try {
        if (typeof l == "string") {
          if (!(l = l.trim()))
            return !0;
          if (!cn.test(l))
            return Object.keys(JSON.parse(l)).length === 0;
        } else if (!(l instanceof Blob))
          return !l || Object.keys(l).length === 0;
      } catch (a) {
      }
      return !1;
    }, r.filteringLevels = function(l, a) {
      l.i("media-src", "filteringLevels. input: " + a.levels.length + ". mse: " + Z.isMSEAvailable());
      var t = $.chrome || $.firefox;
      a.levels.forEach(function(h) {
        t && h.audioCodec && h.audioCodec.indexOf("mp4a.40.34") !== -1 && (h.audioCodec = "");
      });
      var n = Z.isMSEAvailable() ? Z.isMSECodecStrSupportedInMp4 : Z.isVideoCodecStrSupportedInMp4, s = Z.isMSEAvailable() ? Z.isMSECodecSupported : Z.isVideoCodecSupported;
      a.levels = a.levels.filter(function(h) {
        var p = !h.audioCodec || n(h.audioCodec, "audio"), m = typeof h.hdr == "number" && h.hdr > 0, O = h.videoCodec ? n(h.videoCodec) : h.vCodecType === A.unknown || s(h.vCodecType, Z.getPlayTestDefinition(h), m);
        O || l.i("media-src", "filteringLevels. " + h.qualityType + " v unsupported. codec: " + h.vCodecType + " hdr: " + m), h.qualityType.toLocaleLowerCase().indexOf("4k") >= 0 && ($.mobile && (O = !1), O || l.i("media-src", "filteringLevels. " + h.qualityType + " v unsupported. mobile: " + $.mobile));
        var U = en(h);
        return U || l.i("media-src", "filteringLevels. " + h.qualityType + " v unsupported. drm: " + h.drmSchemaId), p && O && U;
      });
      var u = !1;
      return a.levels.forEach(function(h, p) {
        h.index = p, h.default && (a.def = p, u = !0);
      }), u ? l.i("media-src", "filteringLevels. default main level: " + a.def + "/" + a.levels.length) : (a.def = a.levels.reduce(function(h, p, m) {
        return p.bitrate < a.levels[h].bitrate ? m : h;
      }, 0), l.i("media-src", "filteringLevels. no default main level, select the one with the lowest bit rate: " + a.def)), a.audioTracks && (a.audioTracks = a.audioTracks.filter(function(h) {
        var p = !h.audioCodec || n(h.audioCodec, "audio");
        p || l.i("media-src", "filteringLevels. " + h.qualityType + " a unsupported. codec: " + h.audioCodec);
        var m = en(h);
        return m || l.i("media-src", "filteringLevels. " + h.qualityType + " a unsupported. drm: " + h.drmSchemaId), p && m;
      }), a.audioTracks.forEach(function(h) {
        t && h.audioCodec && h.audioCodec.indexOf("mp4a.40.34") !== -1 && (h.audioCodec = "");
      }), a.defAudio = void 0, a.audioTracks.forEach(function(h, p) {
        h.index = p, h.default && (a.defAudio = p);
      }), a.defAudio === void 0 && (a.defAudio = 0)), a.subtitleTracks && a.subtitleTracks.length && a.subtitleTracks.forEach(function(h, p) {
        h.index = p, h.default && (a.defSubtitle = p);
      }), a;
    }, r.preParse = function(l, a, t, n, s, u) {
      if (t === void 0 && (t = !1), u === void 0 && (u = ""), l.i("media-src", "pre parse. mixManifestEnabled: " + t + ", native: " + n + ", codecType: " + s + ", baseUrl: " + u), typeof a == "string") {
        var h = this._formatStrData(l, a);
        if (!h)
          return [{ src: a, box: g.unknown, srcType: k.OTHERS }];
        a = h;
      } else
        a instanceof Blob || (a = JSON.parse(JSON.stringify(a)));
      if (Array.isArray(a)) {
        l.i("media-src", "input mix container.");
        var p = [], m = [];
        a.forEach(function(C) {
          if (C != null && C.src) {
            var M = { info: r._preParseMd(l, C.src, t, n, s, u), priority: 0, mime: void 0 };
            p.push(M.info.box), C.type && (M.mime = on(C.type)), m.push(M);
          }
        });
        for (var O = 0; O < m.length; O++) {
          var U = m[O];
          if (U.info && U.info.src) {
            if (U.mime && (U.mime.box !== g.unknown && (U.info.box = U.mime.box), U.mime.vCodec !== A.unknown && (U.info.codecType = U.mime.vCodec)), n !== void 0 && n !== U.info.nativeFirst || U.priority++, U.info.nativeFirst)
              U.priority += U.info.box === g.unknown ? 1 : Z.isVideoBoxSupported(U.info.box) ? 2 : -100, U.priority += U.info.codecType === A.unknown ? 1 : s && s === U.info.codecType || Z.isVideoCodecSupported(U.info.codecType) ? 2 : -100;
            else {
              if (!Z.isMSEAvailable())
                continue;
              U.priority += U.info.box === g.unknown ? 1 : ps.indexOf(U.info.box) >= 0 ? 2 : -100, U.priority += U.info.codecType === A.unknown ? 1 : s && s === U.info.codecType || Z.isMSECodecSupported(U.info.codecType) ? 2 : -100;
            }
            l.i("media-src", "input mix container. media desc " + O + ". box: " + U.info.box + " codec: " + U.info.codecType + " priority: " + U.priority);
          }
        }
        return m.sort(function(C, M) {
          return M.priority - C.priority;
        }).filter(function(C) {
          return C.priority > 0;
        }).map(function(C) {
          return C.info;
        });
      }
      return [r._preParseMd(l, a, t, n, s, u)];
    }, r._preParseMd = function(l, a, t, n, s, u) {
      if (t === void 0 && (t = !1), u === void 0 && (u = ""), l.i("media-src", "parse media desc. native: " + n + " codecType: " + s), typeof a == "string") {
        var h = this._formatStrData(l, a);
        if (!h)
          return { src: a, box: g.unknown, srcType: k.OTHERS };
        a = h;
      }
      var p, m = Z.isMSEAvailable();
      if (r.verifyMix(a)) {
        l.i("media-src", "input mix codec.");
        var O = a, U = [];
        for (var C in O) {
          var M = C;
          if (un.indexOf(M) !== -1) {
            var j = O[M];
            if (typeof j == "string" && (j = j.trim()), !j)
              continue;
            var le = this._getMediaSrcInfoBySrc(l, j, u, M), re = Array.isArray(le) ? this._getMediaSrcInfoFromArr(le, M) || le[0] : le;
            if (!re)
              continue;
            re.codecType = M, U.push(re);
          }
        }
        p = this._getMediaSrcInfoByCompatibility(l, U, t, n, s);
      } else {
        var Q = this._getMediaSrcInfoBySrc(l, a, u);
        Array.isArray(Q) ? Q.length > 1 ? (l.i("media-src", "input aas v2 mix codec."), p = this._getMediaSrcInfoByCompatibility(l, Q, t, n, s)) : (p = Q[0]).nativeFirst = this._getNativeFirstByBox(l, p.box, m, n) : (p = Q).nativeFirst = this._getNativeFirstByBox(l, p.box, m, n);
      }
      return p || (p = { src: a, box: g.unknown, srcType: k.OTHERS }), p;
    }, r._getMediaSrcInfoByCompatibility = function(l, a, t, n, s) {
      var u, h, p = this;
      t === void 0 && (t = !1);
      var m = {}, O = {}, U = [], C = Z.isMSEAvailable();
      a.forEach(function(tt) {
        var Me = tt.codecType;
        if (Me)
          if (tt.nativeFirst = p._getNativeFirstByBox(l, tt.box, C, n), U.push(Me), C && !tt.nativeFirst) {
            var Ae = Z.getVideoCodecCompatibilityByCodec(Me);
            O[Me] = Ae.decoder, Me === A.h264 && (Ae.decoder = L.buildin, Ae.smooth = !0), Ae.smooth && Ae.decoder === L.buildin && tt.mediaLevels && (tt.compatibility = Ae, m[Me] = tt);
          } else {
            var fe = Z.isVideoCodecSupported(Me);
            O[Me] = fe ? L.buildin : L.unsupported, (Me === A.h264 || fe) && (tt.compatibility = { decoder: L.buildin, smooth: !0, mix: !1 }, m[Me] = tt);
          }
      });
      var M, j, le = (u = m[A.hevc]) != null && u.mediaLevels && m[A.hevc].mediaLevels.levels.length ? m[A.hevc] : void 0, re = (h = m[A.av1]) != null && h.mediaLevels && m[A.av1].mediaLevels.levels.length ? m[A.av1] : void 0, Q = m[A.h264];
      if (l.i("media-src", "input vcodec. hevc: " + !!le + " av1: " + !!re + " h264: " + !!Q), s && m[s])
        M = m[s], l.i("media-src", "selected the specified codec: " + s);
      else {
        var we = re || le;
        if (t) {
          var $e = this._mixManifest(l, we, Q);
          $e && (M = $e), l.i("media-src", "mixed codec used");
        }
      }
      return M || ((M = re || le || Q) && (M.nativeFirst = this._getNativeFirstByBox(l, M.box, C, n)), l.i("media-src", "selected src: " + ((j = M) == null ? void 0 : j.codecType), M)), M && (U.length && (M.mixCodecInput = U), M.mixCodecAvailable = O), M;
    }, r._getMediaSrcInfoFromArr = function(l, a) {
      for (var t = 0; t < l.length; t++)
        if (l[t].codecType === a)
          return l[t];
    }, r._mixManifest = function(l, a, t) {
      var n;
      if (!$.mobile && a && a.compatibility && a.compatibility.mix && t && (Lt.verify(a.src) && Lt.verify(t.src) && a.box === t.box ? n = function(h, p, m) {
        if (m === void 0 && (m = A.hevc), h.mediaType === p.mediaType) {
          var O = Lt.getAdaptationIdxByType(h, "audio"), U = Lt.getAdaptationIdxByType(p, "audio");
          if (O >= 0 && U >= 0 || O === -1 && U === -1) {
            var C = Lt.getAdaptationIdxByType(h, "video"), M = Lt.getAdaptationIdxByType(p, "video");
            if (C === -1 || M === -1)
              return;
            var j = h.adaptationSet[C].representation, le = p.adaptationSet[M].representation;
            if (j.length === 0 || le.length === 0 || j.length === 1 && le.length === 1)
              return;
            var re = [], Q = [], we = {}, $e = j.length > 1 ? j : le, tt = $e[0].width < $e[$e.length - 1].width;
            if (le.forEach(function(fe) {
              an(fe.height, fe.width, fe.frameRate) || (we[fe.qualityType] = m, Q.push(fe));
            }), j.forEach(function(fe) {
              (an(fe.height, fe.width, fe.frameRate) || Q.length === 0) && (we[fe.qualityType] = A.h264, re.push(fe));
            }), re.length === 0 && Q.length === 0)
              return;
            var Me = re.concat(Q);
            if (Q.length && Me.sort(function(fe, yi) {
              return tt ? fe.width - yi.width : yi.width - fe.width;
            }), Me.length) {
              var Ae = d()({}, p);
              return Ae.adaptationSet[M].representation = Me, { manifest: Ae, qualityList: we };
            }
          }
        }
      }(t.src, a.src, a.codecType) : gi.verify(a.src) && gi.verify(t.src) && (t.src, a.src, n = void (a.codecType === void 0 && A.hevc)), n)) {
        var s;
        l.i("media-src", "mix kwai manifest"), a.src = n.manifest;
        var u = (s = Lt.parse(a.src, !0)[0]) == null ? void 0 : s.mediaLevels;
        return u && (a.mediaLevels = r.filteringLevels(l, u)), a.codecType = A.unknown, a.mixQualityList = n.qualityList, a;
      }
    }, r._getNativeFirstByBox = function(l, a, t, n) {
      if (!t || _s.indexOf(a) !== -1)
        return l.i("media-src", "get native first true. box: " + a + " mse: " + t), !0;
      if (As.indexOf(a) !== -1 || !Z.isVideoBoxSupported(a))
        return l.i("media-src", "get native first false. box: " + a), !1;
      if (!$.mobile) {
        if (n) {
          var s = Z.isVideoBoxSupported(a), u = !!s;
          return l.i("media-src", "get native first pc " + u + ". box: " + a + " nativeFirstParams: true video box supported: " + s), u;
        }
        if (n === void 0) {
          var h = Z.isMSEAvailable(), p = !h;
          return l.i("media-src", "get native first pc " + p + ". box: " + a + " nativeFirstParams: undefined mse supported: " + h), p;
        }
        return l.i("media-src", "get native first pc false. nativeFirstParams: false"), !1;
      }
      if (a === g.mp4 || a === g.hls || a === g.hls_ts || a === g.ts) {
        if (n === void 0 || n) {
          var m = Z.isVideoBoxSupported(a), O = !!m;
          return l.i("media-src", "get native first mobile " + O + ". box: " + a + " nativeFirstParams: " + n + " video box supported: " + m), O;
        }
        return l.i("media-src", "get native first mobile false. nativeFirstParams: " + n), !1;
      }
      if (a === g.hls_fmp4) {
        if (n === void 0 || n) {
          var U = Z.isVideoBoxSupported(a), C = !(!U || !$.x5 && !$.xweb);
          return l.i("media-src", "get native first mobile " + C + ". box: " + a + " nativeFirstParams: " + n + " video box supported: " + U + " x5: " + $.x5 + " xweb: " + $.xweb), C;
        }
        return l.i("media-src", "get native first mobile false. nativeFirstParams: " + n), !1;
      }
    }, r._getMediaSrcInfoBySrc = function(l, a, t, n) {
      var s = this;
      t === void 0 && (t = ""), n === void 0 && (n = A.unknown);
      var u = { src: a, box: g.unknown, srcType: k.OTHERS };
      if (typeof a == "string")
        u.box = te(a), u.mediaLevels = { levels: [new ii(a)], def: 0 }, u.isLive = this._getIsLiveByBox(u.box);
      else if (a instanceof Blob) {
        var h = new ii(URL.createObjectURL(a));
        u.mediaLevels = { levels: [h], def: 0 }, a instanceof File ? (u.box = te(a.name), h.fileName = a.name) : (u.box = on(a.type).box, h.fileName = "unknow"), u.srcType = k.FILE, u.isLive = !1;
      } else {
        if (Lt.verify(a)) {
          var p = Lt.parse(a);
          l.i("media-src", "kwai manifest");
          var m = p.map(function(C) {
            var M, j;
            l.i("media-src", "kwai manifest codec: " + C.codecType + " meta:", C.mediaLevels.meta), C.mediaLevels.levels.forEach(function(re) {
              l.i("media-src", "kwai manifest levels meta:", re.meta, re.vCodecType, n), re.vCodecType === A.unknown && n !== A.unknown && (re.vCodecType = n);
            });
            var le = { mediaLevels: r.filteringLevels(l, C.mediaLevels), src: a, box: C.mediaLevels.box || te(((M = C.mediaLevels.levels[0]) == null ? void 0 : M.url[0]) || ""), srcType: k.KWAI, isLive: s._getIsLiveByBox(u.box), isLiveShift: C.mediaLevels.isLiveShift, codecType: C.codecType };
            return typeof ((j = le.mediaLevels) == null ? void 0 : j.isLive) == "boolean" && (le.isLive = le.mediaLevels.isLive), ze(le.box) && (le.multipart = !0), le;
          });
          return m.length ? m : m[0];
        }
        if (gi.verify(a)) {
          l.i("media-src", "flv abr manifest");
          var O = gi.parse(a);
          O.levels.forEach(function(C) {
            C.vCodecType === A.unknown && n !== A.unknown && (C.vCodecType = n);
          }), u.mediaLevels = r.filteringLevels(l, O), u.box = g.flv, u.isLive = !0, u.srcType = k.KWAI_FLV_ABR;
        } else if (sn.verify(a)) {
          l.i("media-src", "flv multipart");
          var U = sn.parse(a, t);
          u.mediaLevels = d()({ def: 0 }, U), u.box = g.flv, u.isLive = !1, u.multipart = !0, u.srcType = k.KWAI_FLV_MP;
        } else
          ln.verify(a) && (u.mediaLevels = r.filteringLevels(l, ln.parse(a)), u.box = g.hls, u.srcType = k.KWAI);
      }
      return ze(u.box) && (u.multipart = !0), u;
    }, r._getIsLiveByBox = function(l) {
      var a;
      return [g.flv, g.hls, g.unknown, g.ivf, g.yuv].indexOf(l) === -1 && (a = !1), l === g.webrtc && (a = !0), a;
    }, r._formatStrData = function(l, a) {
      var t = a.trim();
      if (t) {
        if (!cn.test(t)) {
          try {
            t = JSON.parse(t);
          } catch (n) {
            l.i("media-src", "formatStrData error", n);
          }
          typeof t == "string" && (t = Object(mi.buildAbsoluteURL)(location.href, t, { alwaysNormalize: !0 }));
        }
        return t;
      }
    }, r;
  }(), fs = ((ar = {})[S.FHD] = "data:video/mp4;base64,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", ar[S.UHD_4K] = "data:video/mp4;base64,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", ar), hn = function() {
    function r(a) {
      var t = this;
      this._logger = void 0, this._ls = new fi(), this._timeout = void 0, this._testType = [S.FHD, S.UHD_4K], this._testIdx = 0, this._testResult = void 0, this._onVideoEvent = function() {
        var n, s;
        t._logger.i("playback-hevc-test", "on video event. " + ((n = r._testVideo) == null ? void 0 : n.videoWidth) + " " + ((s = r._testVideo) == null ? void 0 : s.error)), t._testResult ? (t._testResult[t._testType[t._testIdx]] = !!r._testVideo && r._testVideo.videoWidth > 0 && !r._testVideo.error, t._testIdx++, t._testIdx < t._testType.length ? (t._clearTestVideo(), t._testPlay(t._testType[t._testIdx])) : t._onComplete()) : t._onComplete();
      }, this._logger = a;
    }
    var l = r.prototype;
    return l.init = function(a) {
      if (this._logger.i("playback-hevc-test", "init"), a > 0) {
        var t = this._ls.read("kwai-kernel-hevc", a);
        this._logger.i("playback-hevc-test", "load from ls", t);
        try {
          t !== void 0 && Object.prototype.hasOwnProperty.call(t, S.FHD) && Object.prototype.hasOwnProperty.call(t, S.UHD_4K) && (Z.playHEVCTest = t, this._testResult = Z.playHEVCTest);
        } catch (n) {
          this._logger.i("playback-hevc-test", "load ls error");
        }
      }
    }, l.start = function() {
      var a;
      this._logger.i("playback-hevc-test", "start");
      var t = this._testResult !== void 0 || r._testVideo;
      this._logger.i("playback-hevc-test", "start. tested: " + t), t || (a = r._testVideo) != null && a.src || this._startVideoTest();
    }, l.destroy = function() {
      this._stopTimer(), this._clearTestVideo();
    }, l._onComplete = function() {
      this._logger.i("playback-hevc-test", "complete result:", this._testResult, performance.now()), this._stopTimer(), this._clearTestVideo(), Z.playHEVCTest = this._testResult, this._ls.write("kwai-kernel-hevc", this._testResult);
    }, l._startVideoTest = function() {
      var a;
      this._logger.i("playback-hevc-test", "start video test"), ht() ? this._onComplete() : (this._startTimer(), this._testResult = ((a = {})[S.FHD] = !1, a[S.UHD_4K] = !1, a), this._testIdx = 0, this._testPlay(this._testType[this._testIdx]));
    }, l._testPlay = function(a) {
      this._logger.i("playback-hevc-test", "test: " + a), r._testVideo || (r._testVideo = document.createElement("video")), r._testVideo.preload = "metadata", r._testVideo.addEventListener("error", this._onVideoEvent), r._testVideo.addEventListener("loadeddata", this._onVideoEvent), r._testVideo.addEventListener("loadedmetadata", this._onVideoEvent), r._testVideo.src = fs[a], r._testVideo.play().catch(function() {
      });
    }, l._clearTestVideo = function() {
      r._testVideo && (r._testVideo.removeEventListener("error", this._onVideoEvent), r._testVideo.removeEventListener("loadeddata", this._onVideoEvent), r._testVideo.removeEventListener("loadedmetadata", this._onVideoEvent), r._testVideo.src = "");
    }, l._startTimer = function() {
      var a = this;
      this._stopTimer(), this._timeout = setTimeout(function() {
        a._logger.i("playback-hevc-test", "timeout"), a._onComplete();
      }, 1e3);
    }, l._stopTimer = function() {
      this._timeout && (clearTimeout(this._timeout), this._timeout = void 0);
    }, r;
  }();
  hn._testVideo = void 0;
  var vs = hn, ms = o(11), gs = o.n(ms), _n = function(r) {
    function l(t, n) {
      var s;
      return (s = r.call(this) || this).video = void 0, s.mse = void 0, s.stat = new ns(), s.loadRec = void 0, s.lctx = void 0, s._mediaDescList = [], s._mediaDescIdx = 0, s._srcUpdateTime = 0, s._originSrc = void 0, s._config = void 0, s._streamingMuxEnabled = !1, s._streamingMux = !1, s._cOutput = void 0, s._liveDelay = void 0, s._fps = new os(), s._yuvParams = void 0, s._hevcTest = void 0, s._id = void 0, s._logger = void 0, s._evt = void 0, s._fallback = void 0, s._streamTime = void 0, s._id = tr.next(), s._logger = new Zi().setId(s._id), s._evt = new ss(), s.video = n, s._liveDelay = new Zr(s._logger), s._hevcTest = new vs(s._logger), s.lctx = new Qr(s._logger, !0), s._fallback = new Ko(Ie()(s)), s._streamTime = new es(Ie()(s)), s._setConfig(St.processConfig(t)), s._destroyableList.push(s._liveDelay, s._hevcTest, s._fallback, s._streamTime), s;
    }
    y()(l, r);
    var a = l.prototype;
    return a.destroy = function() {
      var t;
      this.logger.i("av-ctx", "destroy"), (t = this.stat.muxWorker) == null || t.terminate(), this._destroyLevels(), this._destroyCanvasOutput(), this._evt.removeAllListeners(), r.prototype.destroy.call(this);
    }, a.updateVideoPlaybackQuality = function(t, n) {
      this.stat.videoPlaybackQuality ? (this.stat.videoPlaybackQuality.droppedVideoFrames = n, this.stat.videoPlaybackQuality.totalVideoFrames = t) : this.stat.videoPlaybackQuality = { corruptedVideoFrames: 0, creationTime: 0, droppedVideoFrames: n, totalVideoFrames: t };
    }, a.isTimeinBuffered = function(t) {
      if (this.video) {
        for (var n = this.video.buffered, s = 0; s < n.length; s++)
          if (t >= n.start(s) && t < n.end(s))
            return !0;
      }
      return !1;
    }, a.currentBuffer = function(t) {
      if (this.video)
        for (var n = this.video.buffered, s = 0; s < n.length; s++) {
          var u = n.start(s), h = n.end(s);
          if (u <= t && t < h)
            return { start: u, end: h };
        }
    }, a.nextBuffer = function(t) {
      if (this.video)
        for (var n = this.video.buffered, s = 0; s < n.length; s++) {
          var u = n.start(s), h = n.end(s);
          if (u > t)
            return { start: u, end: h };
        }
    }, a.getGeneralLiveShiftUrl = function(t) {
      var n, s = this.stat;
      if ((n = s.liveShiftParams) != null && n.urlParams) {
        var u = ie()(t, !0);
        for (var h in s.liveShiftParams.urlParams)
          u.query[h] = s.liveShiftParams.urlParams[h];
        return u.toString();
      }
      return t;
    }, a.getRemuxConfig = function() {
      var t = this._config;
      return { isLive: this.stat.isLive, logLevel: t.logLevel, enableSoftwareAES: t.enableSoftwareAES, gopRemux: this.stat.gopRemux, preferDecoder: t.preferDecoder, streamingMux: this.streamingMux, ensureVideo: t.ensureVideo, maxAudioFramesDrift: t.maxAudioFramesDrift, forceKeyFrameOnDiscontinuity: t.forceKeyFrameOnDiscontinuity, wasmDecoderEnabled: t.wasmDecoderEnabled, enableAacPriv: t.enableAacPriv };
    }, a.getDecConfig = function() {
      var t = this._config;
      return { logLevel: t.logLevel, videoDropFramePolicy: t.videoDropFramePolicy, videoFrameBufferSize: t.videoFrameBufferSize, videoDecBlockPolicy: t.videoDecBlockPolicy, maxVideoDecThreads: t.maxVideoDecThreads, mainThreadRendering: t.mainThreadRendering, mainThreadDecoding: t.mainThreadDecoding };
    }, a.setSrc = function(t, n) {
      this.logger.i("av-ctx", "set src", t), t && (this._resetStat(), this.resetStreamingEnabled(), this._yuvParams = void 0, this.loadRec = new Jr()), this._setSrc(t, n);
    }, a.reProcessSrc = function(t, n) {
      this.logger.i("av-ctx", "reprocess src. codecType: " + t + " native: " + n + ", has origin src: " + !!this._originSrc), this._originSrc && this._processSrc(this._originSrc, t, n);
    }, a.updateLiveShiftStatuByTime = function(t) {
      var n;
      if (this.stat.liveShiftType && (t === void 0 && (t = (n = this.video) == null ? void 0 : n.currentTime), this.lctx.current && typeof t == "number")) {
        var s = this.liveLocalTime;
        this.stat.liveShift = !!(s && t < s - 0.1);
      }
    }, a.resetStreamingEnabled = function() {
      var t = this._config;
      this._streamingMuxEnabled = this._streamingMux = !(!t.streamingMux || !St.isStreamingSupported() || $.msie || $.safari && (this.stat.isLive === !1 || this.stat.multipart) || $.msedge && $.version.major < 88 && (this.stat.isLive === !1 || this.stat.multipart)), this.logger.i("av-ctx", "resetStreamingEnabled: " + this._streamingMuxEnabled);
    }, a.resetGopRemux = function() {
      this.stat.multipart && !this._streamingMuxEnabled ? this.stat.gopRemux = !1 : this.stat.gopRemux = !!($.safari || $.opera && $.version.major < 37), this.logger.i("av-ctx", "resetGopRemux: " + this.stat.gopRemux);
    }, a.hasNextMediaDesc = function() {
      return this._mediaDescIdx + 1 < this._mediaDescList.length;
    }, a.nextMediaDesc = function() {
      if (this.hasNextMediaDesc()) {
        this._mediaDescIdx++;
        var t = this._mediaDescList[this._mediaDescIdx];
        if (t)
          return this._useMediaDesc(t), !0;
      }
      return !1;
    }, a._setConfig = function(t) {
      if (this._config = t, !t.logLevel) {
        var n = Zi.loadLogLevel();
        t.logLevel = n || Br;
      }
      var s;
      if (t.logger && this._logger.setOutput(t.logger), this._logger.setLevel(t.logLevel), this._logger.getLevel() !== ke.NONE && (s = l.version, $.msie || console.log("%c kwai-player-kernel %c " + s + " %c", "background:#35495e ; padding: 1px; border-radius: 4px 0 0 4px;  color: #fff", "background:#ffa483 ; padding: 1px; border-radius: 0 4px 4px 0;  color: #fff", "background:transparent")), this.logger.i("av-ctx", "logger init."), this.logger.i("av-ctx", "set config"), this._hevcTest.init(this._config.playbackAbilityCacheTimeout), this.resetStreamingEnabled(), this.logger.i("av-ctx", "browser", JSON.stringify($)), ht() || this.logger.i("av-ctx", "ua", navigator.userAgent), this._resetStat(), this._yuvParams = void 0, this.stat.startFromSec = t.startFromSec || (t.startFrom || -1e3) / 1e3, this.stat.webWorker = t.webWorker && !!Y.a, typeof t.preferNativeLoader == "boolean" && (this.stat.preferNativeLoader = t.preferNativeLoader), this._config.autoPlaybackRateConf)
        this.logger.i("av-ctx", "use config.autoPlaybackRateConf", this._config.autoPlaybackRateConf), this.stat.autoPlaybackRateConf = this._config.autoPlaybackRateConf;
      else {
        var u = -Math.floor(this._config.defaultSpts / 1e3);
        this.stat.autoPlaybackRateConf = function(h, p) {
          p === void 0 && (p = 3);
          var m = { startDelay: 0, interval: 0.6, rule: [] };
          return jr(h, p, m), m;
        }(u), this.logger.i("av-ctx", "use default autoPlaybackRateConf", this.stat.autoPlaybackRateConf), this._logger.i("av-ctx", "get by delay: " + u);
      }
      try {
        this.stat.webWorker && (this.stat.muxWorker = gs()(5)), Zr.workerTimeOffset = performance.now(), this.logger.i("av-ctx", "init mux worker");
      } catch (h) {
      }
      t.lazyLoadMaxDuration > 0 && t.lazyLoadRecoverDuration > 0 && t.lazyLoadMaxDuration >= t.lazyLoadRecoverDuration && (this.stat.lazyLoadMaxDuration = t.lazyLoadMaxDuration, this.stat.lazyLoadRecoverDuration = t.lazyLoadRecoverDuration), this.loadRec = new Jr(), t.src && this._setSrc(t.src);
    }, a._resetStat = function() {
      this.logger.i("av-ctx", "reset stat");
      var t = this._config, n = this.stat;
      this._streamingMux = this._streamingMuxEnabled;
      var s = n.preferNativeLoader;
      n.reset(), this.resetGopRemux(), this._streamTime.reset(), this._fallback.reset(), n.isLive = t.isLive, n.native = t.nativeFirst, n.liveShiftType = this._config.liveShiftType, n.preferNativeLoader = s, this.stat = n;
    }, a._setSrc = function(t, n) {
      this._mediaDescIdx = 0, this._srcUpdateTime = Date.now(), this._processSrc(t, n);
    }, a._processSrc = function(t, n, s) {
      this._logger.i("av-ctx", "process src. codec: " + n + " native: " + s), t && (this._originSrc = t);
      var u = this.config;
      this._mediaDescList = dn.preParse(this._logger, t, u.mixManifestEnabled, typeof s == "boolean" ? s : u.nativeFirst, n, u.baseURL);
      var h = this._mediaDescList[this._mediaDescIdx];
      h && this._useMediaDesc(h);
    }, a._useMediaDesc = function(t) {
      var n, s, u, h, p = this.config, m = this.stat;
      if (this._cOutput && this._cOutput.reset(), this.stat.srcType === k.FILE && this._destroyLevels(), this.lctx = new Qr(this._logger, p.adaptive), m.codecType = t.codecType ? t.codecType : A.unknown, m.box = p.box || t.box || g.unknown, m.srcType = t.srcType, m.mixContainerInput = t.mixContainerInput, m.mixCodecInput = t.mixCodecInput, m.mixCodecAvailable = t.mixCodecAvailable, m.mixQualityList = t.mixQualityList, m.multipart = t.multipart, m.stereoType = (n = t.mediaLevels) == null ? void 0 : n.stereoType, (s = t.mediaLevels) != null && s.meta && (m.srcMeta = (u = t.mediaLevels) == null ? void 0 : u.meta), p.liveDelayFragNum && p.liveDelayFragNum > 0 && m.multipart && (m.multipartLiveDelay = -1e4 * p.liveDelayFragNum, !p.autoPlaybackRateConf)) {
        var O = 10 * p.liveDelayFragNum;
        jr(O, 10, m.autoPlaybackRateConf), this._logger.i("av-ctx", "update by delay: " + O + ".", p);
      }
      t.nativeFirst !== void 0 && (m.native = t.nativeFirst), typeof t.isLive == "boolean" && (m.isLive = t.isLive), t.isLiveShift === !0 && (m.liveShiftType = q.KWAI), typeof ((h = t.mediaLevels) == null ? void 0 : h.isLive) == "boolean" && (m.isLive = t.mediaLevels.isLive), !t.mediaLevels || t.srcType === k.OTHERS && ze(m.box) && !m.native || (this._logger.i("av-ctx", "hls src. get levels from m3u8."), m.hasAudio = t.mediaLevels.hasAudio, m.hasVideo = t.mediaLevels.hasVideo, m.drm = t.mediaLevels.drm, this.lctx.levels = t.mediaLevels.levels, this.lctx.default = this.lctx.currentIdx = t.mediaLevels.def, t.mediaLevels.audioTracks && (this.lctx.audioTracks = t.mediaLevels.audioTracks, this.lctx.audioIdx = t.mediaLevels.defAudio || 0), t.mediaLevels.subtitleTracks && (this.lctx.subtitleTracks = t.mediaLevels.subtitleTracks, this.lctx.subtitleIdx = t.mediaLevels.defSubtitle || 0)), this.lctx.default = function(U) {
        if (!$.mobile || U.levels.length <= 1 || U.levels[0].vCodecType !== A.hevc)
          return U.default;
        var C, M;
        if (U.levels.forEach(function(le, re) {
          if (le.width && le.height) {
            var Q = Math.min(le.width, le.height);
            Q > 720 ? M = M && Q > M.minWH ? M : { idx: re, minWH: Q } : C = C && C.minWH > Q ? C : { idx: re, minWH: Q };
          }
        }), !C || !M)
          return U.default;
        if ($.android)
          return parseFloat($.platformVersion) >= 10 ? M.idx : C.idx;
        if ($.iphone) {
          var j = Yr();
          return j === "unknown" ? typeof window < "u" && window.screen && (window.screen.width > 400 || window.devicePixelRatio > 2) ? M.idx : C.idx : [Fe.SERIES_1, Fe.SERIES_2, Fe.SERIES_3, Fe.SERIES_4, Fe.SERIES_8].indexOf(j) === -1 ? M.idx : C.idx;
        }
        return U.default;
      }(this.lctx), t.box === g.yuv && (this._yuvParams = function(U) {
        if (U) {
          var C = U.match(is);
          if (C && C.length > 2) {
            var M = parseInt(C[1]), j = parseInt(C[2]), le = C[4] ? parseInt(C[4]) : 25, re = C[6] ? parseInt(C[6]) : 8, Q = vi.AV_PIX_FMT_YUV420P;
            C[8] !== void 0 && (Q = rs.indexOf(C[8]));
            var we = 0, $e = 0;
            return Q === vi.AV_PIX_FMT_YUV420P ? (we = M / 2, $e = j / 2) : Q === vi.AV_PIX_FMT_YUV422P ? (we = M / 2, $e = j) : Q === vi.AV_PIX_FMT_YUV444P ? (we = M, $e = j) : (we = 0, $e = 0), { width: M, height: j, chroma: Q, chromaWidth: we, chromaHeight: $e, cropLeft: 0, cropTop: 0, cropWidth: M, cropHeight: j, displayWidth: M, displayHeight: j, pts: 0, fps: le, bpp: re, dataSize: (M * j + we * $e * 2) * (re > 8 ? 2 : 1) };
          }
        }
      }(t.src instanceof File ? t.src.name : this.lctx.currentUrl)), this.resetStreamingEnabled(), this.resetGopRemux(), this.logger.i("av-ctx", "use media desc complete. box: " + m.box + " live: " + m.isLive + " mobile: " + !!$.mobile + " gopRemux: " + m.gopRemux + " streamingMux " + this.streamingMux);
    }, a._destroyLevels = function() {
      this.lctx && this.lctx.levels.forEach(function(t) {
        t.url.forEach(function(n) {
          n.indexOf("blob:") === 0 && URL.revokeObjectURL(n);
        });
      });
    }, a._destroyCanvasOutput = function() {
      this._cOutput && (this._cOutput.destroy(), this._cOutput = void 0);
    }, v()(l, [{ key: "logger", get: function() {
      return this._logger;
    } }, { key: "id", get: function() {
      return this._id;
    } }, { key: "live", get: function() {
      return !(!this.stat.isLive || this.stat.liveShift);
    } }, { key: "liveLocalTime", get: function() {
      var t = this.lctx.current;
      return t && t.totalduration && this.stat.multipartLiveDelay ? t.totalduration + this.stat.multipartLiveDelay / 1e3 + 0.1 : 0;
    } }, { key: "yuvParams", get: function() {
      return this._yuvParams;
    } }, { key: "canCodecFallback", get: function() {
      return !(!this.stat.mixCodecInput || this.stat.codecType === A.h264 || this.stat.mixCodecInput.indexOf(A.h264) === -1 || this.stat.decoder !== L.buildin);
    } }, { key: "fps", get: function() {
      return this._fps;
    } }, { key: "liveDelay", get: function() {
      return this._liveDelay;
    } }, { key: "cOutput", get: function() {
      return this._cOutput || (this._cOutput = new as(this._logger)), this._cOutput;
    } }, { key: "isAbrAvailable", get: function() {
      return this._config.adaptive && this.lctx.levels.length > 1 && !this.stat.isPreload && !this.isSwitchLevelByReload;
    } }, { key: "isSwitchLevelByReload", get: function() {
      return this.stat.box !== g.flv && !ze(this.stat.box);
    } }, { key: "mediaBufferedSec", get: function() {
      return this.video && this.video.buffered && this.video.buffered.length ? { start: this.video.buffered.start(0), end: this.video.buffered.end(this.video.buffered.length - 1) } : { start: 0, end: 0 };
    } }, { key: "bufferedEnd", get: function() {
      return this.video && this.video.buffered.length ? this.video.buffered.end(this.video.buffered.length - 1) : 0;
    } }, { key: "bufferedSec", get: function() {
      return this.video && this.video.buffered.length > 0 ? Math.max(0, this.video.buffered.end(this.video.buffered.length - 1) - this.video.currentTime) : 0;
    } }, { key: "bufferSliceNum", get: function() {
      return this.video ? this.video.buffered.length : 0;
    } }, { key: "currentTime", get: function() {
      return this.video ? this.video.currentTime : 0;
    } }, { key: "playbackRate", get: function() {
      return this.video ? this.video.playbackRate : 1;
    } }, { key: "config", get: function() {
      return this._config;
    } }, { key: "src", get: function() {
      var t;
      return ((t = this._mediaDescList[this._mediaDescIdx]) == null ? void 0 : t.src) || "";
    } }, { key: "srcUpdateTime", get: function() {
      return this._srcUpdateTime;
    } }, { key: "originSrc", get: function() {
      return this._originSrc;
    } }, { key: "videoPlaybackQuality", get: function() {
      return this.stat.videoPlaybackQuality ? this.stat.videoPlaybackQuality : this.video ? this.video.getVideoPlaybackQuality !== void 0 ? this.video.getVideoPlaybackQuality() : { corruptedVideoFrames: 0, creationTime: 0, droppedVideoFrames: this.video.webkitDecodedFrameCount || 0, totalVideoFrames: this.video.webkitDroppedFrameCount || 0 } : void 0;
    } }, { key: "demuxerType", get: function() {
      return this.stat.demuxerType;
    }, set: function(t) {
      this.logger.i("av-ctx", "set demuxer type", t);
      var n = this.stat;
      if (t !== n.demuxerType) {
        var s = n.box === void 0 || n.box === g.unknown;
        t === Ze.RAW ? (n.box = g.raw, n.isLive = !1) : t === Ze.FLV ? (n.box = g.flv, n.multipart && (n.isLive = !1)) : t === Ze.MP4 || t === Ze.FMP4 ? (s && (n.box = g.mp4), n.multipart || (n.isLive = !1)) : t === Ze.TS ? s && (n.box = g.ts) : t === Ze.IVF && (n.box = g.ivf, n.isLive = !1), n.demuxerType = t, this.resetGopRemux();
      }
    } }, { key: "streamingMuxEnabled", get: function() {
      return this._streamingMuxEnabled && !(this.src instanceof Blob);
    }, set: function(t) {
      this._streamingMuxEnabled = t;
    } }, { key: "streamingMux", get: function() {
      return this.stat.box === g.flv && this.stat.isLive !== !1 || this.streamingMuxEnabled && this._streamingMux;
    }, set: function(t) {
      this._streamingMux = t;
    } }, { key: "hevcTest", get: function() {
      return this._hevcTest;
    } }, { key: "evt", get: function() {
      return this._evt;
    } }, { key: "fallback", get: function() {
      return this._fallback;
    } }, { key: "streamTime", get: function() {
      return this._streamTime;
    } }], [{ key: "packName", get: function() {
      return "mini_es";
    } }, { key: "version", get: function() {
      return "3.3.30";
    } }, { key: "buildTime", get: function() {
      return "Wed Jul 10 2024 16:08:47 GMT+0800 (中国标准时间)";
    } }]), l;
  }(W);
  _n.instanceCount = 0;
  var or, ct = _n, At = function(r) {
    return r.NORMEL = "normal", r.SEEK = "seek", r.END = "end", r.LEVEL_SWITCH = "levelSwitch", r.FIRST_FRAME = "firstFrame", r.LOAD = "load", r.BACKUP = "backup", r;
  }({}), Te = function(r) {
    return r.START = "start", r.MANIFEST = "manifest", r.LEVEL = "level", r.STREAM_CONNECTED = "streamConnected", r.DATA = "data", r.DEMUX = "demux", r.SEGMENT = "segment", r.CANPLAY = "canplay", r.LOADEDMETADATA = "loadedmetadata", r.LOADEDDATA = "loadeddata", r.SEEKED = "seeked", r;
  }(Te || {}), An = [{ event: Te.START, detailName: "first-loader-open" }, { event: Te.MANIFEST, detailName: "manifest-duration" }, { event: Te.LEVEL, detailName: "level-duration" }, { event: Te.STREAM_CONNECTED, detailName: "stream-connected-duration" }, { event: Te.DATA, detailName: "first-package-duration" }, { event: Te.DEMUX, detailName: "first-remux-duration" }, { event: Te.SEGMENT, detailName: "first-segment-duration" }, { event: Te.LOADEDMETADATA, detailName: "first-meta-duration" }, { event: [Te.LOADEDDATA, Te.CANPLAY, Te.SEEKED], detailName: "first-frame-duration" }], ys = function() {
    function r(a) {
      this._complete = 0, this._duration = 0, this._events = void 0, this._start = 0, this._lastEventTime = 0, this._details = {}, this._ctx = void 0, this._events = An.slice(0), this._ctx = a;
    }
    var l = r.prototype;
    return l.start = function() {
      this._ctx.logger.i("first-frame", "start"), this._complete = 0, this._start = performance.now(), this._duration = 0, this._events = An.slice(0), this._lastEventTime = 0, this._details = {}, this.process(Te.START, this._start);
    }, l.process = function(a, t) {
      var n;
      if (t === void 0 && (t = 0), this._ctx.logger.i("first-frame", "process type: " + a + " " + t + " complete: " + this._complete), this._complete)
        return !1;
      var s = this._events, u = -1;
      t = t || performance.now();
      for (var h = 0; h < s.length; h++) {
        var p = s[h];
        if (Array.isArray(p.event)) {
          if (p.event.indexOf(a) !== -1) {
            u = h;
            break;
          }
        } else if (p.event === a) {
          u = h;
          break;
        }
      }
      if (u === -1)
        return !1;
      var m = s.splice(0, u + 1).pop(), O = ((n = this._ctx.mse) == null ? void 0 : n.readyState) === "closed";
      if ((s.length === 0 || O && a === Te.SEGMENT) && (this._duration = t - this._start, this._complete = Date.now(), this._ctx.logger.i("first-frame", "complete " + this._duration + " " + this._complete)), m) {
        var U = Math.round(t - this._lastEventTime);
        this._lastEventTime === 0 && (U = Date.now()), this._lastEventTime = t, this._details[m.detailName] = U;
      }
      return !!this._complete;
    }, l.onDownloadError = function() {
      this._details.download_retry ? this._details.download_retry++ : this._details.download_retry = 1;
    }, l.onRetry = function() {
      this._details.retry ? this._details.retry++ : this._details.retry = 1;
    }, v()(r, [{ key: "complete", get: function() {
      return this._complete;
    } }, { key: "duration", get: function() {
      return this._duration;
    } }, { key: "details", get: function() {
      return this._details;
    } }]), r;
  }(), pn = [/headless/, /spider/, /[a-z0-9]+bot[^a-z0-9]/], gt = function(r) {
    return r.none = "", r.probably = "probably", r.maybe = "maybe", r;
  }(gt || {}), fn = function() {
    if (ht())
      return gt.none;
    if (navigator.webdriver)
      return gt.probably;
    for (var r = navigator.userAgent.toLowerCase(), l = 0; l < pn.length; l++)
      if (pn[l].test(r))
        return gt.probably;
    if (window.innerWidth <= 0 && window.innerHeight <= 0)
      return gt.probably;
    if (Z.isMSEAvailable() && !Z.isMSECodecCapabilityNormal())
      return gt.maybe;
    try {
      var a = document.createElement("canvas");
      a.width = 4, a.width = 4;
      var t = a.getContext("2d");
      if (t) {
        t.fillStyle = "#FFFFFF", t == null || t.fillRect(0, 0, a.width, a.height);
        for (var n = t.getImageData(0, 0, a.width, a.height).data, s = 0; s < n.length; s++)
          if (n[s] !== 0)
            return gt.none;
        return gt.maybe;
      }
    } catch (u) {
      return gt.probably;
    }
    return gt.none;
  }(), Es = new Uint8Array(16);
  function Ts() {
    if (!or && !(or = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto)))
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    return or(Es);
  }
  for (var bs = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i, Rs = function(r) {
    return typeof r == "string" && bs.test(r);
  }, Be = [], sr = 0; sr < 256; ++sr)
    Be.push((sr + 256).toString(16).substr(1));
  var Ss = function(r) {
    var l = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a = (Be[r[l + 0]] + Be[r[l + 1]] + Be[r[l + 2]] + Be[r[l + 3]] + "-" + Be[r[l + 4]] + Be[r[l + 5]] + "-" + Be[r[l + 6]] + Be[r[l + 7]] + "-" + Be[r[l + 8]] + Be[r[l + 9]] + "-" + Be[r[l + 10]] + Be[r[l + 11]] + Be[r[l + 12]] + Be[r[l + 13]] + Be[r[l + 14]] + Be[r[l + 15]]).toLowerCase();
    if (!Rs(a))
      throw TypeError("Stringified UUID is invalid");
    return a;
  }, lr, ws = function(r, l, a) {
    var t = (r = r || {}).random || (r.rng || Ts)();
    if (t[6] = 15 & t[6] | 64, t[8] = 63 & t[8] | 128, l) {
      a = a || 0;
      for (var n = 0; n < 16; ++n)
        l[a + n] = t[n];
      return l;
    }
    return Ss(t);
  };
  function cr() {
    return lr || (lr = { support_mse: Z.isMSEAvailable() ? 1 : 0, support_aac_mse: Z.TYPE_SUPPORTED.aac ? 1 : 0, support_aac: Z.isVideoCodecSupported(A.aac) ? 1 : 0, support_h264_mse: Z.TYPE_SUPPORTED.h264 ? 1 : 0, support_h264: Z.isVideoCodecSupported(A.h264) ? 1 : 0, support_h265_mse: Z.TYPE_SUPPORTED.hevc ? 1 : 0, support_h265: Z.isVideoCodecSupported(A.hevc) ? 1 : 0, support_av1_mse: Z.TYPE_SUPPORTED.av1 ? 1 : 0, support_simd: Z.isSupportSimd ? 1 : 0, support_thread: Z.isSupportThreads ? 1 : 0, support_hw: Z.isSupportHW ? 1 : 0, support_change_type: Z.isChangeTypeSupported() ? 1 : 0, support_streaming: St.isStreamingSupported() ? 1 : 0, hardware_concurrency: pi() || 0, wasm_dec_smooth: Z.wasmSmooth ? 1 : 0 }), lr;
  }
  function ur(r, l) {
    var a, t;
    return typeof navigator < "u" && (navigator.webdriver && (a = navigator.webdriver ? 1 : 0), navigator.onLine !== void 0 && (t = navigator.onLine ? 1 : 0)), { session_id: l.sessionId, kernel_version: ct.version, pack_name: ct.packName, creation_time: l.creationTime, src_update_time: r.srcUpdateTime, load_start_time: l.loadStartTime, instance_count: ct.instanceCount, webdriver: a, on_line: t };
  }
  function vn() {
    var r = {};
    if (typeof navigator < "u") {
      navigator.onLine !== void 0 && (r.network_on_line = navigator.onLine ? 1 : 0);
      var l = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      (l == null ? void 0 : l.rtt) !== void 0 && (r.network_rtt = l.rtt), (l == null ? void 0 : l.rtt) !== void 0 && (r.network_downlink = l.downlink), (l == null ? void 0 : l.effectiveType) !== void 0 && (r.network_effective_type = l.effectiveType), (l == null ? void 0 : l.saveData) !== void 0 && (r.network_save_data = l.saveData ? 1 : 0);
    }
    return r;
  }
  function mn(r, l) {
    var a, t, n, s = (a = r.video) == null ? void 0 : a.duration, u = r.lctx.current, h = (u == null ? void 0 : u.currentUrl) || "", p = d()({ play_url: (u == null ? void 0 : u.fileName) || h, url_id: (u == null ? void 0 : u.urlId) || 0, stream_host: h ? new ie.a(h).host : "", reuse: l.reuse, metadata_time: l.metadataTime, play_start_time: l.playStartTime, playing_start_time: l.playingStartTime, stream_duration: Math.round(1e3 * (s && Number.isFinite(s) ? s : 0)), max_bitrate: (u == null ? void 0 : u.maxBitrate) || 0, codec: l.codecs, play_pos: l.playPos || 0, v_data_rate: Math.round(((t = r.loadRec.currentLoad) == null ? void 0 : t.videoDataRate) || 0), a_data_rate: Math.round(((n = r.loadRec.currentLoad) == null ? void 0 : n.audioDataRate) || 0), drm: r.stat.drm ? 1 : 0, adaptive_multi_rate: r.lctx.abr ? 1 : 0, use_backup: l.useBackup, play_to_end: l.playToEnd, v_decoder: r.stat.decoder, video_codec_type: r.stat.codecType || A.unknown, start_codec: l.startCodec, demuxer: r.stat.demuxerType || Ze.UNKNOWN, core_type: r.stat.coreType, mms: r.stat.mms ? 1 : 0, box: r.stat.box, kwai_slice: r.stat.isKwaiSlice ? 1 : 0, monkey_patched_fetch: l.monkeyPatchedFetch }, ur(r, l), vn(), function(U) {
      var C = U.video;
      return C ? { elem_crossorigin: C.crossOrigin, elem_autoplay: C.autoplay ? 1 : 0, elem_loop: C.loop ? 1 : 0, elem_volume: C.volume, elem_muted: C.muted ? 1 : 0, elem_preload: C.preload, elem_controls: C.controls ? 1 : 0, elem_ready_state: C.readyState, elem_network_state: C.networkState } : {};
    }(r));
    typeof Z.playHEVCTest == "boolean" && (p.play_hevc_test = Z.playHEVCTest ? 1 : 0), r.stat.isLive !== void 0 && (p.live = r.stat.isLive ? 1 : 0), p.live_shift_type = r.stat.liveShiftType;
    var m = Mt((u == null ? void 0 : u.fileName) || h);
    r.stat.box === g.flv && r.stat.isLive !== !1 && (p.stream_id = m.streamID, l.cdnIP && (p.cdn_ip = l.cdnIP)), l.httpHeader && (p.response_header = ft(l.httpHeader)), u != null && u.bitrate && (p.bitrate = Math.round(u.bitrate)), u != null && u.qualityType && (p.quality_type = u.qualityType), u != null && u.qualityLabel && (p.quality_label = u.qualityLabel), l.startQualityType && (p.start_quality_type = l.startQualityType), m.transcodingTpl && (p.transcoding_template = m.transcodingTpl), m.filename && (p.filename = m.filename), typeof navigator < "u" && navigator.deviceMemory && (p.device_memory = navigator.deviceMemory);
    var O = qi();
    return O.renderer && (p.gpu_renderer = O.renderer), fn && (p.bot = fn), r.stat.wasmDecoder && (p.wasm_dec = r.stat.wasmDecoder, p.wasm_dec_simd = r.stat.wasmSimd ? 1 : 0, p.wasm_dec_threads = r.stat.wasmThreads || 0), p;
  }
  function gn() {
    var r, l, a, t = {};
    return ht() || ((r = window.screen) != null && r.width && (t.screen_w = window.screen.width), (l = window.screen) != null && l.height && (t.screen_h = window.screen.height), (a = window.screen) != null && a.colorDepth && (t.screen_color_depth = window.screen.colorDepth), t.device_pixel_ratio = window.devicePixelRatio || 1), t;
  }
  function yn(r) {
    var l = {};
    return r && (r.fps && (l.fps = Math.round(1e3 * r.fps) / 1e3), r.width && (l.width = r.width), r.height && (l.height = r.height), r.codedWidth && (l.coded_width = r.codedWidth), r.codedHeight && (l.coded_height = r.codedHeight), r.sar && r.sar.width !== r.sar.height && (l.sar = r.sar), r.enhancedFlv && (l.enhanced_flv = r.enhancedFlv ? 1 : 0)), l;
  }
  function En(r) {
    var l = { src_type: r.stat.srcType };
    return r.stat.stereoType && (l.stereo_type = r.stat.stereoType), r.stat.mixCodecInput && r.stat.mixCodecInput.length && (l.mix_codec_input = r.stat.mixCodecInput), r.stat.mixContainerInput && r.stat.mixContainerInput.length && (l.mix_container_input = r.stat.mixContainerInput), r.stat.mixCodecAvailable && (l.mix_codec_available = r.stat.mixCodecAvailable), r.stat.mixQualityList && (l.mix_quality_list = r.stat.mixQualityList), l;
  }
  function Tn(r) {
    var l = {};
    return r.stat.srcMeta && (l.src_meta = r.stat.srcMeta), l;
  }
  function bn(r) {
    var l, a, t, n = {};
    return (l = r.lctx.current) != null && l.meta && (n.current_level_meta = r.lctx.current.meta, r.lctx.current.meta.comment && r.lctx.current.meta.comment.split("/").forEach(function(s) {
      s.indexOf("tt=") === 0 && (n.transcoding_template = s.substring(3)), s.indexOf("ttExplain=") === 0 && (n.transcoding_template_explain = s.substring(10));
    })), (a = r.lctx.current) != null && a.fileSize && (n.filesize = (t = r.lctx.current) == null ? void 0 : t.fileSize), n;
  }
  function Rn(r) {
    var l = performance.now();
    return { play: Math.round(r.playDuration + (r.playStartMS ? l - r.playStartMS : 0)), actualPlay: Math.round(r.actualPlayDuration + (r.actualPlayStartMS ? l - r.actualPlayStartMS : 0)), pause: Math.round(r.pauseDuration + (r.pauseStartMS ? l - r.pauseStartMS : 0)), buffer: Math.round(r.bufferTime + (r.bufferingStartMS ? l - r.bufferingStartMS : 0)) };
  }
  function Sn() {
    return document.hidden || document.webkitHidden || document.mozHidden || !0;
  }
  var Ls = function() {
    function r(a, t) {
      this._data = void 0, this._ctx = void 0, this._snapshot = void 0, this._tickIndex = 1, this._statTimestampMillis = 0, this._statTimestampMillisUTC = 0, this._firstScreen = !0, this._firstScreenDetails = void 0, this._firstScreenDuration = void 0, this._clickToFirstFrame = 0, this._errorCode = 0, this._errorMessage = "", this._retryInfo = new qr(), this._data = a, this._ctx = t, this._tickIndex = 1, this._snapshot = { play: 0, actualPlay: 0, pause: 0, buffer: 0, blockCount: 0, pauseCnt: 0, renderBlockCount: 0, seekCnt: 0, seekLoadCnt: 0, decodedFrames: 0, droppedFrames: 0, traffic: 0, download: 0, mseUpdate: 0, mseRemove: 0, segment: 0, preloadCount: 0, muxA: 0, muxV: 0, fillA: 0, fillV: 0, droppedA: 0, droppedV: 0, keyFrame: 0, onLineChange: 0, visibilityChange: 0, heartbeatTimeout: 0, loadCnt: 0, refreshCnt: 0 }, this._resetForNewInterval();
    }
    var l = r.prototype;
    return l._updateSnapshot = function(a, t) {
      var n = {};
      for (var s in t) {
        var u = a[s];
        typeof u == "number" && (n[s] = u - t[s], t[s] = u);
      }
      return n;
    }, l._resetForNewInterval = function() {
      this._statTimestampMillis = performance.now(), this._statTimestampMillisUTC = Date.now(), this._firstScreenDuration = void 0, this._firstScreenDetails = void 0, this._errorCode = 0, this._errorMessage = "";
    }, l.setFirstScreenDuration = function(a, t, n) {
      this._firstScreenDuration = Math.round(a), this._firstScreenDetails = t, this._firstScreen = !0, this._clickToFirstFrame = n;
    }, l.setError = function(a, t) {
      this._errorCode = a, this._errorMessage = t;
    }, l.build = function() {
      var a = this._data, t = this._ctx, n = this._ctx.stat, s = performance.now(), u = Math.round(s - this._statTimestampMillis), h = this._updateSnapshot(a, this._snapshot), p = this._updateSnapshot(Rn(this._data), this._snapshot), m = this._updateSnapshot(this._ctx.loadRec, this._snapshot), O = this._ctx.loadRec.downloadInfoByRange(u), U = O.timeCost ? Math.round(O.size / O.timeCost * 1e3) : 0, C = { tick_index: this._tickIndex, tick_start: this._statTimestampMillisUTC, tick_duration: u, error_code: this._errorCode, error_message: this._errorMessage, block_cnt: h.blockCount || 0, render_block_cnt: h.renderBlockCount || 0, decoded_video_frames: h.decodedFrames || 0, dropped_video_frames: h.droppedFrames || 0, segment_cnt: h.segment || 0, play_duration: p.play || 0, buffer_time: p.buffer || 0, actual_play_duration: p.actualPlay || 0, played_video_duration: p.play || 0, traffic: Math.round(((m == null ? void 0 : m.traffic) || 0) / 1024), hidden: Sn() ? 1 : 0, download: h.download, download_speed: U, seek_cnt: h.seekCnt, seek_load_cnt: h.seekLoadCnt, pause_duration: p.pause, pause_cnt: h.pauseCnt, preload_cnt: h.preloadCount, on_line_change: h.onLineChange, visibility_change: h.visibilityChange, heartbeat_timeout: h.heartbeatTimeout, load_cnt: h.loadCnt, refresh_cnt: h.refreshCnt, media_buffered_a: a.bufferedEndA, media_buffered_v: a.bufferedEndV };
      return d()(C, cr(), mn(t, a), function(M) {
        var j, le, re, Q, we;
        return M.mse ? (Q = M.mse.bufferedByType(B.VIDEO), we = M.mse.bufferedByType(B.AUDIO)) : Q = we = M.mediaBufferedSec, { a_buf_start: Math.round(1e3 * we.start) || 0, a_buf_end: Math.round(1e3 * we.end) || 0, a_buf_len: Math.round(1e3 * Math.max(0, we.end - M.currentTime)) || 0, a_buf_slices: ((j = M.mse) == null ? void 0 : j.bufferSliceNumByType(B.AUDIO)) || M.bufferSliceNum || 0, v_buf_start: Math.round(1e3 * Q.start) || 0, v_buf_end: Math.round(1e3 * Q.end) || 0, v_buf_len: Math.round(1e3 * Math.max(0, Q.end - M.currentTime)) || 0, v_buf_slices: ((le = M.mse) == null ? void 0 : le.bufferSliceNumByType(B.VIDEO)) || M.bufferSliceNum || 0, buffer_queue_cnt: ((re = M.mse) == null ? void 0 : re.pendingNum()) || 0 };
      }(t), function(M) {
        if (M.stat.isLive && M.stat.box === g.flv) {
          var j = M.liveDelay.getDisplayDelay(M.currentTime);
          if (j)
            return { v_rec_delay: M.liveDelay.getRecDelay(), v_render_delay: j || 0, a_render_delay: M.liveDelay.getAudioRenderDelay(M.currentTime) || 0 };
        }
        return {};
      }(t), bn(t)), this._retryInfo.hasData && (C.retry_record = this._retryInfo.beacon, C.retry_cnt = this._retryInfo.retryCount, this._retryInfo.clear()), m.muxA && (C.mux_a = m.muxA), m.muxV && (C.mux_v = m.muxV), m.fillA && (C.fill_a = m.fillA), m.fillV && (C.fill_v = m.fillV), m.droppedA && (C.dropped_a = m.droppedA), m.droppedV && (C.dropped_v = m.droppedV), n.coreType === N.mse && (C.mse_update_cnt = h.mseUpdate || 0, C.mse_remove_cnt = h.mseRemove || 0, C.key_frame_cnt = h.keyFrame, n.isLive ? (C.live_shift_type = t.stat.liveShiftType, t.stat.liveShiftType !== q.NONE && (C.live_shift = t.stat.liveShift ? 1 : 0)) : (C.lazyload_min = Math.floor(n.lazyLoadRecoverDuration), C.lazyload_max = Math.floor(n.lazyLoadMaxDuration))), this._firstScreen && (this._firstScreenDuration === void 0 ? C.first_screen_total_duration = 0 : (C.first_screen_total_duration = this._firstScreenDuration, C.first_screen_details = this._firstScreenDetails, n.coreType === N.mse && n.box === g.mp4 && (C.mp4_moov_size = a.mp4MoovSize, a.mp4FastStart !== void 0 && (C.mp4_fast_start = a.mp4FastStart ? 0 : 1)), this._firstScreenDetails = void 0, this._firstScreenDuration = void 0, this._firstScreen = !1)), typeof this._clickToFirstFrame == "number" && a.playStartTime && (C.click_to_first_frame = this._clickToFirstFrame, this._clickToFirstFrame > 0 && (this._clickToFirstFrame = void 0)), this._tickIndex === 1 && d()(C, cr(), En(this._ctx), gn()), this._resetForNewInterval(), this._tickIndex++, C;
    }, r;
  }();
  function wn(r, l) {
    var a = Object.keys(r);
    if (Object.getOwnPropertySymbols) {
      var t = Object.getOwnPropertySymbols(r);
      l && (t = t.filter(function(n) {
        return Object.getOwnPropertyDescriptor(r, n).enumerable;
      })), a.push.apply(a, t);
    }
    return a;
  }
  function Ln(r) {
    for (var l = 1; l < arguments.length; l++) {
      var a = arguments[l] != null ? arguments[l] : {};
      l % 2 ? wn(Object(a), !0).forEach(function(t) {
        Wr()(r, t, a[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(r, Object.getOwnPropertyDescriptors(a)) : wn(Object(a)).forEach(function(t) {
        Object.defineProperty(r, t, Object.getOwnPropertyDescriptor(a, t));
      });
    }
    return r;
  }
  var xs = function(r) {
    function l(t) {
      var n;
      return (n = r.call(this) || this)._beaconTimer = void 0, n._creationTime = void 0, n._runningStartTime = void 0, n._ctx = void 0, n._firstFrame = void 0, n._data = void 0, n._realtimeBeacon = void 0, n._hiddenStart = !1, n._playing = !1, n._seeking = !1, n._seekLoadFlag = !1, n._mediaInfoUpdated = !1, n._seekingThrottle = null, n._seekedDebounce = null, n._onOnlineChange = function() {
        n._data.onLineChange++, n._triggerEventReport(Ee.NETWORK_CHANGE, { online: navigator.onLine !== void 0 ? navigator.onLine ? 1 : 0 : void 0 });
      }, n._onVisibilityChange = function() {
        n._data.visibilityChange++;
      }, n._sendRealtimeBeacon = function(s) {
        var u;
        s === void 0 && (s = At.NORMEL);
        var h = (u = n._realtimeBeacon) == null ? void 0 : u.build();
        if (h) {
          var p;
          s === At.NORMEL && h.first_screen_total_duration > 0 ? h.type = At.FIRST_FRAME : (s === At.LOAD && d()(h, Tn(n._ctx)), h.type = s), n._mediaInfoUpdated && (d()(h, yn((p = n._ctx.loadRec.currentLoad) == null ? void 0 : p.mediaInfo)), n._mediaInfoUpdated = !1), n._ctx.stat.isLive || (h.seek_record = n._data.seekRecord.slice(0), n._data.seekRecord = []), n._ctx.logger.i("monitor", "realtime beacon", h), n.emit(F.REPORT, { type: et.REALTIME_BEACON, value: h });
        }
      }, n._runningStartTime = performance.now(), n._creationTime = Date.now(), n._firstFrame = new ys(t), n._ctx = t, n._reset(), ht || (window.addEventListener("online", n._onOnlineChange), window.addEventListener("offline", n._onOnlineChange), document.addEventListener("visibilitychange", n._onVisibilityChange)), n;
    }
    y()(l, r);
    var a = l.prototype;
    return a._reset = function() {
      var t;
      this._playing = !1, this._seeking = !1, this._seekLoadFlag = !1, this._mediaInfoUpdated = !1, this._seekedDebounce && clearTimeout(this._seekedDebounce), this._seekingThrottle && clearTimeout(this._seekingThrottle), this._data = (t = { decodedFrames: 0, droppedFrames: 0, sessionId: ws(), creationTime: 0, startTime: 0, loadStartTime: 0, playStartTime: 0, metadataTime: 0, playingStartTime: 0, playDuration: 0, actualPlayDuration: 0, pauseDuration: 0, pauseCnt: 0, bufferTime: 0, blockCount: 0, renderBlockCount: 0, seekCnt: 0, seekDuration: 0, seekLoadCnt: 0, seekLoadDuration: 0, seekStartTime: 0, unknownTSPacketCount: 0, audioNonMonotonous: 0, startBitrate: 0, smoothBitrate: -1, useBackup: 0, aacOverhead: 0, errorCode: 0, errorMessage: "", download: 0, preloadCount: 0, reuse: 0, playPos: 0, seekRecord: [], codecs: "", firstScreenTotalDuration: 0, clickToFirstFrame: 0, playToEnd: 0, keyFrame: 0, onLineChange: 0, visibilityChange: 0, lastHeartbeatTime: 0, heartbeatTimeout: 0, loadCnt: 0, refreshCnt: 0, monkeyPatchedFetch: "", bufferedEndA: 0, bufferedEndV: 0 }, X.isSupported() && (t.monkeyPatchedFetch = It(fetch, "fetch")), t), this._data.creationTime = this._creationTime, this._ctx.logger.i("monitor", "reset", this._data.sessionId), this._ctx.fps.reset(), this._ctx.fps.getFPS(this._ctx.videoPlaybackQuality);
    }, a.onLoaderChunkArrival = function(t) {
      this._ctx.loadRec.onDataReceive(t), this._processFirstFrame(Te.DATA);
    }, a.onMediaConnected = function(t) {
      t.headers && (this._data.httpHeader = t.headers), this._processFirstFrame(Te.STREAM_CONNECTED);
    }, a.onMediaDemux = function() {
      this._processFirstFrame(Te.DEMUX, performance.now());
    }, a.onKeyFrame = function(t) {
      this._ctx.loadRec.currentLoad && this._ctx.loadRec.currentLoad.keyFrame++, this.data.keyFrame++, t && this.emit(F.REPORT, { type: et.KEY_FRAME, value: t });
    }, a.onDecLibLoaded = function(t) {
      this._data.decLibLoadDuration = t.duration, this._data.decLibCacheHit = t.hitCache;
    }, a.onNewSource = function(t) {
      var n = this._data, s = this._ctx.lctx.current;
      s ? (this._ctx.loadRec.onStreamOpen(t.sync, s.currentUrl, s.bitrate, s.qualityType), n.level = this._ctx.lctx.currentIdx, n.startQualityType || (n.startQualityType = s.qualityType)) : this._ctx.loadRec.onStreamOpen(t.sync, "", 0, "unknown");
    }, a.onDiscontinuity = function(t) {
      this.emit(F.REPORT, { type: et.DISCONTINUITY, value: t });
    }, a.onDownload = function(t) {
      var n = this, s = this._data;
      t.error_code && !this._firstFrame.complete && this._firstFrame.onDownloadError(), s.download++;
      var u = d()({ use_backup: s.useBackup, first_screen: s.firstScreenTotalDuration ? 1 : 0 }, ur(this._ctx, s), vn(), t);
      t.error_code === 1009 ? setTimeout(function() {
        n.emit(F.REPORT, { type: et.DOWNLOAD, value: u });
      }, 0) : this.emit(F.REPORT, { type: et.DOWNLOAD, value: u });
    }, a.onHeartbeat = function() {
      var t, n, s = this._data, u = this._ctx, h = u.fps.getFPS(this._ctx.videoPlaybackQuality), p = {}, m = u.loadRec, O = performance.now();
      s.lastHeartbeatTime && O - s.lastHeartbeatTime > 1500 && s.heartbeatTimeout++, s.lastHeartbeatTime = performance.now(), (u.stat.coreType === N.mse || u.stat.coreType === N.rtc) && (p.totalReceive = m.traffic, p.speed = m.speed, p.videoDataRate = ((t = m.currentLoad) == null ? void 0 : t.videoDataRate) || 0, p.audioDataRate = ((n = m.currentLoad) == null ? void 0 : n.audioDataRate) || 0), u.mse && (p.videoBuffered = s.bufferedEndV = Math.round(Math.max(0, 1e3 * (u.mse.bufferedEndByType(B.VIDEO) - u.currentTime))), p.audioBuffered = s.bufferedEndA = Math.round(Math.max(0, 1e3 * (u.mse.bufferedEndByType(B.AUDIO) - u.currentTime))), p.fillAudio = m.fillA, p.fillVideo = m.fillV, p.keyFrame = s.keyFrame, u.stat.isLive ? (p.isLive = u.stat.isLive, u.stat.liveShiftType && (p.liveShift = u.stat.liveShift)) : (p.lazyloadMin = u.stat.lazyLoadRecoverDuration, p.lazyloadMax = u.stat.lazyLoadMaxDuration)), p.buffered = Math.round(1e3 * u.bufferedSec), p.decodedFPS = (h == null ? void 0 : h.decodedFPS) || 0, p.droppedFPS = (h == null ? void 0 : h.droppedFPS) || 0, s.decodedFrames = p.decodedFrames = (h == null ? void 0 : h.decoded) || 0, s.droppedFrames = p.droppedFrames = (h == null ? void 0 : h.dropped) || 0, u.stat.isLive && u.stat.box === g.flv && (p.audioRenderDelay = u.liveDelay.getAudioRenderDelay(u.currentTime), p.displayDelay = u.liveDelay.getDisplayDelay(u.currentTime), p.recDelay = u.liveDelay.getRecDelay()), u.logger.i("monitor", "heartbeat", p), this.emit(F.REPORT, { type: et.HEARTBEAT, value: p });
    }, a.destroy = function() {
      this._ctx.logger.i("monitor", "destroy"), this._triggerEventReport(Ee.DESTORY), this._sendRealtimeBeacon(At.END), this._stopBeaconTimer(), ht() || (window.removeEventListener("online", this._onOnlineChange), window.removeEventListener("offline", this._onOnlineChange), document.removeEventListener("visibilitychange", this._onVisibilityChange)), this._seekedDebounce && clearTimeout(this._seekedDebounce), this._seekingThrottle && clearTimeout(this._seekingThrottle), r.prototype.destroy.call(this);
    }, a.onPreloadComplete = function() {
      this._data.preloadCount++;
    }, a.onLoad = function(t) {
      if (this._ctx.logger.i("monitor", "on load: " + t.type), this._data.loadCnt++, t.type)
        t.type !== G.internal && t.type !== G.retry || this._firstFrame.complete || this._firstFrame.start(), this._data.errorCode = 0, this._data.errorMessage = "";
      else {
        var n, s = ((n = this._ctx.lctx.current) == null ? void 0 : n.currentUrl) || "";
        if (this._data.startTime) {
          var u = this._data.reuse;
          this._reset(), this._data.reuse = u + 1;
        }
        this._triggerEventReport(Ee.LOAD, { url: s, protocol: this._ctx.stat.box, initial_speed: String(this._ctx.video && this._ctx.video.playbackRate) }), this._data.startTime = performance.now(), this._data.loadStartTime = Date.now(), this._firstFrame.start(), this._hiddenStart = Sn(), this._stopBeaconTimer(), this._realtimeBeacon = new Ls(this._data, this._ctx), this._sendRealtimeBeacon(At.LOAD);
      }
    }, a.onStopLoad = function() {
      this._sendRealtimeBeacon(At.END), this._stopBeaconTimer(), this._waitingEnd(), this._ctx.stat.isLive && this._triggerEventReport(Ee.LIVE_STOP);
    }, a.onManifestParsed = function(t) {
      this._ctx.logger.i("monitor", "on manifest:", t);
      var n = this._ctx.lctx.current;
      n && (this._data.startBitrate || (this._data.startBitrate = n.bitrate)), this._processFirstFrame(Te.MANIFEST);
    }, a.onLevelUpdated = function(t) {
      this._processFirstFrame(Te.LEVEL);
    }, a.onAudioTrackUpdated = function() {
    }, a.onMediaInfo = function(t) {
      var n, s, u = this._ctx;
      (t = t || {}).box = u.stat.box, u.stat.srcMeta && (t.srcMeta = u.stat.srcMeta), (n = u.lctx.current) != null && n.meta && (t.currentLevelMeta = (s = u.lctx.current) == null ? void 0 : s.meta), typeof u.stat.isLive == "boolean" && (t.isLive = u.stat.isLive), t.liveShiftEnabled = u.stat.liveShiftType !== q.NONE, t.liveShiftType = u.stat.liveShiftType, t.packName = ct.packName, u.loadRec.onMediaInfo(t);
      var h = [];
      t.videoCodec && h.push(t.videoCodec), t.audioCodec && h.push(t.audioCodec), this._data.codecs = h.join(","), this._data.startCodec || (this._data.startCodec = this._data.codecs), t.sid = this._data.sessionId, t.hardwareAccelerated = Z.isSupportHW, t.coreType = u.stat.coreType, !t.streamHost && u.lctx.currentUrl && (t.streamHost = new ie.a(u.lctx.currentUrl).host);
      var p = qi();
      p.renderer && (t.gpu = p.renderer), u.loadRec.currentLoad && (u.loadRec.currentLoad.mediaInfo = t), u.stat.isLive && u.stat.box === g.flv && u.config.ntp && u.liveDelay.init(u.stat.preferNativeLoader), u.stat.isKwaiSlice && (t.isKwaiSlice = u.stat.isKwaiSlice);
      var m = JSON.stringify(t);
      this._ctx.logger.i("monitor", "mediainfo", m), this._mediaInfoUpdated = !0, this.emit(F.REPORT, { type: et.MEDIA_INFO, value: JSON.parse(m) });
    }, a.onParsingData = function(t) {
      if (t.extra && t.extra.stat) {
        var n = this._data;
        n.unknownTSPacketCount = n.unknownTSPacketCount || t.extra.stat.unknownTSPacketCount || 0, n.audioNonMonotonous = n.audioNonMonotonous || t.extra.stat.audioNonMonotonous || 0, n.aacOverhead = n.aacOverhead || t.extra.stat.aacOverhead || 0;
      }
      this._processFirstFrame(Te.SEGMENT);
    }, a.onPrivNal = function(t) {
      this._ctx.liveDelay.onPrivNal(t), this.emit(F.REPORT, { type: et.PRIV_NAL, value: { info: t.info } });
    }, a.onSei = function(t) {
      this.emit(F.REPORT, { type: et.SEI, value: t });
    }, a.onAacPriv = function(t) {
      this.emit(F.REPORT, { type: et.AAC_PRIV, value: t });
    }, a.onPlay = function() {
      this._data.playStartTime || (this._data.playStartTime = Date.now()), this._startBeaconTimer();
    }, a.onLoadedmetadata = function() {
      this._processFirstFrame(Te.LOADEDMETADATA), this._data.metadataTime || (this._data.metadataTime = Date.now());
    }, a.onLoadeddata = function() {
      this._processFirstFrame(Te.LOADEDDATA), this._waitingEnd();
    }, a.onCanplay = function() {
      this._processFirstFrame(Te.CANPLAY), $.safari && this._ctx.stat.coreType !== N.mse || this._waitingEnd();
    }, a.onPlaying = function() {
      var t;
      $.ios && ((t = this._ctx.video) == null ? void 0 : t.readyState) !== 4 || (this._playing || (this._playing = !0, this._triggerEventReport(Ee.PLAY)), this._playStart(), this._pauseEnd(), this._waitingEnd());
    }, a.onPause = function() {
      var t;
      (t = this._ctx.video) != null && t.seeking || !this._playing || (this._playEnd(), this._pauseStart(), this._triggerEventReport(Ee.PAUSE), this._playing = !1);
    }, a.onEnded = function() {
      this._data.playToEnd++, this._playing = !1, this._playEnd(), this._pauseEnd(), this._waitingEnd(), this._sendRealtimeBeacon(At.END), this._stopBeaconTimer(), this._triggerEventReport(Ee.END);
    }, a.onWaiting = function(t) {
      this._data.playPos = Math.round(1e3 * this._ctx.currentTime), this._playing && this._firstFrame.complete && t.block && (this._waitingStart(t.bufferedSec), this._triggerEventReport(Ee.BLOCK_START));
    }, a.onSeeking = function(t) {
      var n, s, u = this;
      this._data.seekRecord.push({ from: this._data.playPos, to: Math.round(1e3 * this._ctx.currentTime), time: Date.now() }), this._data.seekRecord.length > 50 && this._data.seekRecord.shift(), this._ctx.stat.isLive || t != null && t.internal || (this._data.seekStartTime = performance.now(), this._seeking ? !this._seekingThrottle && this._seeking && (this._seekingThrottle = +setTimeout(function(h) {
        var p, m;
        u._triggerEventReport(Ee.SEEK_START, { paused: (p = u._ctx.video) == null ? void 0 : p.paused, seeking: (m = u._ctx.video) == null ? void 0 : m.seeking, position: h }), u._seekingThrottle = null;
      }, 500, this._data.playPos / 1e3)) : (this._triggerEventReport(Ee.SEEK_START, { paused: (n = this._ctx.video) == null ? void 0 : n.paused, seeking: (s = this._ctx.video) == null ? void 0 : s.seeking, position: this._data.playPos / 1e3 }), this._seeking = !0));
    }, a.onSeekWithLoad = function() {
      this._firstFrame.complete && (this._sendRealtimeBeacon(At.SEEK), this._resetBeaconTimer(), this._seekLoadFlag = !0);
    }, a.onSeeked = function() {
      var t = this;
      if (this._ctx.fps.getFPS(this._ctx.videoPlaybackQuality), this._data.seekStartTime) {
        this._data.seekCnt++;
        var n = Math.round(performance.now() - this._data.seekStartTime);
        this._data.seekDuration += n, this._data.seekStartTime = 0, this._seekLoadFlag && (this._data.seekLoadCnt++, this._data.seekLoadDuration += n), this._seekedDebounce && clearTimeout(this._seekedDebounce), this._seekedDebounce = +setTimeout(function() {
          var s, u, h;
          (s = t._ctx.video) != null && s.seeking || (t._seeking = !1, t._triggerEventReport(Ee.SEEK_END, { paused: (u = t._ctx.video) == null ? void 0 : u.paused, seeking: (h = t._ctx.video) == null ? void 0 : h.seeking }));
        }, 500);
      }
      this._seekLoadFlag = !1, this._firstFrame.complete || this._ctx.stat.coreType === N.mse || !$.safari && !$.msie || this._processFirstFrame(Te.SEEKED);
    }, a.onTimeupdate = function() {
      var t, n, s = this._ctx, u = s.video;
      if (u) {
        u.loop && !s.stat.isLive && s.currentTime === 0 && Number.isFinite(u.duration) && u.duration > 0 && u.duration - this._data.playPos / 1e3 < 1 && this._data.playToEnd++;
        var h = Math.round(1e3 * s.currentTime);
        $.msie && s.stat.coreType !== N.mse && this._data.bufferingStartMS && this._data.playPos !== h && this.onPlaying(), this._data.playPos = h, !$.ios || typeof this._data.bufferingStartMS != "number" || ((t = this._ctx.video) == null ? void 0 : t.readyState) !== 4 || (n = this._ctx.video) != null && n.paused || this.onPlaying();
      }
    }, a.onProgress = function() {
      var t;
      $.safari && this._ctx.stat.coreType !== N.mse && this._data.bufferingStartMS && ((t = this._ctx.video) == null ? void 0 : t.readyState) === 4 && this._waitingEnd();
    }, a.mediaCapabilities = function(t) {
      this._data.smoothBitrate = t;
    }, a.onLevelSwitching = function(t) {
      t.smooth || (this._sendRealtimeBeacon(At.LEVEL_SWITCH), this._resetBeaconTimer());
      var n = this._ctx.lctx.current;
      n && this._triggerEventReport(Ee.QUALITY_CHANGE, { quality_type: n.qualityType, trigger_mode: t.auto ? "abr" : "user", play_url: n.currentUrl, is_smooth: t.smooth ? 1 : 0 });
    }, a.onLevelSwitched = function() {
      this._triggerEventReport(Ee.QUALITY_CHANGE_DATA);
    }, a.onLevelSwitchPlaying = function() {
      this._triggerEventReport(Ee.QUALITY_CHANGE_RENDER);
    }, a.onAudioTrackSwitching = function() {
      this._triggerEventReport(Ee.AUDIO_CHANGE);
    }, a.onAudioTrackSwitched = function() {
      this._triggerEventReport(Ee.AUDIO_CHANGE);
    }, a.onRetry = function(t) {
      this._ctx.stat.retryInfo.append(t), t.type === H.BACKUP && (this._data.useBackup = 1), this._firstFrame.onRetry(), this._triggerEventReport(Ee.RETRY, { retry_type: t.type, retry_message: t.message, error_code: t.code || 0 }), t.type === H.BACKUP && (this._realtimeBeacon && this._realtimeBeacon.setError(t.code || 0, t.message || ""), this._sendRealtimeBeacon(At.BACKUP), this._realtimeBeacon && this._realtimeBeacon.setError(0, ""));
    }, a.onLiveShift = function(t) {
      this._triggerEventReport(Ee.LIVE_SHIFT, { live_shift_type: this._ctx.stat.liveShiftType, live_shift_time: t != null && t.time ? t.time : -1 });
    }, a.onRefresh = function() {
      this._data.refreshCnt++;
    }, a.onMetadata = function(t) {
      t.mp4MoovSize && (this._data.mp4MoovSize = t.mp4MoovSize), typeof t.mp4FastStart == "number" && (this._data.mp4FastStart = t.mp4FastStart), typeof t.cdn_ip == "string" && (this._data.cdnIP = t.cdn_ip), this._ctx.logger.i("monitor", "metadata", t), this.emit(F.REPORT, { type: et.METADATA, value: t }), this._triggerEventReport(Ee.METADATA_LOAD, Ln({}, t));
    }, a._triggerEventReport = function(t, n) {
      this.emit(F.REPORT, { type: et.EVENT, value: d()(Ln({ type: t, position: this._ctx.currentTime }, n), ur(this._ctx, this._data)) });
    }, a.onRatechange = function() {
      var t;
      !this._ctx.video || (t = this._ctx.video) != null && t.seeking || this._triggerEventReport(Ee.SPEED_CHANGE, { speed: this._ctx.video.playbackRate });
    }, a.onError = function(t) {
      t.fatal && !t.preventFollowUp && (this._ctx.logger.e("monitor", "error"), this._data.errorCode = t.code, this._data.errorMessage = t.reason, this._triggerEventReport(Ee.ERROR, { error_message: t.reason, error_type: t.code }), this._realtimeBeacon && this._realtimeBeacon.setError(t.code, t.reason), this._playEnd(), this._pauseEnd(), this._waitingEnd());
    }, a._processFirstFrame = function(t, n) {
      n === void 0 && (n = 0), !this._firstFrame.complete && this._firstFrame.process(t, n) && this._onFirstFrame();
    }, a._playStart = function() {
      this._data.playingStartTime || (this._data.playingStartTime = Date.now()), this._data.playStartMS = this._data.playStartMS || performance.now(), this._data.actualPlayStartMS = this._data.actualPlayStartMS || performance.now();
    }, a._playEnd = function() {
      this._data.playStartMS && (this._data.playDuration += performance.now() - this._data.playStartMS), this._data.actualPlayStartMS && (this._data.actualPlayDuration += performance.now() - this._data.actualPlayStartMS), this._data.playStartMS = void 0, this._data.actualPlayStartMS = void 0;
    }, a._pauseStart = function() {
      this._data.pauseCnt++, this._data.pauseStartMS = this._data.pauseStartMS || performance.now();
    }, a._pauseEnd = function() {
      this._data.pauseStartMS && (this._data.pauseDuration += performance.now() - this._data.pauseStartMS), this._data.pauseStartMS = void 0;
    }, a._waitingStart = function(t) {
      this._data.bufferingStartMS || (this._data.blockCount++, this._data.bufferingStartMS = performance.now(), t > 0.6 && this._data.renderBlockCount++), this._data.actualPlayStartMS && (this._data.actualPlayDuration += performance.now() - this._data.actualPlayStartMS), this._data.actualPlayStartMS = void 0;
    }, a._waitingEnd = function() {
      this._data.bufferingStartMS && (this._data.bufferTime += performance.now() - this._data.bufferingStartMS, this._data.bufferingStartMS = void 0, this._triggerEventReport(Ee.BLOCK_END));
    }, a._onFirstFrame = function() {
      var t, n, s, u, h, p;
      this._ctx.logger.i("monitor", "first frame"), this._ctx.stat.firstFrameLoaded = !0;
      var m = this._data, O = this._ctx.loadRec.currentLoad;
      m.firstScreenTotalDuration = m.firstScreenTotalDuration || Math.round(this._firstFrame.duration), m.firstScreenDetails = m.firstScreenDetails || this._firstFrame.details, this._triggerEventReport(Ee.FIRST_SCREEN_RENDER, { initial_rate: Math.round(((t = this._ctx.loadRec.currentLoad) == null ? void 0 : t.videoDataRate) || 0), inital_quality_type: this._data.startQualityType, fps: O == null || (n = O.mediaInfo) == null || (n = n.fps) == null ? void 0 : n.toString(), a_codec: O == null || (s = O.mediaInfo) == null ? void 0 : s.audioCodec, v_codec: O == null || (u = O.mediaInfo) == null ? void 0 : u.videoCodec, channels: O == null || (h = O.mediaInfo) == null || (h = h.channel) == null ? void 0 : h.toString(), sample_rate: O == null || (p = O.mediaInfo) == null || (p = p.audioSampleRate) == null ? void 0 : p.toString() }), m.playStartTime && this._firstFrame.complete ? m.clickToFirstFrame = m.clickToFirstFrame || Math.max(1, this._firstFrame.complete - m.playStartTime) : m.clickToFirstFrame = 1, this._realtimeBeacon && this._realtimeBeacon.setFirstScreenDuration(this._firstFrame.duration, this._firstFrame.details, m.clickToFirstFrame), this._ctx.video && !this._ctx.video.paused && this._playStart();
    }, a._startBeaconTimer = function() {
      this._beaconTimer === void 0 && (this._beaconTimer = setInterval(this._sendRealtimeBeacon, 1e4));
    }, a._stopBeaconTimer = function() {
      this._beaconTimer && (clearTimeout(this._beaconTimer), this._beaconTimer = void 0);
    }, a._resetBeaconTimer = function() {
      this._stopBeaconTimer(), this._startBeaconTimer();
    }, v()(l, [{ key: "runningStartTime", get: function() {
      return this._runningStartTime;
    } }, { key: "sid", get: function() {
      return this._data.sessionId;
    } }, { key: "snapshot", get: function() {
      var t = this._ctx.loadRec, n = this._ctx.stat;
      return d()({ streams: t.streams, live: n.isLive, liveShift: n.liveShift, demuxer: n.demuxerType, decSimd: n.wasmSimd, decThreads: n.wasmThreads, decoderType: n.wasmDecoder }, this._data);
    } }, { key: "data", get: function() {
      return this._data;
    } }, { key: "audienceStat", get: function() {
      var t, n = this._data, s = Rn(n), u = this._ctx.stat, h = this._ctx.loadRec, p = { play_duration: s.play, actual_play_duration: s.actualPlay, traffic: Math.round(h.traffic / 1024), buffer_time: s.buffer, block_cnt: n.blockCount, render_block_cnt: n.renderBlockCount, click_to_first_frame: n.playStartTime && n.clickToFirstFrame || 0, first_screen_total_duration: Math.round(n.firstScreenTotalDuration) || 0, first_screen_details: n.firstScreenDetails || this._firstFrame.details || null, error_code: n.errorCode || 0, error_message: n.errorMessage || "", remux_process_type: (this._ctx.streamingMuxEnabled ? 1 : 0) + (u.gopRemux ? 1 : 0), hidden_start: this._hiddenStart ? 1 : 0, current_running_time: Math.round(performance.now() - n.startTime), running_time: Math.round(performance.now() - this._runningStartTime), smooth_bitrate: n.smoothBitrate, start_bitrate: n.startBitrate || 0, abr: this._ctx.config.adaptive ? 1 : 0, pause_cnt: n.pauseCnt, preload_cnt: n.preloadCount, traffic_vcodec: h.trafficGroupedByVCodecType, traffic_level: h.trafficGroupedByLevel, decoded_video_frames: n.decodedFrames || 0, dropped_video_frames: n.droppedFrames || 0, pause_duration: s.pause, seek_cnt: n.seekCnt, seek_duration: n.seekDuration, seek_load_cnt: n.seekLoadCnt, seek_load_duration: n.seekLoadDuration, start_sec: u.isLive ? 0 : Math.round(this._ctx.config.startFromSec || 0), on_line_change: n.onLineChange, visibility_change: n.visibilityChange, heartbeat_timeout: n.heartbeatTimeout, load_cnt: n.loadCnt, refresh_cnt: n.refreshCnt, media_buffered_v: n.bufferedEndV, media_buffered_a: n.bufferedEndA, remux_worker: this._ctx.stat.webWorker ? 1 : 0, av_separated: this._ctx.stat.avSeparated ? 1 : 0 };
      if ($.platformVersion && (p.platform = $.platform || "", p.platform_version = $.platformVersion || 0), $.iphone && (p.model = Yr()), $.version && (p.browser_name = $.name || "", p.browser_major = $.version.major || 0), u.retryInfo.hasData && (p.retry_record = u.retryInfo.mergedBeacon, p.retry_cnt = u.retryInfo.retryCount), d()(p, cr(), mn(this._ctx, n), yn((t = this._ctx.loadRec.currentLoad) == null ? void 0 : t.mediaInfo), En(this._ctx), Tn(this._ctx), bn(this._ctx), gn()), u.coreType === N.mse && this._ctx.mse && (p.mse_buffer_full = this._ctx.mse.stat.mseBufferFull, p.mse_remove = this._ctx.mse.stat.mseRemove, p.key_frame_cnt = n.keyFrame, u.box === g.mp4 && (p.mp4_moov_size = n.mp4MoovSize, n.mp4FastStart !== void 0 && (p.mp4_fast_start = n.mp4FastStart ? 0 : 1))), h.muxA && (p.mux_a = h.muxA), h.muxV && (p.mux_v = h.muxV), h.fillA && (p.fill_a = h.fillA), h.fillV && (p.fill_v = h.fillV), h.droppedA && (p.dropped_a = h.droppedA), h.droppedV && (p.dropped_v = h.droppedV), ze(u.box) && (p.unknown_ts_packet_count = n.unknownTSPacketCount, p.audio_non_monotonous = n.audioNonMonotonous, p.aac_overhead = n.aacOverhead), typeof n.decLibLoadDuration == "number" && (p.dec_lib_load_duration = Math.round(n.decLibLoadDuration), p.dec_lib_hit = n.decLibCacheHit ? 1 : 0), this._ctx.stat.coreType === N.native) {
        var m = this._ctx.stat.retryInfo.getLastMseError();
        m && (p.last_error_code = n.errorCode, p.last_error_message = n.errorMessage, p.error_code = m.code, p.error_message = m.reason);
      }
      return p;
    } }]), l;
  }(Or), se = "kernel", xn = function(r) {
    function l(t, n) {
      var s;
      return (s = r.call(this) || this)._video = void 0, s._ctx = void 0, s._monitor = void 0, s._error = void 0, s._exposedEvt = new D.EventEmitter(), s._logger = void 0, s._destroyed = !1, s._avcore = void 0, s._evt = void 0, s._onManifestParsed = function(u) {
        var h = s._ctx;
        u.levels = h.lctx.levels.map(function(O) {
          return O.getKLevel();
        }), u.currentLevel = h.lctx.currentIdx, u.auto = h.lctx.abr, u.levels = h.lctx.levels.map(function(O) {
          return O.getKLevel();
        });
        var p = h.lctx.audioTracks;
        p && p.length && (u.audioTrack = h.lctx.audioIdx, u.audioTracks = p.map(function(O) {
          return { lang: O.lang, qualityLabel: O.qualityLabel, qualityType: O.qualityType, bitrate: O.bitrate, groupId: O.groupId };
        }));
        var m = h.lctx.subtitleTracks;
        m && m.length && (u.subtitleTrack = h.lctx.subtitleIdx, u.subtitleTracks = m.map(function(O) {
          return { lang: O.lang, name: O.name, groupId: O.groupId };
        })), u.currentLevel = h.lctx.currentIdx, u.auto = h.lctx.abr, u.isLive = h.stat.isLive, h.stat.stereoType !== void 0 && (u.stereoType = h.stat.stereoType);
      }, s._onVideoRandererChange = function(u) {
        s._rendererChanged(u);
      }, s._onLoad = function(u) {
        u.type === G.retry && (s._error = void 0);
      }, s._onRetry = function(u) {
        u.pos = Math.floor(s._video.currentTime), u.ts = Math.floor(performance.now());
      }, s._onError = function(u) {
        if (s._logger.i(se, "on error", u), !u.preventFollowUp) {
          var h = s._ctx;
          if (u.details === J.MANIFEST_PARSING_ERROR)
            try {
              dn.isSrcEmpty(s._ctx.src) && (s._logger.i(se, "src empty", s._ctx.src), u.details = J.SRC_EMPTY), h.src ? typeof h.src == "string" ? u.reason += "src str:" + h.src.slice(0, 1024) : h.src instanceof Blob ? u.reason += "src: blob" : u.reason += "src other:" + JSON.stringify(h.src).slice(0, 1024) : u.reason += "src:" + h.src;
            } catch (m) {
              u.reason += m.message;
            }
          var p = Ct(u.details, u.reason, u.statusCode || 0);
          u.code = p, s._error || (s._error = u), u.fatal && s.stopLoad();
        }
      }, s._onWindowError = function(u) {
        s._logger.i(se, "window error:", u.message);
        try {
          s._logger.i(se, "window error stack:", u.error.stack);
        } catch (h) {
        }
      }, s._video = t, s._ctx = new ct(n || {}, s._video), s._bindEvent(), s._logger = s._ctx.logger, typeof location < "u" && s._logger.i(se, "href: " + location.href), s._logger.i(se, ct.packName + ", " + ct.version + " build: " + ct.buildTime + " cors: " + (t == null ? void 0 : t.crossOrigin) + " autoplay: " + (t == null ? void 0 : t.autoplay), n), s._ctx.cOutput.setVideo(t), s._ctx.config || setTimeout(function() {
        s._emitError(pe(Re.OTHER_ERROR, J.CONFIG_ERROR, "config data error"));
      }, 0), s._monitor = new xs(s._ctx), s._ctx.config.src && (s._avcore = s._initAVCore()), s._evt = new Do(s._logger, s._ctx.evt), s._evt.register(s._monitor), s._evt.register(new Oo(s._ctx, s._exposedEvt)), s._destroyableList.push(s._evt, s._monitor), s._logger.i(se, "config", s._ctx.config), ct.instanceCount++, typeof window < "u" && window.addEventListener("error", s._onWindowError), s;
    }
    y()(l, r), l.isSupport = function(t) {
      if (g.webrtc === (t == null ? void 0 : t.box))
        return Z.isWebRTCSupported();
      if (t != null && t.nativeFirst)
        return Z.isVideoBoxSupported(t == null ? void 0 : t.box);
      var n = Z.isSupported();
      if (n) {
        var s = !0;
        t && (s = !(!t.isLive || t.box !== g.flv));
        var u = !s || St.isStreamingSupported();
        return n && !!u;
      }
      return Z.isVideoBoxSupported(t == null ? void 0 : t.box);
    }, l.videoCodecCapabilities = function(t) {
      return Z.getVideoCodecCompatibilityByCodec(t);
    };
    var a = l.prototype;
    return a.on = function(t, n) {
      this._logger.i(se, "call on " + t), this._exposedEvt.on(t, n);
    }, a.once = function(t, n) {
      this._logger.i(se, "call once " + t), this._exposedEvt.once(t, n);
    }, a.removeAllListeners = function(t) {
      this._logger.i(se, "call removeAllListeners"), this._exposedEvt.removeAllListeners(t);
    }, a.off = function(t, n) {
      this._logger.i(se, "call off " + t), this._exposedEvt.off(t, n);
    }, a.listeners = function(t) {
      return this._exposedEvt.listeners(t);
    }, a.emit = function(t, n) {
      return this._exposedEvt.emit(t, n);
    }, a.listenerCount = function(t) {
      return this._exposedEvt.listenerCount(t);
    }, a.prependListener = function(t, n) {
      this._exposedEvt.prependListener(t, n);
    }, a.prependOnceListener = function(t, n) {
      this._exposedEvt.prependOnceListener(t, n);
    }, a.load = function(t, n) {
      var s, u = this;
      if (this._logger.i(se, "call kernel load", t), this._monitor.data.startTime > 0 && this._logger.i(se, "play summary data:", this._monitor.audienceStat), t && this._ctx.setSrc(t), this._ctx.src) {
        var h, p;
        l.isSupport({ box: this._ctx.stat.box, isLive: this._ctx.stat.isLive, nativeFirst: this._ctx.stat.native }) || setTimeout(function() {
          u._emitError(pe(Re.OTHER_ERROR, J.UNSUPPORTED, "unsupported: " + u._ctx.stat.box + " live: " + u._ctx.stat.isLive + " native: " + u._ctx.stat.native));
        }, 0), typeof (n == null ? void 0 : n.startFromSec) == "number" ? this._ctx.stat.startFromSec = n.startFromSec : t && (this._ctx.stat.startFromSec = -1), this._ctx.stat.multipart && this._ctx.config.resourceBuffer && hi(this._ctx.config.resourceBufferSize), t && ((s = this._avcore) == null ? void 0 : s.type) !== ((p = this._ctx).stat.box === g.webrtc ? N.rtc : p.stat.native ? N.native : N.mse) && ((h = this._avcore) == null || h.destroy(), this._avcore = void 0), this._ctx.fallback.register(oe.NEXT_DESC, new No(this._ctx).setRetryFunc(this._recover.bind(this))), this._ctx.fallback.register(oe.SWAP_264, new Ho(this._ctx).setRetryFunc(this._recover.bind(this))), this._load();
      } else
        this._emitError(pe(Re.OTHER_ERROR, J.SRC_EMPTY, "url empty"));
    }, a.getTimeNow = function() {
      return zt.serverNowMs;
    }, a.setAvailableAbrLevels = function(t) {
      this._logger.i(se, "setAvailableAbrLevels", t), this._ctx.lctx.availableList = t.splice(0), this._avcore && "onAbrLevelsUpdated" in this._avcore && this._avcore.onAbrLevelsUpdated();
    }, a.preload = function(t, n) {
      this._logger.i(se, "call preload");
    }, a.isTimeinBuffered = function(t) {
      return this._ctx.stat.box !== g.webrtc && this._ctx.isTimeinBuffered(t);
    }, a.resume = function() {
      var t;
      this._logger.i(se, "call resume"), (t = this._avcore) == null || t.resume(), this._video.paused && this._video.play();
    }, a.destroy = function() {
      var t;
      this._logger.i(se, "call kernel destroy. play summary data:", this._monitor.audienceStat), this._destroyed && (ct.instanceCount--, this._destroyed = !0), performance.removeEventListener && performance.removeEventListener("resourcetimingbufferfull", Cr), this._ctx.fallback.unregisterAndDestroy(oe.NEXT_DESC), this._ctx.fallback.unregisterAndDestroy(oe.SWAP_264), this._ctx.fallback.unregisterAndDestroy(oe.SWAP_CORE), r.prototype.destroy.call(this), (t = this._avcore) == null || t.destroy(), this.removeAllListeners(), window.removeEventListener("error", this._onWindowError);
    }, a.refresh = function() {
      var t;
      this._logger.i(se, "call kernel refresh"), this._monitor.onRefresh(), this._error = void 0, this._ctx.cOutput.reset(), (t = this._avcore) == null || t.refresh();
    }, a.stopLoad = function() {
      var t;
      this._logger.i(se, "call kernel stopLoad"), (t = this._avcore) == null || t.stopLoad();
    }, a.getStreamTime = function(t) {
      var n = this._ctx.streamTime.getStreamTime(t / 1e3);
      return n ? 1e3 * n : NaN;
    }, a.getAudienceStat = function() {
      return this._monitor.audienceStat;
    }, a.getMediaInfo = function() {
      var t;
      return d()({}, (t = this._ctx.loadRec.currentLoad) == null ? void 0 : t.mediaInfo);
    }, a.experiment = function(t) {
      this._logger.i(se, "experiment", t);
    }, a.liveEnd = function() {
      this._logger.i(se, "call liveEnd"), this._avcore && "liveEnd" in this._avcore && this._avcore.liveEnd();
    }, a.seekToNextFrame = function() {
      this._logger.i(se, "call seekToNextFrame"), this._avcore && "seekToNextFrame" in this._avcore ? this._avcore.seekToNextFrame() : this._unsupportFrameSeek();
    }, a.seekToPrevFrame = function() {
      this._logger.i(se, "call seekToPrevFrame"), this._avcore && "seekToPrevFrame" in this._avcore ? this._avcore.seekToPrevFrame() : this._unsupportFrameSeek();
    }, a.seekByFrameIndex = function(t) {
      if (this._logger.i(se, "call seekByFrameIndex", t), this._avcore && "setCurretVideoFrame" in this._avcore)
        return this._avcore.setCurretVideoFrame(t);
      this._unsupportFrameSeek();
    }, a.bindVPP = function(t) {
      return this._logger.i(se, "bind vpp. config.mainThreadRendering: " + this._ctx.stat.mainThreadRendering), this._ctx.stat.mainThreadRendering !== !1 ? (this._ctx.cOutput.bindVPP(t) && this._rendererChanged(), !0) : (this._logger.w(se, "offscreen causes binding failure. set config.mainThreadRendering=true or bindVpp before play."), !1);
    }, a.unbindVPP = function(t) {
      this._ctx.cOutput.unbindVPP(t) && this._rendererChanged();
    }, a.jumpToLiveTime = function(t) {
      this._logger.i(se, "call jumpToLiveTime", t), this._avcore && "jumpToLiveTime" in this._avcore && this._avcore.jumpToLiveTime(t) && this._monitor.onLiveShift(t);
    }, a._load = function(t) {
      this._error = void 0, this._avcore || (this._avcore = this._initAVCore()), this._avcore && (this._ctx.fallback.hasFallback(oe.SWAP_CORE) || (this._avcore.type === N.mse ? this._ctx.fallback.register(oe.SWAP_CORE, new Wo(this._ctx).setRetryFunc(this._recoverToNative.bind(this))) : this._avcore.type === N.native && this._ctx.fallback.register(oe.SWAP_CORE, new Go(this._ctx).setRetryFunc(this._recoverToMse.bind(this)))), this._avcore.load(t), this._ctx.stat.coreType = this._avcore.type);
    }, a._initAVCore = function() {
      var t = this._ctx, n = function(s) {
        return s.stat.native ? new qo(s) : s.stat.box !== g.webrtc && Y.a ? new Y.a(s) : s.stat.box === g.webrtc && $r ? new $r(s) : void 0;
      }(t);
      if (n)
        return this._logger.i(se, "init av core. type: " + n.type), t.stat.coreType = n.type, n;
    }, a._recoverToNative = function() {
      this._recover(N.native);
    }, a._recoverToMse = function() {
      this._recover(N.mse);
    }, a._recover = function(t) {
      var n, s, u = this, h = this._video.paused;
      this._ctx.live || (this._ctx.stat.startFromSec = this._video.currentTime), (n = this._avcore) == null || n.destroy(), this._avcore = void 0, t !== void 0 && (this._ctx.stat.native = t !== N.mse), this._ctx.stat.demuxerType = void 0, this._load(G.retry), h || (s = this._video.play()) == null || s.catch(function(p) {
        return u._logger.i(se, "recover, call play() fail.", p);
      });
    }, a._rendererChanged = function(t) {
      var n = this._ctx.cOutput;
      t === void 0 && (t = { enabled: !0, type: n.rendererType, canvas: n.rendererType === b.canvas && n.canvas ? n.canvas : void 0 }), this._logger.i(se, "video renderer change", t), t.canvas && this.emit(F.H265_DETECTED, { canvas: t.canvas, message: "", enabled: t.enabled, decoder: L.wasm });
    }, a._unsupportFrameSeek = function() {
      this._emitError(pe(Re.MEDIA_ERROR, J.CANNOT_SEEK_BY_FRAME_INDEX, "unsupported", { fatal: !1 }));
    }, a._emitError = function(t) {
      this._ctx.evt.emit(F.ERROR, t);
    }, a._bindEvent = function() {
      var t = this._ctx.evt;
      t.on(F.ERROR, this._onError), t.on(F.MANIFEST_PARSED, this._onManifestParsed), t.on(F.VIDEO_RENDERER_CHANGE, this._onVideoRandererChange), t.on(F.LOAD, this._onLoad), t.on(F.RETRY, this._onRetry);
    }, v()(l, [{ key: "liveShiftType", get: function() {
      return this._ctx.stat.liveShiftType;
    } }, { key: "liveShift", get: function() {
      return this._ctx.stat.liveShift;
    } }, { key: "currentVideoFrame", get: function() {
      return this._avcore && "getCurrentVideoFrame" in this._avcore ? this._avcore.getCurrentVideoFrame() : 0;
    }, set: function(t) {
      this._logger.i(se, "call set currentVideoFrame", t), this._avcore && "setCurretVideoFrame" in this._avcore && this._avcore.setCurretVideoFrame(t);
    } }, { key: "totalVideoFrames", get: function() {
      return this._avcore && "getTotalVideoFrames" in this._avcore ? this._avcore.getTotalVideoFrames() : 0;
    } }, { key: "audioTrack", get: function() {
      return this._ctx.lctx.audioIdx || 0;
    }, set: function(t) {
      var n;
      this._logger.i(se, "call set audioTrack", t), this._avcore && "setAudioTrack" in this._avcore && ((n = this._avcore) == null || n.setAudioTrack(t));
    } }, { key: "subtitleTrack", get: function() {
      return this._ctx.lctx.subtitleIdx || 0;
    }, set: function(t) {
      var n;
      this._logger.i(se, "call set subtitleTrack", t), this._avcore && "setSubtitleTrack" in this._avcore && ((n = this._avcore) == null || n.setSubtitleTrack(t));
    } }, { key: "currentLevel", get: function() {
      return this._ctx.lctx.currentIdx || 0;
    }, set: function(t) {
      var n;
      this._logger.i(se, "call set currentLevel", t), this._avcore && "setCurrentLevel" in this._avcore && ((n = this._avcore) == null || n.setCurrentLevel(t));
    } }, { key: "nextLevel", get: function() {
      return this._ctx.lctx.nextIdx || 0;
    }, set: function(t) {
      var n;
      this._logger.i(se, "call set nextLevel", t), this._avcore && "setNextLevel" in this._avcore && ((n = this._avcore) == null || n.setNextLevel(t));
    } }, { key: "startLevel", get: function() {
      return this._ctx.lctx.startIdx || 0;
    }, set: function(t) {
      this._logger.i(se, "call set startLevel", t), this._ctx.lctx.startIdx = t;
    } }, { key: "autoLevelEnabled", get: function() {
      return this._ctx.lctx.abr;
    } }, { key: "monitorData", get: function() {
      return this._monitor && this._avcore ? d()(this._monitor.snapshot, { trackBufInfo: this._avcore.getTrackBufInfo() }) : null;
    } }, { key: "currentLevelTimeInfo", get: function() {
      var t = this._ctx.lctx.current;
      if (t && t.timeInfo)
        return t.timeInfo;
    } }, { key: "instanceId", get: function() {
      return this._ctx.id;
    } }], [{ key: "version", get: function() {
      return ct.version;
    } }, { key: "buildTime", get: function() {
      return ct.buildTime;
    } }, { key: "MediaBox", get: function() {
      return g;
    } }, { key: "Events", get: function() {
      return { REPORT: F.REPORT, ERROR: F.ERROR, LEVEL_SWITCHING: F.LEVEL_SWITCHING, LEVEL_SWITCHED: F.LEVEL_SWITCHED, LEVEL_SWITCH_PLAYING: F.LEVEL_SWITCH_PLAYING, LEVEL_SWITCH_FAILED: F.LEVEL_SWITCH_FAILED, AUDIO_TRACK_SWITCHING: F.AUDIO_TRACK_SWITCHING, AUDIO_TRACK_SWITCHED: F.AUDIO_TRACK_SWITCHED, AUDIO_TRACK_UPDATED: F.AUDIO_TRACK_UPDATED, SUBTITLE_TRACK_SWITCHED: F.SUBTITLE_TRACK_SWITCHED, MANIFEST_PARSED: F.MANIFEST_PARSED, LEVEL_UPDATED: F.LEVEL_UPDATED, LOAD_END: F.LOAD_END, VIDEO_RENDERER_CHANGE: F.VIDEO_RENDERER_CHANGE };
    } }, { key: "Reports", get: function() {
      return d()({}, et);
    } }]), l;
  }(W);
  function Is(r, l) {
    return ht() ? void 0 : new xn(r, l);
  }
}]);
Oe === void 0 && console.error("esm-webpack-plugin: nothing exported!");
const xl = Oe.default;
Oe.createKernel;
Oe.CodecType;
Oe.Decoder;
Oe.DemuxerType;
Oe.DownloadStatus;
Oe.HttpRangeType;
const dt = Oe.KEvents;
Oe.LogLevel;
const qt = Oe.LiveShiftType;
Oe.MediaBox;
Oe.ReportTypes;
Oe.StereoType;
Oe.VideoDecBlockPolicy;
Oe.VideoDropFramePolicy;
Oe.VideoRendererType;
Oe.WasmDecoder;
Oe.EventReportTypes;
const xt = {
  "kwai-player": "_kwai-player_uxc1a_2",
  "kwai-player-video-interactive": "_kwai-player-video-interactive_uxc1a_11",
  "kwai-player-poster": "_kwai-player-poster_uxc1a_19",
  "kwai-player-video": "_kwai-player-video_uxc1a_11",
  "kwai-player-disable-scroll": "_kwai-player-disable-scroll_uxc1a_50"
};
var wa = /* @__PURE__ */ ((e) => (e[e.CTOR_ERROR = 1e4] = "CTOR_ERROR", e))(wa || {});
const Il = "https://ntp.nc.gifshow.com/", si = {
  local: 0,
  server: 0
};
function Er() {
  return si.server ? performance.now() - si.local + si.server : Date.now();
}
const Bn = "ntp";
class kl {
  constructor() {
    V(this, "_xhr");
  }
  load() {
    this._disposeLoader();
    const i = this._xhr = new XMLHttpRequest(), o = performance.now();
    i.open("GET", Il, !0), i.responseType = "text", i.timeout = 5e3, i.ontimeout = i.onerror = () => {
      I.i(Bn, "load error");
    }, i.onload = () => {
      if (i.status < 200 || i.status > 299)
        I.i(Bn, `load error: ${i.status}`);
      else {
        this._disposeLoader(), i.responseText;
        {
          si.local = performance.now();
          const c = i.responseText.split(",");
          si.server = parseFloat(c[0]) * 1e3 + (performance.now() - o) / 2;
        }
      }
    }, i.send();
  }
  destroy() {
    this._disposeLoader();
  }
  _disposeLoader() {
    this._xhr && (this._xhr.onreadystatechange = null, this._xhr.onprogress = null, this._xhr.onload = null, this._xhr.onerror = null, this._xhr.abort(), this._xhr = void 0);
  }
}
function Cl(e, i, o) {
  if (typeof o == "number") {
    if (e === qt.KWAI)
      return {
        time: o
      };
    if (e === qt.GENERAL && i) {
      const c = o - (Er() - i.start);
      return {
        time: c,
        urlParams: {
          offset: c.toFixed(0)
        }
      };
    }
  }
}
const Vn = typeof document > "u" ? void 0 : document.createElement("video");
function Dl() {
  return !!(Vn != null && Vn.requestPictureInPicture);
}
function Ol(e) {
  const i = Ge.browser.name;
  i && ["IE", "IEMobile"].indexOf(i) === -1 && console.log(
    `%c kwai-player %c ${e} %c`,
    "background:#35495e ; padding: 1px; border-radius: 4px 0 0 4px;  color: #fff",
    "background:#ffa483 ; padding: 1px; border-radius: 0 4px 4px 0;  color: #fff",
    "background:transparent"
  );
}
const Ml = "fullscreen";
class Nl {
  constructor(i) {
    V(this, "_evt"), V(this, "_element"), V(this, "_isFillWindow", !1), V(this, "_originStyle"), V(this, "_isSupportFullscreen", !0), V(this, "_onFullscreenChange", () => {
      I.i(Ml, "_onFullscreenChange", this.isFull()), this.isFull() || (this._recoverStyle(), document.body.classList.remove(xt["kwai-player-disable-scroll"])), this._isFillWindow = !1, this._evt.emit("fullChange", {
        type: yt.SYSTEM,
        isFull: this.isFull()
      });
    }), this._evt = i, !(typeof document > "u") && (this._isSupportFullscreen = typeof this._getExitFullscreenFunc() < "u" && !(Ge.os.name === "iOS" && Ge.device.type === "mobile"), "onfullscreenchange" in document ? (document.addEventListener("fullscreenchange", this._onFullscreenChange), document.addEventListener("fullscreenerror", this._onFullscreenChange)) : "onwebkitfullscreenchange" in document && (document.addEventListener("webkitfullscreenchange", this._onFullscreenChange), document.addEventListener("webkitfullscreenerror", this._onFullscreenChange)));
  }
  destroy() {
    document.removeEventListener("fullscreenchange", this._onFullscreenChange), document.removeEventListener("fullscreenerror", this._onFullscreenChange), document.removeEventListener("webkitfullscreenchange", this._onFullscreenChange), document.removeEventListener("webkitfullscreenerror", this._onFullscreenChange);
  }
  /**
   * 全屏或网页全屏
   * @param e 需要全屏的元素 
   */
  requestFull(i, o) {
    o === yt.SYSTEM ? this.requestFullscreen(i) : o === yt.WINDOW ? this.requestFillWindow(i) : this._isSupportFullscreen ? this.requestFullscreen(i) : this.requestFillWindow(i);
  }
  /**
   * 退出全屏或网页全屏
   */
  exitFull(i) {
    if (i === yt.SYSTEM)
      return this.exitFullscreen();
    if (i === yt.WINDOW)
      return this.exitFillWindow();
    this.isFull(yt.SYSTEM) ? this.exitFullscreen() : this.exitFillWindow();
  }
  /**
   * 是否是全屏或网页全屏状态
   * @returns 全屏状态
   */
  isFull(i) {
    return i === yt.SYSTEM ? this.isFullScreen() : i === yt.WINDOW ? this.isFillWindow() : this.isFullScreen() || this.isFillWindow();
  }
  /**
   * 全屏
   * @param element 需要全屏的元素
   * @returns 
   */
  requestFullscreen(i) {
    this._element = i, this._originStyle || this._saveOriginStyle(i), (Ge.os.name === "Mac OS" || Ge.browser.name === "IE" || Ge.os.name === "iOS" && Ge.device.type !== "mobile") && (i.style.width = "100%", i.style.height = "100%", i.style.background = "black");
    const o = i;
    let c;
    o.requestFullscreen ? c = o.requestFullscreen() : o.mozRequestFullScreen ? c = o.mozRequestFullScreen() : o.webkitRequestFullScreen ? c = o.webkitRequestFullscreen() : o.msRequestFullscreen && (c = o.msRequestFullscreen()), typeof Promise < "u" && c instanceof Promise && c.catch((d) => I.e(d));
  }
  /**
   * 退出全屏
   */
  exitFullscreen() {
    this._recoverStyle(), this._element = void 0;
    const i = document;
    i.exitFullscreen ? i.exitFullscreen() : i.webkitCancelFullScreen ? i.webkitCancelFullScreen() : i.mozCancelFullScreen ? i.mozCancelFullScreen() : i.msExitFullscreen && i.msExitFullscreen();
  }
  /**
   * 当前是否是全屏状态
   * @returns 全屏状态
   */
  isFullScreen() {
    const i = document;
    return !!(i.fullscreen || i.fullscreenElement || i.isFullScreen || i.webkitIsFullScreen || i.mozFullScreen || i.msFullscreenElement);
  }
  /**
   * 网页全屏
   * @param element 需要全屏的元素
   * @returns 
   */
  requestFillWindow(i) {
    this._element = i, this._originStyle || this._saveOriginStyle(i), i.style.width = "100%", i.style.height = "100%", i.style.background = "black", i.style.position = "fixed", i.style.left = "0", i.style.top = "0", i.style.zIndex = "99999", document.body.classList.add(xt["kwai-player-disable-scroll"]), this._isFillWindow = !0, this._evt.emit("fullChange", {
      type: "window",
      isFull: !0
    });
  }
  /**
   * 退出网页全屏
   */
  exitFillWindow() {
    this._recoverStyle(), this._isFillWindow = !1, this._element && (this._element.style.zIndex = "auto"), this._element = void 0, document.body.classList.remove(xt["kwai-player-disable-scroll"]), this._evt.emit("fullChange", {
      type: "window",
      isFull: !1
    });
  }
  /**
   * 当前是否是网页全屏状态
   * @returns 网页全屏状态
   */
  isFillWindow() {
    return this._isFillWindow;
  }
  isFullscreenAvailable(i) {
    return i !== yt.WINDOW && typeof document < "u" ? !!document.body.requestFullscreen || !!document.body.webkitRequestFullscreen || !!document.body.msRequestFullscreen || !!document.body.mozRequestFullscreen : !0;
  }
  _getExitFullscreenFunc() {
    const i = document;
    return i.exitFullscreen || i.webkitCancelFullScreen || i.mozCancelFullScreen || i.msExitFullscreen;
  }
  _saveOriginStyle(i) {
    this._originStyle = {
      position: i.style.position,
      background: i.style.background,
      width: i.style.width,
      height: i.style.height,
      left: i.style.left,
      right: i.style.right
    };
  }
  _recoverStyle() {
    if (this._element)
      for (const i in this._originStyle)
        this._element.style[i] = this._originStyle[i];
    this._originStyle = void 0;
  }
}
const Pl = "ControlsPlugin", Ul = "I18nPlugin", Fl = "LoggerPlugin", Bl = "HotkeyPlugin", Vl = "PlayInfoPlugin", Hl = "MirrorPlugin", Gl = "RotatePlugin", Wl = "PreviewPlugin", Kl = "MaskPlugin", zl = "VRPlugin", $l = "DanmakuPlugin";
var jl = /* @__PURE__ */ ((e) => (e.DARK = "dark", e.LIGHT = "light", e))(jl || {}), Yl = /* @__PURE__ */ ((e) => (e.BOTTOM = "bottom", e.PLAY_BAR = "playBar", e.NONE = "none", e))(Yl || {});
let Xe = class extends Ki {
  static isInstanceOfPlugin(i) {
    return typeof i.beforeInstall == "function" && typeof i.afterInstall == "function" && typeof i.beforeUninstall == "function" && typeof i.afterUninstall == "function" && typeof i.getLabel == "function";
  }
  /**
   * 播放器实例化前钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  beforeInstall(i, o) {
  }
  /**
   * 播放器实例化后钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  afterInstall(i, o) {
  }
  /**
   * 播放器销毁前钩子
   * @param player 播放器实例
   */
  beforeUninstall(i) {
  }
  /**
   * 播放器销毁后钩子
   * @param player 播放器实例
   */
  afterUninstall(i) {
  }
};
V(Xe, "label"), /**
* 版本
*/
V(Xe, "version"), /**
* 当前环境是否支持
*/
V(Xe, "isSupported");
const La = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return La.label;
  }
  beforeInstall(e, i) {
  }
  afterInstall(e, i) {
  }
};
let ql = La;
V(ql, "label", Pl);
const xa = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return xa.label;
  }
  beforeInstall(e, i) {
  }
  afterInstall(e, i) {
  }
};
let Ql = xa;
V(Ql, "label", Ul);
const Ia = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Ia.label;
  }
  beforeInstall(e, i) {
  }
  afterInstall(e, i) {
  }
  /**
   * 增加业务相关数据
   * @param key 上报数据key
   * @param value 上报数据
   */
  addBizLog(e, i) {
  }
  appendSummaryField(e, i) {
  }
};
let Xl = Ia;
V(Xl, "label", Fl);
const ka = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return ka.label;
  }
};
let Zl = ka;
V(Zl, "label", Bl);
const Ca = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Ca.label;
  }
};
let Jl = Ca;
V(Jl, "label", Vl);
const Da = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Da.label;
  }
};
let ec = Da;
V(ec, "label", Hl);
const Oa = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Oa.label;
  }
};
let tc = Oa;
V(tc, "label", Gl);
const Ma = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Ma.label;
  }
};
let ic = Ma;
V(ic, "label", Wl);
const Na = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Na.label;
  }
};
let rc = Na;
V(rc, "label", Kl);
const Pa = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Pa.label;
  }
};
let nc = Pa;
V(nc, "label", zl);
const Ua = class extends Xe {
  /**
   * @override
   */
  getLabel() {
    return Ua.label;
  }
};
let ac = Ua;
V(ac, "label", $l);
const je = "pluginBase", Fa = class {
  constructor() {
    V(this, "_instances", []);
  }
  static register(e) {
    I.i(je, "register", e.label, e.version), e.label || I.i(je, "register plugin label is empty.");
    const i = this._plugins.findIndex((o) => o.label === e.label);
    i >= 0 && (I.i(je, `register plugin label: ${e.label} exists.`), this._plugins.splice(i, 1)), this._plugins.push(e);
  }
  static deregister(e) {
    I.i(je, "deregister", e.label);
    const i = this._plugins.indexOf(e);
    if (i === -1) {
      I.i(e.label + "plugin unregistered");
      return;
    }
    this._plugins.splice(i, 1);
  }
  initialize(e) {
    const i = this._instances;
    for (const o of Fa._plugins)
      try {
        if (e && e[o.label] === !1)
          continue;
        if (o.isSupported === !1) {
          I.i(je, `initialize ${o.label}, ${o.version}. The current browser does not support this plugin.`);
          continue;
        }
        I.i(je, "initialize", o.label, o.version, e);
        const c = new o();
        Xe.isInstanceOfPlugin(c) ? i.push(c) : I.e(je, `plugin type error: ${c}`);
      } catch (c) {
        I.e(je, "plugin initialize error", c);
      }
  }
  beforeInstallPlugins(e, i) {
    for (const o of this._instances) {
      const c = o.getLabel();
      I.i(je, "beforeInstallPlugins", i, c);
      try {
        if (!o.beforeInstall)
          continue;
        i && typeof i[c] == "object" ? o.beforeInstall(e, i[c]) : o.beforeInstall(e);
      } catch (d) {
        I.e(je, "beforeInstallPlugins error", d);
      }
    }
  }
  afterInstallPlugins(e, i) {
    for (const o of this._instances) {
      const c = o.getLabel();
      I.i(je, "afterInstallPlugins", c, i);
      try {
        if (!o.afterInstall)
          continue;
        i && typeof i[c] == "object" ? o.afterInstall(e, i[c]) : o.afterInstall(e);
      } catch (d) {
        I.e(je, "afterInstallPlugins error", d);
      }
    }
  }
  beforeUninstallPlugins(e) {
    for (const i of this._instances)
      try {
        if (I.i(je, "beforeUninstallPlugins", i.getLabel()), !i.beforeUninstall)
          continue;
        i.beforeUninstall.call(i, e);
      } catch (o) {
        I.e(je, "plugin beforeUninstall error", o);
      }
  }
  afterUninstallPlugins(e) {
    for (const i of this._instances)
      try {
        if (I.i(je, "afterUninstallPlugins", i.getLabel()), !i.afterUninstall)
          continue;
        i.afterUninstall.call(i, e);
      } catch (o) {
        I.e(je, "plugin afterUninstall error", o);
      }
    this._instances = [];
  }
  getPlugin(e) {
    for (let i = 0; i < this._instances.length; i++)
      if (this._instances[i].getLabel() === e)
        return this._instances[i];
  }
};
let Li = Fa;
V(Li, "_plugins", []);
const oc = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAC1JREFUWEft0EERAAAAAUH6lxbDZxU4s815PffjAAECBAgQIECAAAECBAgQIDAaPwAh6O5R/QAAAABJRU5ErkJggg==", z = "native", Yt = class {
  constructor(i, o) {
    V(this, "_pluginBase", new Li()), V(this, "_eventHandlers"), V(this, "_evt"), V(this, "_mainDom"), V(this, "_video"), V(this, "_kernel"), V(this, "_error"), V(this, "_config"), V(this, "_src", ""), V(this, "_autoplay", !1), V(this, "_preload", "none"), V(this, "_poster", ""), V(this, "_controls", "default"), V(this, "_videoWidth", 0), V(this, "_videoHeight", 0), V(this, "_kernelLoaded", !1), V(this, "_livePaused", !1), V(this, "_canvas"), V(this, "_mediaInfo"), V(this, "_isLiveShift", !1), V(this, "_full"), V(this, "_subContainerNumber", 0), V(this, "_data"), V(this, "_id"), V(this, "_videoLayer"), V(this, "_videoInteractiveLayer"), V(this, "_posterLayer"), V(this, "_preprocessSrcFunc"), V(this, "_preprocessURL"), V(this, "_kernelStartTimeout", 0), V(this, "_liveTimeHelper", new kl()), V(this, "_liveOffset", 0), V(this, "requestFullscreen", (_) => {
      I.i(z, "requestFullscreen"), this._mainDom && (this._full.isFull(_) || this._full.requestFull(this._mainDom, _));
    }), V(this, "exitFullscreen", (_) => {
      I.i(z, "exitFullscreen"), this._mainDom && this._full.isFull(_) && this._full.exitFull(_);
    }), V(this, "_onFullscreenchange", (_) => {
      this._updateCanvasSize(_.isFull), this.emit(P.FULLSCREEN_CHANGE, _);
    }), V(this, "_onMutedChange", (_) => {
      this._video && (this._video.muted = _);
    }), V(this, "_onVideoLoadstart", () => {
      this.emit(P.LOADSTART);
    }), V(this, "_onVideoProgress", () => {
      this.emit(P.PROGRESS);
    }), V(this, "_onVideoSuspend", () => {
      this.emit(P.SUSPEND);
    }), V(this, "_onVideoAbort", () => {
      this.emit(P.ABORT);
    }), V(this, "_onVideoEmptied", () => {
      this.emit(P.EMPTIED);
    }), V(this, "_onVideoStalled", () => {
      this.emit(P.STALLED);
    }), V(this, "_onVideoLoadedmetadata", () => {
      this.emit(P.LOADEDMETADATA);
    }), V(this, "_onVideoLoadeddata", () => {
      this.emit(P.LOADEDDATA);
    }), V(this, "_onVideoCanplay", () => {
      this.emit(P.CANPLAY);
    }), V(this, "_onVideoCanplaythrough", () => {
      this.emit(P.CANPLAYTHROUGH);
    }), V(this, "_onVideoPlaying", () => {
      Ge.os.name !== "iOS" && Ge.os.name !== "Android" && this._hidePosterDom(), this.emit(P.PLAYING);
    }), V(this, "_onVideoWaiting", () => {
      this.emit(P.WAITING);
    }), V(this, "_onVideoSeeking", () => {
      this.emit(P.SEEKING);
    }), V(this, "_onVideoSeeked", () => {
      this.emit(P.SEEKED);
    }), V(this, "_onVideoEnded", () => {
      this.emit(P.ENDED);
    }), V(this, "_onVideoDurationchange", () => {
      this.emit(P.DURATIONCHANGE);
    }), V(this, "_onVideoTimeupdate", () => {
      var _, v;
      this._posterLayer.style.display !== "none" && ((_ = this._video) == null ? void 0 : _.readyState) === 4 && !((v = this._video) != null && v.paused) && this._hidePosterDom(), this.emit(P.TIMEUPDATE);
    }), V(this, "_onVideoPlay", () => {
      this.emit(P.PLAY);
    }), V(this, "_onVideoPause", () => {
      this.emit(P.PAUSE);
    }), V(this, "_onVideoRatechange", () => {
      this.emit(P.RATECHANGE);
    }), V(this, "_onVideoResize", () => {
      this.emit(P.RESIZE);
    }), V(this, "_onVideoVolumechange", () => {
      this.emit(P.VOLUMECHANGE);
    }), V(this, "_onVideoEnterpictureinpicture", () => {
      this.emit(P.ENTER_PICTURE_IN_PICTURE);
    }), V(this, "_onVideoLeavepictureinpicture", () => {
      this.emit(P.LEAVE_PICTURE_IN_PICTURE);
    });
    var c;
    if ((I.ENABLE_VERBOSE || I.ENABLE_INFO || I.ENABLE_INFO || I.ENABLE_DEBUG) && Ol(Yt.packVersion), I.i(z, Yt.packVersion, Yt.version, i.toString(), o), this._data = o || {}, typeof i == "string" ? (this._id = i, this._mainDom = document.querySelector(i)) : (this._id = `kp_${Math.random() * 1e3 | 0}`, this._mainDom = i), this._evt = new Ki(), this._evt.setMaxListeners(30), this._full = new Nl(this._evt), this._evt.on("fullChange", this._onFullscreenchange), this._eventHandlers = {
      loadstart: this._onVideoLoadstart,
      progress: this._onVideoProgress,
      suspend: this._onVideoSuspend,
      abort: this._onVideoAbort,
      emptied: this._onVideoEmptied,
      stalled: this._onVideoStalled,
      loadedmetadata: this._onVideoLoadedmetadata,
      loadeddata: this._onVideoLoadeddata,
      canplay: this._onVideoCanplay,
      canplaythrough: this._onVideoCanplaythrough,
      playing: this._onVideoPlaying,
      waiting: this._onVideoWaiting,
      seeking: this._onVideoSeeking,
      seeked: this._onVideoSeeked,
      ended: this._onVideoEnded,
      durationchange: this._onVideoDurationchange,
      timeupdate: this._onVideoTimeupdate,
      play: this._onVideoPlay,
      pause: this._onVideoPause,
      ratechange: this._onVideoRatechange,
      resize: this._onVideoResize,
      volumechange: this._onVideoVolumechange,
      enterpictureinpicture: this._onVideoEnterpictureinpicture,
      leavepictureinpicture: this._onVideoLeavepictureinpicture
    }, o && typeof o.controls < "u" && (this.controls = o.controls), this._videoLayer = document.createElement("div"), this._videoLayer.className = xt["kwai-player-video"], this._posterLayer = document.createElement("div"), this._posterLayer.className = xt["kwai-player-poster"], this._posterLayer.dataset.kpRole = "poster", this._videoLayer.appendChild(this._posterLayer), this._videoInteractiveLayer = document.createElement("div"), this._videoInteractiveLayer.className = xt["kwai-player-video-interactive"], this._video = document.createElement("video"), !this._mainDom) {
      I.i(z, `container not found.${i}`), this._setError({ code: wa.CTOR_ERROR, message: `container not found.${i}` });
      return;
    }
    this._mainDom.className = this._mainDom.className ? `${this._mainDom.className} ${xt["kwai-player"]}` : xt["kwai-player"], this._mainDom.setAttribute("role", "player"), this._mainDom.appendChild(this._videoLayer), this._mainDom.appendChild(this._videoInteractiveLayer), this._video.controls = !1, this._videoLayer.appendChild(this.video), this._bindVideo(), this._pluginBase.initialize(o == null ? void 0 : o.plugins), this._pluginBase.beforeInstallPlugins(this, o == null ? void 0 : o.plugins), o && this._parseData(o);
    const d = ((c = this._config) == null ? void 0 : c.src) || this._src;
    d && this._initKernel("", !1), this._pluginBase.afterInstallPlugins(this, o == null ? void 0 : o.plugins), d && (this._kernelStartTimeout = +setTimeout(() => {
      this._clearKernelStartTimer(), this._kernelStart();
    }, 0)), I.i(z, "constructor completed.");
  }
  static get version() {
    return "1.1.0";
  }
  /**
     * 获取版本号
     */
  get version() {
    return Yt.version;
  }
  /**
     * 获取包版本号
     */
  get packVersion() {
    return Yt.packVersion;
  }
  /**
     * 配置
    */
  get config() {
    return I.i(z, "call get config", this._config), this._config;
  }
  set config(i) {
    I.i(z, "call set config", i), this._config = i, this._initKernel(), this.emit(P.ATTRIBUTE_CHANGE_CONFIG, i);
  }
  /**
     * 获取当前错误
     */
  get error() {
    return I.i(z, "call get error", this._error), this._error;
  }
  /**
     * videoId
     */
  get videoId() {
    var i;
    return (i = this._data) == null ? void 0 : i.videoId;
  }
  set videoId(i) {
    this._data && (this._data.videoId = i, this.emit(P.ATTRIBUTE_CHANGE_VIDEO_ID));
  }
  /**
     * 设置预览图url
     */
  get previewUrl() {
    var i;
    return (i = this._data) == null ? void 0 : i.previewUrl;
  }
  set previewUrl(i) {
    I.i(z, "call set previewUrl", i), this._data && (this._data.previewUrl = i, this.emit(P.ATTRIBUTE_CHANGE_PREVIEW_URL));
  }
  /**
     * 设置弹幕防挡url
     */
  get maskUrl() {
    var i;
    return (i = this._data) == null ? void 0 : i.maskUrl;
  }
  set maskUrl(i) {
    I.i(z, "call set maskUrl", i), this._data && (this._data.maskUrl = i, this.emit(P.ATTRIBUTE_CHANGE_MASK_URL));
  }
  /**
     * 禁用弹幕
     */
  get disableMask() {
    var i;
    return (i = this._data) == null ? void 0 : i.disableMask;
  }
  set disableMask(i) {
    I.i(z, "call set disableMask", i), this._data && (this._data.disableMask = i, this.emit(P.ATTRIBUTE_CHANGE_DISABLE_MASK));
  }
  /**
     * 获取播放地址
     */
  get src() {
    return I.v(z, "call get src", this._src), this._src;
  }
  set src(i) {
    I.i(z, "call set src", i), this._src = this._preprocessSrcFunc ? this._preprocessSrcFunc(i) : i, this.emit(P.ATTRIBUTE_CHANGE_SRC), this._initKernel();
  }
  /**
     * 获取当前是否时移回放
    */
  get isLiveShift() {
    return this._isLiveShift;
  }
  set liveShiftType(i) {
    I.i(z, "call set liveShiftType", i), this._data && (this._data.liveShiftType = i, this.emit(P.LIVE_SHIFT_TYPE_CHANGE));
  }
  /**
     * 直播时移类型
     */
  get liveShiftType() {
    var i;
    return ((i = this._data) == null ? void 0 : i.liveShiftType) || qt.NONE;
  }
  set crossOrigin(i) {
    I.i(z, "call set crossOrigin", i), this._video && (this._video.crossOrigin = i), this.emit(P.ATTRIBUTE_CHANGE_CROSS_ORIGIN);
  }
  /**
     * 跨域配置
     */
  get crossOrigin() {
    var i;
    return I.v(z, "call get crossOrigin", (i = this._video) == null ? void 0 : i.crossOrigin), this._video ? this._video.crossOrigin : null;
  }
  /**
     * 网络状态
     */
  get networkState() {
    var i;
    return I.v(z, "call get networkState", (i = this._video) == null ? void 0 : i.networkState), this._video ? this._video.networkState : 0;
  }
  /**
     * 预加载配置
     */
  get preload() {
    return I.v(z, "call get preload", this._preload), this._preload;
  }
  set preload(i) {
    I.i(z, "call set preload", i), this._preload = i, this._video.preload = i, this.emit(P.ATTRIBUTE_CHANGE_PRELOAD);
  }
  /**
     * 获取预加载配置
     */
  get buffered() {
    var i, o;
    return I.v(z, "call get buffered", (i = this._video) == null ? void 0 : i.buffered), (o = this._video) == null ? void 0 : o.buffered;
  }
  /**
     * 获取video元素readyState
     */
  get readyState() {
    var i;
    return I.v(z, "call get readyState", (i = this._video) == null ? void 0 : i.readyState), this._video ? this._video.readyState : 0;
  }
  /**
     * 获取video元素seeking状态
     */
  get seeking() {
    var i, o;
    return I.v(z, "call get seeking", (i = this._video) == null ? void 0 : i.seeking), !!((o = this._video) != null && o.seeking);
  }
  /**
     * 获取video播放时间
     */
  get currentTime() {
    var i, o, c;
    return I.v(z, "call get currentTime", (i = this._video) == null ? void 0 : i.currentTime), ((o = this._data) == null ? void 0 : o.liveShiftType) === qt.GENERAL && (c = this._data) != null && c.liveTime ? (Er() - this._data.liveTime.start + this._liveOffset) / 1e3 : this._video ? this._video.currentTime : 0;
  }
  set currentTime(i) {
    I.i(z, "call set currentTime", i), this._video && (this._video.currentTime = i), this.emit(P.ATTRIBUTE_CHANGE_CURRENT_TIME);
  }
  /**
     * 获取video时长
     */
  get duration() {
    var i, o, c;
    if (I.v(z, "call get duration", (i = this._video) == null ? void 0 : i.duration), ((o = this._data) == null ? void 0 : o.liveShiftType) === qt.GENERAL && (c = this._data) != null && c.liveTime) {
      const d = Er();
      return ((this._data.liveTime.end || d) - this._data.liveTime.start) / 1e3;
    }
    return this._video ? this._video.duration : NaN;
  }
  /**
     * 获取暂停状态
     */
  get paused() {
    var i;
    return I.v(z, "call get paused", (i = this._video) == null ? void 0 : i.paused), this._video ? this._video.paused : !0;
  }
  /**
     * 获取默认倍速
     */
  get defaultPlaybackRate() {
    var i;
    return I.v(z, "call get defaultPlaybackRate", (i = this._video) == null ? void 0 : i.defaultPlaybackRate), this._video ? this._video.defaultPlaybackRate : 1;
  }
  set defaultPlaybackRate(i) {
    I.i(z, "call set defaultPlaybackRate", i), this._video && (this._video.defaultPlaybackRate = i), this.emit(P.ATTRIBUTE_CHANGE_DEFAULT_PLAYBACK_RATE);
  }
  /**
     * 获取当前倍速
     */
  get playbackRate() {
    return this._video ? this._video.playbackRate : 1;
  }
  set playbackRate(i) {
    I.i(z, "call set playbackRate", i), this._video && (this._video.playbackRate = i), this.emit(P.ATTRIBUTE_CHANGE_PLAYBACK_RATE);
  }
  /**
     * 获取是否播放
     */
  get played() {
    var i;
    return (i = this._video) == null ? void 0 : i.played;
  }
  /**
     * 获取是否可以seek
     */
  get seekable() {
    var i;
    return (i = this._video) == null ? void 0 : i.seekable;
  }
  /**
     * 获取是否播放完成
     */
  get ended() {
    return this._video ? this._video.ended : !1;
  }
  /**
     * 获取是否自动播放
     */
  get autoplay() {
    return this._autoplay;
  }
  set autoplay(i) {
    I.i(z, "call set autoplay", i), this._autoplay = i, this.emit(P.ATTRIBUTE_CHANGE_AUTOPLAY);
  }
  /**
     * 获取是否循环播放
     */
  get loop() {
    return this._video ? this._video.loop : !1;
  }
  set loop(i) {
    I.i(z, "call set loop", i), this._video && (this._video.loop = i), this.emit(P.ATTRIBUTE_CHANGE_LOOP);
  }
  /**
     * 获取是否显示控制条
     */
  get controls() {
    return this._controls;
  }
  set controls(i) {
    I.i(z, "call set controls", i), i !== this._controls && (this._controls = i), this.emit(P.ATTRIBUTE_CHANGE_CONTROLS);
  }
  /**
     * 音量
     */
  get volume() {
    return this._video ? this._video.volume : 1;
  }
  set volume(i) {
    this._video && (this._video.volume = i < 0 ? 0 : i > 1 ? 1 : i, this.emit(P.ATTRIBUTE_CHANGE_VOLUME));
  }
  /**
     * 获取静音状态
    */
  get muted() {
    return this._video ? this._video.muted : !1;
  }
  set muted(i) {
    I.i(z, `call set muted: ${i}, hasVideo: ${!!this._video}`), this._video && (this._video.muted = i, this.emit(P.ATTRIBUTE_CHANGE_MUTED));
  }
  /**
     * 获取默认静音状态
     */
  get defaultMuted() {
    return this._video ? this._video.defaultMuted : !1;
  }
  set defaultMuted(i) {
    I.i(z, "call set defaultMuted", i), this._video && (this._video.defaultMuted = i, this.emit(P.ATTRIBUTE_CHANGE_DEFAULT_MUTED));
  }
  // public set width(val: number | string) {
  //     this._width = val;
  // }
  // public set height(val: number | string) {
  //     this._height = val;
  // }
  /**
     * 获取视频宽
     */
  get videoWidth() {
    var i;
    return this._videoWidth || ((i = this._video) == null ? void 0 : i.videoWidth);
  }
  /**
     * 获取视频高
     */
  get videoHeight() {
    var i;
    return this._videoHeight || ((i = this._video) == null ? void 0 : i.videoHeight);
  }
  /**
     * 获取封面图
     */
  get poster() {
    return this._poster;
  }
  set poster(i) {
    I.i(z, "call set poster", i), this._poster = i, this._updatePosterDom(), this.emit(P.ATTRIBUTE_CHANGE_POSTER);
  }
  /**
     * 获取禁用画中画状态
     */
  get disablePictureInPicture() {
    var i;
    return !!((i = this._video) != null && i.disablePictureInPicture);
  }
  set disablePictureInPicture(i) {
    I.i(z, "call set disablePictureInPicture", i), this._video && (this._video.disablePictureInPicture = i, this.emit(P.ATTRIBUTE_CHANGE_DISABLE_PICTURE_IN_PICTURE));
  }
  /**
     * UI中是否展示下载按钮
     */
  get disableDownload() {
    var i;
    return (i = this._data) == null ? void 0 : i.disableDownload;
  }
  set disableDownload(i) {
    I.i(z, "call set disableDownload", i), this._data && (this._data.disableDownload = i, this.emit(P.ATTRIBUTE_CHANGE_DISABLE_DOWNLOAD));
  }
  /**
     * 获取是否内联（inline）播放
     */
  get playsinline() {
    var i;
    return !!((i = this._video) != null && i.hasAttribute("playsinline"));
  }
  set playsinline(i) {
    I.i(z, "call set playsinline", i), this._video && (this._video.playsInline = i, this._video.WebKitPlaysInline = i, i ? (this._video.setAttribute("playsinline", "playsinline"), this._video.setAttribute("webkit-playsinline", "webkit-playsinline"), this._video.setAttribute("x5-playsinline", "x5-playsinline")) : (this._video.removeAttribute("playsinline"), this._video.removeAttribute("webkit-playsinline"), this._video.removeAttribute("x5-playsinline")), this.emit(P.ATTRIBUTE_CHANGE_PLAYSINLINE));
  }
  /**
     * 获取自适应码率开关状态
     */
  get disableAdaptive() {
    var i;
    return (i = this._data) == null ? void 0 : i.disableAdaptive;
  }
  set disableAdaptive(i) {
    I.i(z, "call set disableAdaptive", i), this._data && (this._data.disableAdaptive = i, this.emit(P.ATTRIBUTE_CHANGE_DISABLE_ADAPTIVE));
  }
  /**
     * 获取当前视频轨id
     */
  get currentLevel() {
    var i;
    return ((i = this._kernel) == null ? void 0 : i.currentLevel) || 0;
  }
  set currentLevel(i) {
    var o, c;
    if (I.i(z, "call set currentLevel", i, !!this._kernel, this._livePaused), this._kernel) {
      const d = this._video.paused;
      this._livePaused ? ((o = this._kernel) == null || o.refresh(), this._kernel.currentLevel = i) : (this._kernel.currentLevel = i, this.emit(P.ATTRIBUTE_CHANGE_CURRENT_LEVEL)), !d && this._video.paused && (I.i(z, "set level. play"), (c = this._video) == null || c.play());
    }
  }
  /**
     * 获取即将切换的视频轨id
     */
  get nextLevel() {
    var i;
    return ((i = this._kernel) == null ? void 0 : i.nextLevel) || 0;
  }
  set nextLevel(i) {
    var o, c;
    if (I.i(z, "call set nextLevel", i), this._kernel) {
      const d = this._video.paused;
      this._livePaused ? ((o = this._kernel) == null || o.refresh(), this._kernel.currentLevel = i) : (this._kernel.nextLevel = i, this.emit(P.ATTRIBUTE_CHANGE_NEXT_LEVEL)), !d && this._video.paused && (I.i(z, "set next level. play"), (c = this._video) == null || c.play());
    }
  }
  /**
     * 获取当前播放帧数
     */
  get currentVideoFrame() {
    var i;
    return ((i = this._kernel) == null ? void 0 : i.currentVideoFrame) || 0;
  }
  set currentVideoFrame(i) {
    this._kernel && (this._kernel.currentVideoFrame = i, this.emit(P.ATTRIBUTE_CHANGE_CURRENT_FRAME));
  }
  /**
     * 获取当前视频总帧数
     */
  get totalVideoFrames() {
    var i;
    return ((i = this._kernel) == null ? void 0 : i.totalVideoFrames) || 0;
  }
  /**
     * 当前清晰度时间信息
     */
  get currentLevelTimeInfo() {
    var i;
    return (i = this._kernel) == null ? void 0 : i.currentLevelTimeInfo;
  }
  /**
     * 返回当前video
     */
  get video() {
    return this._video;
  }
  /**
     * 返回当前canvas，视频渲染在canvas时有值
     */
  get canvas() {
    return this._canvas;
  }
  /**
     * 获取当前音频轨id
     */
  get audioTrack() {
    return this._kernel ? this._kernel.audioTrack : -1;
  }
  set audioTrack(i) {
    I.i(z, "call set audioTrack", i), this._kernel && (this._kernel.audioTrack = i, this.emit(P.ATTRIBUTE_CHANGE_AUDIO_TRACK));
  }
  /**
     * 产品ID，用于上报
     */
  get productName() {
    var i;
    return (i = this._data) == null ? void 0 : i.productName;
  }
  set productName(i) {
    I.i(z, "call set productName", i), this._data && (this._data.productName = i);
  }
  /**
     * 获取当前是否开启连接预热
     */
  get prefetch() {
    var i;
    return (i = this._data) == null ? void 0 : i.prefetch;
  }
  set prefetch(i) {
    I.i(z, "call set prefetch", i), this._data && (this._data.prefetch = i, this.emit(P.ATTRIBUTE_CHANGE_PREFETCH));
  }
  /**
     * 获取是否显示进度条
     * @remarks 依赖控制条插件
     */
  get showProgress() {
    var i;
    return (i = this._data) == null ? void 0 : i.showProgress;
  }
  set showProgress(i) {
    I.i(z, "call set showProgress", i), this._data && (this._data.showProgress = i, this.emit(P.ATTRIBUTE_CHANGE_SHOW_PROGRESS));
  }
  /**
     * 是否显示时间
     * @remarks 依赖控制条插件
     */
  get showTime() {
    var i;
    return (i = this._data) == null ? void 0 : i.showTime;
  }
  set showTime(i) {
    I.i(z, "call set showTime", i), this._data && (this._data.showTime = i, this.emit(P.ATTRIBUTE_CHANGE_SHOW_TIME));
  }
  /**
     * 获取是否启用热键
     * @remarks 依赖热键插件
    */
  get disableHotkey() {
    var i;
    return (i = this._data) == null ? void 0 : i.disableHotkey;
  }
  set disableHotkey(i) {
    I.i(z, "call set disableHotkey", i), this._data && (this._data.disableHotkey = i, this.emit(P.ATTRIBUTE_CHANGE_DISABLE_HOTKEY));
  }
  /**
     * 弹幕是否可用
     */
  get disableDanmaku() {
    var i;
    return (i = this._data) == null ? void 0 : i.disableDanmaku;
  }
  set disableDanmaku(i) {
    I.i(z, "call set disableDanmaku", i), this._data && (this._data.disableDanmaku = i, this.emit(P.ATTRIBUTE_CHANGE_DISABLE_DANMAKU));
  }
  /**
     * 是否渲染弹幕
     */
  get danmakuRendering() {
    var i;
    return (i = this._data) == null ? void 0 : i.danmakuRendering;
  }
  set danmakuRendering(i) {
    I.i(z, "call set danmakuRendering", i), this._data && (this._data.danmakuRendering = i, this.emit(P.ATTRIBUTE_CHANGE_DANMAKU_RENDERING));
  }
  /**
     * 设置是否显示信息面板
     * @remarks 依赖信息面板插件
     */
  get showInfoPanel() {
    var i;
    return (i = this._data) == null ? void 0 : i.showInfoPanel;
  }
  set showInfoPanel(i) {
    I.i(z, "call set showInfoPanel", i), this._data && (this._data.showInfoPanel = i, this.emit(P.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL));
  }
  /**
     * 是否显示下一个按钮，与UI相关
     */
  get showNext() {
    var i;
    return (i = this._data) == null ? void 0 : i.showNext;
  }
  set showNext(i) {
    I.i(z, "call set showNext", i), this._data && (this._data.showNext = i, this.emit(P.ATTRIBUTE_CHANGE_SHOW_NEXT));
  }
  /**
     * 是否显示上一个按钮，与UI相关
     */
  get showPrev() {
    var i;
    return (i = this._data) == null ? void 0 : i.showPrev;
  }
  set showPrev(i) {
    I.i(z, "call set showPrev", i), this._data && (this._data.showPrev = i, this.emit(P.ATTRIBUTE_CHANGE_SHOW_PREV));
  }
  /**
     * 业务参数
     */
  get bizData() {
    var i;
    return (i = this._data) == null ? void 0 : i.bizData;
  }
  set bizData(i) {
    I.i(z, "set biz data", i), this._data && (this._data.bizData = i), this.emit(P.ATTRIBUTE_CHANGE_BIZ_DATA);
  }
  /**
     * 当前场次直播时间信息，配合直播时移功能
     */
  get liveTime() {
    var i;
    return (i = this._data) != null && i.liveTime ? { start: this._data.liveTime.start, end: this._data.liveTime.end } : void 0;
  }
  set liveTime(i) {
    I.i(z, "set live time", i), this._data && (this._data.liveTime = Object.assign({}, i)), this.emit(P.ATTRIBUTE_CHANGE_LIVE_TIME);
  }
  /**
     * 返回当前的内核实例
     */
  get kernel() {
    return this._kernel;
  }
  setPreprocessURL(i) {
    this._preprocessURL = i;
  }
  setPreprocessSrcFunc(i) {
    this._preprocessSrcFunc = i;
  }
  /**
     * 加载视频
     */
  load() {
    var i;
    I.i(z, "call load"), (i = this._kernel) == null || i.load(), this._kernelLoaded = !0;
  }
  /**
     * 播放视频
     */
  play() {
    var i, o;
    return I.i(z, "call play", this._kernelLoaded, this._livePaused), this._livePaused && !this._isLiveShiftMode() ? (i = this._kernel) == null || i.refresh() : this._kernelLoaded || this.load(), this._video.paused ? (o = this._video) == null ? void 0 : o.play() : Promise.resolve();
  }
  /**
     * 暂停视频
     */
  pause() {
    var i, o, c;
    return I.i(z, "call pause", (i = this._mediaInfo) == null ? void 0 : i.isLive), this._kernel && (o = this._mediaInfo) != null && o.isLive && !this._isLiveShiftMode() && (I.i(z, "live stop load"), this._kernel.stopLoad(), this._livePaused = !0), this._isLiveShiftMode() && !this._isLiveShift && this._updateIsLiveShift(!0), (c = this._video) == null ? void 0 : c.pause();
  }
  /**
     * 开启画中画
     */
  requestPictureInPicture() {
    return I.i(z, "call requestPictureInPicture"), this._video && "requestPictureInPicture" in this._video ? this._video.requestPictureInPicture() : Promise.reject("not support requestPictureInPicture");
  }
  isPictureInPictureAvailable() {
    return Dl();
  }
  /**
     * 销毁播放器
     */
  destroy() {
    var i, o;
    I.i(z, "call destroy"), this._liveTimeHelper.destroy(), this._clearKernelStartTimer(), this._preprocessSrcFunc = void 0, this._pluginBase.beforeUninstallPlugins(this), this._evt.removeAllListeners(), this._destroyKernel(), this._unbindVideo(), (i = this._videoLayer.parentElement) == null || i.removeChild(this._videoLayer), (o = this._videoLayer.parentElement) == null || o.removeChild(this._videoInteractiveLayer), this.removeAllListeners(), this._pluginBase.afterUninstallPlugins(this);
  }
  /**
     * 重新加载视频
     */
  refresh() {
    var i;
    I.i(z, "call refresh"), (i = this._kernel) == null || i.refresh();
  }
  /**
     * 支持时移时回到直播状态
     */
  jumpToLiveTime(i) {
    var o, c, d;
    if (I.i(z, `call jumpToLiveTime: ${i} type: ${(o = this._data) == null ? void 0 : o.liveShiftType}`), (c = this._data) != null && c.liveShiftType && this._isLiveShiftMode()) {
      const _ = typeof i == "number" ? Cl(this._data.liveShiftType, this._data.liveTime, i) : void 0;
      this._liveOffset = (_ == null ? void 0 : _.time) || 0, (d = this._kernel) == null || d.jumpToLiveTime(_), this._updateIsLiveShift(!!_);
    }
  }
  /**
     * 获取流时间
     * @param val 播放时间，ms
     * @returns 播放时间对应的流时间，ms
     */
  getStreamTime(i) {
    var o;
    return ((o = this._kernel) == null ? void 0 : o.getStreamTime(i)) || 0;
  }
  /**
     * 注册播放器插件
     * @param plugin plugin需继承自PluginModule
     */
  static register(i) {
    Li.register(i);
  }
  /**
     * 注销播放器插件
     * @param plugin plugin需继承自PluginModule
     */
  static deregister(i) {
    Li.deregister(i);
  }
  /**
     * 根据插件名获取插件实例
     * @param label 插件名
     * @returns plugin
     */
  getPluginInstance(i) {
    return this._pluginBase.getPlugin(i);
  }
  /**
     * 创建一个子容器
     * @returns HTMLDivELement
     */
  createSubContainer(i = wi.DEFAULT) {
    const o = document.createElement("div");
    o.id = `${this._id}-sub-${Math.round(this._subContainerNumber++)}`;
    let c = this._mainDom;
    if (i === wi.VIDEO && (c = this._videoLayer), i === wi.VIDEO_INTERACTIVE && (c = this._videoInteractiveLayer), c)
      c.children.length ? c.children[c.children.length - 1].insertAdjacentElement("afterend", o) : c.appendChild(o);
    else
      throw new Error("cteate sub container error. no parent found.");
    return o;
  }
  /**
     * 是否全屏
     * @returns boolean
     */
  isFullscreen(i) {
    return this._full.isFull(i);
  }
  isFullscreenAvailable(i) {
    return this._full.isFullscreenAvailable(i);
  }
  removeSubContainer(i) {
    i.parentElement && i.parentElement.removeChild(i);
  }
  /**
   * 当前画面截图
   * @returns 截图
   */
  screenshot() {
    if (this.videoWidth && this.videoHeight) {
      const i = document.createElement("canvas");
      i.width = this.videoWidth, i.height = this.videoHeight;
      const o = i.getContext("2d");
      if (this.canvas) {
        const c = this.canvas.width / this.canvas.height, d = this.videoWidth / this.videoHeight;
        let _ = 0, v = 0;
        c > d ? _ = (this.canvas.width - this.videoWidth * this.canvas.height / this.videoHeight) / 2 : v = (this.canvas.height - this.videoHeight * this.canvas.width / this.videoWidth) / 2, o == null || o.drawImage(this.canvas, _, v, this.canvas.width - _ * 2, this.canvas.height - v * 2, 0, 0, this.videoWidth, this.videoHeight);
      } else
        o == null || o.drawImage(this.video, 0, 0, this.videoWidth, this.videoHeight);
      return i;
    }
  }
  /**
     * 获取主容器
     * @returns
     */
  get mainContainer() {
    return this._mainDom;
  }
  get videoLayer() {
    return this._videoLayer;
  }
  get videoInteractiveLayer() {
    return this._videoInteractiveLayer;
  }
  /**
     * 获取当前QOS信息
     * @returns
     */
  get audienceStat() {
    var i;
    return (i = this._kernel) == null ? void 0 : i.getAudienceStat();
  }
  _updatePosterDom() {
    Wt ? (this._video.poster = this._poster || "", this._hidePosterDom()) : this._poster ? (this._video.poster = oc, this._posterLayer.className = xt["kwai-player-poster"], this._posterLayer.style.backgroundImage = `url(${this._poster})`) : (this._video.poster = "", this._posterLayer.className = "", this._posterLayer.style.backgroundImage = "");
  }
  _hidePosterDom() {
    this._posterLayer.style.display = "none";
  }
  _setIsUseCanvas(i) {
    this._video && (this._video.style.display = i ? "none" : "block");
  }
  _setError(i) {
    this._error = i, this._error && setTimeout(() => {
      try {
        this.emit(P.ERROR, this._error);
      } catch (o) {
      }
    }, 0);
  }
  _resetPlayerStat() {
    if (this._canvas) {
      try {
        this._videoLayer.removeChild(this._canvas);
      } catch (i) {
      }
      this._canvas = void 0;
    }
    this._setError(void 0), this._setIsUseCanvas(!1), this._mediaInfo = void 0, this._isLiveShift = !1, this._liveOffset = 0;
  }
  _destroyKernel() {
    this._kernel && (this._kernelLoaded = !1, this._livePaused = !1, this.pause(), this._kernel.destroy(), this._kernel = void 0);
  }
  _bindVideo() {
    if (this._video)
      for (const i in this._eventHandlers)
        this._video.addEventListener(i, this._eventHandlers[i]);
  }
  _unbindVideo() {
    if (this._video)
      for (const i in this._eventHandlers)
        this._video.removeEventListener(i, this._eventHandlers[i]);
  }
  _parseData(i) {
    I.i(z, "parse data.", i), i.src && (this._src = this._preprocessSrcFunc ? this._preprocessSrcFunc(i.src) : i.src), i.config && (this._config = i.config), i.crossOrigin && (this.crossOrigin = i.crossOrigin), typeof i.preload < "u" && (this.preload = i.preload), typeof i.defaultPlaybackRate == "number" && (this.defaultPlaybackRate = i.defaultPlaybackRate), typeof i.playbackRate == "number" && (this.playbackRate = i.playbackRate), typeof i.autoplay < "u" && (this.autoplay = i.autoplay), typeof i.loop < "u" && (this.loop = i.loop), typeof i.controls < "u" && (this.controls = i.controls), typeof i.volume == "number" && (this.volume = i.volume), typeof i.muted < "u" && (this.muted = i.muted), typeof i.defaultMuted < "u" && (this.defaultMuted = i.defaultMuted), typeof i.disablePictureInPicture < "u" && (this.disablePictureInPicture = i.disablePictureInPicture), typeof i.disableAdaptive < "u" && (this.disableAdaptive = i.disableAdaptive), typeof i.playsinline < "u" && (this.playsinline = i.playsinline), typeof i.liveShiftType < "u" && (this.liveShiftType = i.liveShiftType), this.poster = i.poster || "";
  }
  _initKernel(i, o = !0) {
    var c, d, _;
    if (!this._video)
      return;
    if (this._posterLayer.style.display = Wt ? "none" : "block", this._destroyKernel(), !this._src && !((c = this._config) != null && c.src) && !i) {
      this._video.src = "", this._resetPlayerStat();
      return;
    }
    this._config || (this._config = {});
    const v = Object.assign({}, this._config, {
      adaptive: ((d = this._data) == null ? void 0 : d.disableAdaptive) === !1,
      liveShiftType: (_ = this._data) == null ? void 0 : _.liveShiftType,
      ntp: !1
    });
    i ? v.src = i : this._src && (v.src = this._src), this._preprocessURL && (v.preprocessUrl = this._preprocessURL), typeof v.nativeFirst > "u" && Wt && (v.nativeFirst = !0), this._isLiveShiftMode() && (v.catchUpPausedLive = !1), this._resetPlayerStat(), I.i(z, "init kernel");
    const f = this._kernel = new xl(this._video, v);
    f.on(dt.VIDEO_RENDERER_CHANGE, (y) => {
      const D = this._videoLayer;
      if (y.type === "canvas" && (this._setIsUseCanvas(!0), this._canvas = y.canvas, D.insertAdjacentElement("afterbegin", y.canvas), this._updateCanvasSize()), y.type === "video") {
        this._setIsUseCanvas(!1);
        try {
          this._canvas && D.removeChild(this._canvas);
        } catch (A) {
        }
        this._canvas = void 0;
      }
      this.emit(P.VIDEO_RENDERER_CHANGE, y);
    }), f.on(dt.MANIFEST_PARSED, (y) => {
      I.i(z, dt.MANIFEST_PARSED, y), this.emit(P.MANIFEST_PARSED, y);
    }), f.on(dt.LEVEL_SWITCHING, (y) => {
      this.emit(P.LEVEL_SWITCHING, y);
    }), f.on(dt.LEVEL_SWITCHED, (y) => {
      this.emit(P.LEVEL_SWITCHED, y);
    }), f.on(dt.LEVEL_SWITCH_PLAYING, (y) => {
      this.emit(P.LEVEL_SWITCH_PLAYING, y);
    }), f.on(dt.LEVEL_SWITCH_FAILED, () => {
      this.emit(P.LEVEL_SWITCH_FAILED);
    }), f.on(dt.LEVEL_UPDATED, (y) => {
      this.emit(P.LEVEL_UPDATED, y);
    }), f.on(dt.AUDIO_TRACK_SWITCHING, (y) => {
      this.emit(P.AUDIO_TRACKS_SWITCHING, y);
    }), f.on(dt.AUDIO_TRACK_SWITCHED, (y) => {
      this.emit(P.AUDIO_TRACKS_SWITCHED, y);
    }), f.on(dt.ERROR, (y) => {
      this._setError({ code: y.code, message: y.reason });
    }), f.on(dt.REPORT, (y) => {
      y.type === "mediaInfo" && (this._videoWidth = y.value.width || 0, this._videoHeight = y.value.height || 0, this._mediaInfo = y.value, this._updateCanvasSize(), this._data && (y.value.liveShiftType && (this.liveShiftType = y.value.liveShiftType), this._isLiveShiftMode() && this._liveTimeHelper.load())), this.emit(P.REPORT, y);
    }), o && (this._clearKernelStartTimer(), this._kernelStart());
  }
  _clearKernelStartTimer() {
    this._kernelStartTimeout && (clearTimeout(this._kernelStartTimeout), this._kernelStartTimeout = 0);
  }
  _kernelStart() {
    if (!(!this._kernel || !this._video) && (this._autoplay || this._preload === "" || this._preload === "auto" || this._preload === "metadata") && (this._kernel.load(), this._kernelLoaded = !0, this.autoplay)) {
      const i = this._video.play();
      i instanceof Promise && i.catch(() => {
        var o;
        I.i(z, "autoplay fail, retry."), this._onMutedChange(!0), (o = this._video) == null || o.play().catch(() => {
        });
      });
    }
  }
  _updateCanvasSize(i) {
    I.i(z, "updateCanvas", i || this._full.isFull(), this._videoWidth, this._videoHeight), typeof i > "u" && (i = this._full.isFull()), this._canvas && this._videoWidth && this._videoHeight && (this._canvas.style.width = i ? "100%" : `${this._videoWidth}px`, this._canvas.style.height = i ? "100%" : `${this._videoHeight}px`);
  }
  _updateIsLiveShift(i) {
    this._isLiveShift = i, this.emit(P.LIVE_SHIFT_CHANGE);
  }
  _isLiveShiftMode() {
    var i;
    return !!((i = this._data) != null && i.liveShiftType) && this._data.liveShiftType !== qt.NONE;
  }
  on(i, o) {
    this._evt.on(i, o);
  }
  once(i, o) {
    this._evt.once(i, o);
  }
  removeAllListeners(i) {
    I.i(z, "call removeAllListeners"), this._evt.removeAllListeners(i);
  }
  off(i, o) {
    this._evt.off(i, o);
  }
  listeners(i) {
    return this._evt.listeners(i);
  }
  emit(i, o) {
    return this._evt.emit(i, o);
  }
  listenerCount(i) {
    return this._evt.listenerCount(i);
  }
};
let Jt = Yt;
V(Jt, "packVersion", "1.1.0");
(function() {
  try {
    if (typeof document != "undefined") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("")), document.head.appendChild(e);
    }
  } catch (i) {
    console.error("vite-plugin-css-injected-by-js", i);
  }
})();
const ue = "vue2", sc = [
  P.LOADSTART,
  P.PROGRESS,
  P.SUSPEND,
  P.ABORT,
  P.ERROR,
  P.EMPTIED,
  P.STALLED,
  P.LOADEDMETADATA,
  P.LOADEDDATA,
  P.CANPLAY,
  P.CANPLAYTHROUGH,
  P.PLAYING,
  P.WAITING,
  P.SEEKING,
  P.SEEKED,
  P.ENDED,
  P.DURATIONCHANGE,
  P.TIMEUPDATE,
  P.PLAY,
  P.PAUSE,
  P.RATECHANGE,
  P.RESIZE,
  P.VOLUMECHANGE,
  P.MANIFEST_PARSED,
  P.LEVEL_SWITCHING,
  P.LEVEL_SWITCHED,
  P.LEVEL_SWITCH_PLAYING,
  P.LEVEL_SWITCH_FAILED,
  P.AUDIO_TRACKS_SWITCHING,
  P.AUDIO_TRACKS_SWITCHED,
  P.FULLSCREEN_CHANGE,
  P.LEVEL_UPDATED,
  P.CLICK_NEXT,
  P.CLICK_PREV,
  P.CLICK_REGISTER,
  P.CLICK_LOGIN,
  P.CLICK_VIP,
  P.REPORT
], lc = {
  name: "KwaiPlayerVue2",
  props: {
    id: {
      type: String,
      default: ""
    },
    config: {
      type: Object,
      default() {
        return {};
      }
    },
    plugins: {
      type: Object,
      default() {
        return {};
      }
    },
    src: {
      type: [Object, String],
      default: ""
    },
    controls: {
      type: [Boolean, String],
      default: !0
    },
    videoId: {
      type: [String],
      default: ""
    },
    autoplay: {
      type: [Boolean],
      default: !1
    },
    crossOrigin: {
      type: [String, null],
      default: null
    },
    defaultMuted: {
      type: [Boolean],
      default: !1
    },
    defaultPlaybackRate: {
      type: [Number],
      default: 1
    },
    loop: {
      type: [Boolean],
      default: !1
    },
    muted: {
      type: [Boolean],
      default: !1
    },
    preload: {
      type: [String, void 0],
      default: void 0
    },
    poster: {
      type: [String],
      default: ""
    },
    currentTime: {
      type: [Number]
    },
    playbackRate: {
      type: [Number],
      default: 1
    },
    volume: {
      type: [Number],
      default: 1
    },
    disablePictureInPicture: {
      type: [Boolean],
      default: !1
    },
    playsinline: {
      type: [Boolean],
      default: !1
    },
    disableDownload: {
      type: [Boolean],
      default: !0
    },
    disableAdaptive: {
      type: [Boolean],
      default: !0
    },
    disableHotkey: {
      type: [Boolean],
      default: !1
    },
    disableMask: {
      type: [Boolean],
      default: !1
    },
    currentLevel: {
      type: [Number],
      default: 0
    },
    nextLevel: {
      type: [Number],
      default: 0
    },
    audioTrack: {
      type: [Number],
      default: 0
    },
    currentVideoFrame: {
      type: [Number],
      default: 0
    },
    showProgress: {
      type: [Boolean],
      default: void 0
    },
    showTime: {
      type: [Boolean],
      default: void 0
    },
    prefetch: {
      type: [Boolean],
      default: !0
    },
    showInfoPanel: {
      type: [Boolean],
      default: !1
    },
    productName: {
      type: [String],
      default: ""
    },
    previewUrl: {
      type: [String],
      default: ""
    },
    maskUrl: {
      type: [String],
      default: ""
    },
    disableDanmaku: {
      type: [Boolean]
    },
    danmakuRendering: {
      type: [Boolean],
      default: !0
    },
    bizData: {
      type: [Object]
    },
    liveShiftType: {
      type: [String]
    }
  },
  data() {
    return {
      player: void 0,
      cid: 0
    };
  },
  watch: {
    config: function(e) {
      I.i(ue, "call set config", e), this.player && (this.player.config = e);
    },
    controls: function(e) {
      I.i(ue, "call set controls", e), this.player && (this.player.controls = e);
    },
    videoId: function(e) {
      I.i(ue, "call set videoId", e), this.player && (this.player.videoId = e);
    },
    src: function(e) {
      I.i(ue, "call set src", e), this.player && (this.player.src = e);
    },
    autoplay: function(e) {
      I.i(ue, "call set autoplay", e), this.player && (this.player.autoplay = e);
    },
    crossOrigin: function(e) {
      I.i(ue, "call set crossOrigin", e), this.player && (this.player.crossOrigin = e);
    },
    defaultMuted: function(e) {
      I.i(ue, "call set defaultMuted", e), this.player && (this.player.defaultMuted = e);
    },
    defaultPlaybackRate: function(e) {
      I.i(ue, "call set defaultPlaybackRate", e), this.player && (this.player.defaultPlaybackRate = e);
    },
    loop: function(e) {
      I.i(ue, "call set loop", e), this.player && (this.player.loop = e);
    },
    muted: function(e) {
      I.i(ue, "call set muted", e), this.player && (this.player.muted = e);
    },
    preload: function(e) {
      I.i(ue, "call set preload", e), this.player && (this.player.preload = e);
    },
    poster: function(e) {
      I.i(ue, "call set poster", e), this.player && (this.player.poster = e);
    },
    currentTime: function(e) {
      I.i(ue, "call set currentTime", e), this.player && (this.player.currentTime = e);
    },
    playbackRate: function(e) {
      I.i(ue, "call set playbackRate", e), this.player && (this.player.playbackRate = e);
    },
    volume: function(e) {
      I.i(ue, "call set volume", e), this.player && (this.player.volume = e);
    },
    disablePictureInPicture: function(e) {
      I.i(ue, "call set disablePictureInPicture", e), this.player && (this.player.disablePictureInPicture = e);
    },
    playsinline: function(e) {
      I.i(ue, "call set playsinline", e), this.player && (this.player.playsinline = e);
    },
    disableDownload: function(e) {
      I.i(ue, "call set disableDownload", e), this.player && (this.player.disableDownload = e);
    },
    disableAdaptive: function(e) {
      I.i(ue, "call set disableAdaptive", e), this.player && (this.player.disableAdaptive = e);
    },
    disableHotkey: function(e) {
      I.i(ue, "call set disableHotkey", e), this.player && (this.player.disableHotkey = e);
    },
    disableMask: function(e) {
      I.i(ue, "call set disableMask", e), this.player && (this.player.disableMask = e);
    },
    currentLevel: function(e) {
      I.i(ue, "call set currentLevel", e), this.player && (this.player.currentLevel = e);
    },
    nextLevel: function(e) {
      I.i(ue, "call set nextLevel", e), this.player && (this.player.nextLevel = e);
    },
    audioTrack: function(e) {
      I.i(ue, "call set audioTrack", e), this.player && (this.player.audioTrack = e);
    },
    currentVideoFrame: function(e) {
      I.i(ue, "call set currentVideoFrame", e), this.player && (this.player.currentVideoFrame = e);
    },
    showProgress: function(e) {
      I.i(ue, "call set showProgress", e), this.player && (this.player.showProgress = e);
    },
    showTime: function(e) {
      I.i(ue, "call set showTime", e), this.player && (this.player.showTime = e);
    },
    prefetch: function(e) {
      I.i(ue, "call set prefetch", e), this.player && (this.player.prefetch = e);
    },
    showInfoPanel: function(e) {
      I.i(ue, "call set showInfoPanel", e), this.player && (this.player.showInfoPanel = e);
    },
    previewUrl: function(e) {
      I.i(ue, "call set previewUrl", e), this.player && (this.player.previewUrl = e);
    },
    maskUrl: function(e) {
      I.i(ue, "call set maskUrl", e), this.player && (this.player.maskUrl = e);
    },
    disableDanmaku: function(e) {
      I.i(ue, "call set disableDanmaku", e), this.player && (this.player.disableDanmaku = e);
    },
    danmakuRendering: function(e) {
      I.i(ue, "call set danmakuRendering", e), this.player && (this.player.danmakuRendering = e);
    },
    bizData: function(e) {
      this.player && (this.player.bizData = e);
    },
    liveShiftType: function(e) {
      this.player && (this.player.liveShiftType = e);
    }
  },
  methods: {
    load() {
      var e;
      (e = this.player) == null || e.load();
    },
    play() {
      var e;
      return (e = this.player) == null ? void 0 : e.play();
    },
    pause() {
      var e;
      (e = this.player) == null || e.pause();
    },
    destroy() {
      var e;
      (e = this.player) == null || e.destroy();
    },
    requestPictureInPicture() {
      var e;
      return (e = this.player) == null ? void 0 : e.requestPictureInPicture();
    },
    isFullscreen(e) {
      var i;
      return (i = this.player) == null ? void 0 : i.isFullscreen(e);
    },
    requestFullscreen(e) {
      var i;
      (i = this.player) == null || i.requestFullscreen(e);
    },
    exitFullscreen(e) {
      var i;
      (i = this.player) == null || i.exitFullscreen(e);
    },
    isFullscreenAvailable(e) {
      var i;
      return (i = this.player) == null ? void 0 : i.isFullscreenAvailable(e);
    },
    screenshot() {
      var e;
      return (e = this.player) == null ? void 0 : e.screenshot();
    },
    // readonly
    getError() {
      var e;
      return (e = this.player) == null ? void 0 : e.error;
    },
    getNetworkState() {
      var e;
      return ((e = this.player) == null ? void 0 : e.networkState) || 0;
    },
    getBuffered() {
      var e;
      return (e = this.player) == null ? void 0 : e.buffered;
    },
    getReadyState() {
      var e;
      return ((e = this.player) == null ? void 0 : e.readyState) || 0;
    },
    getSeeking() {
      var e;
      return ((e = this.player) == null ? void 0 : e.seeking) || !1;
    },
    getDuration() {
      var e;
      return ((e = this.player) == null ? void 0 : e.duration) || 0;
    },
    getPaused() {
      var e;
      return ((e = this.player) == null ? void 0 : e.paused) || !1;
    },
    getSeekable() {
      var e;
      return (e = this.player) == null ? void 0 : e.seekable;
    },
    getEnded() {
      var e;
      return ((e = this.player) == null ? void 0 : e.ended) || !1;
    },
    getVideoWidth() {
      var e;
      return (e = this.player) == null ? void 0 : e.videoWidth;
    },
    getVideoHeight() {
      var e;
      return (e = this.player) == null ? void 0 : e.videoHeight;
    },
    getTotalVideoFrames() {
      var e;
      return ((e = this.player) == null ? void 0 : e.totalVideoFrames) || 0;
    },
    //
    setSrc(e) {
      this.player && (this.player.src = e);
    },
    getSrc() {
      var e;
      return (e = this.player) == null ? void 0 : e.src;
    },
    setConfig(e) {
      this.player && (this.player.config = e);
    },
    getConfig() {
      var e;
      return (e = this.player) == null ? void 0 : e.config;
    },
    setCrossOrigin(e) {
      this.player && (this.player.crossOrigin = e);
    },
    getCrossOrigin() {
      var e;
      return ((e = this.player) == null ? void 0 : e.crossOrigin) || null;
    },
    setPreload(e) {
      this.player && (this.preload = e);
    },
    getPreload() {
      var e;
      return ((e = this.player) == null ? void 0 : e.preload) || "";
    },
    setCurrentTime(e) {
      this.player && (this.player.currentTime = e);
    },
    getCurrentTime() {
      var e;
      return ((e = this.player) == null ? void 0 : e.currentTime) || 0;
    },
    setDefaultPlaybackRate(e) {
      this.player && (this.player.defaultPlaybackRate = e);
    },
    getDefaultPlaybackRate() {
      var e;
      return (e = this.player) == null ? void 0 : e.defaultPlaybackRate;
    },
    setPlaybackRate(e) {
      this.player && (this.player.playbackRate = e);
    },
    getPlaybackRate() {
      var e;
      return ((e = this.player) == null ? void 0 : e.playbackRate) || 1;
    },
    setAutoplay(e) {
      this.player && (this.player.autoplay = e);
    },
    getAutoplay() {
      var e;
      return ((e = this.player) == null ? void 0 : e.autoplay) || !1;
    },
    setLoop(e) {
      this.player && (this.player.loop = e);
    },
    getLoop() {
      var e;
      return ((e = this.player) == null ? void 0 : e.loop) || !1;
    },
    setControls(e) {
      this.player && (this.player.controls = e);
    },
    getControls() {
      var e;
      return ((e = this.player) == null ? void 0 : e.controls) || !1;
    },
    setVideoId(e) {
      this.player && (this.player.videoId = e);
    },
    getVideoId() {
      var e;
      return ((e = this.player) == null ? void 0 : e.videoId) || !1;
    },
    setVolume(e) {
      this.player && (this.player.volume = e);
    },
    getVolume() {
      var e;
      return ((e = this.player) == null ? void 0 : e.volume) || 0;
    },
    setMuted(e) {
      this.player && (this.player.muted = e);
    },
    getMuted() {
      var e;
      return ((e = this.player) == null ? void 0 : e.muted) || !1;
    },
    setDefaultMuted(e) {
      player && (this.player.defaultMuted = e);
    },
    getDefaultMuted() {
      var e;
      return ((e = this.player) == null ? void 0 : e.defaultMuted) || !1;
    },
    setPoster(e) {
      this.player && (this.player.poster = e);
    },
    getPoster() {
      var e;
      return ((e = this.player) == null ? void 0 : e.poster) || "";
    },
    setDisablePictureInPicture(e) {
      player && (this.player.disablePictureInPicture = e);
    },
    getDisablePictureInPicture() {
      var e;
      return ((e = this.player) == null ? void 0 : e.disablePictureInPicture) || !1;
    },
    setPlaysinline(e) {
      this.player && (this.player.playsinline = e);
    },
    getPlaysinline() {
      var e;
      return ((e = this.player) == null ? void 0 : e.playsinline) || !1;
    },
    setDisableDownload(e) {
      this.player && (this.player.disableDownload = e);
    },
    getDisableDownload() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableDownload;
    },
    setDisableAdaptive(e) {
      this.player && (this.player.disableAdaptive = e);
    },
    getDisableAdaptive() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableAdaptive;
    },
    setDisableHotkey(e) {
      this.player && (this.player.disableHotkey = e);
    },
    getDisableHotkey() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableHotkey;
    },
    setDisableMask(e) {
      this.player && (this.player.disableMask = e);
    },
    getDisableMask() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableMask;
    },
    setCurrentLevel(e) {
      this.player && (this.player.currentLevel = e);
    },
    getCurrentLevel() {
      var e;
      return ((e = this.player) == null ? void 0 : e.currentLevel) || 0;
    },
    setNextLevel(e) {
      this.player && (this.player.nextLevel = e);
    },
    getNextLevel() {
      var e;
      return ((e = this.player) == null ? void 0 : e.nextLevel) || 0;
    },
    setAudioTrack(e) {
      this.player && (this.player.audioTrack = e);
    },
    getAudioTrack() {
      var e;
      return ((e = this.player) == null ? void 0 : e.audioTrack) || 0;
    },
    setCurrentVideoFrame(e) {
      this.player && (this.player.currentVideoFrame = e);
    },
    getCurrentVideoFrame() {
      var e;
      return ((e = this.player) == null ? void 0 : e.currentVideoFrame) || 0;
    },
    setShowProgress(e) {
      this.player && (this.player.showProgress = e);
    },
    getShowProgress() {
      var e;
      return (e = this.player) == null ? void 0 : e.showProgress;
    },
    setShowTime(e) {
      this.player && (this.player.showTime = e);
    },
    getShowTime() {
      var e;
      return (e = this.player) == null ? void 0 : e.showTime;
    },
    setPrefetch(e) {
      this.player && (this.player.prefetch = e);
    },
    getPrefetch() {
      var e;
      return (e = this.player) == null ? void 0 : e.prefetch;
    },
    setShowInfoPanel(e) {
      this.player && (this.player.showInfoPanel = e);
    },
    getShowInfoPanel() {
      var e;
      return (e = this.player) == null ? void 0 : e.showInfoPanel;
    },
    setProductName(e) {
      this.player && (this.player.productName = e);
    },
    getProductName() {
      var e;
      return (e = this.player) == null ? void 0 : e.productName;
    },
    setPreviewUrl(e) {
      this.player && (this.player.previewUrl = e);
    },
    getPreviewUrl() {
      var e;
      return (e = this.player) == null ? void 0 : e.previewUrl;
    },
    setMaskUrl(e) {
      this.player && (this.player.maskUrl = e);
    },
    getMaskUrl() {
      var e;
      return (e = this.player) == null ? void 0 : e.maskUrl;
    },
    setDisableDanmaku(e) {
      this.player && (this.player.disableDanmaku = e);
    },
    getDisableDanmaku() {
      var e;
      return (e = this.player) == null ? void 0 : e.disableDanmaku;
    },
    setDanmakuRendering(e) {
      this.player && (this.player.danmakuRendering = e);
    },
    getDanmakuRendering() {
      var e;
      return (e = this.player) == null ? void 0 : e.danmakuRendering;
    },
    getAudienceStat() {
      var e;
      return (e = this.player) == null ? void 0 : e.audienceStat;
    },
    getStreamTime(e) {
      var i;
      return ((i = this.player) == null ? void 0 : i.getStreamTime(e)) || 0;
    },
    getIsLiveShift() {
      var e;
      return ((e = this.player) == null ? void 0 : e.isLiveShift) || !1;
    },
    getLiveShiftType() {
      var e;
      return ((e = this.player) == null ? void 0 : e.liveShiftType) || Sa.NONE;
    },
    setLiveShiftType(e) {
      this.player && (this.player.liveShiftType = e);
    },
    getVersion() {
      return Jt.version;
    },
    getPluginInstance(e) {
      var i;
      return (i = this.player) == null ? void 0 : i.getPluginInstance(e);
    }
  },
  created() {
    this.cid = this.id || bl();
  },
  mounted() {
    I.i(ue, "mounted");
    const e = this.player = new Jt(`#${this.cid}`, {
      config: this.config,
      src: this.src,
      crossOrigin: this.crossOrigin,
      preload: this.preload,
      defaultPlaybackRate: this.defaultPlaybackRate,
      playbackRate: this.playbackRate,
      autoplay: this.autoplay,
      loop: this.loop,
      controls: this.controls,
      videoId: this.videoId,
      volume: this.volume,
      muted: this.muted,
      defaultMuted: this.defaultMuted,
      poster: this.poster,
      disablePictureInPicture: this.disablePictureInPicture,
      disableDownload: this.disableDownload,
      disableAdaptive: this.disableAdaptive,
      disableHotkey: this.disableHotkey,
      disableMask: this.disableMask,
      playsinline: this.playsinline,
      showProgress: this.showProgress,
      showTime: this.showTime,
      prefetch: this.prefetch,
      showInfoPanel: this.showInfoPanel,
      productName: this.productName,
      previewUrl: this.previewUrl,
      maskUrl: this.maskUrl,
      disableDanmaku: this.disableDanmaku,
      danmakuRendering: this.danmakuRendering,
      plugins: this.plugins,
      bizData: this.bizData,
      liveShiftType: this.liveShiftType
    });
    sc.forEach((i) => {
      e.on(i, (o) => {
        this.$emit(i, o);
      });
    });
  },
  beforeUnmount() {
    this.player.destroy();
  }
};
var cc = function() {
  var e = this, i = e.$createElement, o = e._self._c || i;
  return o("div", {
    attrs: {
      id: e.cid
    }
  }, [e._t("watermark")], 2);
}, uc = [];
function dc(e, i, o, c, d, _, v, f) {
  var y = typeof e == "function" ? e.options : e;
  i && (y.render = i, y.staticRenderFns = o, y._compiled = !0), c && (y.functional = !0), _ && (y._scopeId = "data-v-" + _);
  var D;
  if (v ? (D = function(E) {
    E = E || // cached call
    this.$vnode && this.$vnode.ssrContext || // stateful
    this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext, !E && typeof __VUE_SSR_CONTEXT__ < "u" && (E = __VUE_SSR_CONTEXT__), d && d.call(this, E), E && E._registeredComponents && E._registeredComponents.add(v);
  }, y._ssrRegister = D) : d && (D = f ? function() {
    d.call(
      this,
      (y.functional ? this.parent : this).$root.$options.shadowRoot
    );
  } : d), D)
    if (y.functional) {
      y._injectStyles = D;
      var A = y.render;
      y.render = function(E, b) {
        return D.call(b), A(E, b);
      };
    } else {
      var S = y.beforeCreate;
      y.beforeCreate = S ? [].concat(S, D) : [D];
    }
  return {
    exports: e,
    options: y
  };
}
const Hn = {};
var hc = /* @__PURE__ */ dc(
  lc,
  cc,
  uc,
  !1,
  _c,
  null,
  null,
  null
);
function _c(e) {
  for (let i in Hn)
    this[i] = Hn[i];
}
const Qu = /* @__PURE__ */ function() {
  return hc.exports;
}();
var Ac = Object.defineProperty, pc = (e, i, o) => i in e ? Ac(e, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[i] = o, _e = (e, i, o) => (pc(e, typeof i != "symbol" ? i + "" : i, o), o);
const Gn = {
  development: "./misc2",
  production: "https://log-sdk.ksapisrv.com/rest/wd/common/log/collect/misc2",
  oversea: "https://logsdk.kwai-pro.com/rest/wd/common/log/collect/misc2",
  "logger-oversea": "https://data-track-sgp.corp.kuaishou.com/rest/wd/common/log/collect/misc2"
}, fc = 5e3;
var Xt = /* @__PURE__ */ ((e) => (e.SUMMARY = "KP_WEB_SUMMARY", e.REALTIME = "KP_WEB_REALTIME", e.DOWNLOAD = "KP_WEB_DOWNLOAD", e.EVENT = "KP_WEB_EVENT", e))(Xt || {});
const vc = {
  summary: "KP_WEB_SUMMARY",
  realtimeBeacon: "KP_WEB_REALTIME",
  download: "KP_WEB_DOWNLOAD",
  event: "KP_WEB_EVENT"
  /* EVENT */
}, Ba = "production", mc = "streamlake", Wn = [
  "summary",
  "realtimeBeacon",
  "download",
  "event"
  /* EVENT */
];
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("")), document.head.appendChild(e);
    }
  } catch (i) {
    console.error("vite-plugin-css-injected-by-js", i);
  }
})();
var gc = Object.defineProperty, yc = (e, i, o) => i in e ? gc(e, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[i] = o, it = (e, i, o) => (yc(e, typeof i != "symbol" ? i + "" : i, o), o);
const Ec = "ControlsPlugin", Tc = "I18nPlugin", bc = "LoggerPlugin", Rc = "HotkeyPlugin", Sc = "PlayInfoPlugin", wc = "MirrorPlugin", Lc = "RotatePlugin", xc = "PreviewPlugin", Ic = "MaskPlugin", kc = "VRPlugin", Cc = "DanmakuPlugin";
let rt = class extends Ki {
  static isInstanceOfPlugin(i) {
    return typeof i.beforeInstall == "function" && typeof i.afterInstall == "function" && typeof i.beforeUninstall == "function" && typeof i.afterUninstall == "function" && typeof i.getLabel == "function";
  }
  /**
   * 播放器实例化前钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  beforeInstall(i, o) {
  }
  /**
   * 播放器实例化后钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  afterInstall(i, o) {
  }
  /**
   * 播放器销毁前钩子
   * @param player 播放器实例
   */
  beforeUninstall(i) {
  }
  /**
   * 播放器销毁后钩子
   * @param player 播放器实例
   */
  afterUninstall(i) {
  }
};
it(rt, "label"), /**
* 版本
*/
it(rt, "version"), /**
* 当前环境是否支持
*/
it(rt, "isSupported");
const Va = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return Va.label;
  }
  beforeInstall(e, i) {
  }
  afterInstall(e, i) {
  }
};
let Dc = Va;
it(Dc, "label", Ec);
const Ha = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return Ha.label;
  }
  beforeInstall(e, i) {
  }
  afterInstall(e, i) {
  }
};
let Oc = Ha;
it(Oc, "label", Tc);
const Ga = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return Ga.label;
  }
  beforeInstall(i, o) {
  }
  afterInstall(i, o) {
  }
  /**
   * 增加业务相关数据
   * @param key 上报数据key
   * @param value 上报数据
   */
  addBizLog(i, o) {
  }
  appendSummaryField(i, o) {
  }
};
let Wa = Ga;
it(Wa, "label", bc);
const Ka = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return Ka.label;
  }
};
let Mc = Ka;
it(Mc, "label", Rc);
const za = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return za.label;
  }
};
let Nc = za;
it(Nc, "label", Sc);
const $a = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return $a.label;
  }
};
let Pc = $a;
it(Pc, "label", wc);
const ja = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return ja.label;
  }
};
let Uc = ja;
it(Uc, "label", Lc);
const Ya = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return Ya.label;
  }
};
let Fc = Ya;
it(Fc, "label", xc);
const qa = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return qa.label;
  }
};
let Bc = qa;
it(Bc, "label", Ic);
const Qa = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return Qa.label;
  }
};
let Vc = Qa;
it(Vc, "label", kc);
const Xa = class extends rt {
  /**
   * @override
   */
  getLabel() {
    return Xa.label;
  }
};
let Hc = Xa;
it(Hc, "label", Cc);
var Ft = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.MANIFEST_PARSED = "manifestparsed", e.LEVEL_SWITCHING = "levelswitching", e.LEVEL_SWITCHED = "levelswitched", e.LEVEL_SWITCH_PLAYING = "levelswitchplaying", e.LEVEL_SWITCH_FAILED = "levelswitchfailed", e.LEVEL_UPDATED = "levelupdated", e.AUDIO_TRACKS_SWITCHING = "audiotrackswitching", e.AUDIO_TRACKS_SWITCHED = "audiotrackswitched", e.LOADSTART = "loadstart", e.PROGRESS = "progress", e.SUSPEND = "suspend", e.ABORT = "abort", e.EMPTIED = "emptied", e.STALLED = "stalled", e.LOADEDMETADATA = "loadedmetadata", e.LOADEDDATA = "loadeddata", e.CANPLAY = "canplay", e.CANPLAYTHROUGH = "canplaythrough", e.PLAYING = "playing", e.WAITING = "waiting", e.SEEKING = "seeking", e.SEEKED = "seeked", e.ENDED = "ended", e.DURATIONCHANGE = "durationchange", e.TIMEUPDATE = "timeupdate", e.PLAY = "play", e.PAUSE = "pause", e.RATECHANGE = "ratechange", e.RESIZE = "resize", e.VOLUMECHANGE = "volumechange", e.ENTER_PICTURE_IN_PICTURE = "enterpictureinpicture", e.LEAVE_PICTURE_IN_PICTURE = "leavepictureinpicture", e.REPORT = "report", e.VIDEO_RENDERER_CHANGE = "videorendererchange", e.FULLSCREEN_CHANGE = "fullscreenchange", e.LIVE_SHIFT_CHANGE = "liveshiftchange", e.LIVE_SHIFT_TYPE_CHANGE = "liveshifttypechange", e.ATTRIBUTE_CHANGE_CONFIG = "attribute:change:config", e.ATTRIBUTE_CHANGE_SRC = "attribute:change:src", e.ATTRIBUTE_CHANGE_VIDEO_ID = "attribute:change:videoid", e.ATTRIBUTE_CHANGE_PREVIEW_URL = "attribute:change:previewurl", e.ATTRIBUTE_CHANGE_MASK_URL = "attribute:change:maskurl", e.ATTRIBUTE_CHANGE_CROSS_ORIGIN = "attribute:change:crossorigin", e.ATTRIBUTE_CHANGE_PRELOAD = "attribute:change:preload", e.ATTRIBUTE_CHANGE_CURRENT_TIME = "attribute:change:currenttime", e.ATTRIBUTE_CHANGE_DEFAULT_PLAYBACK_RATE = "attribute:change:defaultplaybackrate", e.ATTRIBUTE_CHANGE_PLAYBACK_RATE = "attribute:change:playbackrate", e.ATTRIBUTE_CHANGE_AUTOPLAY = "attribute:change:autoplay", e.ATTRIBUTE_CHANGE_LOOP = "attribute:change:loop", e.ATTRIBUTE_CHANGE_CONTROLS = "attribute:change:controls", e.ATTRIBUTE_CHANGE_VOLUME = "attribute:change:volume", e.ATTRIBUTE_CHANGE_MUTED = "attribute:change:muted", e.ATTRIBUTE_CHANGE_DEFAULT_MUTED = "attribute:change:defaultmuted", e.ATTRIBUTE_CHANGE_POSTER = "attribute:change:poster", e.ATTRIBUTE_CHANGE_DISABLE_PICTURE_IN_PICTURE = "attribute:change:disablepictureinpicture", e.ATTRIBUTE_CHANGE_PLAYSINLINE = "attribute:change:playsinline", e.ATTRIBUTE_CHANGE_DISABLE_ADAPTIVE = "attribute:change:disableadaptive", e.ATTRIBUTE_CHANGE_DISABLE_DOWNLOAD = "attribute:change:disabledownload", e.ATTRIBUTE_CHANGE_DISABLE_MASK = "attribute:change:disablemask", e.ATTRIBUTE_CHANGE_DISABLE_HOTKEY = "attribute:change:disablehotkey", e.ATTRIBUTE_CHANGE_DISABLE_DANMAKU = "attribute:change:disabledanmaku", e.ATTRIBUTE_CHANGE_DANMAKU_RENDERING = "attribute:change:danmakurendering", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS = "attribute:change:danmakucontrolspos", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS_FULLSCREEN = "attribute:change:danmakucontrolsposfullscreen", e.ATTRIBUTE_CHANGE_CURRENT_LEVEL = "attribute:change:currentlevel", e.ATTRIBUTE_CHANGE_NEXT_LEVEL = "attribute:change:nextlevel", e.ATTRIBUTE_CHANGE_CURRENT_FRAME = "attribute:change:currentframe", e.ATTRIBUTE_CHANGE_AUDIO_TRACK = "attribute:change:audiotrack", e.ATTRIBUTE_CHANGE_PREFETCH = "attribute:change:prefetch", e.ATTRIBUTE_CHANGE_SHOW_PROGRESS = "attribute:change:showprogress", e.ATTRIBUTE_CHANGE_SHOW_TIME = "attribute:change:showtime", e.ATTRIBUTE_CHANGE_SHOW_NEXT = "attribute:change:shownext", e.ATTRIBUTE_CHANGE_SHOW_PREV = "attribute:change:showprev", e.ATTRIBUTE_CHANGE_BIZ_DATA = "attribute:change:bizdata", e.ATTRIBUTE_CHANGE_LIVE_TIME = "attribute:change:livetime", e.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL = "attribute:change:showinfopanel", e.CLICK_NEXT = "clicknext", e.CLICK_PREV = "clickprev", e.CLICK_LOGIN = "clicklogin", e.CLICK_REGISTER = "clickregister", e.CLICK_SEND_DANMAKU = "clicksenddanmaku", e.CLICK_VIP = "clickvip", e))(Ft || {}), Ti, Gc = new Uint8Array(16);
function Wc() {
  if (!Ti && (Ti = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto < "u" && typeof msCrypto.getRandomValues == "function" && msCrypto.getRandomValues.bind(msCrypto), !Ti))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return Ti(Gc);
}
const Kc = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;
function zc(e) {
  return typeof e == "string" && Kc.test(e);
}
var Ve = [];
for (var hr = 0; hr < 256; ++hr)
  Ve.push((hr + 256).toString(16).substr(1));
function $c(e) {
  var i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, o = (Ve[e[i + 0]] + Ve[e[i + 1]] + Ve[e[i + 2]] + Ve[e[i + 3]] + "-" + Ve[e[i + 4]] + Ve[e[i + 5]] + "-" + Ve[e[i + 6]] + Ve[e[i + 7]] + "-" + Ve[e[i + 8]] + Ve[e[i + 9]] + "-" + Ve[e[i + 10]] + Ve[e[i + 11]] + Ve[e[i + 12]] + Ve[e[i + 13]] + Ve[e[i + 14]] + Ve[e[i + 15]]).toLowerCase();
  if (!zc(o))
    throw TypeError("Stringified UUID is invalid");
  return o;
}
function Za(e, i, o) {
  e = e || {};
  var c = e.random || (e.rng || Wc)();
  if (c[6] = c[6] & 15 | 64, c[8] = c[8] & 63 | 128, i) {
    o = o || 0;
    for (var d = 0; d < 16; ++d)
      i[o + d] = c[d];
    return i;
  }
  return $c(c);
}
/*! js-cookie v3.0.5 | MIT */
function bi(e) {
  for (var i = 1; i < arguments.length; i++) {
    var o = arguments[i];
    for (var c in o)
      e[c] = o[c];
  }
  return e;
}
var jc = {
  read: function(e) {
    return e[0] === '"' && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
  },
  write: function(e) {
    return encodeURIComponent(e).replace(
      /%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g,
      decodeURIComponent
    );
  }
};
function Tr(e, i) {
  function o(d, _, v) {
    if (!(typeof document > "u")) {
      v = bi({}, i, v), typeof v.expires == "number" && (v.expires = new Date(Date.now() + v.expires * 864e5)), v.expires && (v.expires = v.expires.toUTCString()), d = encodeURIComponent(d).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
      var f = "";
      for (var y in v)
        v[y] && (f += "; " + y, v[y] !== !0 && (f += "=" + v[y].split(";")[0]));
      return document.cookie = d + "=" + e.write(_, d) + f;
    }
  }
  function c(d) {
    if (!(typeof document > "u" || arguments.length && !d)) {
      for (var _ = document.cookie ? document.cookie.split("; ") : [], v = {}, f = 0; f < _.length; f++) {
        var y = _[f].split("="), D = y.slice(1).join("=");
        try {
          var A = decodeURIComponent(y[0]);
          if (v[A] = e.read(D, A), d === A)
            break;
        } catch (S) {
        }
      }
      return d ? v[d] : v;
    }
  }
  return Object.create(
    {
      set: o,
      get: c,
      remove: function(d, _) {
        o(
          d,
          "",
          bi({}, _, {
            expires: -1
          })
        );
      },
      withAttributes: function(d) {
        return Tr(this.converter, bi({}, this.attributes, d));
      },
      withConverter: function(d) {
        return Tr(bi({}, this.converter, d), this.attributes);
      }
    },
    {
      attributes: { value: Object.freeze(i) },
      converter: { value: Object.freeze(e) }
    }
  );
}
var _r = Tr(jc, { path: "/" });
const Kn = "kwai_player_device_id", li = class {
  constructor() {
    _e(this, "_env", Ba), _e(this, "_reportTypes", []), _e(this, "_player"), _e(this, "_logBaseInfo", this._getDefaultLogBaseInfo()), _e(this, "_biz", {}), _e(this, "_extraSummaryFields", {}), _e(this, "_forceSendBeacon", !1);
  }
  setBaseInfo(e, i, o) {
    this._player = e, this._logBaseInfo.env = this._env = i, this._reportTypes = o;
  }
  setBizData(e) {
    if (!e) {
      this._logBaseInfo = this._getDefaultLogBaseInfo();
      return;
    }
    const i = this._logBaseInfo, o = Object.keys(i);
    typeof (e == null ? void 0 : e.resourceId) < "u" && (e.resourceId = this._id2String(e == null ? void 0 : e.resourceId)), typeof (e == null ? void 0 : e.userId) < "u" && (e.userId = this._id2String(e == null ? void 0 : e.userId)), Object.keys(e).forEach((c) => {
      const d = this._underscoreToCamelCase(c);
      o.indexOf(d) >= 0 && (i[d] = e[c]), this._biz[c] = e[c];
    });
  }
  preprocessingLog(e, i, o) {
    var c, d;
    if (i)
      return i = Object.assign(i, {
        player_version: ((c = this._player) == null ? void 0 : c.version) || "",
        pack_version: ((d = this._player) == null ? void 0 : d.packVersion) || "",
        biz: this._biz
      }), e === Xt.SUMMARY && (o ? i.extra = Object.assign({}, this._extraSummaryFields, o) : i.extra = this._extraSummaryFields), i;
  }
  clearExtraSummary() {
    this._extraSummaryFields = {};
  }
  appendSummaryField(e, i) {
    this._extraSummaryFields[e] = i;
  }
  get reportTypes() {
    return this._reportTypes;
  }
  get logBaseInfo() {
    var e;
    return (e = this._player) != null && e.productName && (this._logBaseInfo.productName = this._player.productName), this._logBaseInfo;
  }
  get player() {
    return this._player;
  }
  set forceSendBeacon(e) {
    this._forceSendBeacon = e;
  }
  get forceSendBeacon() {
    return this._forceSendBeacon;
  }
  _getDefaultLogBaseInfo() {
    let e = 10;
    return Ge.os.name === "iOS" ? e = 9 : Ge.os.name === "Android" && (e = 8), {
      env: this._env,
      productName: mc,
      sessionId: Za(),
      platform: e,
      deviceId: li.deviceId,
      userId: "",
      globalId: "",
      networkType: "",
      packageName: "",
      versionName: "",
      channel: ""
    };
  }
  static _generateDeviceId() {
    try {
      let e = _r.get("did") || _r.get("_did") || _r.get("weblogger_did") || "";
      return (!e || e.indexOf("web_") !== 0) && (e = localStorage.getItem(Kn) || ""), e || (e = li._nanoId(), localStorage.setItem(Kn, e)), e;
    } catch (e) {
    }
    return li._nanoId();
  }
  static _nanoId() {
    const e = Math.random() * 1e9 >>> 0, i = [], o = "0123456789ABCDEF";
    for (let c = 0; c < 7; c++)
      i.push(o.charAt(Math.random() * 16));
    return `web_${e}${i.join("")}`;
  }
  _underscoreToCamelCase(e) {
    return e.replace(/_([a-z])/g, (i, o) => o.toUpperCase());
  }
  _id2String(e) {
    return typeof e == "number" ? e.toString() : e || "";
  }
};
let Ja = li;
_e(Ja, "deviceId", li._generateDeviceId());
const Ar = "kwai-player-web-log-temp", Yc = 3 * 24 * 3600 * 1e3, qc = 5 * 1e3, zn = 1, Pt = "log-reissue";
let Qc = class {
  constructor(i, o) {
    _e(this, "_ctx"), _e(this, "_logger"), _e(this, "_active", !1), _e(this, "_processingTs", 0), _e(this, "_lc", new xr()), _e(this, "_timer", 0), _e(this, "_checkMissing", !1), _e(this, "_tick", () => {
      if (!this._active || !this._ctx.player)
        return;
      this._checkMissing && (this._checkMissing = !1, this._checkMissingLog());
      const c = performance.now();
      if (c - this._processingTs >= qc) {
        this._processingTs = c;
        const d = this._ctx.preprocessingLog(Xt.SUMMARY, this._ctx.player.audienceStat, { reissue_log: 1 });
        d && (I.v(Pt, "write temp"), this._writeTemp(this._logger.generateFormData(this._ctx.logBaseInfo, [{ key: Xt.SUMMARY, value: d }])));
      }
    }), _e(this, "_startTimer", () => {
      this._timer || (this._timer = +setInterval(this._tick, 1e3));
    }), _e(this, "_stopTimer", () => {
      clearInterval(this._timer), this._timer = 0;
    }), this._ctx = i, this._logger = o, this._lc.timeout = Yc;
  }
  start() {
    I.i(Pt, "start"), this._active || (this._active = !0, this._processingTs = performance.now(), this._checkMissing = !0, this._startTimer());
  }
  stop() {
    I.i(Pt, "stop"), this._active = !1, this._clear(), this._stopTimer();
  }
  _checkMissingLog() {
    const i = this._readTemp();
    this._clear(), i ? (I.i(Pt, "send missing log"), this._logger.send(this._ctx.logBaseInfo.env, Xt.SUMMARY, i.value)) : I.i(Pt, "no missing log");
  }
  _clear() {
    localStorage.removeItem(Ar);
  }
  _writeTemp(i) {
    if (!i)
      return;
    const o = {
      version: zn,
      value: i,
      checkSum: this._fletcher16(i)
    };
    this._lc.write(Ar, btoa(JSON.stringify(o)));
  }
  _readTemp() {
    const i = this._lc.read(Ar, !0);
    if (i)
      try {
        const o = JSON.parse(atob(i));
        if (o.version === zn && typeof o.value == "string" && o.checkSum === this._fletcher16(o.value))
          return I.i(Pt, "read success"), o;
        I.i(Pt, "read failed", o);
      } catch (o) {
      }
  }
  _fletcher16(i) {
    let o = 0, c = 0;
    for (let d = 0; d < i.length; d++)
      o = (o + i.charCodeAt(d)) % 255, c = (c + o) % 255;
    return c << 8 | o;
  }
};
const $n = {
  unknown: 0,
  none: 1,
  wifi: 2,
  "4g": 3,
  "3g": 4,
  "2g": 5,
  "5g": 7,
  "slow-2g": 5
}, pr = (/* @__PURE__ */ new Date()).toString().match(/GMT\+\d+/);
let fr = "";
const $t = "web-logger", Bt = class {
  constructor() {
    _e(this, "_waitingQueue", []), _e(this, "_nextTickTimer");
  }
  sendLog(i, o, c, d = !1, _) {
    I.i($t, "sendLog", i, o, c, `forceSendBeacon: ${d} immediately: ${_}`), c && (this._waitingQueue.push({ key: o, value: c }), _ ? (this.send(i.env, i.productName, this.generateFormData(i, this._waitingQueue), d), this._waitingQueue.splice(0)) : this._nextTickTimer || (this._nextTickTimer = setTimeout(() => {
      this._nextTickTimer = 0, this.send(i.env, i.productName, this.generateFormData(i, this._waitingQueue), d), this._waitingQueue.splice(0);
    }, 0)));
  }
  send(i, o, c, d = !1) {
    if (I.i($t, "send", i, o, !!c, `forceSendBeacon: ${d}`), !c)
      return;
    let _ = Gn[i] || Gn.production;
    Bt._clientIncrementId++, localStorage.kwai_player_client_increment_id = Bt._clientIncrementId;
    const v = new Fn(_, !0);
    if (v.query.v = "3.10.24", v.query.kpn = o, _ = v.toString(), I.i($t, "send", i, o, !!c, _), d && navigator.sendBeacon) {
      const f = navigator.sendBeacon(_, c);
      I.i($t, "send data use sendBeacon.", f), f || this._sendByXhr(_, c);
    } else
      this._sendByXhr(_, c);
  }
  _sendByXhr(i, o) {
    I.i($t, "send data use xhr.");
    const c = new XMLHttpRequest();
    c.open("POST", i), c.setRequestHeader("Content-Type", "text/plain;charset=UTF-8"), c.onerror = c.ontimeout = () => {
      I.i("sendLog error"), c.onerror = c.ontimeout = c.onload = null;
    }, c.onload = () => {
      c.onerror = c.ontimeout = c.onload = null;
    }, c.timeout = fc, c.send(o);
  }
  generateFormData(i, o) {
    const c = {
      common: Bt._buildCommon(
        i,
        {
          service_name: "KwaiPlayerWeb"
        }
      ),
      logs: o.map((d) => Bt._buildEvent(i, d.key, d.value))
    };
    return c.logs.length ? JSON.stringify(c) : "";
  }
  static _buildEvent(i, o, c) {
    fr || (fr = Za());
    const d = {
      identity: fr,
      page: location.href,
      hostname: location.hostname,
      page_type: 2
    };
    return d.params = new Fn(location.href, !0).query, {
      client_timestamp: Date.now(),
      client_increment_id: Bt._clientIncrementId,
      session_id: i.sessionId,
      time_zone: Bt._timeZone,
      stat_package: {
        custom_stat_event: {
          key: o,
          value: JSON.stringify(Object.assign({}, c, { url_package: d }))
        }
      }
    };
  }
  static _buildCommon(i, o) {
    return I.i($t, `device_id: ${i.deviceId}`), Cn({
      identity_package: {
        device_id: i.deviceId,
        global_id: i.globalId,
        user_id: i.userId
      },
      app_package: {
        language: navigator.language,
        platform: i.platform,
        container: i.platform === 10 ? "WEB" : "H5",
        package_name: i.packageName,
        product_name: i.productName,
        version_name: i.versionName,
        channel: i.channel
      },
      device_package: {
        os_version: Ge.os.version,
        model: Ge.os.name,
        ua: navigator.userAgent
      },
      need_encrypt: !1,
      sdk_version: "",
      h5_extra_attr: this._getH5ExtraAttr(i),
      global_attr: "{}",
      network_package: {
        type: this._getNetworkType(i.networkType)
      }
    }, o);
  }
  static _getNetworkType(i) {
    var o;
    const c = i || ((o = (navigator == null ? void 0 : navigator.connection) || (navigator == null ? void 0 : navigator.mozConnection) || (navigator == null ? void 0 : navigator.webkitConnection)) == null ? void 0 : o.effectiveType);
    return c && $n[c] || $n.unknown;
  }
  static _getH5ExtraAttr(i) {
    const o = parseFloat(devicePixelRatio.toFixed(3)) || 1;
    return JSON.stringify({
      sdk_name: "",
      sdk_version: "",
      sdk_bundle: "",
      app_version_name: i.versionName,
      resolution: `${Math.floor(screen.width * o)}x${Math.floor(screen.height * o)}`,
      screen_width: Math.floor(screen.width),
      screen_height: Math.floor(screen.height),
      device_pixel_ratio: o,
      domain: location.origin,
      fromIframe: self !== top
    });
  }
};
let br = Bt;
_e(br, "_clientIncrementId", parseInt(typeof localStorage < "u" && localStorage != null && localStorage.getItem("kwai_player_client_increment_id") || "") || 0), _e(br, "_timeZone", pr && pr[0] ? pr[0] : "");
const ai = "logger-plugin";
let Xc = class extends Wa {
  constructor() {
    super(...arguments), _e(this, "_summaryAlreadySend", !1), _e(this, "_logger", new br()), _e(this, "_ctx", new Ja()), _e(this, "_logReissue"), _e(this, "_parseBizData", () => {
      var i;
      I.i(ai, "parse biz data"), this._ctx.setBizData((i = this._ctx.player) == null ? void 0 : i.bizData);
    }), _e(this, "_onReport", (i) => {
      if (this._ctx.reportTypes.indexOf(i.type) !== -1) {
        const o = vc[i.type];
        o ? (I.i(ai, "sendLog", this._ctx.logBaseInfo.productName, o), this._send(o, i.value)) : I.i(ai, "unknown weblogger key.");
      }
    }), _e(this, "_onSrcChange", () => {
      var i;
      this._sendSummary(), this._summaryAlreadySend = !1, (i = this._logReissue) == null || i.start();
    }), _e(this, "_sendSummary", () => {
      var i;
      !this._ctx.player || this._summaryAlreadySend || !this._ctx.player.audienceStat || ((i = this._logReissue) == null || i.stop(), this._summaryAlreadySend = !0, I.i(ai, "send summary"), this._send(Xt.SUMMARY, this._ctx.player.audienceStat, !0));
    }), _e(this, "_onBeforeunload", () => {
      this._sendSummary();
    });
  }
  beforeInstall(i, o) {
    let c;
    o && o.reportTypes && Array.isArray(o.reportTypes) && (c = o.reportTypes.filter((d) => Wn.indexOf(d) >= 0)), o != null && o.productName && (i.productName = o.productName), typeof (o == null ? void 0 : o.forceSendBeacon) < "u" && (this._ctx.forceSendBeacon = o.forceSendBeacon), this._ctx.setBaseInfo(i, (o == null ? void 0 : o.env) || Ba, c || Wn), this._logReissue = new Qc(this._ctx, this._logger), i.on(Ft.REPORT, this._onReport), i.on(Ft.ATTRIBUTE_CHANGE_SRC, this._onSrcChange), i.on(Ft.ATTRIBUTE_CHANGE_BIZ_DATA, this._parseBizData), window.addEventListener("beforeunload", this._onBeforeunload), Ge && Ge.device.type === "mobile" && window.addEventListener("unload", this._onBeforeunload), this._parseBizData();
  }
  beforeUninstall() {
    this._sendSummary();
  }
  afterUninstall() {
    var i, o, c;
    (i = this._ctx.player) == null || i.off(Ft.REPORT, this._onReport), (o = this._ctx.player) == null || o.off(Ft.ATTRIBUTE_CHANGE_SRC, this._onSrcChange), (c = this._ctx.player) == null || c.off(Ft.ATTRIBUTE_CHANGE_BIZ_DATA, this._parseBizData), window.removeEventListener("beforeunload", this._onBeforeunload), window.removeEventListener("unload", this._onBeforeunload);
  }
  appendSummaryField(i, o) {
    I.i(ai, "add summary field", i, o), this._ctx.appendSummaryField(i, o);
  }
  _send(i, o, c) {
    o && this._logger.sendLog(this._ctx.logBaseInfo, i, this._ctx.preprocessingLog(i, o), this._ctx.forceSendBeacon, c);
  }
};
(function() {
  try {
    if (typeof document != "undefined") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("._container_afsrn_1{background-color:rgba(0,0,0,.5);border-radius:.375em;position:relative;color:#fff;font-size:12px;font-family:Arial,Roboto,Noto,sans-serif;box-sizing:border-box;padding:2em .625em .625em;overflow:auto;word-break:break-all;white-space:normal;max-width:500px;max-height:calc(100% - 10px);line-height:1.5;margin:.3125em}._container-h5_afsrn_19{background-color:rgba(0,0,0,.5);border-radius:.375em;position:relative;color:#fff;font-size:12px;font-family:Arial,Roboto,Noto,sans-serif;box-sizing:border-box;padding:2em .625em .625em;overflow:auto;word-break:break-all;white-space:normal;font-size:14px;width:100%;height:100%}._close-btn_afsrn_36{position:absolute;right:0;top:0;cursor:pointer;word-break:keep-all;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:.625em}._btn-tip_afsrn_49{background-color:rgba(0,0,0,.5);border-radius:.375em;position:absolute;left:50%;transform:translate(-50%);bottom:2.1875em;white-space:nowrap;padding:.5em}._actions_afsrn_60{display:flex;justify-content:flex-end;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;padding:0}._actions_afsrn_60 ._copy-btn_afsrn_69{word-break:keep-all;cursor:pointer;padding:.625em 0 0 .625em}._info-item_afsrn_75{display:flex}._info-item-name_afsrn_79{width:20%;min-width:7.5em;text-align:right;margin-right:.625em;flex-shrink:0}._info-item-value_afsrn_87{flex-grow:1;text-align:left}._item-svg_afsrn_92{display:inline-block;width:60%;height:1em;margin-right:.625em;background:rgba(255,255,255,.2)}._item-value_afsrn_100{display:inline-block}@media (hover: hover){._close-btn_afsrn_36:hover,._copy-btn_afsrn_69:hover{color:#ccc}}")), document.head.appendChild(e);
    }
  } catch (i) {
    console.error("vite-plugin-css-injected-by-js", i);
  }
})();
var Zc = Object.defineProperty, Jc = (e, i, o) => i in e ? Zc(e, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[i] = o, oi = (e, i, o) => (Jc(e, typeof i != "symbol" ? i + "" : i, o), o);
(function() {
  try {
    if (typeof document < "u") {
      var e = document.createElement("style");
      e.appendChild(document.createTextNode("")), document.head.appendChild(e);
    }
  } catch (i) {
    console.error("vite-plugin-css-injected-by-js", i);
  }
})();
var eu = Object.defineProperty, tu = (e, i, o) => i in e ? eu(e, i, { enumerable: !0, configurable: !0, writable: !0, value: o }) : e[i] = o, nt = (e, i, o) => (tu(e, typeof i != "symbol" ? i + "" : i, o), o);
const iu = "ControlsPlugin", ru = "I18nPlugin", nu = "LoggerPlugin", au = "HotkeyPlugin", ou = "PlayInfoPlugin", su = "MirrorPlugin", lu = "RotatePlugin", cu = "PreviewPlugin", uu = "MaskPlugin", du = "VRPlugin", hu = "DanmakuPlugin";
let at = class extends Ki {
  static isInstanceOfPlugin(e) {
    return typeof e.beforeInstall == "function" && typeof e.afterInstall == "function" && typeof e.beforeUninstall == "function" && typeof e.afterUninstall == "function" && typeof e.getLabel == "function";
  }
  /**
   * 播放器实例化前钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  beforeInstall(e, i) {
  }
  /**
   * 播放器实例化后钩子
   * @param player 播放器实例
   * @param options 实例化播放器时指定的当前插件的参数
   */
  afterInstall(e, i) {
  }
  /**
   * 播放器销毁前钩子
   * @param player 播放器实例
   */
  beforeUninstall(e) {
  }
  /**
   * 播放器销毁后钩子
   * @param player 播放器实例
   */
  afterUninstall(e) {
  }
};
nt(at, "label"), /**
* 版本
*/
nt(at, "version"), /**
* 当前环境是否支持
*/
nt(at, "isSupported");
const eo = class extends at {
  /**
   * @override
   */
  getLabel() {
    return eo.label;
  }
  beforeInstall(e, i) {
  }
  afterInstall(e, i) {
  }
};
let _u = eo;
nt(_u, "label", iu);
const to = class extends at {
  /**
   * @override
   */
  getLabel() {
    return to.label;
  }
  beforeInstall(e, i) {
  }
  afterInstall(e, i) {
  }
};
let Au = to;
nt(Au, "label", ru);
const io = class extends at {
  /**
   * @override
   */
  getLabel() {
    return io.label;
  }
  beforeInstall(e, i) {
  }
  afterInstall(e, i) {
  }
  /**
   * 增加业务相关数据
   * @param key 上报数据key
   * @param value 上报数据
   */
  addBizLog(e, i) {
  }
  appendSummaryField(e, i) {
  }
};
let pu = io;
nt(pu, "label", nu);
const ro = class extends at {
  /**
   * @override
   */
  getLabel() {
    return ro.label;
  }
};
let fu = ro;
nt(fu, "label", au);
const no = class extends at {
  /**
   * @override
   */
  getLabel() {
    return no.label;
  }
};
let ao = no;
nt(ao, "label", ou);
const oo = class extends at {
  /**
   * @override
   */
  getLabel() {
    return oo.label;
  }
};
let vu = oo;
nt(vu, "label", su);
const so = class extends at {
  /**
   * @override
   */
  getLabel() {
    return so.label;
  }
};
let mu = so;
nt(mu, "label", lu);
const lo = class extends at {
  /**
   * @override
   */
  getLabel() {
    return lo.label;
  }
};
let gu = lo;
nt(gu, "label", cu);
const co = class extends at {
  /**
   * @override
   */
  getLabel() {
    return co.label;
  }
};
let yu = co;
nt(yu, "label", uu);
const uo = class extends at {
  /**
   * @override
   */
  getLabel() {
    return uo.label;
  }
};
let Eu = uo;
nt(Eu, "label", du);
const ho = class extends at {
  /**
   * @override
   */
  getLabel() {
    return ho.label;
  }
};
let Tu = ho;
nt(Tu, "label", hu);
var Gt = /* @__PURE__ */ ((e) => (e.ERROR = "error", e.MANIFEST_PARSED = "manifestparsed", e.LEVEL_SWITCHING = "levelswitching", e.LEVEL_SWITCHED = "levelswitched", e.LEVEL_SWITCH_PLAYING = "levelswitchplaying", e.LEVEL_SWITCH_FAILED = "levelswitchfailed", e.LEVEL_UPDATED = "levelupdated", e.AUDIO_TRACKS_SWITCHING = "audiotrackswitching", e.AUDIO_TRACKS_SWITCHED = "audiotrackswitched", e.LOADSTART = "loadstart", e.PROGRESS = "progress", e.SUSPEND = "suspend", e.ABORT = "abort", e.EMPTIED = "emptied", e.STALLED = "stalled", e.LOADEDMETADATA = "loadedmetadata", e.LOADEDDATA = "loadeddata", e.CANPLAY = "canplay", e.CANPLAYTHROUGH = "canplaythrough", e.PLAYING = "playing", e.WAITING = "waiting", e.SEEKING = "seeking", e.SEEKED = "seeked", e.ENDED = "ended", e.DURATIONCHANGE = "durationchange", e.TIMEUPDATE = "timeupdate", e.PLAY = "play", e.PAUSE = "pause", e.RATECHANGE = "ratechange", e.RESIZE = "resize", e.VOLUMECHANGE = "volumechange", e.ENTER_PICTURE_IN_PICTURE = "enterpictureinpicture", e.LEAVE_PICTURE_IN_PICTURE = "leavepictureinpicture", e.REPORT = "report", e.VIDEO_RENDERER_CHANGE = "videorendererchange", e.FULLSCREEN_CHANGE = "fullscreenchange", e.LIVE_SHIFT_CHANGE = "liveshiftchange", e.LIVE_SHIFT_TYPE_CHANGE = "liveshifttypechange", e.ATTRIBUTE_CHANGE_CONFIG = "attribute:change:config", e.ATTRIBUTE_CHANGE_SRC = "attribute:change:src", e.ATTRIBUTE_CHANGE_VIDEO_ID = "attribute:change:videoid", e.ATTRIBUTE_CHANGE_PREVIEW_URL = "attribute:change:previewurl", e.ATTRIBUTE_CHANGE_MASK_URL = "attribute:change:maskurl", e.ATTRIBUTE_CHANGE_CROSS_ORIGIN = "attribute:change:crossorigin", e.ATTRIBUTE_CHANGE_PRELOAD = "attribute:change:preload", e.ATTRIBUTE_CHANGE_CURRENT_TIME = "attribute:change:currenttime", e.ATTRIBUTE_CHANGE_DEFAULT_PLAYBACK_RATE = "attribute:change:defaultplaybackrate", e.ATTRIBUTE_CHANGE_PLAYBACK_RATE = "attribute:change:playbackrate", e.ATTRIBUTE_CHANGE_AUTOPLAY = "attribute:change:autoplay", e.ATTRIBUTE_CHANGE_LOOP = "attribute:change:loop", e.ATTRIBUTE_CHANGE_CONTROLS = "attribute:change:controls", e.ATTRIBUTE_CHANGE_VOLUME = "attribute:change:volume", e.ATTRIBUTE_CHANGE_MUTED = "attribute:change:muted", e.ATTRIBUTE_CHANGE_DEFAULT_MUTED = "attribute:change:defaultmuted", e.ATTRIBUTE_CHANGE_POSTER = "attribute:change:poster", e.ATTRIBUTE_CHANGE_DISABLE_PICTURE_IN_PICTURE = "attribute:change:disablepictureinpicture", e.ATTRIBUTE_CHANGE_PLAYSINLINE = "attribute:change:playsinline", e.ATTRIBUTE_CHANGE_DISABLE_ADAPTIVE = "attribute:change:disableadaptive", e.ATTRIBUTE_CHANGE_DISABLE_DOWNLOAD = "attribute:change:disabledownload", e.ATTRIBUTE_CHANGE_DISABLE_MASK = "attribute:change:disablemask", e.ATTRIBUTE_CHANGE_DISABLE_HOTKEY = "attribute:change:disablehotkey", e.ATTRIBUTE_CHANGE_DISABLE_DANMAKU = "attribute:change:disabledanmaku", e.ATTRIBUTE_CHANGE_DANMAKU_RENDERING = "attribute:change:danmakurendering", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS = "attribute:change:danmakucontrolspos", e.ATTRIBUTE_CHANGE_DANMAKU_CONTROLS_POS_FULLSCREEN = "attribute:change:danmakucontrolsposfullscreen", e.ATTRIBUTE_CHANGE_CURRENT_LEVEL = "attribute:change:currentlevel", e.ATTRIBUTE_CHANGE_NEXT_LEVEL = "attribute:change:nextlevel", e.ATTRIBUTE_CHANGE_CURRENT_FRAME = "attribute:change:currentframe", e.ATTRIBUTE_CHANGE_AUDIO_TRACK = "attribute:change:audiotrack", e.ATTRIBUTE_CHANGE_PREFETCH = "attribute:change:prefetch", e.ATTRIBUTE_CHANGE_SHOW_PROGRESS = "attribute:change:showprogress", e.ATTRIBUTE_CHANGE_SHOW_TIME = "attribute:change:showtime", e.ATTRIBUTE_CHANGE_SHOW_NEXT = "attribute:change:shownext", e.ATTRIBUTE_CHANGE_SHOW_PREV = "attribute:change:showprev", e.ATTRIBUTE_CHANGE_BIZ_DATA = "attribute:change:bizdata", e.ATTRIBUTE_CHANGE_LIVE_TIME = "attribute:change:livetime", e.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL = "attribute:change:showinfopanel", e.CLICK_NEXT = "clicknext", e.CLICK_PREV = "clickprev", e.CLICK_LOGIN = "clicklogin", e.CLICK_REGISTER = "clickregister", e.CLICK_SEND_DANMAKU = "clicksenddanmaku", e.CLICK_VIP = "clickvip", e))(Gt || {}), zi, ee, _o, Ht, jn, Ao, Rr, Fi = {}, po = [], bu = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function Dt(e, i) {
  for (var o in i)
    e[o] = i[o];
  return e;
}
function fo(e) {
  var i = e.parentNode;
  i && i.removeChild(e);
}
function Ru(e, i, o) {
  var c, d, _, v = {};
  for (_ in i)
    _ == "key" ? c = i[_] : _ == "ref" ? d = i[_] : v[_] = i[_];
  if (arguments.length > 2 && (v.children = arguments.length > 3 ? zi.call(arguments, 2) : o), typeof e == "function" && e.defaultProps != null)
    for (_ in e.defaultProps)
      v[_] === void 0 && (v[_] = e.defaultProps[_]);
  return xi(e, v, c, d, null);
}
function xi(e, i, o, c, d) {
  var _ = { type: e, props: i, key: o, ref: c, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: d != null ? d : ++_o };
  return d == null && ee.vnode != null && ee.vnode(_), _;
}
function $i(e) {
  return e.children;
}
function Ii(e, i) {
  this.props = e, this.context = i;
}
function ci(e, i) {
  if (i == null)
    return e.__ ? ci(e.__, e.__.__k.indexOf(e) + 1) : null;
  for (var o; i < e.__k.length; i++)
    if ((o = e.__k[i]) != null && o.__e != null)
      return o.__e;
  return typeof e.type == "function" ? ci(e) : null;
}
function vo(e) {
  var i, o;
  if ((e = e.__) != null && e.__c != null) {
    for (e.__e = e.__c.base = null, i = 0; i < e.__k.length; i++)
      if ((o = e.__k[i]) != null && o.__e != null) {
        e.__e = e.__c.base = o.__e;
        break;
      }
    return vo(e);
  }
}
function Yn(e) {
  (!e.__d && (e.__d = !0) && Ht.push(e) && !Bi.__r++ || jn !== ee.debounceRendering) && ((jn = ee.debounceRendering) || Ao)(Bi);
}
function Bi() {
  var e, i, o, c, d, _, v, f;
  for (Ht.sort(Rr); e = Ht.shift(); )
    e.__d && (i = Ht.length, c = void 0, d = void 0, v = (_ = (o = e).__v).__e, (f = o.__P) && (c = [], (d = Dt({}, _)).__v = _.__v + 1, Ir(f, _, d, o.__n, f.ownerSVGElement !== void 0, _.__h != null ? [v] : null, c, v != null ? v : ci(_), _.__h), To(c, _), _.__e != v && vo(_)), Ht.length > i && Ht.sort(Rr));
  Bi.__r = 0;
}
function mo(e, i, o, c, d, _, v, f, y, D) {
  var A, S, E, b, L, k, g, H = c && c.__k || po, T = H.length;
  for (o.__k = [], A = 0; A < i.length; A++)
    if ((b = o.__k[A] = (b = i[A]) == null || typeof b == "boolean" || typeof b == "function" ? null : typeof b == "string" || typeof b == "number" || typeof b == "bigint" ? xi(null, b, null, null, b) : Array.isArray(b) ? xi($i, { children: b }, null, null, null) : b.__b > 0 ? xi(b.type, b.props, b.key, b.ref ? b.ref : null, b.__v) : b) != null) {
      if (b.__ = o, b.__b = o.__b + 1, (E = H[A]) === null || E && b.key == E.key && b.type === E.type)
        H[A] = void 0;
      else
        for (S = 0; S < T; S++) {
          if ((E = H[S]) && b.key == E.key && b.type === E.type) {
            H[S] = void 0;
            break;
          }
          E = null;
        }
      Ir(e, b, E = E || Fi, d, _, v, f, y, D), L = b.__e, (S = b.ref) && E.ref != S && (g || (g = []), E.ref && g.push(E.ref, null, b), g.push(S, b.__c || L, b)), L != null ? (k == null && (k = L), typeof b.type == "function" && b.__k === E.__k ? b.__d = y = go(b, y, e) : y = yo(e, b, E, H, L, y), typeof o.type == "function" && (o.__d = y)) : y && E.__e == y && y.parentNode != e && (y = ci(E));
    }
  for (o.__e = k, A = T; A--; )
    H[A] != null && (typeof o.type == "function" && H[A].__e != null && H[A].__e == o.__d && (o.__d = Eo(c).nextSibling), Ro(H[A], H[A]));
  if (g)
    for (A = 0; A < g.length; A++)
      bo(g[A], g[++A], g[++A]);
}
function go(e, i, o) {
  for (var c, d = e.__k, _ = 0; d && _ < d.length; _++)
    (c = d[_]) && (c.__ = e, i = typeof c.type == "function" ? go(c, i, o) : yo(o, c, c, d, c.__e, i));
  return i;
}
function yo(e, i, o, c, d, _) {
  var v, f, y;
  if (i.__d !== void 0)
    v = i.__d, i.__d = void 0;
  else if (o == null || d != _ || d.parentNode == null)
    e:
      if (_ == null || _.parentNode !== e)
        e.appendChild(d), v = null;
      else {
        for (f = _, y = 0; (f = f.nextSibling) && y < c.length; y += 1)
          if (f == d)
            break e;
        e.insertBefore(d, _), v = _;
      }
  return v !== void 0 ? v : d.nextSibling;
}
function Eo(e) {
  var i, o, c;
  if (e.type == null || typeof e.type == "string")
    return e.__e;
  if (e.__k) {
    for (i = e.__k.length - 1; i >= 0; i--)
      if ((o = e.__k[i]) && (c = Eo(o)))
        return c;
  }
  return null;
}
function Su(e, i, o, c, d) {
  var _;
  for (_ in o)
    _ === "children" || _ === "key" || _ in i || Vi(e, _, null, o[_], c);
  for (_ in i)
    d && typeof i[_] != "function" || _ === "children" || _ === "key" || _ === "value" || _ === "checked" || o[_] === i[_] || Vi(e, _, i[_], o[_], c);
}
function qn(e, i, o) {
  i[0] === "-" ? e.setProperty(i, o != null ? o : "") : e[i] = o == null ? "" : typeof o != "number" || bu.test(i) ? o : o + "px";
}
function Vi(e, i, o, c, d) {
  var _;
  e:
    if (i === "style")
      if (typeof o == "string")
        e.style.cssText = o;
      else {
        if (typeof c == "string" && (e.style.cssText = c = ""), c)
          for (i in c)
            o && i in o || qn(e.style, i, "");
        if (o)
          for (i in o)
            c && o[i] === c[i] || qn(e.style, i, o[i]);
      }
    else if (i[0] === "o" && i[1] === "n")
      _ = i !== (i = i.replace(/Capture$/, "")), i = i.toLowerCase() in e ? i.toLowerCase().slice(2) : i.slice(2), e.l || (e.l = {}), e.l[i + _] = o, o ? c || e.addEventListener(i, _ ? Xn : Qn, _) : e.removeEventListener(i, _ ? Xn : Qn, _);
    else if (i !== "dangerouslySetInnerHTML") {
      if (d)
        i = i.replace(/xlink(H|:h)/, "h").replace(/sName$/, "s");
      else if (i !== "width" && i !== "height" && i !== "href" && i !== "list" && i !== "form" && i !== "tabIndex" && i !== "download" && i in e)
        try {
          e[i] = o != null ? o : "";
          break e;
        } catch (v) {
        }
      typeof o == "function" || (o == null || o === !1 && i[4] !== "-" ? e.removeAttribute(i) : e.setAttribute(i, o));
    }
}
function Qn(e) {
  return this.l[e.type + !1](ee.event ? ee.event(e) : e);
}
function Xn(e) {
  return this.l[e.type + !0](ee.event ? ee.event(e) : e);
}
function Ir(e, i, o, c, d, _, v, f, y) {
  var D, A, S, E, b, L, k, g, H, T, R, x, w, B, N, K = i.type;
  if (i.constructor !== void 0)
    return null;
  o.__h != null && (y = o.__h, f = i.__e = o.__e, i.__h = null, _ = [f]), (D = ee.__b) && D(i);
  try {
    e:
      if (typeof K == "function") {
        if (g = i.props, H = (D = K.contextType) && c[D.__c], T = D ? H ? H.props.value : D.__ : c, o.__c ? k = (A = i.__c = o.__c).__ = A.__E : ("prototype" in K && K.prototype.render ? i.__c = A = new K(g, T) : (i.__c = A = new Ii(g, T), A.constructor = K, A.render = Lu), H && H.sub(A), A.props = g, A.state || (A.state = {}), A.context = T, A.__n = c, S = A.__d = !0, A.__h = [], A._sb = []), A.__s == null && (A.__s = A.state), K.getDerivedStateFromProps != null && (A.__s == A.state && (A.__s = Dt({}, A.__s)), Dt(A.__s, K.getDerivedStateFromProps(g, A.__s))), E = A.props, b = A.state, A.__v = i, S)
          K.getDerivedStateFromProps == null && A.componentWillMount != null && A.componentWillMount(), A.componentDidMount != null && A.__h.push(A.componentDidMount);
        else {
          if (K.getDerivedStateFromProps == null && g !== E && A.componentWillReceiveProps != null && A.componentWillReceiveProps(g, T), !A.__e && A.shouldComponentUpdate != null && A.shouldComponentUpdate(g, A.__s, T) === !1 || i.__v === o.__v) {
            for (i.__v !== o.__v && (A.props = g, A.state = A.__s, A.__d = !1), A.__e = !1, i.__e = o.__e, i.__k = o.__k, i.__k.forEach(function(G) {
              G && (G.__ = i);
            }), R = 0; R < A._sb.length; R++)
              A.__h.push(A._sb[R]);
            A._sb = [], A.__h.length && v.push(A);
            break e;
          }
          A.componentWillUpdate != null && A.componentWillUpdate(g, A.__s, T), A.componentDidUpdate != null && A.__h.push(function() {
            A.componentDidUpdate(E, b, L);
          });
        }
        if (A.context = T, A.props = g, A.__P = e, x = ee.__r, w = 0, "prototype" in K && K.prototype.render) {
          for (A.state = A.__s, A.__d = !1, x && x(i), D = A.render(A.props, A.state, A.context), B = 0; B < A._sb.length; B++)
            A.__h.push(A._sb[B]);
          A._sb = [];
        } else
          do
            A.__d = !1, x && x(i), D = A.render(A.props, A.state, A.context), A.state = A.__s;
          while (A.__d && ++w < 25);
        A.state = A.__s, A.getChildContext != null && (c = Dt(Dt({}, c), A.getChildContext())), S || A.getSnapshotBeforeUpdate == null || (L = A.getSnapshotBeforeUpdate(E, b)), N = D != null && D.type === $i && D.key == null ? D.props.children : D, mo(e, Array.isArray(N) ? N : [N], i, o, c, d, _, v, f, y), A.base = i.__e, i.__h = null, A.__h.length && v.push(A), k && (A.__E = A.__ = null), A.__e = !1;
      } else
        _ == null && i.__v === o.__v ? (i.__k = o.__k, i.__e = o.__e) : i.__e = wu(o.__e, i, o, c, d, _, v, y);
    (D = ee.diffed) && D(i);
  } catch (G) {
    i.__v = null, (y || _ != null) && (i.__e = f, i.__h = !!y, _[_.indexOf(f)] = null), ee.__e(G, i, o);
  }
}
function To(e, i) {
  ee.__c && ee.__c(i, e), e.some(function(o) {
    try {
      e = o.__h, o.__h = [], e.some(function(c) {
        c.call(o);
      });
    } catch (c) {
      ee.__e(c, o.__v);
    }
  });
}
function wu(e, i, o, c, d, _, v, f) {
  var y, D, A, S = o.props, E = i.props, b = i.type, L = 0;
  if (b === "svg" && (d = !0), _ != null) {
    for (; L < _.length; L++)
      if ((y = _[L]) && "setAttribute" in y == !!b && (b ? y.localName === b : y.nodeType === 3)) {
        e = y, _[L] = null;
        break;
      }
  }
  if (e == null) {
    if (b === null)
      return document.createTextNode(E);
    e = d ? document.createElementNS("http://www.w3.org/2000/svg", b) : document.createElement(b, E.is && E), _ = null, f = !1;
  }
  if (b === null)
    S === E || f && e.data === E || (e.data = E);
  else {
    if (_ = _ && zi.call(e.childNodes), D = (S = o.props || Fi).dangerouslySetInnerHTML, A = E.dangerouslySetInnerHTML, !f) {
      if (_ != null)
        for (S = {}, L = 0; L < e.attributes.length; L++)
          S[e.attributes[L].name] = e.attributes[L].value;
      (A || D) && (A && (D && A.__html == D.__html || A.__html === e.innerHTML) || (e.innerHTML = A && A.__html || ""));
    }
    if (Su(e, E, S, d, f), A)
      i.__k = [];
    else if (L = i.props.children, mo(e, Array.isArray(L) ? L : [L], i, o, c, d && b !== "foreignObject", _, v, _ ? _[0] : o.__k && ci(o, 0), f), _ != null)
      for (L = _.length; L--; )
        _[L] != null && fo(_[L]);
    f || ("value" in E && (L = E.value) !== void 0 && (L !== e.value || b === "progress" && !L || b === "option" && L !== S.value) && Vi(e, "value", L, S.value, !1), "checked" in E && (L = E.checked) !== void 0 && L !== e.checked && Vi(e, "checked", L, S.checked, !1));
  }
  return e;
}
function bo(e, i, o) {
  try {
    typeof e == "function" ? e(i) : e.current = i;
  } catch (c) {
    ee.__e(c, o);
  }
}
function Ro(e, i, o) {
  var c, d;
  if (ee.unmount && ee.unmount(e), (c = e.ref) && (c.current && c.current !== e.__e || bo(c, null, i)), (c = e.__c) != null) {
    if (c.componentWillUnmount)
      try {
        c.componentWillUnmount();
      } catch (_) {
        ee.__e(_, i);
      }
    c.base = c.__P = null, e.__c = void 0;
  }
  if (c = e.__k)
    for (d = 0; d < c.length; d++)
      c[d] && Ro(c[d], i, o || typeof e.type != "function");
  o || e.__e == null || fo(e.__e), e.__ = e.__e = e.__d = void 0;
}
function Lu(e, i, o) {
  return this.constructor(e, o);
}
function xu(e, i, o) {
  var c, d, _;
  ee.__ && ee.__(e, i), d = (c = typeof o == "function") ? null : o && o.__k || i.__k, _ = [], Ir(i, e = (!c && o || i).__k = Ru($i, null, [e]), d || Fi, Fi, i.ownerSVGElement !== void 0, !c && o ? [o] : d ? null : i.firstChild ? zi.call(i.childNodes) : null, _, !c && o ? o : d ? d.__e : i.firstChild, c), To(_, e);
}
zi = po.slice, ee = { __e: function(e, i, o, c) {
  for (var d, _, v; i = i.__; )
    if ((d = i.__c) && !d.__)
      try {
        if ((_ = d.constructor) && _.getDerivedStateFromError != null && (d.setState(_.getDerivedStateFromError(e)), v = d.__d), d.componentDidCatch != null && (d.componentDidCatch(e, c || {}), v = d.__d), v)
          return d.__E = d;
      } catch (f) {
        e = f;
      }
  throw e;
} }, _o = 0, Ii.prototype.setState = function(e, i) {
  var o;
  o = this.__s != null && this.__s !== this.state ? this.__s : this.__s = Dt({}, this.state), typeof e == "function" && (e = e(Dt({}, o), this.props)), e && Dt(o, e), e != null && this.__v && (i && this._sb.push(i), Yn(this));
}, Ii.prototype.forceUpdate = function(e) {
  this.__v && (this.__e = !0, e && this.__h.push(e), Yn(this));
}, Ii.prototype.render = $i, Ht = [], Ao = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, Rr = function(e, i) {
  return e.__v.__b - i.__v.__b;
}, Bi.__r = 0;
var Iu = function() {
  var e = document.getSelection();
  if (!e.rangeCount)
    return function() {
    };
  for (var i = document.activeElement, o = [], c = 0; c < e.rangeCount; c++)
    o.push(e.getRangeAt(c));
  switch (i.tagName.toUpperCase()) {
    case "INPUT":
    case "TEXTAREA":
      i.blur();
      break;
    default:
      i = null;
      break;
  }
  return e.removeAllRanges(), function() {
    e.type === "Caret" && e.removeAllRanges(), e.rangeCount || o.forEach(function(d) {
      e.addRange(d);
    }), i && i.focus();
  };
}, ku = Iu, Zn = {
  "text/plain": "Text",
  "text/html": "Url",
  default: "Text"
}, Cu = "Copy to clipboard: #{key}, Enter";
function Du(e) {
  var i = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return e.replace(/#{\s*key\s*}/g, i);
}
function Ou(e, i) {
  var o, c, d, _, v, f, y = !1;
  i || (i = {}), o = i.debug || !1;
  try {
    d = ku(), _ = document.createRange(), v = document.getSelection(), f = document.createElement("span"), f.textContent = e, f.ariaHidden = "true", f.style.all = "unset", f.style.position = "fixed", f.style.top = 0, f.style.clip = "rect(0, 0, 0, 0)", f.style.whiteSpace = "pre", f.style.webkitUserSelect = "text", f.style.MozUserSelect = "text", f.style.msUserSelect = "text", f.style.userSelect = "text", f.addEventListener("copy", function(A) {
      if (A.stopPropagation(), i.format)
        if (A.preventDefault(), typeof A.clipboardData > "u") {
          o && console.warn("unable to use e.clipboardData"), o && console.warn("trying IE specific stuff"), window.clipboardData.clearData();
          var S = Zn[i.format] || Zn.default;
          window.clipboardData.setData(S, e);
        } else
          A.clipboardData.clearData(), A.clipboardData.setData(i.format, e);
      i.onCopy && (A.preventDefault(), i.onCopy(A.clipboardData));
    }), document.body.appendChild(f), _.selectNodeContents(f), v.addRange(_);
    var D = document.execCommand("copy");
    if (!D)
      throw new Error("copy command was unsuccessful");
    y = !0;
  } catch (A) {
    o && console.error("unable to copy using execCommand: ", A), o && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(i.format || "text", e), i.onCopy && i.onCopy(window.clipboardData), y = !0;
    } catch (S) {
      o && console.error("unable to copy using clipboardData: ", S), o && console.error("falling back to prompt"), c = Du("message" in i ? i.message : Cu), window.prompt(c, e);
    }
  } finally {
    v && (typeof v.removeRange == "function" ? v.removeRange(_) : v.removeAllRanges()), f && document.body.removeChild(f), d();
  }
  return y;
}
var Mu = Ou, di, xe, vr, Jn, ui = 0, So = [], ki = [], ea = ee.__b, ta = ee.__r, ia = ee.diffed, ra = ee.__c, na = ee.unmount;
function ji(e, i) {
  ee.__h && ee.__h(xe, e, ui || i), ui = 0;
  var o = xe.__H || (xe.__H = { __: [], __h: [] });
  return e >= o.__.length && o.__.push({ __V: ki }), o.__[e];
}
function He(e) {
  return ui = 1, Nu(xo, e);
}
function Nu(e, i, o) {
  var c = ji(di++, 2);
  if (c.t = e, !c.__c && (c.__ = [o ? o(i) : xo(void 0, i), function(f) {
    var y = c.__N ? c.__N[0] : c.__[0], D = c.t(y, f);
    y !== D && (c.__N = [D, c.__[1]], c.__c.setState({}));
  }], c.__c = xe, !xe.u)) {
    var d = function(f, y, D) {
      if (!c.__c.__H)
        return !0;
      var A = c.__c.__H.__.filter(function(E) {
        return E.__c;
      });
      if (A.every(function(E) {
        return !E.__N;
      }))
        return !_ || _.call(this, f, y, D);
      var S = !1;
      return A.forEach(function(E) {
        if (E.__N) {
          var b = E.__[0];
          E.__ = E.__N, E.__N = void 0, b !== E.__[0] && (S = !0);
        }
      }), !(!S && c.__c.props === f) && (!_ || _.call(this, f, y, D));
    };
    xe.u = !0;
    var _ = xe.shouldComponentUpdate, v = xe.componentWillUpdate;
    xe.componentWillUpdate = function(f, y, D) {
      if (this.__e) {
        var A = _;
        _ = void 0, d(f, y, D), _ = A;
      }
      v && v.call(this, f, y, D);
    }, xe.shouldComponentUpdate = d;
  }
  return c.__N || c.__;
}
function wo(e, i) {
  var o = ji(di++, 3);
  !ee.__s && kr(o.__H, i) && (o.__ = e, o.i = i, xe.__H.__h.push(o));
}
function Pu(e, i) {
  var o = ji(di++, 4);
  !ee.__s && kr(o.__H, i) && (o.__ = e, o.i = i, xe.__h.push(o));
}
function Ci(e) {
  return ui = 5, Lo(function() {
    return { current: e };
  }, []);
}
function Lo(e, i) {
  var o = ji(di++, 7);
  return kr(o.__H, i) ? (o.__V = e(), o.i = i, o.__h = e, o.__V) : o.__;
}
function jt(e, i) {
  return ui = 8, Lo(function() {
    return e;
  }, i);
}
function Uu() {
  for (var e; e = So.shift(); )
    if (e.__P && e.__H)
      try {
        e.__H.__h.forEach(Di), e.__H.__h.forEach(Sr), e.__H.__h = [];
      } catch (i) {
        e.__H.__h = [], ee.__e(i, e.__v);
      }
}
ee.__b = function(e) {
  xe = null, ea && ea(e);
}, ee.__r = function(e) {
  ta && ta(e), di = 0;
  var i = (xe = e.__c).__H;
  i && (vr === xe ? (i.__h = [], xe.__h = [], i.__.forEach(function(o) {
    o.__N && (o.__ = o.__N), o.__V = ki, o.__N = o.i = void 0;
  })) : (i.__h.forEach(Di), i.__h.forEach(Sr), i.__h = [])), vr = xe;
}, ee.diffed = function(e) {
  ia && ia(e);
  var i = e.__c;
  i && i.__H && (i.__H.__h.length && (So.push(i) !== 1 && Jn === ee.requestAnimationFrame || ((Jn = ee.requestAnimationFrame) || Fu)(Uu)), i.__H.__.forEach(function(o) {
    o.i && (o.__H = o.i), o.__V !== ki && (o.__ = o.__V), o.i = void 0, o.__V = ki;
  })), vr = xe = null;
}, ee.__c = function(e, i) {
  i.some(function(o) {
    try {
      o.__h.forEach(Di), o.__h = o.__h.filter(function(c) {
        return !c.__ || Sr(c);
      });
    } catch (c) {
      i.some(function(d) {
        d.__h && (d.__h = []);
      }), i = [], ee.__e(c, o.__v);
    }
  }), ra && ra(e, i);
}, ee.unmount = function(e) {
  na && na(e);
  var i, o = e.__c;
  o && o.__H && (o.__H.__.forEach(function(c) {
    try {
      Di(c);
    } catch (d) {
      i = d;
    }
  }), o.__H = void 0, i && ee.__e(i, o.__v));
};
var aa = typeof requestAnimationFrame == "function";
function Fu(e) {
  var i, o = function() {
    clearTimeout(c), aa && cancelAnimationFrame(i), setTimeout(e);
  }, c = setTimeout(o, 100);
  aa && (i = requestAnimationFrame(o));
}
function Di(e) {
  var i = xe, o = e.__c;
  typeof o == "function" && (e.__c = void 0, o()), xe = i;
}
function Sr(e) {
  var i = xe;
  e.__c = e.__(), xe = i;
}
function kr(e, i) {
  return !e || e.length !== i.length || i.some(function(o, c) {
    return o !== e[c];
  });
}
function xo(e, i) {
  return typeof i == "function" ? i(e) : i;
}
const Bu = "_container_afsrn_1", Vu = "_actions_afsrn_60", Ye = {
  container: Bu,
  "container-h5": "_container-h5_afsrn_19",
  "close-btn": "_close-btn_afsrn_36",
  "btn-tip": "_btn-tip_afsrn_49",
  actions: Vu,
  "copy-btn": "_copy-btn_afsrn_69",
  "info-item": "_info-item_afsrn_75",
  "info-item-name": "_info-item-name_afsrn_79",
  "info-item-value": "_info-item-value_afsrn_87",
  "item-svg": "_item-svg_afsrn_92",
  "item-value": "_item-value_afsrn_100"
};
var Hu = 0;
function de(e, i, o, c, d, _) {
  var v, f, y = {};
  for (f in i)
    f == "ref" ? v = i[f] : y[f] = i[f];
  var D = { type: e, props: y, key: o, ref: v, __k: null, __: null, __b: 0, __e: null, __d: void 0, __c: null, __h: null, constructor: void 0, __v: --Hu, __source: d, __self: _ };
  if (typeof e == "function" && (v = e.defaultProps))
    for (f in v)
      y[f] === void 0 && (y[f] = v[f]);
  return ee.vnode && ee.vnode(D), D;
}
function pt(e) {
  const {
    title: i,
    value: o
  } = e;
  return de("div", {
    className: Ye["info-item"],
    children: [de("div", {
      className: Ye["info-item-name"],
      children: [i, ":"]
    }), de("div", {
      className: Ye["info-item-value"],
      children: o
    })]
  });
}
function Gu(e) {
  const {
    dataArray: i
  } = e, o = Ci(null), [c, d] = He("");
  return wo(() => {
    if (o != null && o.current) {
      const {
        width: _,
        height: v
      } = o.current.getBoundingClientRect(), f = Math.max(...i) || 1, y = v - 2, D = _ / i.length;
      let A = `M0 ${y * (f - i[0]) / f + 1}`;
      for (let S = 1; S < i.length; S++)
        A += ` L${S * D} ${y * (f - i[S]) / f + 1}`;
      d(A);
    }
  }, [i]), de("svg", {
    ref: o,
    height: "100%",
    width: "100%",
    style: "display:block",
    children: de("path", {
      fill: "none",
      stroke: "#fff",
      "stroke-width": "1",
      d: c
    })
  });
}
function Ri(e) {
  const {
    title: i,
    suffix: o,
    value: c
  } = e, [d, _] = He(0);
  return wo(() => {
    _(c[c.length - 1] || 0);
  }, [c]), de("div", {
    className: Ye["info-item"],
    children: [de("div", {
      className: Ye["info-item-name"],
      children: [i, ":"]
    }), de("div", {
      className: Ye["info-item-value"],
      children: [de("div", {
        className: Ye["item-svg"],
        children: de(Gu, {
          dataArray: c
        })
      }), de("div", {
        className: Ye["item-value"],
        children: o(d)
      })]
    })]
  });
}
const oa = 100, Wu = "info-panel";
function Ku(e) {
  const {
    player: i,
    onChangeShowEventLog: o,
    DID: c,
    playerVersion: d
  } = e, [_, v] = He(""), [f, y] = He(""), [D, A] = He(""), [S, E] = He(""), [b, L] = He(""), [k, g] = He(0), [H, T] = He(""), [R, x] = He(""), [w, B] = He([]), [N, K] = He([]), [G, q] = He([]), [be, bt] = He([]), [W, Ne] = He(""), qe = Ci(void 0), We = Ci([]);
  Pu(() => {
    const X = () => {
      v(""), y(""), A(""), E(""), L(""), g(0), T(""), be.splice(0, N.length), N.splice(0, N.length), G.splice(0, G.length), w.splice(0, w.length), We.current = [];
    }, De = (Y) => {
      if (Y && Y.type === "mediaInfo") {
        qe.current = Y.value, v(Y.value.streamHost), y(Y.value.colorSpace), T(Y.value.sid), x(Y.value.gpu);
        const Le = [];
        Y.value.coreType && Le.push(Y.value.coreType), Y.value.box && (Y.value.enhancedFlv ? Le.push("enhanced-flv") : Le.push(Y.value.box)), Y.value.videoCodecType && Le.push(Y.value.videoCodecType), Y.value.videoDecoder && Le.push(Y.value.videoDecoder), Y.value.width && Y.value.height && Le.push(`${Y.value.width}x${Y.value.height}`), Y.value.sar && Le.push(`[SAR ${Y.value.sar.width}:${Y.value.sar.height}]`), Y.value.fps && Le.push(`@${Y.value.fps.toFixed(2)}`), A(Le.join(" "));
        const Rt = [];
        Y.value.videoCodec && Rt.push(Y.value.videoCodec), Y.value.audioCodec && Rt.push(Y.value.audioCodec), E(Rt.join(","));
      } else
        Y && Y.value && Y.type === "event" && We.current.push(Y.value);
      Y && Y.type === "heartbeat" && (Y.value.decodedFrames && L(`${Y.value.decodedFPS || 0}/${Y.value.droppedFPS || 0} ${Y.value.decodedFrames || 0}/${Y.value.droppedFrames || 0}`), typeof Y.value.totalReceive == "number" && g(Y.value.totalReceive), Pe(Y.value.videoBuffered, N, K), Pe(Y.value.audioBuffered, G, q), !N.length && !G.length && Pe(Y.value.buffered, be, bt), Pe(Y.value.speed, w, B), Ne((/* @__PURE__ */ new Date()).toString()));
    };
    return i.on(Gt.ATTRIBUTE_CHANGE_SRC, X), i.on(Gt.REPORT, De), () => {
      i.off(Gt.ATTRIBUTE_CHANGE_SRC, X), i.off(Gt.REPORT, De), ye.current && clearTimeout(ye.current);
    };
  }, []);
  const [Ce, Ke] = He(""), [ft, ot] = He(!1), ye = Ci(0), Pe = jt((X, De, Y) => {
    typeof X == "number" && !isNaN(X) && (De.push(X), De.length > oa ? De.shift() : De.length === 1 && (De.unshift(...new Array(oa - 1)), De.forEach((Le, Rt) => {
      typeof Le != "number" && (De[Rt] = 0);
    })), Y([...De]));
  }, []), Ot = jt(() => {
    I.i(Wu, "click copy");
    const X = {
      date: W
    };
    c && (X.did = c), d && (X.playerVersion = d), H && (X.sessionId = H), _ && (X.streamHost = _), f && (X.colorSpace = f), D && (X.res = D), S && (X.codec = S), R && (X.gpu = R), N.length && (X.vBuffer = N[N.length - 1]), G.length && (X.aBuffer = G[G.length - 1]), be.length && (X.buffer = be[be.length - 1]), w.length && (X.speed = w[w.length - 1]), qe.current && (X.mediainfo = qe.current), X.userAgent = navigator.userAgent, X.summary = i.audienceStat, X.events = We.current;
    const De = Mu(JSON.stringify(X));
    Ke(De ? "已复制" : "复制失败"), ot(!0), ye.current && clearTimeout(ye.current), ye.current = +setTimeout(() => {
      ot(!1), ye.current = 0;
    }, 1e3);
  }, []), ze = jt((X) => X > 1e9 ? `${(X / 1e9).toFixed(2)} GB` : X > 1e6 ? `${(X / 1e6).toFixed(2)} MB` : `${(X / 1e3).toFixed(2)} KB`, []), vt = jt((X) => X > 1e7 ? `${(X / 1e6).toFixed(2)} MB/s` : `${(X / 1e3).toFixed(2)} KB/s`, []), $ = jt((X) => X > 1e3 ? `${(X / 1e3).toFixed(2)} s` : `${X} ms`, []), It = jt((X) => {
    X.stopPropagation();
  }, []);
  return de("div", {
    className: Wt ? Ye["container-h5"] : Ye.container,
    onContextMenu: It,
    children: [c && de(pt, {
      title: "DeviceId",
      value: c
    }), d && de(pt, {
      title: "PlayerVersion",
      value: d
    }), H && de(pt, {
      title: "SessionId",
      value: H
    }), _ && de(pt, {
      title: "StreamHost",
      value: _
    }), D && de(pt, {
      title: "Res",
      value: D
    }), f && de(pt, {
      title: "Color",
      value: f
    }), S && de(pt, {
      title: "Codec",
      value: S
    }), b && de(pt, {
      title: "Frames",
      value: b
    }), !!be.length && de(Ri, {
      title: "Buffered",
      value: be,
      suffix: $
    }), !!N.length && de(Ri, {
      title: "VideoBuffered",
      value: N,
      suffix: $
    }), !!G.length && de(Ri, {
      title: "AudioBuffered",
      value: G,
      suffix: $
    }), !!w.length && de(Ri, {
      title: "Speed",
      value: w,
      suffix: vt
    }), k > 0 && de(pt, {
      title: "TotalReceive",
      value: ze(k)
    }), R && de(pt, {
      title: "GPU",
      value: R
    }), de(pt, {
      title: "Date",
      value: W
    }), de("div", {
      className: [Wt ? Ye["h5-btn"] : "", Ye["close-btn"]].join(" "),
      onClick: o,
      children: "[X]"
    }), de("div", {
      className: Ye.actions,
      children: de("div", {
        className: [Wt ? Ye["h5-btn"] : "", Ye["copy-btn"]].join(" "),
        onClick: Ot,
        children: [ft && de("div", {
          className: Ye["btn-tip"],
          children: Ce
        }), de("div", {
          children: "[Copy]"
        })]
      })
    })]
  });
}
const Io = class extends ao {
  constructor() {
    super(...arguments), oi(this, "_player"), oi(this, "_container"), oi(this, "_onChangeShowEventLog", () => {
      this._container && (this.isShow = !this.isShow);
    }), oi(this, "_onShowInfoPanelChange", () => {
      var e;
      this.isShow = !!((e = this._player) != null && e.showInfoPanel);
    });
  }
  afterInstall(e) {
    if (this._player = e, !this._player)
      return;
    this._container || (this._container = this._player.createSubContainer(), this._container.style.display = "none", this._container.style.position = "absolute", this._container.style.maxHeight = "100%", this._container.style.overflowY = "auto", Wt && (this._container.style.width = "100%"));
    let i = localStorage.getItem("kwai_player_device_id");
    xu(de(Ku, {
      player: e,
      DID: i || "",
      playerVersion: `${this._player.packVersion}(${this._player.version})`,
      onChangeShowEventLog: this._onChangeShowEventLog
    }), this._container), this.isShow = !!e.showInfoPanel, e.on(Gt.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL, this._onShowInfoPanelChange);
  }
  afterUninstall(e) {
    this._container && e.removeSubContainer(this._container), this._player = void 0, e.off(Gt.ATTRIBUTE_CHANGE_SHOW_INFO_PANEL, this._onShowInfoPanelChange), this.removeAllListeners();
  }
  set isShow(e) {
    this._container && (this._container.style.display = e ? "block" : "none", this.emit(
      "attribute:change"
      /* ATTRIBUTE_CHANGE */
    ));
  }
  get isShow() {
    var e;
    return ((e = this._container) == null ? void 0 : e.style.display) === "block";
  }
  getLabel() {
    return Io.label;
  }
};
let ko = Io;
oi(ko, "version", "1.1.0-alpha.0");
Jt.register(Xc);
Jt.register(ko);
Jt.packVersion = "1.1.8.vue2-mini";
export {
  Pl as ControlsPluginLabel,
  ql as ControlsPluginModule,
  Yl as DanmakuControlsPos,
  jl as DanmakuPluginDomStyle,
  $l as DanmakuPluginLabel,
  ac as DanmakuPluginModule,
  yt as FullscreenType,
  Bl as HotkeyPluginLabel,
  Zl as HotkeyPluginModule,
  Ul as I18nPluginLabel,
  Ql as I18nPluginModule,
  Jt as KwaiPlayer,
  P as KwaiPlayerEvent,
  wi as KwaiPlayerLayer,
  Sa as LiveShiftType,
  Fl as LoggerPluginLabel,
  Xl as LoggerPluginModule,
  Kl as MaskPluginLabel,
  rc as MaskPluginModule,
  Hl as MirrorPluginLabel,
  ec as MirrorPluginModule,
  Vl as PlayInfoPluginLabel,
  Jl as PlayInfoPluginModule,
  Xe as PluginModule,
  Wl as PreviewPluginLabel,
  ic as PreviewPluginModule,
  Gl as RotatePluginLabel,
  tc as RotatePluginModule,
  zl as VRPluginLabel,
  nc as VRPluginModule,
  Qu as default
};
